/**
 * Mahabis v2.0
 */

var app = (function (app, $) {

	/**
	 * @private
	 * @function
	 * @description Initializes global DOM loading order
	 */
	function initializeDom() {
		app.utils.init();
		app.page.init();
		app.ui.init();
		app.lazyload.init();
		app.header.init();
		app.popup.init();
		app.subscribe.init();
		app.multistore.init();
		app.currency.init();
		app.stock.init();
		if (app.page.template == 'plp') {
			app.collection.init();
		}
		app.product.init();
		app.upsell.init();
		app.zoom.init();
		app.myaccount.init();
		app.geoip.init();
		app.carousel.init();
		app.analytics.init();
		app.tracking.init();
		app.validation.init();
		app.paralax.init();
		app.returns.init();
		if (app.product.data.sku.indexOf('CC-C') > -1 || app.product.data.sku.indexOf("CF-C") > -1) {
			app.customizer.init();
		}
	}

	var _app = {
		init: function () {
			initializeDom();
		}
	};

	return $.extend(app, _app);
}(window.app = window.app || {}, jQuery));

/**
 * @class app.utils
 */
(function (app, $) {

	/**
	 * @private
	 * @function
	 * @description Get parameter value from page URL
	 * @param value string Parameter key
	 **/
	function getUrlParam(value) {
		var pageParamsFiltered = decodeURIComponent(app.page.params).replace('?','&');
		var pageUrlVariables = pageParamsFiltered.split('&');
		for (var i = 0; i < pageUrlVariables.length; i++) {
			var sParameterName = pageUrlVariables[i].split('=');
			if (sParameterName[0] == value) {
				return sParameterName[1];
			}
		}
	}

	function checkInViewport($el) {
		var elementTop = $el.offset().top;
		var elementBottom = elementTop + $el.outerHeight();

		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	}

	/**
	 * @private
	 * @function
	 * @description Detect if its mobile browser
	 **/
	function isMobile() {
		return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
	}

	/**
	 * @private
	 * @function
	 * @description Detect if its in viewport
	 **/
	function checkIsInViewport(el) {
		if (typeof jQuery === "function" && el instanceof jQuery) {
			el = el[0];
		}

		var rect = el.getBoundingClientRect();

		if (!isMobile()) {
			//noinspection JSAnnotator
			rect.top = rect.top - 65;
		}

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight - 65) && /*or $(window).height() */
			rect.right <= (window.innerWidth || document.documentElement.clientWidth - 65) /*or $(window).width() */
		);
	}

	/**
	 * @private
	 * @function
	 * @description Get cookies
	 **/
	function getCookies(name) {
		return $.cookie(name);
	}

	/**
	 * @private
	 * @function
	 * @description Get url hash
	 **/
	function getUrlHash() {
		return window.location.hash;
	}

	/**
	 * @private
	 * @function
	 * @description Set cookies
	 **/
	function setCookies(name, value) {
		$.cookie(name, value, {
			path: '/',
			domain: window.location.hostname
		});
	}

	/**
	 * @private
	 * @function
	 * @description Scroll page to specific element
	 **/
	function scrollPage(el, timing, correction, callback) {
		var scrollTime = timing || 1000,
			headerHeight = $('#hdr-nav').outerHeight(),
			bannerHeight = $('#FreeShippingBanner').outerHeight(),
			correctionBuffer = 20,
			isMobile = app.ui.isMobile(),
			correctionAmount = headerHeight + bannerHeight + correctionBuffer;

		if (correction) {
			correctionAmount = correction
		}

		console.log(correctionAmount);

		// if (isMobile) {
		// 	console.log('is mobile scrolling');
		// 	correctionAmount = $('#main-hdr').outerHeight() + $('.delivery-hdr').outerHeight();
		// }

		console.log($(el).offset().top);

		$('html, body').animate({
			scrollTop: $(el).offset().top - correctionAmount
		}, scrollTime, callback());
	}

	/**
	 * @private
	 * @function
	 * @description Remove classes by mask, add new class
	 **/
	function initializeAlterClass() {
		$.fn.alterClass = function (removals, additions) {

			var self = this;

			if (removals.indexOf('*') === -1) {
				self.removeClass(removals);
				return !additions ? self : self.addClass(additions);
			}

			var patt = new RegExp('\\s' +
				removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') +
				'\\s', 'g');

			self.each(function (i, it) {
				var cn = ' ' + it.className + ' ';
				while (patt.test(cn)) {
					cn = cn.replace(patt, ' ');
				}
				it.className = $.trim(cn);
			});

			return !additions ? self : self.addClass(additions);
		};
	}

	/**
	 * @private
	 * @function
	 * @description Format date to yyyy-mm-dd
	 **/
	function formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2)
			month = '0' + month;
		if (day.length < 2)
			day = '0' + day;

		return [year, month, day].join('-');
	}

	function initializeScrollEvents() {
		$('.js-scrollto-section').on('click', function(){
			var $el = $(this).data('scrollto') || $('#product-area').next();
			app.utils.scrollTo($el, 600, 0, function(){});
		})
	}

	function initializePdpScroll() {
		if ($('body').hasClass('template-product')) {
			var $button = $('#addToCartWrapper .submit-button');

			$(window).on('resize scroll', function() {
				if (checkInViewport($('#addToCartWrapper'))) {
					$button.removeClass('is-fixed');
				} else {
					if (!$button.hasClass('is-fixed')) {
						$button.addClass('is-fixed');
					}
				}
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Utils DOM initialization
	 **/
	function initializeDOM() {
		initializeAlterClass();
		initializeScrollEvents();
		initializePdpScroll();
	}

	app.utils = {
		init: function () {
			initializeDOM();
		},
		getUrlParam: function (value) {
			return getUrlParam(value);
		},
		getUrlHash: function () {
			return getUrlHash();
		},
		isMobile: function () {
			return isMobile();
		},
		isInViewport: function (el) {
			return checkIsInViewport(el);
		},
		checkInViewport: function(el) {
			return checkInViewport(el)
		},
		getCookie: function (name) {
			return getCookies(name);
		},
		setCookie: function (name, value) {
			setCookies(name, value);
		},
		formatDate: function(date) {
			return formatDate(date)
		},
		scrollTo: function (el, timing, correction, callback) {
			scrollPage(el, timing, correction, callback);
		}
	}

}(window.app = window.app || {}, jQuery));

/**
 * @class app.ui
 */
(function (app, $) {
	var $cache;

	/**
	 * @private
	 * @function
	 * @description Initialize UI Accordion
	 **/
	function initializeAccordion() {
		$('.js-accordion-dropdown').on('click', '.js-dropdown-link', function (e) {
			e.preventDefault();
			console.log('123');
			if (app.ui.isDesktop()) {
				var $this = $(this),
					$parent = $this.parent(),
					$wrapper = $this.parents('.js-accordion-wrapper'),
					isShopNav = $this.hasClass('js-shop-nav'),
					isActive = $parent.hasClass('is-active');

				// Lazy load navigation images
				$parent.find('.js-navigation-lazy').each(function(){
					var $image = $(this),
						newUrl = $image.attr('data-src');

					$image.attr('src', newUrl);
				});

				if (isActive) {
					$wrapper.removeClass('is-activated');
					$wrapper.find('.hovered').removeClass('hovered');
					$('.modal-overlay-alt').hide().removeClass('modal-show');
				} else {
					$('.modal-overlay-alt').show().addClass('modal-show');
					$wrapper.addClass('is-activated');
					$wrapper.find('.hovered').addClass('no-transition').removeClass('hovered')
				}

				$wrapper.find('.is-active').removeClass('is-active');
				if (!isActive) {
					$parent.addClass('is-active');
					$parent.find('ul').addClass('hovered');
				}

				if (isShopNav) {
					// setTimeout(function () {
						$('.js-category-link.js-initial-submenu').trigger('click');
					// }, 300);
				}
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Fix carousel height for safari browser
	 **/
	function homeHeightFix() {
		var $window = $(window),
			windowHeight = $window.height(),
			windowWidth = $window.width(),
			productBarHeight = $('.js-product-select').outerHeight(),
			carouselHeight = $('.js-hero-initialimage').outerHeight(),
			fbBarHeight = 0,
			mobileDiff = 40,
			topBarHeight = 40,
			heightDiff = carouselHeight;

		if (app.page.isFbApp) {
			heightDiff = productBarHeight + fbBarHeight;
		}

		if (windowHeight > 460 && app.ui.windowWidth != windowWidth) {
			$('.hero-home').css('height', heightDiff);
			app.ui.windowWidth = windowWidth;
		}

		if (windowWidth < 768) {
			carouselHeight = parseInt($('.js-hero-initialimage').width() * 1.5)
			$('.hero-home').css('height', carouselHeight);
			$('.hero-home-content').css('height', carouselHeight + topBarHeight);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Detect specific browser
	 **/
	function detectSpecificBrowser() {
		if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 && navigator.userAgent.indexOf('Windows') != -1) {
			$('html').addClass('b-safari-win');
		} else if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
			$('html').addClass('b-safari');
		}

		if (navigator.userAgent.indexOf('iPhone OS 7') > -1) {
			$('html').addClass('b-ios-7')
		}
	}

	/**
	 * @private
	 * @function
	 * @description Detect FB in-app browser
	 **/
	function detectFBbrowser() {
		var ua = navigator.userAgent || navigator.vendor || window.opera;
		if ((ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1)) {
			$('html').addClass('b-facebook-app');
			app.page.isFbApp = true;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Get browser breakpoints depending on window width
	 **/
	function initializeBreakpoints() {
		var breakpoint = $cache.breakpoint.css('content').replace(/"/g, "");
		if (app.ui.mediaquery != breakpoint) {
			app.ui.mediaquery = breakpoint;
		}
	}

	function initializeRetina() {
		var isRetina = $cache.retina.css('content').replace(/"/g, "");
		if (isRetina == 'true') {
			app.ui.isRetina = true;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Check if browser supports webp format
	 **/
	function detectWebpSupport() {
		var elem = document.createElement('canvas');

		if (!!(elem.getContext && elem.getContext('2d'))) {
			// was able or not to get WebP representation
			if (elem.toDataURL('image/webp').indexOf('data:image/webp') == 0) {
				app.ui.isWebpSupported = true;
			}
		}

		// very old browser like IE 8, canvas not supported
		return false;
	}

	/**
	 * @private
	 * @function
	 * @description Check if browser supports css3 mix-blend-mode
	 **/
	function detectMixBlendSupport() {
		if (typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined') {
			document.documentElement.className += " mix-blend-mode-no";
		}
	}

	/**
	 * @private
	 * @function
	 * @description Get media device type
	 **/
	function checkMobile() {
		if (app.ui.mediaquery == 'isMobile') {
			return true;
		} else {
			return false;
		}
	}

	function checkTablet() {
		if (app.ui.mediaquery == 'isTablet') {
			return true;
		} else {
			return false;
		}
	}

	function checkDesktop() {
		if (app.ui.mediaquery == 'isDesktop') {
			return true;
		} else {
			return false;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Toggle content
	 **/
	function toggleContent(el) {
		el.toggleClass('active');
		el.siblings('.toggle-content').slideToggle("slow");
	}

	/**
	 * @private
	 * @function
	 * @description Tabs functionality
	 **/
	function tabTrigger(el) {
		var $parent = el.parents('.js-tabs'),
			tab = el.data('tab-content');
		el.siblings().removeClass('active');
		el.addClass('active');

		$parent.find('.js-tabs-content').removeClass('show');
		$parent.find('.js-tabs-content[data-tab="' + tab + '"]').addClass('show')
	}

	/**
	 * @private
	 * @function
	 * @description Enable double tap for touch devices
	 **/
	function initializeDoubleTap() {
		$.event.special.doubletap = {
			bindType: 'touchend',
			delegateType: 'touchend',

			handle: function (event) {
				var handleObj = event.handleObj,
					targetData = jQuery.data(event.target),
					now = new Date().getTime(),
					delta = targetData.lastTouch ? now - targetData.lastTouch : 0,
					delay = delay == null ? 300 : delay;

				if (delta < delay && delta > 65) {
					targetData.lastTouch = null;
					event.type = handleObj.origType;
					['clientX', 'clientY', 'pageX', 'pageY'].forEach(function (property) {
						event[property] = event.originalEvent.changedTouches[0][property];
					})

					// let jQuery handle the triggering of "doubletap" event handlers
					handleObj.handler.apply(this, arguments);
				} else {
					targetData.lastTouch = now;
				}
			}
		};
	}

	/**
	 * @private
	 * @function
	 * @description Scroll page to initial load position
	 **/
	function initialPageScroll(el) {
		if (el) {
			var $el = $(".js-scroll-section[data-scroll='" + el + "']");
			if ($el.length) {
				if (app.ui.isMobile()) {
					window.scrollTo(0, $el.offset().top - 20);
				} else {
					window.scrollTo(0, $el.offset().top);
				}
			}
		}
	}

	function pageScrollStart(el) {
		var initialScrollDisabled = $('.js-scrollload-disable').length;
		if (!initialScrollDisabled) {
			initialPageScroll(el);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Detect carousel slide colour and apply to body class
	 **/
	function initializeCarouselColors() {
		var colour = $('.js-hero-initialimage').find('.js-hero-slide').attr('data-mobile-menu');

		if (colour == 'light') {
			$cache.body.removeClass('scheme-dark').addClass('scheme-light');
		} else if (colour == 'dark') {
			$cache.body.removeClass('scheme-light').addClass('scheme-dark');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Toggle pinch zoom
	 **/
	function togglePinchZoom(state) {
		$cache.viewport.attr("content", "");
		if (state) {
			$cache.viewport.attr("content", "width=device-width, user-scalable=yes");
		} else {
			$cache.viewport.attr("content", "width=device-width, user-scalable=no");
		}
	}

	/**
	 * @private
	 * @function
	 * @description Homepage countdown timer initialization
	 **/
	function initializeHomeTimer() {
		var austDay = new Date(Theme.promotions.homepageCountdownToDate);
		$('#heroCountdown').countdown({until: austDay, format: 'HMS'});
	}

	/**
	 * @private
	 * @function
	 * @description Add specific class to Google Shopping Users
	 **/
	function initGshoppingUser() {
		var isGoogleShoppingUser = Cookies.get('gshpng');
		if (app.page.params.indexOf('gshpng=true') > -1 || isGoogleShoppingUser) {
			$cache.body.addClass('is-gshpng');

			if (!isGoogleShoppingUser) {
				Cookies.set('gshpng', 'true', { expires: 14, path: '/' })
			}

		}
		// console.log('start');
		// if (app.page.params.indexOf('gshpng=true')) {
		// 	redirectGoogleShopping();
		// }
	}

	function redirectGoogleShopping() {
		var variantId = app.utils.getUrlParam('variant');
		$.each(app.multistore.data.variants, function( index, object ){
			console.log(object);
		});
	}

	/**
	 * @private
	 * @function
	 * @description Weather specific banner
	 **/
	function initHomepageWeather() {
		var locationParam = Cookies.get('deliveryCt') + ',' + Cookies.get('deliveryCountryISO'),
			weatherStored = Cookies.get('weatherData'),
			weatherLinkStored = Cookies.get('weatherLink'),
			weatherStoredDate = Cookies.get('weatherDataDate'),
			$weatherBar = $('.js-weather-prediction'),
			today = new Date().toLocaleDateString(),
			url = 'http://api.openweathermap.org/data/2.5/weather?q=' + locationParam + '&units=metric&appid=e13589fe512ddaab50c9fd5d4c92d354';

		if (weatherStored && weatherStoredDate == today) {
			$weatherBar.html(weatherStored);
			$weatherBar.parent().attr('data-href', weatherLinkStored)
		} else {
			$.ajax({
				url: url,
				type: 'GET',

				success: function (data) {
					if (data.main.temp) {
						var currentTemp = parseInt(data.main.temp),
							currentWeather = data.weather[0].main.toLowerCase(),
							headerLink = null,
							weatherMessage = null;

						if (currentTemp >= 18 && currentWeather == "clear") {
							weatherMessage = "our recommendation for your current climate: the breathe"
							headerLink = '/collections/breathe-slippers';
						} else if (currentTemp >= 16 && currentTemp > 18 && (currentWeather == "clear" || currentWeather == "clouds")) {
							weatherMessage = "our recommendation for your current climate: the mule";
							headerLink = '/collections/mule';
						} else if (currentTemp > 15 && (currentWeather == "rain" || currentWeather == "thunderstorm")) {
							weatherMessage = "our recommendation for your current climate: the curve canvas";
							headerLink = '/collections/canvas-slippers';
						} else if (currentTemp <= 15) {
							weatherMessage = "our recommendation for your current climate: the curve";
							headerLink = '/collections/curve-slippers';
						}
					} else {
						$weatherBar.parent().addClass('hidden');
					}

					if (weatherMessage && Theme.promotions.weatherMarketing) {
						Cookies.set('weatherData', weatherMessage);
						Cookies.set('weatherLink', headerLink);
						Cookies.set('weatherDataDate', today);
						$weatherBar.html(weatherMessage);
						$weatherBar.parent().attr('data-href', headerLink)
					}
				}
			})
		}
	}

	function trigggerHomepageRedirect() {
		var url = $('.js-hero-initialimage').find('.hero-home-1').data('href');
		window.location.href = url;
	}

	function initHomepageVideoBanner() {
		var $video = $('#homeVideoBanner'),
			posterSrc = $video.data('poster-desktop'),
			posterSrcMobile = $video.data('poster-mobile'),
			videoSrc = $video.data('src'),
			videoSrcMobile = $video.data('src-mobile');

		if ($video.length) {
			if (app.ui.isMobile()) {
				$video.attr('poster', posterSrcMobile);
				$video.attr('src', videoSrcMobile)
			} else {
				$video.attr('poster', posterSrc);
				$video.attr('src', videoSrc);
			}
		}

		$('#clickableBanner, .js-clickable-banner').on('click', function(){
			var link = $(this).data('url');

			if (link) {
				window.location.href = link;
			}
		})
	}

	/**
	 * @private
	 * @function
	 * @description Initialize UI cache
	 **/
	function initializeCache() {
		$cache = {
			breakpoint: $('#js-breakpoint'),
			retina: $('#js-retina'),
			body: $('body'),
			miniCart: $('.mini-cart-container'),
			viewport: $('meta[name=viewport]')
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize UI DOM
	 **/
	function initializeDOM() {
		// p1
		initializeRetina();
		detectFBbrowser();
		homeHeightFix();
		initializeBreakpoints();
		detectWebpSupport();
		detectMixBlendSupport();
		initializeAccordion();
		// p2
		//initGshoppingUser();
		pageScrollStart(app.utils.getUrlHash());
		initializeCarouselColors();
		detectSpecificBrowser();
		initializeDoubleTap();
		// initHomepageWeather();
		initHomepageVideoBanner();
		if (Theme.promotions.homepageCountdownEnabled) {
			initializeHomeTimer();
		}

	}

	/**
	 * @private
	 * @function
	 * @description Initialize UI events
	 **/
	function initializeEvents() {

		$(window).on('resize', function () {
			initializeBreakpoints();
			if (app.page.template == 'homepage') {
				//homeHeightFix();
			}
		});

		// Toggle functions
		$('.toggle-wrapper').on('click', '.toggle-title', function () {
			toggleContent($(this));
		});

		// Tabs events
		$('.js-tabs-title').click(function () {
			tabTrigger($(this));
		});

		// Prevent minicart close on click on it
		$('.mini-cart-container').on('click', function (e) {
			if ($(this).hasClass('active')) {
				e.stopPropagation();
			}
		});

		// Homepage banner click
		$('.js-hero-initialimage').on('click', function(){
			trigggerHomepageRedirect();
		})
	}

	app.ui = {
		init: function () {
			initializeCache();
			initializeDOM();
			initializeEvents();
		},
		isMobile: function () {
			return checkMobile();
		},
		isTablet: function () {
			return checkTablet();
		},
		isDesktop: function () {
			return checkDesktop();
		},
		togglePinchZoom: function (state) {
			togglePinchZoom(state);
		},
		scrollToHash: function () {
			initialPageScroll(app.utils.getUrlHash());
		},
		mediaquery: '',
		isRetina: false,
		isWebpSupported: false,
		scrollTop: 0,
		windowWidth: 0
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.lazyload
 */
(function (app, $) {

	/**
	 * @private
	 * @function
	 * @description Trigger images load from javascript
	 *              to prioritize images order
	 **/
	function triggerInstantLoad(el) {
		var src = el.data('src'),
			mobileLoad = el.data('lazy-mobile') || true,
			tabletLoad = el.data('lazy-tablet') || true,
			desktopLoad = el.data('lazy-desktop') || true,
			src2x = el.data('src2x');

		function replaceImageSrc() {
			if (app.ui.isRetina && src2x) {
				el.attr('src', src2x);
			} else {
				el.attr('src', src);
			}
		}

		if (mobileLoad == "disabled" || tabletLoad == "disabled" || desktopLoad == "disabled") {
			if ((app.ui.isMobile() && mobileLoad == "disabled") || (app.ui.isTablet() && tabletLoad == "disabled") || (app.ui.isDesktop() && desktopLoad == "disabled")) {
				return true;
			} else {
				replaceImageSrc();
			}
		} else {
			replaceImageSrc();
		}
	}

	/**
	 * @private
	 * @function
	 * @description Images lazy load
	 **/
	function setImagesLazyLoad() {
		// Windowload lazy
		$('.js-lazy-windowload-2s, .js-lazy-windowload-3s, .js-lazy-windowload-4s').lazyload({
			event: "sporty"
		});

		// Instant lazy
		$(document).find('.js-lazy-instant').each(function () {
			triggerInstantLoad($(this));
		});

		$(window).on('load', function () {
			var load1 = setTimeout(function () {
				$('.js-lazy-windowload-2s').trigger("sporty");
			}, 2000);

			var load2 = setTimeout(function () {
				$('.js-lazy-windowload-3s').trigger("sporty")
			}, 3000);

			var load3 = setTimeout(function () {
				$('.js-lazy-windowload-4s').trigger("sporty")
			}, 4000);

			if (app.page.template == 'homepage') {
				$('html').addClass('content-loaded');
			}
		});

		// Lazy scroll
		$('.js-lazyload').lazyload({
			threshold: 400
		});

		$('.js-lazyload-200').lazyload({
			threshold: 200,
			failure_limit: 10
		});

		$('.js-lazyload-0').lazyload({
			threshold: 0
		});

		$('.js-lazyload-block').lazyload();

	}

	/**
	 * @private
	 * @function
	 * @description Add class for loaded images
	 **/
	function setImagesLazyClasses() {
		$('.js-lazyload, .js-lazyload-200, .js-lazyload-0').on('load', function () {
			$(this).addClass('js-lazy-loaded');
		});
	}

	/**
	 * @private
	 * @function
	 * @description Trigger lazy load on click/hover/touchend
	 **/
	function triggerLazyImage(el) {
		var type = $.type(el),
			$target;

		if (type == 'string') {
			$target = $(".js-lazy-target[data-lazy-target='" + el + "']");
		} else {
			$target = $(".js-lazy-target[data-lazy-target='" + el.data('lazy-show') + "']");
		}

		$target.each(function () {
			var $this = $(this),
				originalSrc2x = $this.attr('data-src2x'),
				originalSrc = $this.attr('data-src');

			if (originalSrc2x && app.ui.isRetina) {
				$this.attr('src', originalSrc2x);
			} else {
				$this.attr('src', originalSrc);
			}
		})
	}

	/**
	 * @private
	 * @function
	 * @description Initialize lazyload DOM
	 **/
	function initializeDOM() {
		setImagesLazyLoad();
		setImagesLazyClasses();
	}

	/**
	 * @private
	 * @function
	 * @description Initialize lazyload events
	 **/
	function initializeEvents() {
		// Js lazy click
		$('.js-lazy-click-trigger').on('click touchend', function () {
			triggerLazyImage($(this));
		})
	}

	app.lazyload = {
		init: function () {
			initializeDOM();
			initializeEvents();
		},
		show: function (el) {
			triggerLazyImage(el);
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.header
 */
(function (app, $) {
	var $cache,
		settings;

	/**
	 * @private
	 * @function
	 * @description Shuffle brand messages and show random
	 **/
	function showBrandMsg() {
		var quotes = $('.brand-quote').get().sort(function () {
			return Math.round(Math.random()) * 1; //random
		}).slice(0, 1);
		$(quotes).show();
	}

	/**
	 * @private
	 * @function
	 * @description Tablet nav dropdown fix
	 **/
	function triggerTabletNavFix(event) {
		var $width = $(window).width(),
			isTabletLandscape = $width > 768 && $width < 1025;

		if ($width < 1025 && !app.ui.isMobile()) {
			if (!$(event.target).closest('ul.hovered').length) {
				$cache.navigation.removeClass('fill-bg');
				$cache.navigation.find('.hovered').unbind('mouseenter mouseleave').removeClass('hovered');
				if (isTabletLandscape) {
					$('.js-accordion-dropdown').removeClass('is-active');
				}
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Header change background color/size
	 **/
	function headerDynamicBackground(scrollTop) {
		if (!app.ui.isMobile()) {
			if (scrollTop >= 50) {
				$cache.header.addClass('hdr-small');
				if (app.page.template == 'homepage') {
					$cache.header.removeClass('no-background');
				}
			} else {
				$cache.header.removeClass('hdr-small');
				if (app.page.template == 'homepage') {
					$cache.header.addClass('no-background');
				}
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Load navigation images
	 **/
	function initializeNavImages() {
		if (app.ui.isDesktop() || app.ui.isTablet()) {
			app.lazyload.show('navigationImages');
			settings.navIsInitialized = true;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Toggle mobile navigation
	 **/
	function toggleMobileNav() {
		if ($cache.mobileNav.hasClass('active')) {
			var backInitialTitle = $('.js-navigation-backitem').data('initialtitle');
			$('#navigationCategories, #navigationLinks').addClass('is-invisible').removeClass('is-prev');
			$('#navigationBack').removeClass('is-active');
			$('.js-navigation-backitem').html(backInitialTitle);
		}

		$('#navigationDropdown').removeClass('is-invisible');
		$cache.mobileNav.toggleClass('active');
		$('html').toggleClass('noscroll');
		$cache.header.toggleClass('menu-open');


		// Trigger lazy load nav images
		if (!settings.navIsInitialized) {
			app.lazyload.show('navigationImages');
			settings.navIsInitialized = true;
		}
	}

	function toggleMinicart(forceHide, forceShow) {

		if ($cache.miniCart.hasClass('active')) {
			if (!forceShow) {
				$('#addToCartWrapper .submit-button').removeClass('hidden');
				$cache.miniCart.removeClass('active');
				$('#greyOverlay').removeClass('overlay-show');
			}
		} else {
			if (!forceHide) {
				$('#addToCartWrapper .submit-button').addClass('hidden');
				$cache.miniCart.addClass('active');
				$('#greyOverlay').addClass('overlay-show');
			}
		}
	}

	function initializeMinicartEvents() {
		// Show
		$('#cartLink').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			if (Rebuy) {
				Rebuy.SmartCart.show();
			} else {
			}
		});

		$('.js-minicart-close').on('click', function(){
			toggleMinicart();
		});

		// Hide
		// $cache.body.on('click', function (e) {
		$('#greyOverlay').on('click', function (e) {
			toggleMinicart(true);
			toggleSearchBar();
		});
	}

	function toggleSearchBar() {
		$('#searchBar').toggleClass('active');
		$('#greyOverlay').toggleClass('overlay-show');
	}

	function getSearchPhrase() {
		var phrase = $('#searchInputPhrase').val();

		if (phrase.length > 2) {
			sendSearchRequest(phrase);
		}
	}

	function sendSearchAnalyticsEvent() {
		var phrase = $('#searchInputPhrase').val();
		app.analytics.event('mahabis', 'Customer Search', phrase);
	}

	function sendSearchRequest(phrase) {
		var url = "https://mahabis.com/search?view=get.json&q=" + phrase +"&type=product,page&options[unavailable_products]=hide&options[prefix]=last";
		$.ajax({
			url: url,
			type: 'GET',
			beforeSend: function (xhr) {
			},
			success: function (data) {
				var responseData = $.parseJSON(data),
					productsData = responseData["products"],
					pagesData = responseData["pages"];

				if (productsData.length) {
					generateSearchResults(productsData)
				}

				if (pagesData.length) {
					generatePagesSearchResults(pagesData);
				}

				if (pagesData.length && productsData.length) {
					$('#searchResultsTabs').removeClass('hidden')
					$('#searchResultsProducts').removeClass('hidden');
					$('#searchResultsPages').addClass('hidden');
				} else {
					$('#searchResultsTabs').addClass('hidden')
				}

				if (pagesData.length && !productsData.length) {
					$('#searchResultsProducts').addClass('hidden');
					$('#searchResultsPages').removeClass('hidden');
				} else if (!pagesData.length && productsData.length) {
					$('#searchResultsProducts').removeClass('hidden');
					$('#searchResultsPages').addClass('hidden');
				}
			}
		})
	}

	function generateProductTitle(title) {
		var newTitle = "<div class='search-result-title'>" + title + "</div>";

		if (newTitle.indexOf(' in ') > -1) {
			var currentTitleSplitted = title.split(' in ');
			newTitle = "<div class='search-result-title'>" + currentTitleSplitted[0] + "</div><div class='search-result-subtitle'>" + currentTitleSplitted[1] + "</div>";
		}

		return newTitle;
	}

	function generateProductLink(tags, url) {
		var productLink = url,
			tagsArray = tags.split(',');

		$.each(tagsArray, function(index,tag){
			if (tag.indexOf('js-redirect') > -1) {
				var tagSplitted = tag.split('__'),
					productHandle = tagSplitted[1],
					productUpper = tagSplitted[2],
					productColour = tagSplitted[3];

				productLink = '/products/' + productHandle + '?upper=' + productUpper;

				if (productColour) {
					productLink = productLink + '&colour=' + productColour;
				}
			}
		});

		productLink = Theme.shop.baseUrl + productLink;

		return productLink;
	}

	function generatePagesSearchResults(data) {
		var $node = '';

		$.each(data, function(index,page){
			var pageTitle = page.title,
				pageUrl = page.url;

			var pageNode = '<a class="search-result-item search-result-page" href="' + pageUrl + '">' + pageTitle + '</a>';

			$node = $node + pageNode;
		})

		$('#searchResultsPages').html($node);
	}

	function generateSearchResults(data) {
		var $node = '';
		$.each(data, function(index, product){
			var productTitle = generateProductTitle(product.title),
				priceFixedCompare = product["price-fixed-compare-at"],
				priceFixed = product["price-fixed"],
				priceNode = '<span class="is-non-discounted" data-fp="' + priceFixed +'"><span data-fp="' + priceFixed +'">' + product.price + '</span></span>',
				priceNodeCompareAt = product["price-compare-at"] ? '<span class="is-discounted" data-cafp="' + priceFixedCompare +'"><span data-cafp="' + priceFixedCompare +'">' + product["price-compare-at"] + '</span></span>' : '',
				productLink = generateProductLink(product.tags, product.url);
			var productNode = '<a href="' + productLink +'" class="search-result-item">' +
				'<img src="' + product.image + '">' +
				'<div>' + productTitle + '</div>' +
				'<div class="search-result-price">' + priceNodeCompareAt + priceNode +  '</div>' +
				'</a>';

			$node = $node + productNode;
		})

		$('#searchResultsProducts').html($node);

	}

	function initializeSearchEvents() {
		var typingTimer,
			doneTypingInterval = 1500;

		$('#searchToggle').on('click', function(){
			toggleSearchBar()
		})

		$('.js-search-close').on('click', function(){
			toggleSearchBar();
		})

		$('#searchInputPhrase').on('keyup', function(e) {
			var phrase = $('#searchInputPhrase').val();
			clearTimeout(typingTimer);

			if (phrase.length > 3) {
				typingTimer = setTimeout(sendSearchAnalyticsEvent, doneTypingInterval);
			}
			getSearchPhrase();
		});

		$('#searchInputPhrase').on("keydown", function(){
			clearTimeout(typingTimer);
		});

		$('#searchResultProductsTab').on('click', function() {
			$('#searchResultsProducts').removeClass('hidden');
			$('#searchResultsPages').addClass('hidden');
		});

		$('#searchResultPagesTab').on('click', function() {
			$('#searchResultsProducts').addClass('hidden');
			$('#searchResultsPages').removeClass('hidden');
		});
	}

	function initializeNavEvents() {
		$('#main-hdr .dropdown').on('mouseenter', function () {
			$('#main-hdr.no-background').addClass('fill-bg');
		}).on('mouseleave', function () {
			$('#main-hdr.no-background').removeClass('fill-bg');
		});
	}

	function mobileNavigationChange($el) {
		var navigationTitle = $el.html(),
			$dropdown = $('.js-dropdown-category[data-title="' + navigationTitle + '"]'),
			categoriesCount = 0,
			$backContent = $('.js-navigation-backitem'),
			backItemInitialTitle = $backContent.data('initialtitle'),
			node = "";

		$('#navigationPromo').addClass('hidden');

		$dropdown.find('.js-category-link').each(function () {
			var $this = $(this),
				$parent = $this.parent(),
				isThumbnailsCategory = $parent.hasClass('js-submenu-thumbnails'),
				isHorizontalCategory = $parent.hasClass('js-submenu-horizontal'),
				isExpandedCategory = $parent.hasClass('js-submenu-expanded'),
				isAssetCategory = $parent.hasClass('js-submenu-asset'),
				title = $this.html();

			if (isHorizontalCategory) {
				$parent.find('.js-submenu-item').each(function () {
					var $that = $(this),
						isEURcontent = $that.hasClass('currency-eur-content'),
						isGBPcontent = $that.hasClass('currency-gbp-content'),
						isAUDcontent = $that.hasClass('currency-aud-content'),
						isUSDcontent = $that.hasClass('currency-usd-content'),
						link = $that.find('.js-submenu-link').attr('href'),
						content = $that.find('.js-submenu-assetcontent').html(),
						geoContentClass = '',
						image = $that.find('.js-submenu-image').attr('data-src');

					if (isEURcontent) {
						geoContentClass = 'currency-eur-content';
					} else if (isGBPcontent) {
						geoContentClass = 'currency-gbp-content';
					} else if (isUSDcontent) {
						geoContentClass = 'currency-usd-content';
					} else if (isAUDcontent) {
						geoContentClass = 'currency-aud-content';
					}

					node += "<a href='" + link + "' class='navigation-mobile-link navigation-link-fullwidth navigation-link-horizontal js-track-events " + geoContentClass + "' data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + content + "'><div><img class='submenu-asset-image' src='" + image + "' /><span class='submenu-asset-content'>" + content + "</span></div></a>"
				})
			} else if (isAssetCategory) {
				$parent.find('.js-submenu-item').each(function () {
					var $that = $(this),
						isEURcontent = $that.hasClass('currency-eur-content'),
						isAUDcontent = $that.hasClass('currency-aud-content'),
						isGBPcontent = $that.hasClass('currency-gbp-content'),
						isUSDcontent = $that.hasClass('currency-usd-content'),
						link = $that.find('.js-submenu-link').attr('href'),
						content = $that.find('.js-submenu-assetcontent').html(),
						geoContentClass = '',
						image = $that.find('.js-submenu-image').attr('data-src');

					if (isEURcontent) {
						geoContentClass = 'currency-eur-content';
					} else if (isGBPcontent) {
						geoContentClass = 'currency-gbp-content';
					} else if (isUSDcontent) {
						geoContentClass = 'currency-usd-content';
					} else if (isAUDcontent) {
						geoContentClass = 'currency-aud-content';
					}

					node += "<a href='" + link + "' class='navigation-mobile-link navigation-link-fullwidth js-track-events " + geoContentClass + "' data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + content + "'><div><img class='submenu-asset-image' src='" + image + "' /><span class='submenu-asset-content'>" + content + "</span></div></a>"
				})
			} else if (isExpandedCategory) {
				$parent.find('.js-submenu-item').each(function () {
					var $that = $(this),
						isEURcontent = $that.hasClass('currency-eur-content'),
						isGBPcontent = $that.hasClass('currency-gbp-content'),
						isAUDcontent = $that.hasClass('currency-aud-content'),
						isUSDcontent = $that.hasClass('currency-usd-content'),
						link = $that.find('.js-submenu-link').attr('href'),
						content = $that.find('.js-submenu-link span').html(),
						icon = $that.find('.js-submenu-icon').attr('src'),
						label = $that.find('.js-submenu-label'),
						geoContentClass = '',
						image = $that.find('.js-submenu-image').attr('data-src');

					if (isEURcontent) {
						geoContentClass = 'currency-eur-content';
					} else if (isGBPcontent) {
						geoContentClass = 'currency-gbp-content';
					} else if (isUSDcontent) {
						geoContentClass = 'currency-usd-content';
					} else if (isAUDcontent) {
						geoContentClass = 'currency-aud-content';
					}

					node += "<a href='" + link + "' class='navigation-mobile-link js-track-events " + geoContentClass + "' data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + content + "'><span class='submenu-asset-content'>" + content + "</span></a>";

				})
			} else if (isThumbnailsCategory) {
				$parent.find('.js-submenu-item').each(function () {
					var $that = $(this),
						isEURcontent = $that.hasClass('currency-eur-content'),
						isGBPcontent = $that.hasClass('currency-gbp-content'),
						isAUDcontent = $that.hasClass('currency-aud-content'),
						isUSDcontent = $that.hasClass('currency-usd-content'),
						link = $that.find('.js-submenu-link').attr('href'),
						content = $that.find('.js-submenu-link span').html(),
						contentFormatted = content.toLowerCase(),
						icon = $that.find('.js-submenu-icon').attr('src'),
						label = $that.find('.js-submenu-label').html(),
						geoContentClass = '',
						additionalClass = '',
						image = $that.find('.js-submenu-image').attr('data-src');

					if (isEURcontent) {
						geoContentClass = 'currency-eur-content';
					} else if (isGBPcontent) {
						geoContentClass = 'currency-gbp-content';
					} else if (isUSDcontent) {
						geoContentClass = 'currency-usd-content';
					} else if (isAUDcontent) {
						geoContentClass = 'currency-aud-content';
					}

					if (icon) {
						node += "<a href='" + link + "' class='navigation-mobile-link js-track-events " + geoContentClass + "' data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + content + "'><img src='" + image + "' class='submenu-asset-image'/><span class='submenu-asset-content'>" + content + "</span><img class='nav-img-svg' src='" + icon + "' /></a>";
					} else if (label) {
						node += "<a href='" + link + "' class='navigation-mobile-link js-track-events " + geoContentClass + "' data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + content + "'><img src='" + image + "' class='submenu-asset-image " + additionalClass + "'/><span class='submenu-asset-content'>" + content + "</span><span class='submenu-asset-label'>" + label + "</span></a>";
					} else {
						node += "<a href='" + link + "' class='navigation-mobile-link test js-track-events " + geoContentClass + "'  data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + content + "'><img src='" + image + "' class='submenu-asset-image " + additionalClass + "'/><span class='submenu-asset-content'>" + content + "</span></a>";
					}
				})
			} else if (title === "Shop accessories") {
				node += "<div class='navigation-mobile-link js-navigation-category js-track-events '  data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + title + "' data-backtitle='" + navigationTitle + "'><img src='//cdn.mahabis.com/website/navigation/nav-men-accessories.jpg' class='submenu-asset-image' />" + title + "</div>";
			} else {
				node += "<div class='navigation-mobile-link js-navigation-category js-track-events '  data-event-category='Navigation' data-event-action='" + navigationTitle + "' data-event-label='" + title + "' data-backtitle='" + navigationTitle + "'>" + title + "</div>";
			}

			categoriesCount++
		});

		$backContent.html(backItemInitialTitle);

		// Transition
		$('#navigationDropdown').addClass('is-invisible');

		if (categoriesCount === 1) {
			$('#navigationCategories').html(node);
			var $categorySingleEl = $('#navigationCategories').find('.js-navigation-category');
			$('#navigationBack').addClass('is-active').attr('data-step', 'links');
			mobileCategoryChange($categorySingleEl, true);
		} else {
			$('#navigationCategories').html(node).removeClass('is-invisible');
			$('#navigationBack').addClass('is-active').attr('data-step', 'category');
		}

		// Replace view all to top
		$('.navigation-mobile-link').each(function(){
			var content = $(this).find('.submenu-asset-content').text().toLowerCase();

			if (content === "view all") {
				$(this).parent().prepend(this);
			}
		})
	}

	function mobileCategoryChange($el, isCategorySkipped) {
		var categoryTitle = $el.text(),
			backTitle = $el.attr('data-backtitle'),
			$category = $('.js-dropdown-category[data-title="' + backTitle + '"]').find('.js-category-link[data-title="' + categoryTitle + '"]'),
			$submenu = $category.parents('.js-shop-submenu'),
			isThumbnailMenu = $submenu.hasClass('is-submenu-thumbnails'),
			isAssetMenu = $submenu.hasClass('is-submenu-asset'),
			node = "";

		$('#navigationMobile').scrollTop(0);

		$category.siblings('.submenu-list').find('.js-submenu-link').each(function () {
			var $this = $(this),
				geoContentClass = null,
				title = $this.data('title'),
				img = $this.find('.js-submenu-image').attr('src'),
				isEURcontent = $this.hasClass('currency-eur-content'),
				isGBPcontent = $this.hasClass('currency-gbp-content'),
				isAUDcontent = $this.hasClass('currency-aud-content'),
				isUSDcontent = $this.hasClass('currency-usd-content'),
				link = $this.attr('href'),
				containerClass = "navigation-mobile-link";
			content = "<span class='submenu-asset-content'>" + title + "</span>";

			if (isEURcontent) {
				geoContentClass = 'currency-eur-content';
			} else if (isGBPcontent) {
				geoContentClass = 'currency-gbp-content';
			} else if (isUSDcontent) {
				geoContentClass = 'currency-usd-content';
			} else if (isAUDcontent) {
				geoContentClass = 'currency-aud-content';
			}

			if (isThumbnailMenu) {
				content = '<img class="submenu-asset-image" src="' + img + '" />' + content;
			} else if (isAssetMenu) {
				content = '<div><img class="submenu-asset-image" src="' + img + '" />' + content + '</div>';
				containerClass += " navigation-link-fullwidth";
			}

			node += '<a href="' + link + '" class="' + containerClass + ' ' + geoContentClass + '">' + content + '</a>'
		});

		// Transition

		$('.js-navigation-backitem').html(backTitle);

		if (isCategorySkipped) {
			$('#navigationCategories').removeClass('is-invisible is-prev');
			$('#navigationBack').attr('data-step', 'category');
		} else {
			$('#navigationCategories').addClass('is-prev');
			$('#navigationLinks').html(node).removeClass('is-invisible');
			$('#navigationBack').attr('data-step', 'links');
		}
	}

	function mobileNavigationBack($el) {
		var $backContent = $('.js-navigation-backitem'),
			navigationStep = $el.attr('data-step'),
			initialTitle = $backContent.data('initialtitle');

		if (navigationStep === "category") {
			$('#navigationBack').removeClass('is-active');
			$('#navigationDropdown').removeClass('is-invisible');
			$('#navigationCategories, #navigationLinks').addClass('is-invisible').removeClass('is-prev');
			$('#navigationPromo').removeClass('hidden');
		} else if (navigationStep === "links") {
			$backContent.html(initialTitle);
			$('#navigationBack').attr('data-step', 'category');
			$('#navigationCategories').removeClass('is-prev');
			$('#navigationLinks').addClass('is-invisible');
		}
		$('#navigationMobile').scrollTop(0);
	}

	function closeNavigation($el) {
		if ($el) {
			$el.parents('.js-accordion-dropdown').find('.js-dropdown-link').trigger('click');
		} else {
			$('.js-accordion-dropdown.is-active').find('.js-dropdown-link').trigger('click');
		}
	}

	function triggerHeaderRedirect(link) {
		if (link) {
			window.location.href = link;
		}
	}

	function showHeaderBar() {
		if (Shopify.country == "GB" || Shopify.country == "US") {
			$('#headerBarLink').removeClass('hidden');
		}
	}

	function initializeHeaderBar() {
		showHeaderBar();
	}

	function setNavGeoLinks() {
		if (Shopify.country == "GB") {
			$('.js-shop-menu').find('.currency-gbp-content').removeClass('hidden');
		}
	}

	function initializeNavGeoLink() {
		setNavGeoLinks();
	}

	function addToCartToggle($el, isCollectionTrigger) {
		if (app.product.data.type === 'giftcard') {
			var currentPrice = $('#giftPriceWrapper').find('.money').html().replace('.', '').replace(',', '').match(/\d+/)[0] / 100;
		} else if (app.product.data.type === 'wholesale') {
			var currentPrice = parseFloat($('#bundlePrice').find('.money:not(.money-discount)').html().replace('.','').replace(',','').match(/\d+/)[0]).toFixed(2);
		} else if ($el) {
			var currentPrice = parseFloat($el.find('.money:not(.money-discount)').html().replace('.','').replace(',','').match(/\d+/)[0] / 100).toFixed(2);
		} else {
			var currentPrice = parseFloat($('#bundlePrice').find('.money:not(.money-discount)').html().replace('.','').replace(',','').match(/\d+/)[0] / 100).toFixed(2);
		}

		var	currentSize = $('#sizeSelection').find('.selected').data('size-eu') || $('#sizeSelection').find('.selected').text(),
			currentTitle = $('#productSubtitle').html(),
			currentColour = $('#legend-upper').html(),
			cartSubtotal = parseFloat($('.minicart-sub').html().replace('.','').replace(',','').match(/\d+/)[0] / 100),
			cartSubtotalString = parseFloat($('.minicart-sub').html().replace('.','').replace(',','').match(/\d+/)[0] / 100).toFixed(2),
			cartCurrency = $('.minicart-sub').html().replace(cartSubtotalString,''),
			newCartName = currentTitle,
			newCartSubtotal = parseFloat(cartSubtotal + currentPrice).toFixed(2),
			newCartSubtotalNode = "<span class='money'>" + cartCurrency + newCartSubtotal + "</span>";

		if (currentColour) {
			newCartName = newCartName + ' ' + currentColour;
		}

		var lineItemNode = "<div class='item item-fake clearfix'>" +
			"<div class='image-wrap is-loading js-cartitem-dynamic'>" +
			"<img src='//cdn.shopify.com/s/files/1/0238/5795/files/bg-white.png?v=1660043639' />" +
			"</div>" +
			"<div class='details'>" +
			"<p class='title'><a href='#'></a></p>" +
			"<p class='variant'></p>" +
			"<p class='count'></p>" +
			"<p class='line-item-price'></p>" +
			"</div>" +
			"</div>"

		$('#minicartItems').prepend(lineItemNode);
		// $('.minicart-sub').html(newCartSubtotalNode);
		$('.js-cart-subtotal-actions .js-checkout-btn-default').removeClass('hidden').addClass('loading').prop('disabled', true);

		if (isCollectionTrigger) {
			toggleMinicart(false, true);
		} else {
			toggleMinicart();
		}
	}

	function calculateMultiCurrencySubtotal(items) {
		var country = Shopify.country;

		if (Theme.page.template === 'collection') {
			var	priceCurrency = $('.clp-collection-item-price').html().replace(/[0-9]+/g, '').replace('.', '');
		} else {
			var	priceCurrency = $('#bundlePrice').find('.money').html().replace(/[0-9]+/g, '').replace('.', '');
		}

		var	subtotalPricesArray = [],
			subtotalCurrenciesArray = [],
			subtotalSumPricesArray = [],
			subtotalDataFp = '',
			subtotalFinalPrice = 0,
			subtotalNewFixPrices = [];

		$.each(items, function(key, item){
			var fixedPrices = item["price-fixed"],
				fixedPricesCompareAt = item["price-fixed-compare-at"],
				quantity = parseInt(item.quantity),
				fixedPricesArray = fixedPrices.replace(/\'/g,"").replace(/\"/g,"").replace('{', '').replace('}', '').split(','),
				newCurrenciesArray = [],
				newPricesArray = [];

			$.each(fixedPricesArray, function(key2, arrItem) {
				var splittedPrice = arrItem.split(':'),
					currency = splittedPrice[0],
					price = splittedPrice[1],
					newPrice = parseFloat(price) * quantity;

				newCurrenciesArray.push(currency);

				newPricesArray.push(newPrice);
			});

			subtotalCurrenciesArray = newCurrenciesArray;
			subtotalPricesArray.push(newPricesArray);
		});

		$.each(subtotalPricesArray, function(key1, value1){
			$.each(value1, function(key2, value2){
				subtotalSumPricesArray[key2] = subtotalSumPricesArray[key2] ? subtotalSumPricesArray[key2] : 0;
				subtotalSumPricesArray[key2] += value2;
			});
		});

		$.each(subtotalCurrenciesArray, function(key, value){
			var newFixPrice = "'" + value + "':" + subtotalSumPricesArray[key];
			subtotalNewFixPrices.push(newFixPrice);
			console.log(value);
			if (value === country) {
				subtotalFinalPrice = parseFloat(subtotalSumPricesArray[key]).toFixed(2);
			}
		});

		$.each(subtotalNewFixPrices, function(key, value){
			if (key === 0) {
				subtotalDataFp = value;
			} else {
				subtotalDataFp = subtotalDataFp + ',' + value;
			}
		});

		var subtotalNode = '<span class="money" data-fp="' + subtotalDataFp +'">' + priceCurrency + subtotalFinalPrice + '</span>';

		return subtotalNode;
	}

	function updateCartSubtotals(data) {
		var cartData = $.parseJSON(data),
			country = Shopify.country,
			subtotal = cartData["total"];

		$('.js-minicart-sub-total').html(subtotal);
	}

	function getCartData(forceTotalsUpdate) {
		$.ajax({
			url: '/cart?view=get.json',
			type: 'get',
			beforeSend: function () {
			},
			success: function (cartData) {
				var data = $.parseJSON(cartData),
					itemFromNonDiscountedCollection = 0,
					fullPriceItems = 0;

				$('#minicartItems').html('');

				updateCartSubtotals(cartData);

				$.each(data.items, function(index, itemData){
					var price = itemData["price-fixed"],
						priceCompareAt = itemData["price-fixed-compare-at"],
						isDiscounted = itemData["isDiscounted"],
						priceFinal = itemData["priceFinal"],
						itemImage = itemData["image"],
						priceFreeFP = "{'US':0,'AT':0,'AU':0,'NZ':0,'BE':0,'EE':0,'FI':0,'FR':0,'DE':0,'IE':0,'IT':0,'LV':0,'LT':0,'LU':0,'NL':0,'PT':0,'SK':0,'SI':0,'ES':0}",
						isNonDiscountedCollection = itemData["isNotDiscountedCollection"],
						priceNodeCompareAt = '<span class="is-discounted" data-cafp="' + priceCompareAt +'"><span data-cafp="' + priceCompareAt +'">' + itemData["price-compare-at"] + '</span></span>';
					priceNode = '<span data-fp="' + price +'"><span data-fp="' + price +'">' + itemData.price + '</span></span>';

					if (priceCompareAt === price) {
						priceNodeCompareAt = '';
					}

					if (isDiscounted === "false") {
						fullPriceItems = fullPriceItems + parseInt(itemData["quantity"]);
					}

					if (priceFinal === "0") {
						priceNode = '<span data-fp="' + priceFreeFP +'"><span data-fp="' + priceFreeFP +'">' + itemData.price + '</span></span>';
					}

					if (isNonDiscountedCollection === "true") {
						itemFromNonDiscountedCollection = itemFromNonDiscountedCollection + parseInt(itemData["quantity"]);
					}

					// Customizer product
					if (itemData["property-dku"]) {
						itemImage = app.customizer.imagesCartUrl + '?' + itemData["property-params"];
					}

					var lineItemNode = "<div class='item clearfix js-minicart-item'>" +
						"<div class='image-wrap'>" +
						"<img src='" + itemImage + "' />" +
						"</div>" +
						"<div class='details'>" +
						"<p class='title'><a href='#'>" + itemData.title + "</a></p>" +
						"<p class='variant'>" + itemData.variant + "</p>" +
						"<p class='count-wrapper'>" +
						"<span class='quantity js-quantity-wrapper' data-product-id='" + itemData.id + "'>" +
						"<span class='quantity-selector selector-minus js-quantity-change' data-change='reduce'></span>" +
						"<span class='count js-quantity-amount'>" + itemData.quantity + "</span>" +
						"<span class='quantity-selector selector-plus js-quantity-change' data-change='increase'></span>" +
						"</p>" +
						"<p class='line-item-price'>" + priceNode + "</p>" +
						"</div>" +
						"</div>";

					$('#minicartItems').append(lineItemNode);
					$('.js-cart-subtotal-actions .js-checkout-btn-default').removeClass('loading').prop('disabled', false);
				});

				setDynamicMinicartNote(itemFromNonDiscountedCollection);

				if (fullPriceItems > 1) {
					$('.js-discount-not-applied').addClass('hidden');
					$('.js-discount-applied').removeClass('hidden');
				} else {
					$('.js-discount-not-applied').removeClass('hidden');
					$('.js-discount-applied').addClass('hidden');
				}
			}
		});
	}

	function setDynamicMinicartNote(amount) {
		$('#cartDynamicNote').fadeOut(function(){
			$('.cart-dynamic-note').addClass('hidden');
			if (amount === 1) {
				$('#cart-custom-note-1').removeClass('hidden');
			} else if (amount === 2) {
				$('#cart-custom-note-2').removeClass('hidden');
			} else if (amount > 2) {
				$('#cart-custom-note-3').removeClass('hidden');
			}
			$('#cartDynamicNote').fadeIn();
		});
	}


	function minicartQuantityChange(el) {
		var changeDirection = el.attr('data-change'),
			productId = el.parents('.js-quantity-wrapper').attr('data-product-id'),
			quantity = parseInt(el.siblings('.js-quantity-amount').text()),
			totalQuantity = parseInt($('.js-minicart-count').text()),
			submitData = null;

		if (changeDirection === 'increase') {
			quantity = quantity + 1;
			totalQuantity = totalQuantity + 1;
		} else if (changeDirection === 'reduce') {
			quantity = quantity - 1;
			totalQuantity = totalQuantity - 1;
		}

		submitData = "updates[" + productId + "]=" + quantity;

		$.ajax({
			url: '/cart/update.js',
			dataType: 'json',
			type: 'post',
			data: submitData,
			beforeSend: function () {
				el.parents('.js-minicart-item').addClass('is-loading');
			},
			success: function (itemData) {
				$('.js-minicart-count').html(totalQuantity);
				getCartData(true);
			}
		});
	}

	function updateMinicartAmount() {
		var currentAmount = 	parseInt($('.js-minicart-count').html()),
			newAmount =  currentAmount + 1;

		$('.js-minicart-count').html(newAmount);

	}

	function triggerSubmenuNav($el) {
		var $parent = $el.parent();

		$parent.siblings().removeClass('is-expanded');
		$parent.addClass('is-expanded')
	}

	function addSubmenuContent($el) {
		var $content = $el.parents('.js-dropdown-category').parent().find('.js-shop-menu-innercontent'),
			submenuContent = $el.next().html();

		$content.html(submenuContent);
	}

	function mobileNavigationExpand($el) {
		var $menu = $el.parent();
		// reset states
		$menu.siblings().removeClass('is-opened')
		$menu.siblings().find('.js-navigation-submenus').addClass('is-collapsed');

		$menu.find('.js-navigation-submenus').toggleClass('is-collapsed');
		$menu.toggleClass('is-opened');

		$('#navigationMobile').scrollTop(0);
	}

	function mobileSubNavigationExpand($el) {
		var $menu = $el.parent();
		$menu.find('.js-navigation-submenus-second').toggleClass('is-collapsed');
		$menu.toggleClass('is-opened');
		// $('#navigationDropdown, #navigationMobile').scrollTop(0);
	}

	/**
	 * @private
	 * @function
	 * @description Initialize header DOM
	 **/
	function initializeDOM() {
		initializeNavImages();
		showBrandMsg();
		initializeMinicartEvents();
		initializeNavEvents();
		initializeSearchEvents();
		initializeHeaderBar();
		initializeNavGeoLink();
	}

	/**
	 * @private
	 * @function
	 * @description Initialize header events
	 **/
	function initializeEvents() {

		$('#headerBarLink li').on('click', function() {
			triggerHeaderRedirect($(this).attr('data-href'));
		});

		// Navigation tablet close fix
		$(document).on('touchstart', function (event) {
			triggerTabletNavFix(event);
		});

		$(document).on('scroll', function () {
			app.ui.scrollTop = $(this).scrollTop();
			headerDynamicBackground(app.ui.scrollTop);
			app.page.animateElements(app.ui.scrollTop);
			app.page.lazyVideoLoad(app.ui.scrollTop);

			if (app.ui.scrollTop > 50 && !app.page.zendeskInited) {
				// app.page.initZenDesk()
			}

			if (app.ui.scrollTop > 50 && !app.page.iubendaInited) {
				setTimeout(function () {
					//app.page.initIubenda();
				}, 3000);
			}

			if (app.ui.scrollTop > 70 && app.page.template === 'homepage' && !app.page.homeproductCarouselInited) {
				app.page.initHomeProductCarousel();
			}

			if (app.ui.scrollTop > 100 && (app.page.template === 'homepage' || app.page.template === 'pdp')  && !app.paralax.inited) {
				app.paralax.initImages();
			}
		});

		$('.js-lazy-hover').on('mouseenter touchend', function () {
			$(this).find('.js-lazy-show').each(function () {
				var $this = $(this),
					src = $this.attr('data-original');
				$this.attr('src', src);
			});
		});

		$cache.mobileNav.on('click', function () {
			toggleMobileNav();
		});

		$('.js-navigation-dropdown-button').on('click', function () {
			mobileNavigationExpand($(this));
		});

		$('.js-navigation-submenus-toggle').on('click', function(){
			mobileSubNavigationExpand($(this));
		})

		$('.js-navigation-dropdown').on('click', function () {
			// mobileNavigationExpand($(this));
			// mobileNavigationChange($(this));
		});

		$('.js-category-link').on('click', function(){
			triggerSubmenuNav($(this));
			addSubmenuContent($(this));
		})

		$('.js-navigation-mobile').on('click', '.js-navigation-category', function () {
			mobileCategoryChange($(this));
		});

		$('.js-submenu-close').on('click', function () {
			closeNavigation($(this));
		});

		$('.js-navigation-close').on('click', function () {
			closeNavigation();
		});

		$('#navigationBack').on('click', function () {
			mobileNavigationBack($(this));
		});

		$('.js-checkout-generate').on('click', function(){
			app.multistore.setCheckoutLinks(true)
		});

		$('#minicartItems').on('click', '.js-quantity-change', function() {
			minicartQuantityChange($(this));
		})
	}

	/**
	 * @private
	 * @function
	 * @description Initialize header cache
	 **/
	function initializeCache() {
		$cache = {
			navigation: $('#hdr-nav'),
			header: $('#main-hdr'),
			body: $('body'),
			miniCart: $('.mini-cart-container'),
			mobileNav: $('#mobile-nav-button')
		}
	}

	function initializeSettings() {
		settings = {
			navIsInitialized: false
		}
	}

	app.header = {
		init: function () {
			initializeCache();
			initializeSettings();
			initializeDOM();
			initializeEvents();
		},
		addToCartToggle: function (el, isCollectionTrigger) {
			addToCartToggle(el, isCollectionTrigger)
		},
		updateMinicartAmount: function() {
			updateMinicartAmount()
		},
		getCartData: function() {
			getCartData();
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.validation
 */
(function (app, $) {

	/**
	 * @private
	 * @function
	 * @description Email validation with .{{domain}}
	 **/
	function initializeEmailValidation() {
		$.validator.addMethod('emailWithDomain', function (val, elem) {
			var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

			if (!filter.test(val)) {
				return false;
			} else {
				return true;
			}
		}, '*');
	}

	/**
	 * @private
	 * @function
	 * @description Initialize validation DOM
	 **/
	function initializeDOM() {
		initializeEmailValidation();
	}

	app.validation = {
		init: function () {
			initializeDOM();
		}
	}

}(window.app = window.app || {}, jQuery));

/**
 * @class app.cart
 */
(function (app, $) {
	var $cache;

	/**
	 * @private
	 * @function
	 * @description Update cart items and refresh page after update
	 **/
	function updateCartVariants(items) {
		$.ajax({
			url: '/cart/update.js',
			dataType: 'json',
			type: 'post',
			data: items,
			success: function (itemData) {
				window.parent.location.reload();
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Fix cart actions css height
	 **/
	function cartActionsFix() {
		if ($('.cart-items').outerHeight() < $('.cart-subtotal').outerHeight()) {
			$('.cart-details').css('clear', 'both');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Detect Gift wrap id by type/size
	 **/
	function getGiftwrapData(type, size, isStock) {
		var giftId = '',
			giftAvailable = true;

		$('#giftwrapVariants').find('.js-giftwrap-variants').each(function () {
			var $this = $(this),
				giftType = $this.data('type'),
				giftSize = $this.data('sizes');

			if (giftType === type) {
				if (giftSize.indexOf(size) > -1) {
					giftId = $this.data('id');
					giftAvailable = $this.data('quantity') > 0;

					// if (giftAvailable) {
					return false;
					// }

				}
			}
		});

		if (isStock) {
			return giftAvailable;
		} else {
			return giftId;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Change gift wrap quantity
	 **/
	function giftwrapChange(ajaxUrl, giftQuantity, giftId, productSku) {
		$.ajax({
			url: ajaxUrl,
			dataType: 'json',
			type: 'post',
			data: {
				quantity: giftQuantity,
				id: giftId,
				properties: {
					'Gift wrap': productSku
				}
			},
			success: function () {
				window.parent.location.reload();
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Add/Remove gift wrap AJAX
	 **/
	function giftwrapAdd(el) {
		var isGiftWrapped = el.hasClass('js-giftwrap-added'),
			ajaxUrl = '/cart/add.js',
			productSKU = el.data('product-sku'),
			productType = el.data('product-type'),
			giftWrapQuantity = el.data('product-quantity'),
			productSize = el.data('product-size'),
			giftwrapId = getGiftwrapData(productType, productSize);

		// If giftwrap already added
		if (isGiftWrapped) {
			giftWrapQuantity = 0;
			ajaxUrl = '/cart/change.js';
		}

		giftwrapChange(ajaxUrl, giftWrapQuantity, giftwrapId, productSKU);
	}

	/**
	 * @private
	 * @function
	 * @description Check gift wrap stock to show/hide action button
	 **/
	function giftwrapCheckStock() {
		$('.js-giftwrap-add').each(function () {
			var $this = $(this),
				productType = $this.data('product-type'),
				productSize = $this.data('product-size'),
				giftwrapAvailable = getGiftwrapData(productType, productSize, true);

			if (giftwrapAvailable) {
				$this.removeClass('hidden');
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description YML upsell initialize
	 **/
	function initializeYMLcarousel() {
		var $cartYmlCarousel = $('#cartYmlCarousel').owlCarousel({
			items: 3,
			loop: true,
			lazyLoad: true,
			nav: true,
			dots: false,
			margin: 0,
			responsive: {
				600: {
					items: 5,
					center: false
				}
			},
			navText: ["<i class='chevron left'></i>", "<i class='chevron right'></i>"]
		}).on('changed.owl.carousel', function (event) {
			app.analytics.event('Cart Upsell', 'Slide changed');
		});
	}

	/**
	 * @private
	 * @function
	 * @description Add product to cart from inline attributes
	 **/
	function addInlineProduct(el) {
		var id = el.data('variant-id');
		Shopify.addItem(id, 1, true);
	}

	/**
	 * @private
	 * @function
	 * @description Show warning message when one item is out of stock
	 **/
	function showOutOfStockMsg(attr) {
		if (!attr && $cache.oosMessage.length) {
			$cache.oosMessage.removeClass('hidden');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Check stock for each line item
	 **/
	function getLineItemsStock() {
		$('.cart-item-row').each(function () {
			var $this = $(this),
				productType = $this.find('.skuLink').attr('data-type'),
				sku = $this.find('.skuLink').data('sku');

			if (productType !== 'Gift Card' && productType !== 'wholesale') {
				var inStock = app.stock.get(sku);
				showOutOfStockMsg(inStock);

				if (!inStock) {
					var terms = app.stock.getTerms(sku);
					$this.find('.cart-oos-mesage').removeClass('hidden');
					$this.find('.cart-oos-terms');
				}
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Cart stock initialize
	 **/
	function initializeCartStock() {
		if (app.stock.initialized) {
			getLineItemsStock();
		} else if (app.cart.stockRetryAmount < 20) {
			app.cart.stockRetryAmount++;
			setTimeout(initializeCartStock, 1000);
		}
	}

	function showCarriersList(carriers) {
		var carriersFound = false;

		$.each(carriers, function (key, value) {
			var carrier = value.toLowerCase().replace(/ /g, '');
			$cache.carriersList.find('li[data-carrier="' + carrier + '"]').addClass('is-visible');
			carriersFound = true;
		});

		carriersFound ? $cache.carriersList.removeClass('hidden') : null
	}

	/**
	 * @private
	 * @function
	 * @description Cart upsell initialize logic
	 **/
	function initializeCartPromotion() {
		var promotionItemSku = ['MB-F-TO-SW', 'MB-F-FB-WH', 'MB-F-KM-SW', 'MB-F-MR-SW'],
			itemsAdded = 0,
			isItemInArray = false,
			$promoPopup = $('#modalCartPromotion');

		$('.cart-item-row').each(function () {
			var itemSku = $(this).data('item-sku'),
				itemSkuSplitted = itemSku.split('-'),
				itemSkuFormatted = itemSkuSplitted[0] + '-' + itemSkuSplitted[1] + '-' + itemSkuSplitted[3] + '-' + itemSkuSplitted[4],
				isItemFound = $.inArray(itemSkuFormatted, promotionItemSku);

			if (isItemFound !== -1) {
				isItemInArray = true
			}

			itemsAdded++
		});

		if ($promoPopup.length) {
			showPromotionPopup();
		}
	}

	function showPromotionPopup() {
		var timeToOpen = 3000;

		setTimeout(function () {
			app.popup.open('modalCartPromotion');
		}, timeToOpen);
	}

	function getLastItemSize(type) {
		var lastSizeInCart = $('#cartLastItemSize').html(),
			newSize = null;

		if (type === "socks") {
			if (lastSizeInCart >= 35 && lastSizeInCart <= 38) {
				newSize = 'SM';
			} else if (lastSizeInCart >= 39 && lastSizeInCart <= 42) {
				newSize = 'MD';
			} else if (lastSizeInCart > 42) {
				newSize = 'LR'
			}
		} else {
			newSize = lastSizeInCart;
		}

		return newSize
	}

	function setYMLSizing() {
		$('.js-yml-dynamicsize').each(function(){
			var $this = $(this),
				sku = $this.data('product-sku'),
				type = $this.data('product-type'),
				skuSplitted = sku.split('-'),
				lastItemSize = getLastItemSize(type),
				newVariant = null;
			newSku = '';

			skuSplitted[2] = lastItemSize;
			newSku = skuSplitted.join('-');
			newVariant = app.multistore.data.variants[newSku]["variant-gbp"];
			// console.log(app.stock.data[newSku]);

			$this.attr('data-product-sku', newSku);
			$this.attr('data-variant-id', newVariant);

			if (app.stock.data[newSku] < 1) {
				$this.addClass('is-outstock').html('out of stock');
			}
		})
	}

	function initializeYMLSizing() {
		if (app.multistore.initialized && app.stock.initialized)  {
			setYMLSizing();
		} else {
			setTimeout(function () {
				initializeYMLSizing();
			}, 500);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize cart cache
	 **/
	function initializeCache() {
		$cache = {
			oosMessage: $('#oneItemOOS'),
			carriersList: $('#carriersList')
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize cart DOM
	 **/
	function initializeDOM() {
		initializeCartStock();
		cartActionsFix();
		giftwrapCheckStock();
		initializeYMLcarousel();
		initializeYMLSizing();
		initializeCartPromotion();
		app.delivery.getCountriesList();
	}

	function initializeEvents() {
		$('.js-giftwrap-add').on('click', function () {
			giftwrapAdd($(this));
		});

		$('.js-inline-productadd').on('click', function () {
			addInlineProduct($(this));
		});

		$('#discountCodeInput').on('keyup', function (e) {
			app.multistore.updateCheckoutLinks();
		});
	}

	app.cart = {
		init: function () {
			initializeCache();
			initializeDOM();
			initializeEvents();
		},
		updateCartVariants: function (items) {
			updateCartVariants(items);
		},
		stockRetryAmount: 0,
		showCarriersList: function (carriers) {
			showCarriersList(carriers);
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.page
 */
(function (app, $) {
	var $cache;

	/**
	 * @private
	 * @function
	 * @description Get page link
	 **/
	function getPageURL() {
		app.page.url = window.location;
	}

	/**
	 * @private
	 * @function
	 * @description Get page query parameters
	 **/
	function getPageParameters() {
		app.page.params = app.page.url.search.substring(1);
	}

	/**
	 * @private
	 * @function
	 * @description Get shop url from liquid
	 **/
	function getShopUrl() {
		app.page.shopUrl = Theme.shop.url;
	}

	/**
	 * @private
	 * @function
	 * @description Get product images URL
	 **/
	function getProductImagesUrl() {
		app.page.prodImgUrl = Theme.product.imageUrl;
	}

	/**
	 * @private
	 * @function
	 * @description Detect page template
	 **/
	function getPageTemplate() {
		switch (true) {
			case $cache.body.hasClass('template-index'):
				app.page.template = 'homepage';
				break;
			case $cache.body.hasClass('template-product'):
				app.page.template = 'pdp';
				break;
			case $cache.body.hasClass('template-collection'):
				app.page.template = 'plp';
				break;
			case $cache.body.hasClass('template-cart'):
				app.page.template = 'cart';
				break;
			case $cache.body.hasClass('template-customers-login'):
				app.page.template = 'accountlogin';
				break;
			case $cache.body.hasClass('page-delivery-returns'):
				app.page.template = 'delivery';
				break;
			case $cache.body.hasClass('page-delivery'):
				app.page.template = 'delivery';
				break;
			case $cache.body.hasClass('page-returns'):
				app.page.template = 'delivery';
				break;
			case $cache.body.hasClass('template-blog'):
				app.page.template = 'blog';
				break;
			case $cache.body.hasClass('page-blogs'):
				app.page.template = 'blogs';
				break;
			case $cache.body.hasClass('template-article'):
				app.page.template = 'article';
				break;
			case $cache.body.hasClass('template-faq'):
				app.page.template = 'faq';
				break;
			case $cache.body.hasClass('page-mahabis-gift'):
				app.page.template = 'gifting';
				break;
			case $cache.body.hasClass('page-mahabis-gift-confirm'):
				app.page.template = 'gifting-confirm';
				break;
			case $cache.body.hasClass('page-teaser'):
				app.page.template = 'teaser';
				break;
			case $cache.body.hasClass('page-sizing-chart'):
				app.page.template = 'sizeguide';
				break;
			default:
				app.page.template = 'other';
				break;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Redirect page which contains specific tag
	 **/
	function initializePageRedirect() {
		if (app.page.template == 'pdp' && Theme.product.redirectTag && app.page.params.indexOf('noredirect') == -1 && Theme.product.redirectJS) {
			var tag = Theme.product.redirectTag.split('__'),
				collection = tag[1],
				upper = tag[2],
				colour = tag[3],
				url = "/products/" + collection + "?",
				urlUpper = $('#redirectUpper').text() ||  app.utils.getUrlParam('upper'),
				urlColour = $('#redirectColour').text() ||  app.utils.getUrlParam('colour'),
				variant = app.utils.getUrlParam('variant'),
				gtin8 = Microdata.gtin8;

			// console.log(urlUpper);
			// console.log(urlColour);
			// console.log('---')
			// Upper param
			if (urlUpper) {
				url += "upper=" + urlUpper;
			} else {
				url += "upper=" + upper;
			}

			// Colour param
			if (urlColour) {
				url += "&colour=" + urlColour;
			} else if (colour) {
				url += "&colour=" + colour;
			}

			// Variant (Merchant Feed)
			if (variant) {
				url += "&variant=" + variant;
			}

			if (gtin8) {
				url += "&gtin8=" + gtin8;
			}


			// console.log(url);


			// similar behavior as an HTTP redirect
			if (url.indexOf("flow-slippers") > -1 ||
				url.indexOf("outdoor-slippers") > -1 ||
				url.indexOf('outlet-slippers?upper=sb&colour=sb') > -1 ||
				url.indexOf('outlet-slippers?upper=lw&colour=fb') > -1
			){
				window.location.replace(url);
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Capture CJ events to store in cookies
	 **/
	function initializeCjEvents() {
		var cjEventValue = app.utils.getUrlParam('cjevent');
		if (cjEventValue) {
			Cookies.set('cjEvent', cjEventValue, {
				domain: '.mahabis.com',
				expires: 15
			});
		}

	}

	/**
	 * @private
	 * @function
	 * @description Show popup on url parameter
	 **/
	function initializeParameterPopup() {
		var popupName = app.utils.getUrlParam('modalshow');

		if (!app.popup.initialized) {
			app.popup.init()
		}
		if (popupName) {
			app.popup.open(popupName, false);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Lazy load instagram photos
	 **/
	function initializeInstaImg() {
		// Instagram photos add links
		$('#insta-bar').on('scroll', function () {
			var $wrapper = $('#insta-bar'),
				isAllImagesLoaded = $wrapper.hasClass('is-loaded');
			if (!isAllImagesLoaded) {
				$wrapper.find('img').each(function () {
					var $img = $(this),
						isImageLoaded = $img.hasClass('js-lazy-loaded');
					if (!isImageLoaded) {
						var imgSrc = $img.data('original');
						$img.attr('src', imgSrc);
					}
				});
				$wrapper.addClass('is-loaded').unbind('scroll');
			}
		});
	}

	function animateElements(position) {
		var scrollViewPosition = position + $cache.windowHeight,
			$element = $('#insta-bar');
		if ($element.length) {
			var elementHeight = $element.outerHeight() / 2,
				elementViewPosition = $element.offset().top + elementHeight;
			if (scrollViewPosition > elementViewPosition) {
				$element.addClass('in-viewport')
			}
		}
	}

	function lazyVideoLoad(position) {
		var scrollViewPosition = position + $cache.windowHeight;

		$('.js-homegrid-video').each(function(){
			var $this = $(this);
			if ($this.length) {
				var elementViewPosition = $this.offset().top - 600;
				if ((scrollViewPosition > elementViewPosition) && !$this.hasClass('is-loaded')) {
					var originSource = $this.find('source').attr('data-original'),
						originSourceMobile = $this.find('source').attr('data-original-mobile'),
						videoSource = originSource;

					if (app.ui.isMobile()) {
						videoSource = originSourceMobile;
					}

					$this.addClass('is-loaded');
					$this.find('source').attr('src', videoSource);
					$this.load();
				}
			}
		})
	}

	function initZenDesk() {
		var page = app.page.template,
			existingScript = document.getElementById('ze-snippet'),
			isAvailablePage = page === 'homepage' || page === 'plp' || page === 'pdp' || page === 'delivery';

		if (!existingScript && isAvailablePage) {
			var script = document.createElement('script');
			script.src = 'https://static.zdassets.com/ekr/snippet.js?key=7bc2a081-66cf-4ce6-bed7-7b55d4726c86';
			script.id = 'ze-snippet';
			script.defer = 'defer';
			document.body.appendChild(script);
			app.page.zendeskInited = true
		}
	}

	function initIubenda() {
		var existingScript = document.getElementById('iubenda-snippet');

		if (!existingScript) {
			var script = document.createElement('script');
			script.src = 'https://cdn.iubenda.com/cs/iubenda_cs.js';
			script.id = 'iubenda-snippet';
			script.defer = 'defer';
			document.body.appendChild(script);
			app.page.iubendaInited = true;
		}
	}

	function initHomeProductCarousel() {
		$('.js-homeproduct-wrapper').each(function(){
			var $img = $(this).find('img'),
				lazyImage = $img.data('src');

			$img.attr('src', lazyImage);

		});
		app.page.homeproductCarouselInited = true
	}

	function initGiftingPage() {
		var isGifting = app.utils.getUrlParam('ig');

		if (isGifting) {
			$('body').addClass('is-gifting');
			$('#logo-m').attr('href', '#');
			$('#insta-bar img').attr('data-pageurl', '');

			// check verify
			var requestUrl = "https://store-live-api.mahabis.io/v1/gift-authenticate",
				productUrl = window.location.pathname.split('/').splice(-1,1).toString(),
				orderId = app.utils.getUrlParam('order_id'),
				auth = app.utils.getUrlParam('acode'),
				requestBody = {
					"order_id": orderId,
					"acode": auth
				};

			$.ajax({
				url: requestUrl,
				type: 'POST',
				data: JSON.stringify(requestBody),
				dataType: 'json',
				contentType: "application/json",
				beforeSend: function (xhr) {
				},
				success: function (data) {
					app.popup.init();
					app.popup.open('modalMyGiftChoose');

					var productSKU = data.data[0].sku.split('-'),
						skuPrefix = productSKU[0] + '-' + productSKU[1],
						productLink = CollectionLinks[skuPrefix];

					if (data.status !== 'success' || (productLink !== productUrl)){
						$('#product-area').html('');
						$('.footer-tp-reviews').addClass('invisible');
						$('#modalMyGiftChoose .modal-description').html('');
						$('#modalMyGiftChoose .modal-left h2').html('something went wrong');
						$('#modalMyGiftChoose .modal-left h4').html('please try again later, or contact support');
						$('#modalMyGiftChoose .modal-content').html(data.responseJSON.error);
					}
				},
				error: function(data) {
					app.popup.init();
					app.popup.open('modalMyGiftChoose');
					$('#product-area').html('');
					$('.footer-tp-reviews').addClass('invisible');
					$('#modalMyGiftChoose .modal-left h2').html('something went wrong');
					$('#modalMyGiftChoose .modal-left h4').html('please try again later, or contact support');
					$('#modalMyGiftChoose .modal-content').html(data.responseJSON.error);
				}
			})
		}
	}

	function generateGiftLink(data, orderId, auth) {
		var itemSKU = data[0].sku,
			itemSKUSplitted = itemSKU.split('-'),
			skuPrefix = itemSKUSplitted[0] + '-' + itemSKUSplitted[1],
			giftLink = CollectionLinks[skuPrefix],
			giftParam = '?upper=' + itemSKUSplitted[3] + itemSKUSplitted[4];

		if (skuPrefix === 'MC-F') {
			giftParam = '?upper=' + itemSKUSplitted[3] + '&colour=' + itemSKUSplitted[4];
		}

		var redirectLink = '/products/' + giftLink + giftParam.toLowerCase() + '&sku=' + itemSKU +  '&order_id=' + orderId + '&acode=' + auth + '&ig=true';

		window.location.href = redirectLink;
	}

	function initGifting() {
		var requestUrl = "https://store-live-api.mahabis.io/v1/gift-authenticate",
			orderId = app.utils.getUrlParam('order_id'),
			auth = app.utils.getUrlParam('acode'),
			requestBody = {
				"order_id": orderId,
				"acode": auth
			};

		$.ajax({
			url: requestUrl,
			type: 'POST',
			data: JSON.stringify(requestBody),
			dataType: 'json',
			contentType: "application/json",
			beforeSend: function (xhr) {
				// generateGiftLink();
			},
			success: function (data) {
				if (data.status === 'success'){
					generateGiftLink(data.data, orderId, auth);
				} else {
					$('.js-gift-loading').addClass('hidden');
					$('.js-gift-error-container').removeClass('hidden');
					$('.js-gift-error').html(data.error);
				}
			},
			error: function(data) {
				$('.js-gift-loading').addClass('hidden');
				$('.js-gift-error-container').removeClass('hidden');
				$('.js-gift-error').html("(" + data.responseJSON.error + ")");
			}
		})
	}

	function initGiftConfirm() {
		var requestUrl = "https://store-live-api.mahabis.io/v1/gift-accept",
			orderId = app.utils.getUrlParam('order_id'),
			auth = app.utils.getUrlParam('acode'),
			requestBody = {
				"order_id": orderId,
				"acode": auth
			};

		$.ajax({
			url: requestUrl,
			type: 'POST',
			data: JSON.stringify(requestBody),
			dataType: 'json',
			contentType: "application/json",
			beforeSend: function (xhr) {

			},
			success: function (data) {
				if (data.status === 'failure') {
					$('.js-gift-confirm-sucesss').addClass('hidden');
					$('.js-gift-confirm-error').removeClass('hidden');
					$('.js-gift-error').html(data.error);
				}
			},
			error: function(data) {
				$('.js-gift-confirm-sucesss').addClass('hidden');
				$('.js-gift-confirm-error').removeClass('hidden');
				$('.js-gift-loader').addClass('hidden');
				$('.js-gift-error').html("(" + data.responseJSON.error + ")");
			}
		})
	}

	function initTrustpilotReviews() {
		$('.trustpilot-widget').appendTo('#trustpilotReviews');
	}

	function initDynamicSizeGuide() {
		var selectedCountry = Shopify.country,
			selectedSizeType = "eu";

		if (selectedCountry === "US") {
			selectedSizeType = "us";
		} else if (selectedCountry === "AU") {
			selectedSizeType = "au";
		} else if (selectedCountry === "GB") {
			selectedSizeType = "uk";
		}

		$('.js-shopsize').each(function(){
			var $this = $(this),
				sizeAttrEu = $this.attr('data-size-eu'),
				currentLink = $this.find('a').attr('href'),
				newLink = currentLink + '&size=' + sizeAttrEu,
				sizeAttr = 'data-size-' + selectedSizeType,
				newValue = $this.attr(sizeAttr);

			$this.find('a').attr('href', newLink);
			$this.find('.js-shopsize-value').html(newValue);
		})
	}

	function resetRebuyDiscountCode() {
		var discountCodeApplied = localStorage.getItem('discount_code');

		if (discountCodeApplied) {
			var discountCodeValue = discountCodeApplied,
				discountCodeConfig = 'discount_code-' + discountCodeValue;

			localStorage.removeItem('discount_code');
			localStorage.removeItem(discountCodeConfig);
		}
	}

	function initVideoSliderEvents() {
		var $videoCarousel = $('.mn-video-slider');

		$videoCarousel.owlCarousel({
			items: 4,
			margin: 20,
			loop:true,
			nav: false,
			dots: true,
			stagePadding: 100,
			responsive: {
				0: {
					items: 1
				},
				1000: {
					items: 4
				}
			}
		}).on('changed.owl.carousel', function (property) {
			var screenSize = $(window).width();
			if (screenSize < 769) {
				var $target = $(property.target),
					currentSlide = property.item.index,
					$videoNext = $target.find(".owl-item").eq(currentSlide + 1).find('video');
					$videoPrev = $target.find(".owl-item").eq(currentSlide - 1).find('video');

				$videoNext.prop('autoplay', true);
				$videoNext.get(0).load();
				$videoNext.get(0).play();

				$videoPrev.prop('autoplay', true);
				$videoPrev.get(0).load();
				$videoPrev.get(0).play();
			}
		})

		setTimeout(function () {
			// Enable autoplay for desktop only
			var screenSize = $(window).width();
			if (screenSize > 768) {
				$('.js-video-slide').each(function(){
					var $video = $(this).find('video');
					$video.prop('autoplay', true);
					$video.get(0).load();
					$video.get(0).play();
				})
			} else {
				var $video = $('.mn-video-slider').find('.owl-item.active').find('video'),
					$videoPrev = $('.mn-video-slider').find('.owl-item.active').prev().find('video'),
					$videoNext = $('.mn-video-slider').find('.owl-item.active').next().find('video');

				$video.prop('autoplay', true);
				$video.get(0).load();
				$video.get(0).play();
				$videoPrev.prop('autoplay', true);
				$videoPrev.get(0).load();
				$videoPrev.get(0).play();
				$videoNext.prop('autoplay', true);
				$videoNext.get(0).load();
				$videoNext.get(0).play();
			}
		}, 2500);


		$('.js-video-slide').on('click', function(){
			var $this = $(this),
				isActive = $this.hasClass('is-active'),
				videoSrc = $this.find('video').data('src');

			$this.parent().parent().find('.js-video-slide').each(function(){
				$(this).removeClass('is-active');
				$(this).find('video').get(0).pause();
			})

			if (isActive) {
				$this.removeClass('is-active');
				$this.find('video').get(0).pause();
			} else {
				$this.find('video').find('source').attr('src', videoSrc);
				$this.find('video').get(0).load();
				$this.find('video').prop('muted', false);
				$this.find('video').prop('playsinline', false);
				$this.find('video').prop("controls",true);
				$this.addClass('is-active');
				$this.find('video').get(0).play();
			}
		})
	}

	function initSideToSideStatic() {
		$(window).on('load', function(){
			$("#doubleImagesCarousel").twentytwenty({
				default_offset_pct: 0.88
			});
		})
	}


	function initializeRebuyEvents() {
		document.addEventListener('rebuy:cart.change', function (event) {
			var items = event.detail.cart.cart.items,
				fullPriceItemsAmount = 0;

			items.forEach(function (item, index) {
				var comparePrice = item.compare_at_price,
					handle = item.handle,
					linePrice = item.discounted_price;

				if (comparePrice == linePrice && handle != "swap-protect") {
					fullPriceItemsAmount = fullPriceItemsAmount + 1;
				}
			});

			if (fullPriceItemsAmount == 0) {
				$('body').addClass('hide-upsell-message');
			} else {
				$('body').removeClass('hide-upsell-message');
			}
		});
	}

	function initSingleHeroBannerEvents() {
		// Handle clicks on carousel items with data-href attribute
		const carouselItems = document.querySelectorAll('.js-data-image-carousel');

		carouselItems.forEach(function(item) {
			item.addEventListener('click', function() {
				console.log('clicked');
				const href = this.getAttribute('data-href');

				if (href) {
					window.location.href = href;
				}
			});
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize page DOM
	 **/
	function initializeDOM() {
		getPageTemplate();
		getPageURL();
		getShopUrl();
		getProductImagesUrl();
		getPageParameters();
		initGiftingPage();
		initializePageRedirect();
		initializeParameterPopup();
		initializeInstaImg();
		initializeCjEvents();
		initTrustpilotReviews();
		initVideoSliderEvents();
		initSideToSideStatic();
		resetRebuyDiscountCode();
		initializeRebuyEvents();
		initSingleHeroBannerEvents();
		if (app.page.template === 'gifting') {
			initGifting();
		} else if (app.page.template === 'gifting-confirm') {
			initGiftConfirm();
		} else if (app.page.template == "sizeguide") {
			initDynamicSizeGuide();
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize page cache
	 **/
	function initializeCache() {
		$cache = {
			body: $('body'),
			windowHeight: window.innerHeight
		}
	}

	app.page = {
		init: function () {
			initializeCache();
			initializeDOM();
		},
		animateElements: function (position) {
			animateElements(position)
		},
		lazyVideoLoad: function (position) {
			lazyVideoLoad(position)
		},
		initZenDesk: function() {
			initZenDesk()
		},
		initIubenda: function() {
			initIubenda()
		},
		initHomeProductCarousel: function() {
			initHomeProductCarousel()
		},
		template: '',
		url: '',
		shopUrl: '',
		prodImgUrl: '',
		params: '',
		isFbApp: false,
		zendeskInited: false,
		iubendaInited: false,
		homeproductCarouselInited: false
	}

}(window.app = window.app || {}, jQuery));


/**
 * @class app.popup
 */
(function (app, $) {
	var $cache;

	/**
	 * @private
	 * @function
	 * @description Open popup
	 * @param el string Popup selector to open
	 * @param a boolean Auto-height popup
	 **/
	function openPopup(el, a) {
		var $popup = $('#' + el),
			$window = $(window);

		console.log($cache);
		console.log($cache.overlay);

		$popup.show().css('display', 'table').addClass('modal-show');
		$cache.overlay.show().addClass('modal-show');
		if (($popup.height() > $window.height()) || (a == true)) {
			$popup.addClass('auto-height');
			$window.scrollTop(20);
		} else {
			$popup.removeClass('auto-height');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Close popup
	 **/
	function closePopup() {
		$('.modal-frm').hide().removeClass('modal-show');
		$cache.overlay.hide().removeClass('modal-show');
	}

	/**
	 * @private
	 * @function
	 * @description Initialize popup cache
	 **/
	function initializeCache() {
		$cache = {
			overlay: $('.modal-overlay'),
			overlayAlt: $('.modal-overlay-alt'),
			body: $('body')
		}
	}

	/**
	 * @private
	 * @function
	 * @description Ititialize popup events
	 **/
	function initializeEvents() {
		$(document).on('scroll', function () {
			var scrollTop = $(this).scrollTop();

			if (scrollTop > 700) {
				$('.js-mn-two-images-cta').addClass('is-visible-cta')
			} else {
				$('.js-mn-two-images-cta').removeClass('is-visible-cta')
			}
		});


		// Popup open
		$('.modalOpenLink').on('click', function (e) {
			e.preventDefault();
			var $this = $(this),
				container = $this.data('popup'),
				autoHeight = $this.data('autoheight'),
				lazyShow = $this.data('lazy-show');
			if (lazyShow) {
				app.lazyload.show(lazyShow);
			}
			openPopup(container, autoHeight);
		});

		// Popup close
		$(document).on('click  touchend', '.modal-close, .modal-area, .popups-close', function (e) {
			closePopup();
			e.stopPropagation();
			e.preventDefault();
		});
	}

	app.popup = {
		initialized: false,
		init: function () {
			initializeCache();
			initializeEvents();
			app.popup.initialized = true;
		},
		open: function (el, autoheight) {
			openPopup(el, autoheight);
		},
		close: function () {
			closePopup();
		}
	}

}(window.app = window.app || {}, jQuery));

/**
 * @class app.carousel
 */
(function (app, $) {
	var $cache,
		settings;

	/**
	 * @private
	 * @function
	 * @description IOS specific carousel fix to prevent page scroll
	 **/
	function carouselScrollFix() {
		window.addEventListener('touchmove', function () {
		});
	}

	/**
	 * @private
	 * @function
	 * @description PDP product main carousel
	 **/
	function initializePDPCarousel() {
		var itemsVisible = 2;

		if (app.product.data.type == 'slippers-flow' ||
			app.product.data.type == 'outdoor' ||
			app.product.data.type == 'mule' ||
			app.product.data.type == 'sandals' ||
			app.product.data.type == 'slides' ||
			app.product.data.type == 'verbier' ||
			app.product.data.type == 'leather' ||
			app.product.data.type == 'meribel' ||
			app.product.data.type == 'aero' ||
			app.product.data.type == 'vista' ||
			app.product.data.type == 'solar' ||
			app.product.data.type == 'boot' ||
			app.product.data.type == 'lite' ||
			app.product.data.type == 'tova' ||
			app.product.data.type == 'volare' ||
			app.product.data.type == 'neo' ||
			app.product.data.type == 'detachable' ||
			app.product.data.type == 'metallic' ||
			app.product.data.type == 'sereno' ||
			app.product.data.type == 'sierra' ||
			app.product.data.type == 'quilted-womens' ||
			app.product.data.type == 'quilted-mens' ||
			app.product.data.type == 'alto' ||
			app.product.data.type == 'slippers-fs' ||
			app.product.data.type == 'slippers-breathe' ||
			app.product.data.type == 'slippers-curve' ||
			app.product.data.type == 'wholesale'
		) {
			itemsVisible = 1;
		}

		var isLoopCarousel = false;

		if (app.product.data.type == 'solar') {
			isLoopCarousel = true;
		}

		$cache.pdpCarousel.owlCarousel({
			center: true,
			items: itemsVisible,
			loop: isLoopCarousel,
			nav: true,
			dots: true,
			pagination: true,
			onInitialized: showCarousel,
			margin: 0,
			navText: ['<span class="chevron left"></span>', '<span class="chevron right"></span>'],
			responsive: {
				600: {
					items: itemsVisible
				}
			}
		}).on('changed.owl.carousel', function (property) {
			var $target = $(property.target),
				currentSlide = property.item.index,
				isVideoSlide = $target.find(".owl-item").eq(currentSlide).find('.js-product-video').length > 0,
				isUnboxingSlide = $target.find(".owl-item").eq(currentSlide).find('.js-unboxing-video').length > 0;
			isSpinSlide = $target.find(".owl-item").eq(currentSlide).find('.js-productspin-video').length > 0;
			isOnFootSlide = $target.find(".owl-item").eq(currentSlide).find('.js-onfoot-video').length > 0;

			if (isVideoSlide) {
				var videoSrc = $target.find('.js-product-video').data('src');
				$target.find('.js-product-video').find('source').attr('src', videoSrc);

				var $video = $target.find('.js-product-video').get(0);
				$video.load();
				$video.play();
			} else if (isUnboxingSlide) {
				var video2Src = $target.find('.js-unboxing-video').data('src');
				$target.find('.js-unboxing-video').find('source').attr('src', video2Src);

				var $video2 = $target.find('.js-unboxing-video').get(0);
				$video2.load();
				$video2.play();
			} else if (isSpinSlide) {
				var video3Src = $target.find('.js-productspin-video').data('src');
				$target.find('.js-productspin-video').find('source').attr('src', video3Src);
				var $video3 = $target.find('.js-productspin-video').get(0);
				$video3.load();
				$video3.play();
			} else if (isOnFootSlide) {
				// lazy loading video
				var video4Src = $target.find('.js-onfoot-video').data('src');
				$target.find('.js-onfoot-video').find('source').attr('src', video4Src);
				var $video4 = $target.find('.js-onfoot-video').get(0);
				$video4.load();
				$video4.play();
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Show carousel
	 **/
	function showCarousel() {
		$cache.pdpCarousel.removeClass('invisible');
	}

	/**
	 * @private
	 * @function
	 * @description Change class depends on carousel slide
	 **/
	function changeClassFromCarousel(style) {
		if (style == 'light') {
			$cache.body.removeClass('scheme-dark').addClass('scheme-light');
		} else if (style == 'dark') {
			$cache.body.removeClass('scheme-light').addClass('scheme-dark');
		}
	}

	/**
	 * @private
	 * @function
	 * @description {FullCarousel} Switch carousel classes for different background
	 **/
	function changeSlidesClass() {
		$cache.fullCarousel.on('changed.owl.carousel', function (property) {
			var $target = $(property.target),
				currentSlide = property.item.index,
				$slide = $target.find(".owl-item").eq(currentSlide).find('.js-hero-slide'),
				style = $slide.attr('data-mobile-menu');

			if (!currentSlide) {
				style = $('.js-carousel-fullwidth').find('.js-hero-slide.hero-home-2').attr('data-mobile-menu');
			}

			changeClassFromCarousel(style);
		});
	}

	/**
	 * @private
	 * @function
	 * @description {FullCarousel} HP hero hide initial static slide
	 **/
	function hideInitialImage() {
		$('.js-hero-initialimage').addClass('hidden');
	}

	function onInitFullCarousel() {
		setTimeout(hideInitialImage, 100);
		showFullCarousel();
		setLazyImage('carousel');
	}

	/**
	 * @private
	 * @function
	 * @description {FullCarousel} HP hero carousel init
	 **/
	function initFullOwlCarousel() {
		$cache.fullCarousel.owlCarousel({
			items: 1,
			loop: true,
			lazyLoad: true,
			autoplay: true,
			autoplayTimeout: 5500,
			startPosition: 1,
			onInitialized: onInitFullCarousel,
			mouseDrag: false,
			touchDrag: true,
			animateOut: 'heroOut',
			animateIn: 'heroIn',
			nav: true,
			dots: false,
			margin: 0,
			navText: ["<i class='chevron left'></i>", "<i class='chevron right'></i>"]
		});
	}

	/**
	 * @private
	 * @function
	 * @description {FullCarousel} HP hero carousel
	 **/
	function initializeFullCarousel() {
		changeSlidesClass();
		initFullOwlCarousel();
	}

	function setGeoBanner($this, slideNumber, srcTablet, srcMobile) {
		if (app.geoip.location) {
			var webpAvailable = app.ui.isWebpSupported === true && Theme.shop.webpSupport;

			if (app.geoip.location && app.geoip.location === "au" && slideNumber === "1") {
				// Image
				src = $this.attr('data-original-aunz');

				if (app.ui.isTablet() && srcTablet) {
					if (webpAvailable) {
						src = $this.attr('data-original-aunz-tablet-webp');
					} else {
						src = $this.attr('data-original-aunz-tablet');
					}
				} else if (app.ui.isMobile() && srcMobile) {
					if (webpAvailable) {
						src = $this.attr('data-original-aunz-mobile-webp');
					} else {
						src = $this.attr('data-original-aunz-mobile');
					}
				} else if (webpAvailable) {
					src = $this.attr('data-original-aunz-webp');
				}

				// Content
				var $title = $this.find('h2'),
					$cta = $this.find('.button'),
					newTitle = $title.attr('data-aud-content'),
					newCtaTitle = $cta.attr('data-aud-content'),
					newCtaLink = $cta.attr('data-aud-href');

				if (newTitle !== '') {
					$title.html(newTitle);
				}

				if (newCtaTitle !== '') {
					$cta.html(newCtaTitle);
				}

				if (newCtaLink !== '') {
					$cta.attr('href', newCtaLink);
				}

				$this.attr('style', 'display:block; background-image: url("' + src + '");');

			}
		} else {
			setTimeout(function () {
				console.log('Waiting for GEOIP');
				setGeoBanner($this, slideNumber, srcTablet, srcMobile);
			}, 1000);
		}

	}

	/**
	 * @private
	 * @function
	 * @description Use on owl carousel - onInitialize: setLazyImage
	 **/
	function setLazyImage(container) {

		// Prevent load all carousel images before owl is not initialized
		var containerToLoad = '.js-hero-initialimage, .js-carousel-fullwidth',
			location = app.geoip.location;

		if (container === 'static') {
			containerToLoad = '.js-hero-initialimage'
		} else if (container === 'carousel') {
			containerToLoad = '.js-carousel-fullwidth'
		}

		$(containerToLoad).find('.js-lazyload, .js-hero-slide').each(function () {
			var $this = $(this),
				src = $this.attr('data-original'),
				srcTablet = $this.attr('data-original-tablet'),
				srcMobile = $this.attr('data-original-mobile'),
				slideNumber = $this.attr('data-slide'),
				webpAvailable = app.ui.isWebpSupported === true && Theme.shop.webpSupport;

			if (app.ui.isTablet() && srcTablet) {
				if (webpAvailable) {
					src = $this.attr('data-original-tablet-webp');
				} else {
					src = $this.attr('data-original-tablet');
				}
			} else if (app.ui.isMobile() && srcMobile) {
				if (webpAvailable) {
					src = $this.attr('data-original-mobile-webp');
				} else {
					src = $this.attr('data-original-mobile');
				}
			} else if (webpAvailable) {
				src = $this.attr('data-original-webp');
			}

			$this.attr('style', 'display:block; background-image: url("' + src + '");');

			// AU-NZ GEOIP BANNER
			setGeoBanner($this, slideNumber, srcTablet, srcMobile);

		});
	}

	function showFullCarousel() {
		$('.js-carousel-fullwidth').removeClass('invisible');
	}

	/**
	 * @private
	 * @function
	 * @description PDP. Image carousel with dots
	 **/
	function initializeImageCarousel() {
		$cache.imageCarousel.owlCarousel({
			center: true,
			items: 1,
			margin: 7,
			dots: true,
			onInitialized: app.ui.scrollToHash,
			responsive: {
				600: {
					items: 2
				}
			}
		});

		$cache.imageCarousel.trigger('to.owl.carousel', 1);
		$cache.imageCarousel.find('.owl-stage').children().on('click', function () {
			var orderNum = $(this).index();
			$('.carousel-image').trigger('to.owl.carousel', [orderNum, 1, true]);
		});
	}

	/**
	 * @private
	 * @function
	 * @description PDP. Upsell Carousel
	 **/
	function initializeUpsellCarousel() {
		$('.js-carousel-upsell').owlCarousel({
			center: true,
			items: 2,
			loop: false,
			lazyLoad: true,
			pagination: false,
			dots: false,
			margin: 0,
			onInitialized: $(window).trigger('resize')
		});
	}

	/**
	 * @private
	 * @function
	 * @description PDP. YMAL carousel
	 **/
	function initializeYMALCarousel() {
		$cache.ymalCarousel.owlCarousel({
			center: false,
			items: 3,
			nav: true,
			loop: true,
			pagination: true,
			dots: false,
			margin: 0,
			responsive: {
				0: {
					items: 2,
					center: true
				},
				600: {
					items: 3,
					center: false
				}
			},
			navText: ["<i class='chevron left'></i>", "<i class='chevron right'></i>"]
		});

		$cache.ymalCarousel.trigger('to.owl.carousel', [1, 1, true]);
		$cache.ymalCarousel.find('.owl-stage').children().on('click', function () {
			var orderNum = $(this).index();
			$('.js-carousel-ymal').trigger('to.owl.carousel', [orderNum, 1, true]);
		});
	}

	function initializeThumbnailsCarousel() {
		if (app.ui.isMobile()) {
			var $thumbs = $('.product-gallery-thumbs');
			$thumbs.find('.product-thumb-video, .product-thumb-new').addClass('hidden');
			$thumbs.find('.first').addClass('is-hidden');
		}
	}

	function changeHomeProductCarousel($slide) {
		var slideHref = $slide.attr('data-cta'),
			title = $slide.attr('data-title'),
			handle = $slide.attr('data-handle'),
			$image = $slide.find('.homeproduct-image'),
			image = $image.attr('data-src'),
			eventLabel = title.replace(/<[^>]*>?/gm, ''),
			icon1url = $slide.attr('data-icon-1-url'),
			icon2url = $slide.attr('data-icon-2-url'),
			icon3url = $slide.attr('data-icon-3-url'),
			icon1content = $slide.attr('data-icon-1-content'),
			icon2content = $slide.attr('data-icon-2-content'),
			icon3content = $slide.attr('data-icon-3-content');

		$image.attr('src', image);

		$('.js-homeproduct-cta').attr('href', slideHref).attr('data-event-label', eventLabel);
		$('#homeproductIcon1').html(icon1url);
		$('#homeproductIcon2').html(icon2url);
		$('#homeproductIcon3').html(icon3url);
		$('#homeproductIcon1Content').html(icon1content);
		$('#homeproductIcon2Content').html(icon2content);
		$('#homeproductIcon3Content').html(icon3content);
		$('#homeproductTitle').html(title);
		$('.js-bottomnav-item').removeClass('is-active');
		$('.js-bottomnav-item[data-handle="' + handle + '"]').addClass('is-active');
		$('.js-homeproduct-contentwrapper').removeClass('is-invisible');

		// Carousel scroll event
		if (ga) {
			ga('send', 'event', 'Homepage Product Carousel', 'Scrolled to', eventLabel);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Homepage product list carousel
	 **/
	function initializeHomeProductCarousel() {
		$cache.homeProductCarousel.owlCarousel({
			items: 1,
			center: true,
			nav: true,
			loop: true,
			dots: false,
			onInitialized: $('.js-bottomnav-item').eq(0).addClass('is-active'),
			navText: ['<span class="chevron left"></span>', '<span class="chevron right"></span>']
		}).on('translated.owl.carousel', function (property) {
			var $target = $(property.target),
				currentSlide = property.item.index,
				$slide = $target.find(".owl-item").eq(currentSlide).find('.js-homeproduct-wrapper');
			changeHomeProductCarousel($slide);
		}).on('change.owl.carousel', function (property) {
			$('.js-homeproduct-contentwrapper').addClass('is-invisible');
		});
	}

	/**
	 * @private
	 * @function
	 * @description Collection carousel change url
	 **/
	function changeCollectionCarouselUrl(el, index) {
		var $this = el,
			activeSlide = $this.find('.owl-item').eq(index).find('.collection__section-link'),
			slideHref = activeSlide.attr('href'),
			$ctaLink = $this.siblings('.collection__section-cta').find('.js-section-cta-link');
		$ctaLink.attr('href', slideHref);
	}

	/**
	 * @private
	 * @function
	 * @description PDP. Carousel with image and text
	 **/
	function initializeImageTextCarousel() {
		$('.product-detail-carousel').owlCarousel({
			center: true,
			items: 1,
			margin: 0,
			dots: true,
			nav: false,
			lazyLoad: true,
			loop: true,
			navText: ['<span class="chevron left"></span>', '<span class="chevron right"></span>'],
			responsive: {
				600: {
					dots: false,
					nav: true
				}
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Collection carousel
	 **/
	function initializeCollectionCarousel() {
		$('.js-carousel-collection').owlCarousel({
			center: true,
			items: 2,
			loop: false,
			dots: false,
			margin: 0,
			nav: true,
			navText: ["<i class='chevron left'></i>", "<i class='chevron right'></i>"],
			responsive: {
				600: {
					items: 2
				}
			}
		}).on('changed.owl.carousel', function (property) {
			var $target = $(property.target),
				currentSlide = property.item.index;
			changeCollectionCarouselUrl($target, currentSlide);
		});

		$('.js-carousel-collection-fullwidth').owlCarousel({
			center: true,
			loop: false,
			dots: false,
			startPosition: 0,
			margin: 0,
			nav: true,
			navText: ["<i class='chevron left'></i>", "<i class='chevron right'></i>"],
			responsive: {
				0: {
					items: 2
				},
				1001: {
					items: 4
				}
			}
		}).on('changed.owl.carousel', function (event) {
			var $target = $(event.target),
				currentSlide = event.item.index;
			changeCollectionCarouselUrl($target, currentSlide);
		});
	}

	function initializeCategoriesCarousel() {
		$cache.clpCarousel.owlCarousel({
			center: true,
			items: 2,
			loop: false,
			pagination: true,
			dots: false,
			margin: 0,
			responsive: {
				600: {
					items: 3,
					center: false
				}
			}
		});

		$cache.clpCarousel.trigger('to.owl.carousel', [1, 1, true]);
		$cache.clpCarousel.find('.owl-stage').children().on('click', function () {
			var orderNum = $(this).index();
			$('.js-carousel-clp').trigger('to.owl.carousel', [orderNum, 1, true]);
		});
	}

	/**
	 * @private
	 * @function
	 * @description Lazy load next slide
	 **/
	function carouselLazyLoad(slide) {
		var current = slide.item.index,
			$target = $(slide.target).find(".owl-item").eq(current + 1).find("img:not(.js-lazyload-skip)"),
			lazyImg = $target.attr('data-original');

		if (lazyImg) {
			$target.attr('src', lazyImg);
		}
		$(slide.target).find('.js-lazyload').trigger("scroll");
	}

	/**
	 * @private
	 * @function
	 * @description Start homepage carousel only after popup close
	 **/
	function triggerFullCarousel() {
		app.carousel.startTimeout = setTimeout(initializeFullCarousel, 6000);
	}

	/**
	 * @private
	 * @function
	 * @description Trigger disabled arrow class when reach carousel begin/end
	 **/
	function navArrrowDynamicDisable() {
		$(".owl-carousel").on('initialized.owl.carousel changed.owl.carousel refreshed.owl.carousel', function (event) {
			if (!event.namespace) return;
			var carousel = event.relatedTarget,
				element = event.target,
				current = carousel.current();
			$('.owl-next', element).toggleClass('disabled', current === carousel.maximum());
			$('.owl-prev', element).toggleClass('disabled', current === carousel.minimum());
		})
	}

	function initSideToSideCarousel() {
		$("#sideToSideCarousel").twentytwenty();
	}

	function initReviewsCarousel() {
		$('#reviewsCarousel').owlCarousel({
			items: 1,
			loop: true,
			startPosition: 0,
			mouseDrag: true,
			touchDrag: true,
			nav: true,
			dots: false,
			margin: 0,
			navText: ['<span class="chevron left"></span>', '<span class="chevron right"></span>'],
			responsive: {
				600: {
					items: 1,
					center: false
				}
			},
		});
	}

	function initTestimonialsCarousel() {
		$('#testimonialsCarousel').owlCarousel({
			items: 1,
			loop: true,
			startPosition: 0,
			mouseDrag: true,
			touchDrag: true,
			nav: true,
			dots: false,
			navText: ['<span class="chevron left"></span>', '<span class="chevron right"></span>'],
			margin: 0,
			responsive: {
				600: {
					items: 1,
					center: false
				}
			},
		});

		$('.js-testimonial-logo').on('click', function(){
			var index = $(this).data('index');
			$('#testimonialsCarousel').trigger('to.owl.carousel', index);
		});
	}

	function initGridOverlayCarousel() {
		$('#imageGridOverlayCarousel').owlCarousel({
			items: 1,
			loop: true,
			startPosition: 0,
			mouseDrag: true,
			touchDrag: true,
			stagePadding: 20,
			nav: true,
			dots: true,
			slideBy: 1,
			navText: ['<span class="chevron left">PREV</span>', '<span class="chevron right">NEXT</span>'],
			margin: 7,
			responsive: {
				700: {
					items: 2,
					stagePadding: 50,
					slideBy: 1,
					center: false
				},
				900: {
					items: 4,
					stagePadding: 100,
					slideBy: 1,
					center: false
				}
			},
		});
	}

	function initShowcaseCarousel() {
		$('.js-product-showcase-carousel').each(function() {
			$(this).owlCarousel({
			items: 1,
			loop: true,
			startPosition: 0,
			mouseDrag: true,
			touchDrag: true,
			stagePadding: 20,
			nav: true,
			dots: false,
			slideBy: 1,
			navText: ['<span class="chevron left">PREV</span>', '<span class="chevron right">NEXT</span>'],
			margin: 7,
			responsive: {
				600: {
					items: 4,
					stagePadding: 100,
					slideBy: 4,
					center: false
				},
				700: {
					items: 2,
					stagePadding: 50,
					slideBy: 2,
					center: false
				},
				900: {
					items: 4,
					stagePadding: 100,
					slideBy: 4,
					center: false
				},
			},
			});
		});
	}

	function initPaddedImageCarousel() {
		$('#paddedImageCarousel').owlCarousel({
			items: 1,
			autoplay:true,
			autoplayTimeout:2500,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			loop: true,
			startPosition: 0,
			mouseDrag: true,
			touchDrag: true,
			nav: false,
			dots: true,
			navText: ['<span class="chevron left"></span>', '<span class="chevron right"></span>'],
			margin: 0,
			responsive: {
				600: {
					items: 1,
					center: false
				}
			},
		});
	}

	function initDualImageCarousel() {
		if ($('#dualImageCarousel').hasClass('is-carousel-enabled')) {
			$('#dualImageCarousel').owlCarousel({
				items: 1,
				loop: true,
				startPosition: 0,
				mouseDrag: true,
				touchDrag: true,
				nav: false,
				dots: true,
				navText: ['<span class="chevron left"></span>', '<span class="chevron right"></span>'],
				margin: 0,
				responsive: {
					600: {
						items: 1,
						center: false
					}
				},
			});
		}
	}

	function initAdsCarousel() {
		var $carousel = $('#autoscroll-carousel');
		if (!$carousel.length || typeof $.fn.owlCarousel === 'undefined') return;

		if ($carousel.hasClass('owl-loaded')) {
			$carousel.trigger('destroy.owl.carousel');
			$carousel.removeClass('owl-loaded');
			$carousel.find('.owl-stage-outer').children().unwrap();
		}

		var itemsMobile = parseInt($carousel.data('items-mobile'), 10) || 1;
		var itemsDesktop = parseInt($carousel.data('items-desktop'), 10) || 4;
		var marginMobile = parseInt($carousel.data('margin-mobile'), 10) || 8;
		var marginDesktop = parseInt($carousel.data('margin-desktop'), 10) || 16;
		var autoplayTimeout = parseInt($carousel.data('autoplay-timeout'), 10) || 2500;
		var autoplaySpeed = parseInt($carousel.data('autoplay-speed'), 10) || 2500;

		$carousel.owlCarousel({
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			autoplayTimeout: autoplayTimeout,
			autoplaySpeed: autoplaySpeed,
			smartSpeed: autoplaySpeed,
			autoplayHoverPause: false,
			slideTransition: 'linear',
			mouseDrag: false,
			touchDrag: true,
			pullDrag: false,
			freeDrag: false,
			responsive: {
				0: {
					items: itemsMobile,
					margin: marginMobile
				},
				990: {
					items: itemsDesktop,
					margin: marginDesktop
				}
			}
		});

		document.addEventListener('shopify:section:load', function(event) {
			if (event.detail && event.detail.sectionId === sectionId) {
				initAutoscrollCarousel(sectionId);
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize carousel DOM
	 **/
	function initializeDOM() {
		carouselScrollFix();
		navArrrowDynamicDisable();
		initializeCollectionCarousel();
		initializePDPCarousel();
		initializeImageCarousel();
		initializeYMALCarousel();
		initializeThumbnailsCarousel();
		initializeHomeProductCarousel();
		initializeUpsellCarousel();
		initializeImageTextCarousel();
		initializeCategoriesCarousel();
		triggerFullCarousel();
		initSideToSideCarousel();
		initTestimonialsCarousel(); // old
		initDualImageCarousel();
		initPaddedImageCarousel();
		initShowcaseCarousel();
		initGridOverlayCarousel();
		initReviewsCarousel();
		initAdsCarousel();
		setLazyImage('static');
	}

	function initializeCache() {
		$cache = {
			fullCarousel: $('.js-carousel-fullwidth'),
			ymalCarousel: $('.js-carousel-ymal'),
			clpCarousel: $('.js-carousel-clp'),
			homeProductCarousel: $('.js-carousel-homeproduct'),
			pdpCarousel: $('#productpage-carousel'),
			imageCarousel: $('.carousel-image'),
			body: $('body')
		}
	}

	function initializeSettings() {
		settings = {
			autoPlayTimeout: ''
		}
	}

	function initializeEvents() {
		$('.owl-carousel').on('changed.owl.carousel', function (property) {
			carouselLazyLoad(property);
		});

		// Stop carousel autoscroll
		$('.js-carousel-stop').on('mouseenter', function () {
			$cache.fullCarousel.trigger('stop.owl.autoplay');
			if (settings.autoPlayTimeout) {
				clearTimeout(settings.autoPlayTimeout);
			}
		}).on('mouseleave', function () {
			settings.autoPlayTimeout = setTimeout(function () {
				$cache.fullCarousel.trigger('play.owl.autoplay', [3500]);
			}, 3500);
		});

		// Carousel homepage links
		$('.js-carousel-fullwidth').on('click', '.js-hero-slide', function () {
			window.location.href = $(this).data('href');
		});
	}

	app.carousel = {
		init: function () {
			initializeSettings();
			initializeCache();
			console.log('234');
			initializeDOM();
			initializeEvents();
		},
		initUpsellCarousel: function () {
			initializeUpsellCarousel();
		},
		initHomepageLazy: function () {
			setLazyImage()
		},
		initCollectionCarousel: function () {
			initializeCollectionCarousel()
		},
		startTimeout: ""
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.upsell
 */
(function (app, $) {

	/**
	 * @private
	 * @function
	 * @description Get upsell subtotal price
	 **/
	function getUpsellTotals() {
		Shopify.getCart(function (cart) {
			var cartItems = app.multistore.getCartItems(cart.items);
			$('#multistoreCheckoutList').text(cartItems);
			app.multistore.getLineItemsData();
			app.multistore.setCheckoutLinks();
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize upsell events
	 **/
	function initializeEvents() {

	}

	app.upsell = {
		init: function () {
			initializeEvents();
		},
		getTotals: function () {
			getUpsellTotals();
		},
		productsAdded: false
	}

}(window.app = window.app || {}, jQuery));

/**
 * @class app.stock
 */
(function (app, $) {

	/**
	 * @private
	 * @function
	 * @description Generate stock data and delivery object
	 **/
	function generateStockData(data) {
		var dataObject;

		(typeof data === 'object') ? dataObject = data : dataObject = JSON.parse(data);

		$.each(dataObject, function (i) {
			app.stock.data[dataObject[i].sku] = dataObject[i].quantity;
			app.stock.terms[dataObject[i].sku] = dataObject[i].delivery;
		});

		// Test Data

		// app.stock.data['MC-P-42-PI-PI-A5'] = 10;
		// app.stock.data['SL-F-42-BE-SB-A5'] = 10;
		// app.stock.data['SL-F-42-BL-HO-A5'] = 10;
		// app.stock.data['SL-F-42-NY-SB-A5'] = 10;
		// app.stock.data['SL-F-42-WH-HV-A5'] = 10;
		// app.stock.data['SL-F-42-GR-WH-A5'] = 10;
		// app.stock.data['SL-F-42-BE-WH-A5'] = 10;
		// app.stock.data['SL-F-42-BL-WH-A5'] = 10;
		// app.stock.data['SL-F-42-NY-WH-A5'] = 10;
		// app.stock.data['PL-F-42-TN-TN-A5'] = 10;
		// app.stock.data['PL-F-42-NY-NY-A5'] = 10;
		// app.stock.data['SL-F-37-NY-NY-A5'] = 10;
		// app.stock.data['BT-L-36-BE-BE-A5'] = 10;
		// app.stock.data['BT-L-36-BE-BE-A5'] = 10;
		// app.stock.data['LM-F-36-SL-WH'] = 10;
		// app.stock.data['LM-F-36-CH-WH'] = 10;
		// app.stock.terms['BC-C-SB-38'] = '20-30 days';
		// console.warn("FAKE STOCK ADDED. PLEASE REMOVE CHANGES BEFORE DEPLOYMENT!!!")
	}


	// Get inventory data from Shopify directly
	function getShopifyStockData() {
		$('.js-inventory-data-levels').each(function(){
			var $this = $(this),
				inventory = $this.data('inventory'),
				sku = $this.data('sku');

			app.stock.data[sku] = inventory;
		})
	}

	/**
	 * @private
	 * @function
	 * @description Get inventory url depends on customer geoip data
	 **/
	function getStockUrl() {
		var stockLink = Theme.multistore.inventoryDataUrl,
			customerCountry = Cookies.get('deliveryCountryISO');
		if (customerCountry &&
			customerCountry === 'us'
		) {
			stockLink = Theme.multistore.inventoryUsDataUrl
		}
		return stockLink;
	}

	/**
	 * @private
	 * @function
	 * @description Fetch stock products json from endpoint
	 **/
	function initProductsStock() {
		var productStockUrl = Theme.multistore.inventoryDataUrl;

		$.ajax({
			url: productStockUrl,
			tryCount: 0,
			retryLimit: 3,
			crossDomain: true,
			success: function (data) {
				generateStockData(data);
				getShopifyStockData();
				app.stock.initialized = true;
			},
			error: function (xhr, textStatus, errorThrown) {
				if (textStatus === 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						//try again
						$.ajax(this);
						return;
					}
					return;
				}
				if (xhr.status === 500) {
					$('#deliveryOutOfStock').find('span').text("").parent().removeClass('hidden');
				}
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description GET sku stock value
	 **/
	function getStockValue(sku) {
		if (app.stock.initialized) {
			if (app.stock.data[sku]) {
				return app.stock.data[sku];
			} else {
				return 0
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description GET stock terms
	 **/
	function getStockTerms(sku) {
		if (app.stock.initialized) {
			return app.stock.terms[sku]
		}
	}

	/**
	 * @private
	 * @function
	 * @description Check if sku is not sold-out
	 **/
	function checkSoldOut(sku) {
		var skuArr = sku.split('-');
		skuArr.splice(2, 1);
		var skuNew = skuArr.join('-');
		console.log(skuNew);
		if (Theme.stock.soldOutProducts.indexOf(skuNew) > -1) {
			return true
		}

		return false;
	}

	/**
	 * @private
	 * @function
	 * @description Check if sku is preorder forced
	 **/
	function checkPreorderForced(sku) {
		var skuArr = sku.split('-'),
			skuFormatted = skuArr[0] + '-' + skuArr[1] + '-' + skuArr[2] + '-' + skuArr[3] + '-' + skuArr[4];

		if (Theme.stock.preorderForcedProducts.indexOf(skuFormatted) > -1) {
			return true
		}

		return false;
	}

	function getPreorderDates(sku) {
		var response = null,
			skuArr = sku.split('-'),
			skuFormatted = skuArr[0] + '-' + skuArr[1] + '-' + skuArr[3] + '-' + skuArr[4];

		if (PreorderForcedVariants[skuFormatted]) {
			response = 	PreorderForcedVariants[skuFormatted];
		}
		return response;
	}

	function initializeDOM() {
		if (app.page.template === 'pdp' ||
			app.page.template === 'cart' ||
			app.page.template === 'plp'
		) {
			initProductsStock();
		}
	}

	app.stock = {
		init: function () {
			initializeDOM();
		},
		get: function (sku, country) {
			return getStockValue(sku, country);
		},
		getTerms: function (sku) {
			return getStockTerms(sku)
		},
		checkSoldOut: function (sku) {
			return checkSoldOut(sku)
		},
		checkPreorderForced: function (sku) {
			return checkPreorderForced(sku)
		},
		getPreorderDates: function (sku) {
			return getPreorderDates(sku)
		},
		data: {},
		terms: {},
		attemptsLeft: 5,
		initialized: false
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.product
 */
(function (app, $) {
	var $cache,
		settings;

	/**
	 * @private
	 * @function
	 * @description Set product quantity
	 **/
	function setQuantity(qty) {
		app.product.data.quantity = qty;
	}

	/**
	 * @private
	 * @function
	 * @description Change product quantity using selector
	 **/
	function changeQuantity(el) {
		var $this = el,
			$amount = $this.siblings('.js-qtyAmount'),
			changeDirection = $this.data('change'),
			amount = parseInt($amount.text());

		if (changeDirection == 'minus') {
			if (amount > 1) {
				amount--
			}
		} else if (changeDirection == 'plus') {
			amount++
		}

		$amount.text(amount);
		setQuantity(amount);
	}

	/**
	 * @private
	 * @function
	 * @description Change gift card type after change option
	 **/
	function changeGiftCardType(el) {
		var $selected = el.find('option:selected'),
			src = $selected.attr('data-src'),
			currency = $('#giftPriceWrapper').find('span.money').attr('data-currency') || 'GBP',
			sku = $selected.attr('data-sku'),
			price = $('#giftCardVariants').find('.js-giftcard-variant[data-sku="' + sku + '"]').html();

		$('.product-gallery-feature').find('img').attr('src', src).attr('data-highres', src);
		$('#giftPriceWrapper, #giftPriceWrapperMob').html(price);
	}

	/**
	 * @private
	 * @function
	 * @description Switch product sizes depends on currency
	 **/
	function switchProductSizes() {
		var selectedCurrency = Shopify.currency.active,
			selectedCountry = Shopify.country,
			selectedSizeType = "uk";

		if (selectedCurrency === 'USD' || selectedCountry === "US") {
			selectedSizeType = "us";
		} else if (selectedCurrency === 'AUD' || selectedCountry === "AU") {
			selectedSizeType = "au";
		} else if (selectedCurrency === 'GBP' || selectedCountry === "GB") {
			selectedSizeType = "uk";
		} else {
			selectedSizeType = "eu";
		}
		$('#multiSizeSelector').find("li[data-size-country='" + selectedSizeType + "']").trigger('click');
	}

	/**
	 * @private
	 * @function
	 * @description Switch product size country
	 **/
	function switchSizesCountry(country) {
		$cache.sizeSelector.children('div').each(function () {
			var $this = $(this),
				sizeShow = $this.data('size-show'),
				sizeType = $this.data('size-type'),
				gender = app.product.size.gender;

			if (app.product.data.saleType == 'slippers') {
				gender = 'women'
			}

			if (sizeShow.indexOf(country) > -1) {
				if (sizeType) {
					$this.find('li').each(function () {
						var $that = $(this),
							dataSizeAtr = 'size-' + country + '-' + sizeType,
							dataSize = $that.data(dataSizeAtr);
						// hide sizes with no convertion value
						if (dataSize) {
							$that.removeClass('hidden').html(dataSize);
						} else {
							$that.addClass('hidden');
						}
					});
				}
				$this.removeClass('hidden');
			} else {
				$this.addClass('hidden');
			}

			if (gender == sizeType && country !== 'eu') {
				$this.removeClass('hidden');
				if (app.product.data.saleType != 'slippers') {
					$cache.sizeLegend.addClass('is-active').css('display', 'inline-block');
				}
			} else if (country == 'eu' && sizeShow == 'eu') {
				if (app.product.data.saleType != 'slippers') {
					$cache.sizeLegend.removeClass('is-active').hide();
				}
				$cache.sizeGenderSelector.hide();
				$cache.sizeSelector.removeClass('hidden');
				$this.removeClass('hidden');
			} else if (country == 'uk') {
				$cache.sizeGenderSelector.hide();
				$cache.sizeSelector.removeClass('hidden');
				app.product.generateSizeSelector(false);
			}else if (!gender && country !== 'eu') {
				$cache.sizeSelector.addClass('hidden');
				$cache.sizeGenderSelector.show();
			} else {
				if (app.product.data.saleType != 'slippers') {
					$this.addClass('hidden');
				}
			}

			// force gender selection
			if (app.product.data.type == 'quilted-womens') {
				$('#genderSelection').find('li[data-gendertype="womens"]').trigger('click');
			} else if (app.product.data.type == 'quilted-mens') {
				$('#genderSelection').find('li[data-gendertype="mens"]').trigger('click');
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Switch product size country
	 **/
	function changeSizeCountry(el) {
		var country = el.data('size-country');

		if (country == 'au') {
			country = 'eu'
		}

		$('.sizelegendCountry, .sizelegendCountryValue').html(country.toUpperCase());
		switchSizesCountry(country);

		el.siblings().removeClass('selected');
		el.addClass('selected');
	}

	/**
	 * @private
	 * @function
	 * @description Clear product gender
	 **/
	function clearGender(el) {
		el.hide().removeClass('is-active');
		$('.sizelegend').hide();
		$cache.sizeGenderSelector.show();
		$cache.sizeSelector.addClass('hidden');
		app.product.size.gender = false;
	}

	/**
	 * @private
	 * @function
	 * @description Select product gender
	 **/
	function selectGender(el) {
		var gender = el.data('gendertype'),
			country = el.find('.sizelegendCountry').html(),
			genderCropped = gender.slice(0, -1);

		app.product.size.gender = genderCropped;
		app.product.size.country = country;
		el.parent().hide();
		$cache.sizeGenderValue.html(gender);
		$cache.sizeCountryValue.html(country);
		$('.sizelegend, .sizeChange').addClass('is-active').css('display', 'inline-block');
		$cache.sizeSelector.removeClass('hidden');
		$cache.sizeSelector.children().each(function () {
			var $that = $(this),
				_gender = $that.data('size-type');
			if (_gender !== genderCropped) {
				$that.addClass('hidden');
			} else {
				$that.removeClass('hidden');
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Hide product image if parameters are presented
	 **/
	function hideProductImage() {
		if (!(app.utils.getUrlParam('upper') || app.utils.getUrlParam('colour'))) {
			$('#productImagesWrapper').removeClass('invisible');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Set product type
	 **/
	function setProductTypeSKU() {
		var type = settings.productType;

		if (type.indexOf('soles') > -1) {
			app.product.data.type = 'sole';
			$cache.swatchSelector.removeClass('hidden');
		} else if (type === 'fixed sole') {
			app.product.data.type = 'slippers-fs';
			if (Theme.product.handle == 'slippers') {
				app.product.data.saleType = 'slippers';
			}
		}	else if (type === 'curve') {
			app.product.data.type = 'slippers-curve';
		}	else if (type === 'mule') {
			app.product.data.type = 'mule';
		}	else if (type === 'Sandal') {
			app.product.data.type = 'sandals';
		}	else if (type === 'Slides') {
			app.product.data.type = 'slides';
		}	else if (type === 'Verbier') {
			app.product.data.type = 'verbier';
		}	else if (type === 'Leather') {
			app.product.data.type = 'leather';
		}	else if (type === 'Double Shearling') {
			app.product.data.type = 'meribel';
		}	else if (type === 'Aero') {
			app.product.data.type = 'aero';
		}	else if (type === 'Vista') {
			app.product.data.type = 'vista';
		}	else if (type === 'Sierra') {
			app.product.data.type = 'sierra';
		}	else if (type === 'Solar') {
			app.product.data.type = 'solar';
		}	else if (type === 'boot') {
			app.product.data.type = 'boot';
		}	else if (type === 'Tova' || type === 'tova') {
			app.product.data.type = 'tova';
		}	else if (type === 'Volare' || type === 'volare') {
			app.product.data.type = 'volare';
		}	else if (type === 'Neo' || type === 'neo') {
			app.product.data.type = 'neo';
		}	else if (type === 'Detachable' || type === 'detachable') {
			app.product.data.type = 'detachable';
		}	else if (type === 'Lite' || type === 'lite') {
			app.product.data.type = 'lite';
		}	else if (type === 'Metallic' || type === 'metallic') {
			app.product.data.type = 'metallic';
		}	else if (type === 'Sereno') {
			app.product.data.type = 'sereno';
		}	else if (type === 'Quilted Womens') {
			app.product.data.type = 'quilted-womens';
		}	else if (type === 'Quilted Mens') {
			app.product.data.type = 'quilted-mens';
		}	else if (type === 'alto') {
			app.product.data.type = 'alto';
		} else if (type === 'flow') {
			app.product.data.type = 'slippers-flow';
		} else if (type === 'upper') {
			app.product.data.type = 'upper';
			app.product.data.sku = settings.productSKU;
		} else if (type.indexOf('bag') > -1) {
			app.product.data.type = 'bag';
			app.product.data.sku = settings.productSKU;
		} else if (type.indexOf('bundle') > -1) {
			app.product.data.type = 'bundle';
		} else if (type.indexOf('Gift Card') > -1) {
			app.product.data.type = 'giftcard';
			app.product.data.sku = settings.productOption;
		} else if (type.indexOf('outdoor') > -1) {
			app.product.data.type = 'outdoor';
		} else if (type.indexOf('apparel') > -1) {
			app.product.data.type = 'apparel';
		} else if (type.indexOf('watch') > -1) {
			app.product.data.type = 'watch'
		} else if (type.indexOf('socks') > -1) {
			app.product.data.type = 'socks';
		} else if (type.indexOf('insole') > -1) {
			app.product.data.type = 'insole';
		} else if (type.indexOf('breathe') > -1) {
			app.product.data.type = 'slippers-breathe';
		} else if (type.indexOf('wholesale') > -1) {
			app.product.data.type = 'wholesale';
		} else {
			app.product.data.type = 'singleproduct';
			app.product.data.sku = settings.productSKU;
		}
	}

	/**
	 * @private
	 * @function
	 * @description SET product upper from URL
	 **/
	function setUrlUpper(upper) {
		$('#upperSelector .product-options-form').find('.item').each(function () {
			var $this = $(this),
				upperSKU = $this.data('upper-short');

			if (upper == upperSKU) {
				$('.item-upper-select').removeClass('selected');
				$this.addClass('selected');
				$this.trigger('click');  // shame!!
				app.product.switchUpperTab($this.parent());

				// Updating microdata img
				var imgSrc = $this.find('img').attr('src');
				$('#microdataImg').attr('src', imgSrc);
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description SET product colour from URL
	 **/
	function setUrlColour(colour) {
		$('#soleColorBadges').children().each(function () {
			var $this = $(this),
				soleName = $this.find('.input-min').val().replace(/\s+/g, '').toLowerCase(),
				soleSKU = $this.data('colour');

			if (colour == soleName || colour == soleSKU) {
				$('#soleColorBadges').children().removeClass('selected');
				$this.addClass('selected');
				$this.find('label').trigger('click');
			}
		});
	}

	function setUrlGender(gender) {
		var genderValue = gender + 's',
			$gender = $cache.sizeGenderSelector.find('li[data-gendertype="' + genderValue + '"]');

		if (app.currency.get() !== 'EUR' && app.currency.get() !== 'GBP' ) {
			$gender.trigger('click');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Get product ID with SKU parameter
	 **/
	function getProductID(sku, store) {
		var variantStoreID = store || "variant-gbp";
		app.multistore.variantDataDeffer.done(function () {
			return app.multistore.data.variants[sku][variantStoreID];
		});
	}

	/**
	 * @private
	 * @function
	 * @description Check variant inline stock
	 **/
	function checkUpperStock(size) {
		$('#upperSelector').find('.js-variant-inline').each(function () {
			var $this = $(this),
				sku = $this.data('sku').split('-'),
				skuSuffix = $this.data('sku-suffix'),
				preorderDisabled = $this.data('is-out-stock'),
				newSKU = sku[0] + '-' + sku[1] + '-' + size + '-' + sku[2] + '-' + sku[3] + '-' + skuSuffix,
				stock = app.stock.get(newSKU);

			console.log('123');
			console.log(stock);

			if (preorderDisabled && (stock <= settings.itemStockToOOS)) {
				$this.addClass('is-oos-faded').removeClass('is-unavailable');
			} else if (stock === undefined) {
				$this.addClass('is-unavailable');
			} else {
				$this.removeClass('is-oos-faded is-unavailable');
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize All sizes stock on DOM
	 **/
	function initializeAllSizesStock() {
		if (app.stock.initialized) {
			checkAllSizesStock();
			checkAllUppersStock();
			checkInitialColour();
		} else if (app.product.sizeStockRetryAmount < 20) {
			app.product.sizeStockRetryAmount++;
			setTimeout(initializeAllSizesStock, 1000);
		}
	}


	function checkInitialColour() {
		var upper = app.utils.getUrlParam('upper');

		// hide initial purpledot message
		$('#pd-waitlist-info').addClass('is-hidden');

		if ($('#redirectUpper').text() !== "") {
			upper = $('#redirectUpper').text();
		}

		if (!upper) {
			$('.js-variant-inline').each(function(){
				var $this = $(this),
					isHidden = $this.hasClass('hidden');
				if (!isHidden) {
					$this.trigger('click');
					return false;
				}
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Check all upper stock if sizes are available
	 **/
	function checkAllUppersStock() {
		$('.item-upper-select').each(function(){

			var $this = $(this),
				upperSku = $this.data('sku'),
				isUpperInStock = false,
				upperSkuSplitted = upperSku.split('-'),
				stockLoaded = app.stock.get('MC-C-36-LG-SY'),
				sizesRange = $.parseJSON(Theme.product.sizesRange),
				sizeSkuRangeDraft = sizesRange[upperSku] || "35-51",
				sizeSkuRange = sizeSkuRangeDraft.split('-'),
				sizeSkuMin = sizeSkuRange[0],
				skuSuffix = app.product.data.sku.split('-').pop(),
				sizesSocks = ['SM', 'MD', 'LR'],
				sizeSkuMax = sizeSkuRange[1];

			if (sizeSkuRange) {
				for (var i = sizeSkuMin; i <= sizeSkuMax; i++) {
					var skuToCheck = upperSkuSplitted[0] + '-' + upperSkuSplitted[1] + '-' + i + '-' + upperSkuSplitted[2] + '-' + upperSkuSplitted[3] + '-' + skuSuffix,
						skuStock = app.stock.get(skuToCheck);

					if (skuStock > 0 && skuStock !== undefined) {
						isUpperInStock = true;
					}
				}

				if (upperSku.indexOf('ST-A') > -1) {
					$.each(sizesSocks, function(index, size){
						var skuToCheck = upperSkuSplitted[0] + '-' + upperSkuSplitted[1] + '-' + size + '-' + upperSkuSplitted[2] + '-' + upperSkuSplitted[3] + '-' + skuSuffix,
							skuStock = app.stock.get(skuToCheck);

						if (skuStock > 0 && skuStock !== undefined) {
							isUpperInStock = true;
						}
					});
				}

				if (!isUpperInStock && stockLoaded !== undefined) {
					$this.addClass('hidden');
				} else {
					$this.removeClass('hidden');
				}
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Check all sizes selected SKU stock
	 **/
	function checkAllSizesStock($upper) {
		var sku = app.product.data.sku.split('-'),
			replacementSkuList = $.parseJSON(Theme.product.replacementSKU),
			upperColour = $upper,
			preorderSizesList = [];

		if (!$upper) {
			upperColour = $('.js-variant-inline.selected');
		}

		$(upperColour).find('.js-inventory-data-levels').each(function(){
			// console.log('test');
			var isPreorderSize = $(this).data('purpledot-preorder') === "ON_PREORDER";
			// console.log(isPreorderSize);


			if (isPreorderSize) {
				var preOrderSku = $(this).data('sku');
				preorderSizesList.push(preOrderSku);
			}
		})

		// Classic additional cases
		$('.js-inventory-data').find('.js-inventory-data-levels').each(function(){
			var isPreorderSize = $(this).data('purpledot-preorder') === "ON_PREORDER";

			if (isPreorderSize) {
				var preOrderSku = $(this).data('sku');
				preorderSizesList.push(preOrderSku);
			}
		})

		// console.log(preorderSizesList);

		$('.js-size-selector').each(function () {
			var $this = $(this),
				gender = $this.attr('data-size-gender'),
				isActive = !$this.hasClass('hidden');

			if (isActive) {

				$this.find('li').each(function () {
					var $size = $(this),
						size = $size.attr('data-value'),
						newSku = sku[0] + '-' + sku[1] + '-' + size + '-' + sku[3] + '-' + sku[4] + '-' + sku[5],
						isPreorderSizeSelector = $.inArray(newSku, preorderSizesList) > -1;

					if (isPreorderSizeSelector) {
						// console.log('is preorder size -', size);
					}

					$size.removeClass('is-out-stock');

					if (app.stock.initialized) {
						var stock = app.stock.get(newSku),
							replacementSKU = replacementSkuList[newSku],
							replacementStock = 0,
							stockLimit = Theme.stock.outOfStockLimit;

						if (replacementSKU) {
							replacementStock = app.stock.get(replacementSKU);
						}

						if ($cache.collectionType === 'slippers-fs-summer') {
							stockLimit = Theme.stock.zeroOutOfStockLimit;
						}

						// trigger preorder classes
						if (isPreorderSizeSelector) {
							$size.addClass('js-is-preorder-size')
						} else {
							$size.removeClass('js-is-preorder-size')
						}

						if (stock !== undefined && stock < stockLimit && !isPreorderSizeSelector) {
							if (replacementSKU) {
								if (replacementStock === 0 || replacementStock < stockLimit) {
									$size.addClass('is-out-stock')
								} else {

								}
							} else {
								if (isPreorderSizeSelector) {
									$size.addClass('js-is-preorder-size')
								} else {
									$size.addClass('is-out-stock')
								}
							}
						}
					}
				})
			}
		})
	}

	/**
	 * @private
	 * @function
	 * @description Check all colours stock with selected upper
	 **/
	function checkComboStock(size) {
		var $upperSelector = $('#upperSelector');
		if ($upperSelector.length > 0) {
			var selectedUpper = $upperSelector.find('.item-upper-select.selected'),
				upperPartials = selectedUpper.data('sku').split('-'),
				hiddenColourSelected = false,
				skuSuffix = selectedUpper.data('sku-suffix');

			$('#soleColorBadges').find('.js-variant-inline').not(".hidden").each(function () {
				var $this = $(this),
					colourPartials = $this.data('sku').split('-'),
					comboSKU = upperPartials[0] + '-' + upperPartials[1] + '-' + size + '-' + upperPartials[2] + '-' + colourPartials[2];

				if (upperPartials[2] == 'ON' && colourPartials[2] == 'WH') {
					comboSKU = upperPartials[0] + '-' + upperPartials[1] + '-' + size + '-AW-WH';
				}

				if (skuSuffix) {
					comboSKU = comboSKU + '-' + skuSuffix;
				}

				if (comboSKU.indexOf('GY-II') > -1 || comboSKU.indexOf('GY-SB' > -1)) {
					comboSKU = comboSKU.replace('GY', 'GG');
				}

				if (comboSKU.indexOf('MC-F') > -1 && comboSKU.indexOf('LG-SY') > -1) {
					comboSKU = comboSKU.replace('MC-F', 'MC-P');
				}

				if (comboSKU.indexOf('MC-F') > -1 && comboSKU.indexOf('DG-SB') > -1) {
					comboSKU = comboSKU.replace('MC-F', 'MC-P');
				}

				if (comboSKU.indexOf('MC-F') > -1 && comboSKU.indexOf('LG-NY') > -1) {
					comboSKU = comboSKU.replace('MC-F', 'MC-P');
				}

				if (comboSKU.indexOf('MC-F') > -1 && comboSKU.indexOf('LG-GM') > -1) {
					comboSKU = comboSKU.replace('MC-F', 'MC-P');
				}

				if (comboSKU.indexOf('MC-F') > -1 && comboSKU.indexOf('LG-CR') > -1) {
					comboSKU = comboSKU.replace('MC-F', 'MC-P');
				}

				var comboStock = app.stock.get(comboSKU),
					stockLimit = Theme.stock.outOfStockLimit;

				if ($('#productCollectionType').text() === 'slippers-fs-summer') {
					stockLimit = Theme.stock.zeroOutOfStockLimit;
				}

				if (comboStock < stockLimit) {
					$this.addClass('is-oos-faded').removeClass('is-unavailable');
				} else if (comboStock === undefined) {

					$this.addClass('is-unavailable');
					if ($this.hasClass('selected')) {
						hiddenColourSelected = true
					}
				} else {
					$this.removeClass('is-oos-faded is-unavailable')
				}
			});

			// Switch to first available
			if (hiddenColourSelected) {
				$('#soleColorBadges').find('.js-variant-inline').each(function () {
					var $this = $(this),
						isUnavailable = $this.hasClass('is-unavailable'),
						isHidden = $this.hasClass('hidden');

					if (!isUnavailable && !isHidden) {
						$this.find('label').trigger('click');
						return false;
					}
				});
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Remove colour out of stock styling
	 **/
	function resetComboStock() {
		$('#soleColorBadges').find('.js-variant-inline').removeClass('is-oos-faded')
	}

	/**
	 * @private
	 * @function
	 * @description Check collection stock
	 **/
	function checkCollectionStock() {
		$('.js-upper-tabs-content').each(function () {
			var $this = $(this),
				collection = $this.data('collection'),
				$collectionTab = $('.js-upper-tabs-selector[data-collection="' + collection + '"]'),
				availableChildren = $this.children().length;

			// check available uppers
			$this.children().each(function () {
				if ($(this).hasClass('is-outofstock')) {
					availableChildren--;
				}
			});

			// hide collection if all uppers unavailable
			if (availableChildren === 0) {
				$collectionTab.addClass('hidden');
			} else {
				$collectionTab.removeClass('hidden');
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Look for available variant if selected if out of stock
	 **/
	function findAvailableVariant(type, collection) {
		var $wrapper;

		// change wrapper depends on type
		if (type === 'upper') {
			if (collection) {
				$wrapper = $cache.upperSelector.find('.js-upper-tabs-content.active')
			} else {
				$wrapper = $cache.upperSelector;
			}

		} else if (type === 'colour') {
			$wrapper = $cache.colourSelector;
		}
		$wrapper.find('.js-variant-inline').each(function () {
			var $this = $(this),
				isAvailable = !$this.hasClass('is-outofstock');

			if (isAvailable) {
				if (type === 'upper') {
					$this.trigger('click');
				} else if (type === 'colour') {
					$this.find('label').trigger('click');
				}
				return false;
			}
		});
	}

	function triggerStockMessage(availability, option) {
		if (!availability) {
			$cache.stockAvailableMsg.addClass('hidden');
			if (option == 'colours') {
				$('#soleOutOfStock').removeClass('hidden');
			} else if (option == 'upper') {
				$('#upperOutOfStock').removeClass('hidden');
			}
		} else {
			// $cache.stockAvailableMsg.removeClass('hidden invisible');
			$('#productStockMsg').find('.js-outofstock-msg').addClass('hidden');
		}
	}

	function detectAllOptionsUnavailable(uppersLimit, coloursLimit) {
		var uppersNotAvailable = $cache.upperSelector.find('.js-variant-inline.is-outofstock').length,
			coloursNotAvailable = $cache.colourSelector.find('.js-variant-inline.is-outofstock').length;

		if (uppersNotAvailable == uppersLimit) {
			$cache.upperSelector.find('.js-variant-inline').addClass('is-transparent');
			$cache.oosUpsell.removeClass('hidden');
		} else {
			$cache.upperSelector.find('.is-transparent').removeClass('is-transparent');
			$cache.oosUpsell.addClass('hidden');
		}

		if (coloursLimit == coloursNotAvailable) {
			$cache.colourSelector.find('.js-variant-inline:not(".sole-ns")').addClass('is-transparent');
			$cache.oosUpsell.removeClass('hidden');
			triggerStockMessage(false, 'colours');
		} else {
			$cache.colourSelector.find('.is-transparent').removeClass('is-transparent');
			$cache.oosUpsell.addClass('hidden');
			triggerStockMessage(true);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Switch to available variant if selected if out of stock
	 **/
	function switchToAvailableVariant() {
		var selectedUpperOOS = $cache.upperSelector.find('.js-variant-inline.selected').hasClass('is-outofstock'),
			selectedUpperCollection = $cache.upperSelector.find('.js-variant-inline.selected').data('collection-fixed'),
			selectedColourOOS = $cache.colourSelector.find('.js-variant-inline.selected').hasClass('is-outofstock'),
			selectedColourNosole = $cache.colourSelector.find('.js-variant-inline.selected').hasClass('sole-ns'),
			upperOptionsAmount = $cache.upperSelector.find('.js-variant-inline:not(".sole-ns")').length,
			soleOptionsAmount = $cache.colourSelector.find('.js-variant-inline:not(".sole-ns")').length,
			soleSwitchAvailable = $cache.colourSelector.data('switch-oos');

		if (selectedUpperOOS) {
			findAvailableVariant('upper', selectedUpperCollection);
		}

		if (soleSwitchAvailable && (selectedColourOOS || selectedColourNosole)) {
			findAvailableVariant('colour');
		}

		detectAllOptionsUnavailable(upperOptionsAmount, soleOptionsAmount);
	}

	/**
	 * @private
	 * @function
	 * @description Switch upper collection on all slippers page
	 **/
	function changeUpperCollection(el, makeChange) {
		var collection = el.data('collection'),
			isMobile = app.ui.isMobile(),
			$upperTab = $('.js-upper-tabs-wrapper'),
			$collectionWrapper = $('.js-upper-tabs-content[data-collection="' + collection + '"]'),
			scrollPosition = $upperTab.scrollLeft();

		// change tab
		el.siblings().removeClass('active');
		el.addClass('active');

		if (makeChange) {
			// change content
			$('.js-upper-tabs-content').removeClass('active');
			$collectionWrapper.addClass('active');

			// scroll uppers
			if (isMobile) {
				var scrollToEl = $collectionWrapper.position().left - 1;
				$upperTab.animate({
					scrollLeft: scrollToEl + scrollPosition
				});
			}

			// select first available
			$collectionWrapper.children().each(function () {
				var $this = $(this),
					isDisabled = $this.hasClass('is-outofstock');

				if (!isDisabled) {
					$this.trigger('click');
					return false;
				}
			});
		}

	}

	/**
	 * @private
	 * @function
	 * @description Force upper tab switch
	 **/
	function switchUpperTab(el) {
		var collection = el.data('collection') || false;
		if (collection) {
			var $tab = $('.js-upper-tabs-selector[data-collection="' + collection + '"]'),
				$tabContent = $('.js-upper-tabs-content[data-collection="' + collection + '"]');
			$tab.siblings().removeClass('active');
			$tabContent.siblings().removeClass('active');
			$tab.addClass('active');
			$tabContent.addClass('active');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Switch soles available after switching upper
	 **/
	function switchSolesRange(soles) {
		if (soles) {
			var $wrapper = $('#soleColorBadges'),
				selectedColour = $wrapper.find('.item.selected').data('colour'),
				colourIsAvailable = false;

			$wrapper.find('.item').addClass('hidden');

			var solesRange = soles.split(',');
			$.each(solesRange, function (index, value) {
				$wrapper.find('.item[data-colour="' + value + '"]').removeClass('hidden');
				if (selectedColour == value) {
					colourIsAvailable = true;
				}
			});

			// check if selected sole is from soles range
			if (!colourIsAvailable) {
				$.each(solesRange, function (index, value) {
					var isOutOfStockSole = $wrapper.find('.item[data-colour="' + solesRange[index] + '"]').hasClass('is-outofstock');
					if (!isOutOfStockSole) {
						$wrapper.find('.item[data-colour="' + solesRange[index] + '"]').find('label').trigger('click');
						return false;
					}
				});
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Scroll slider to specific slide
	 **/
	function switchProductSlider(slide) {
		if (slide) {
			$('.product-detail-carousel').trigger('to.owl.carousel', [slide - 1, 1, true]);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Product title add specific label
	 **/
	function switchTitleLabel(label, style) {
		if (label) {
			$cache.productTitle.attr('data-title-label', label).addClass('is-label-active');
			$cache.productTitleMobile.attr('data-title-label', label).addClass('is-label-active');
			$('#productImagesWrapper').attr('data-title-label', label).addClass('is-label-active');
		} else {
			$cache.productTitle.attr('data-title-label', '').removeClass('is-label-active');
			$cache.productTitleMobile.attr('data-title-label', '').removeClass('is-label-active');
			$('#productImagesWrapper').attr('data-title-label', '').removeClass('is-label-active');
		}

		$('#productImagesWrapper, #mobileGalleryLabel').removeClass('is-tenis-icon');

		if (style == 'new') {
			$cache.productTitle.addClass('is-label-new');
			$cache.productTitleMobile.addClass('is-label-new');
		} else if (style == 'new-ab') {
			$cache.productTitle.addClass('is-label-new is-label-new-ab');
			$cache.productTitleMobile.addClass('is-label-new is-label-new-ab');
		} else if (style == 'tenis') {
			$('#productImagesWrapper, #mobileGalleryLabel').addClass('is-tenis-icon')
		} else {
			$cache.productTitle.removeClass('is-label-new is-label-new-ab');
			$cache.productTitleMobile.removeClass('is-label-new is-label-new-ab');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Detect title label on DOM load
	 **/
	function detectTitleLabel() {
		var $upperSelector = $('#upperSelector');

		if ($upperSelector.length) {
			var selectedItem = $upperSelector.find('.item-upper-select.selected').attr('data-title-label') || false,
				labelStyle = $upperSelector.find('.item-upper-select.selected').attr('data-label-style') || false
			switchTitleLabel(selectedItem, labelStyle);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Gender Popup dynamic links change
	 **/
	function changeGenderLinks(women, men) {
		var $linkMens = $cache.genderPopup.find('.js-link-mens'),
			$linkWomens = $cache.genderPopup.find('.js-link-womens');

		if (women && men) {
			$linkWomens.attr('href', women);
			$linkMens.attr('href', men);
		} else {
			$linkWomens.attr('href', $linkWomens.data('link-original'));
			$linkMens.attr('href', $linkMens.data('link-original'));
		}
	}

	/**
	 * @private
	 * @function
	 * @description Generate size selector values depends on gender/country
	 **/
	function generateSizeSelector(triggerSelect) {
		var selectedCurrency = Shopify.currency.active,
			selectedCountry = Shopify.country;

		$('.js-size-selector').each(function () {
			var $select = $(this),
				gender = $select.data('size-gender');

			$select.find('li').each(function () {
				var $option = $(this),
					sizeEU = $option.data('size-eu'),
					sizeUS = $option.data('size-us-' + gender),
					sizeAU = $option.data('size-au-' + gender),
					sizeUK = $option.data('size-uk') || '';

				if ($option.val() !== '') {
					if (app.product.data.type === 'socks') {
						var sizeName = $option.data('name');
						if (selectedCurrency === 'USD' || selectedCountry === "US") {
							$option.html(sizeName + '\xa0' + '<div>US ' + sizeUS + '</div>');
						} else if (selectedCurrency === 'GBP' || selectedCountry === "GB") {
							$option.html(sizeName + '\xa0' + '<div>UK ' + sizeUK + '</div>');
						} else if (selectedCurrency === 'AUD' || selectedCountry === "AU") {
							$option.html('EU ' + sizeEU);
						} else {
							$option.html(sizeName + '\xa0' + '<div>EU ' + sizeEU + '</div>');
						}
					} else {
						if (selectedCurrency === 'GBP') {
							if (sizeUK === undefined || sizeUK === '') {
								$option.html('EU ' + sizeEU);
							} else {
								$option.html(sizeUK + '\xa0' + '<div>EU ' + sizeEU + '</div>');
							}
						} else if (selectedCurrency === 'USD') {
							$option.html(sizeUS + '\xa0' + '<div>EU ' + sizeEU + '</div>');
						} else if (selectedCurrency === 'AUD') {
							$option.html('EU ' + sizeEU);
						} else {
							$option.html('EU ' + sizeEU);
						}
					}
				}
			});
		});
	}

	/**
	 * @private
	 * @function
	 * @description Reset size selector on initial page load
	 **/
	function resetSizeSelector() {
		var $sizeSelector = $('.js-size-selector');

		if ($sizeSelector.length > -1) {
			$sizeSelector.find('li').removeClass('selected');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Set product size as selected if no selector exist
	 **/
	function detectSizeSelector() {
		var sizeSelectorAvailable = $('#product-select').length < 1;
		if (sizeSelectorAvailable) {
			app.product.size.selected = true;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Generate product url based on sku
	 **/
	function getProductUrl(sku) {
		var initialUrl = window.location.href.split('?')[0],
			skuArr = sku.split('-'),
			range = skuArr[0] + '-' + skuArr[1],
			upper = skuArr[3].toLowerCase(),
			sole = skuArr[4].toLowerCase();

		if (range === "MO-F") {
			initialUrl = initialUrl + '?upper=' + upper
		} else if (range === "MC-F") {
			initialUrl = initialUrl + '?upper=' + upper + '&colour=' + sole
		} else  {
			initialUrl = initialUrl + '?upper=' + upper + sole
		}

		return initialUrl;
	}

	/**
	 * @private
	 * @function
	 * @description Get form data for BIS automation
	 **/
	function getBackinstockData($form, country) {
		var currency = app.currency.get(),
			sku = app.product.data.sku,
			variant = app.multistore.data.variants[sku]["variant-gbp"];

		data = {
			"email": $form.find('.js-customer-email').val(),
			"sku": sku,
			"store": "mahabis",
			"first_name": $form.find("input[name='firstname']").val(),
			"last_name": $form.find("input[name='lastname']").val(),
			"product_url": getProductUrl(sku),
			"variant_id": variant,
			"extra": {
				"currency" : currency.toLowerCase(),
				"country": country
			}
		}

		return data;
	}

	function validateBackInStockEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	/**
	 * @private
	 * @function
	 * @description Email me when back in stock
	 **/
	function postBackInStockEmail($form) {
		var customerEmail = $form.find('.js-customer-email').val(),
			country = $.cookie('deliveryC'),
			formattedDate = app.utils.formatDate(new Date());
		var isValidEmail = validateBackInStockEmail(customerEmail);

		if (isValidEmail) {
			$form.find('.js-product-sku').val(app.product.data.sku);
			$form.find('.js-product-skudate').val(formattedDate);
			$form.find('.js-ometria-geoip-country').val(country);
			$form.find('.js-email-validation').addClass('hidden');
			var apiData = getBackinstockData($form, country);

			var klaviyoId = 'RuXt72',
				email = $('#notifyMeEmail').val();

			app.multistore.variantDataDeffer.done(function () {
				var variantID = app.multistore.data.variants[app.product.data.sku]["variant-gbp"],
					variantIdParam = "$shopify:::$default:::" + variantID;

				var payload = {
					"data": {
						"type": "back-in-stock-subscription",
						"attributes": {
							"profile": {
								"data": {
									"type": "profile",
									"attributes": {
										"email": customerEmail,
									}
								}
							},
							"channels": ["EMAIL"],
						},
						"relationships": {
							"variant": {
								"data": {
									"type": "catalog-variant",
									"id": variantIdParam
								}
							}
						}
					}
				}

				$.ajax({
					url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + klaviyoId,
					type: 'post',
					headers: {
						"Content-Type": "application/json",
						"revision":"2024-06-15"
					},
					data: JSON.stringify(payload),
					beforeSend: function() {
						$cache.backInStockPopup.addClass('is-loading');
						app.utils.setCookie('cEmail', customerEmail);
					},
					success: function (response) {
						$cache.backInStockPopup.addClass('is-success').removeClass('is-loading');
					}
				});
			});
		} else {
			$form.find('.js-email-validation').removeClass('hidden');
		}

	}

	/**
	 * @private
	 * @function
	 * @description Email slipper interest
	 **/
	function postSlipperInterestEmail($form) {
		var isSubscribed = $form.find('#newsletterSubscribe').prop('checked');
		if (isSubscribed) {
			$('#newsletterSubscribeStatus').val("SUBSCRIBED");
		} else {
			$('#newsletterSubscribeStatus').val("");
		}
		var data = $form.serialize();

		$.ajax({
			type: "POST",
			url: "https://api.ometria.com/forms/signup/ajax",
			data: data,
			cache: false,
			dataType: 'json',
			contentType: "application/x-www-form-urlencoded",
			beforeSend: function () {
				$('#modalNewSlipper').addClass('is-loading');
			},
			complete: function () {
				$('#modalNewSlipper').removeClass('is-loading');
			},
			error: function (err) {
				$('#modalNewSlipper').find('.js-validation-error').html(err);
			},
			success: function (data) {
				var msg = data.errors;

				if (data.ok) {
					$('#modalNewSlipper').addClass('is-success')
				} else {
					if (msg.indexOf('already subscribed') > -1) {
						msg = msg.substring(0, msg.indexOf('subscribed') + 'subscribed'.length);
					}
					$('#modalNewSlipper').find('.js-validation-error').html(msg);
				}
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize product mobile carousel
	 **/
	function initProductCarousel() {
		var slideNumber = $cache.productCarousel.attr('data-initialslide') || 1,
			initialSlide = parseInt(slideNumber) - 1;

		if (initialSlide > 0) {
			$cache.productCarousel.trigger('to.owl.carousel', initialSlide);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Product video play
	 **/
	function playProductVideo($el) {
		var $video = $('#productDesktopVideo'),
			newSrc = $video.attr('data-src');
		$video.find('source').attr('src', newSrc);
		$el.find('img').addClass('hidden');
		$el.find('.product-thumb-videoicon').addClass('hidden');
		$video.get(0).load();
		$video.get(0).play();
		$cache.imageWrapper.addClass('hidden');
		$cache.videoWrapper.removeClass('hidden');
		$('.js-thumbnail-video').addClass('active');
		$('.product-thumb, .product-thumb-new').removeClass('active');
	}

	/**
	 * @private
	 * @function
	 * @description Unboxing video play
	 **/
	function playUnboxingVideo($el) {
		$('#productDesktopVideoUnboxing').get(0).play();
		$cache.imageWrapper.addClass('hidden');
		$el.find('img').addClass('hidden');
		$el.find('.product-thumb-videoicon').addClass('hidden');
		$('.js-product-unboxingvideo').removeClass('hidden');
		$('.js-thumbnail-video').addClass('active');
		$('.product-thumb, .product-thumb-new').removeClass('active');
	}

	/**
	 * @private
	 * @function
	 * @description Spinner video play
	 **/
	function playSpinnerVideo($el) {
		var $video = $('#productDesktopVideoSpinner'),
			newSrc = $video.attr('data-src');
		$video.find('source').attr('src', newSrc);
		$el.find('img').addClass('hidden');
		$el.find('.product-thumb-videoicon').addClass('hidden');
		$video.get(0).load();
		$video.get(0).play();
		$cache.imageWrapper.addClass('hidden');
		$('.js-product-spinvideo').removeClass('hidden');
		$('.js-thumbnail-video').addClass('active');
		$('.product-thumb, .product-thumb-new').removeClass('active');
	}

	/**
	 * @private
	 * @function
	 * @description Spinner video play
	 **/
	function playOnFootVideo($el) {
		var $video = $('#productDesktopVideoOnFoot'),
			newSrc = $video.attr('data-src');
		$video.find('source').attr('src', newSrc);
		$video.get(0).load();
		$el.find('img').addClass('hidden');
		$el.find('.product-thumb-videoicon').addClass('hidden');
		$video.get(0).play();
		$cache.imageWrapper.addClass('hidden');
		$('.js-product-onfootvideo').removeClass('hidden');
		$('.js-thumbnail-video').addClass('active');
		$('.product-thumb, .product-thumb-new').removeClass('active');
	}


	/**
	 * @private
	 * @function
	 * @description Switch product page styling depends on slipper selected
	 **/
	function switchProductStyling(style) {
		var $body = $('body');

		if (style === 'initial') {
			var initialStyle = $('.item-upper-select.selected').data('style-switch') || false;
			$body.addClass(initialStyle);
		} else if (style) {
			$body.addClass(style)
		} else {
			$body.alterClass('is-style-*')
		}

		if (style === 'is-style-preorder') {
			$('#addToCartWrapper').find('.submit-button').attr('value', 'pre order')
		} else {
			var isWholeSale = $('#addToCartWrapper').find('.submit-button').hasClass('submit-button-wholesale');

			if (isWholeSale) {
				$('#addToCartWrapper').find('.submit-button').attr('value', 'add to cart')
			} else {
				$('#addToCartWrapper').find('.submit-button').attr('value', 'add to cart')
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Set sizes dropdown depends on available
	 **/
	function setSizeRange(sizeRange) {
		if (sizeRange) {
			var sizeRangeSplitted = sizeRange.split('-'),
				sizeMin = sizeRangeSplitted[0],
				sizeMax = sizeRangeSplitted[1];
			$('.js-size-selector').each(function () {
				var $sizeSelector = $(this);

				$sizeSelector.find('li').each(function () {
					var $this = $(this),
						sizeOptionValue = $this.data('size-eu');
					if (sizeMin > sizeOptionValue || sizeMax < sizeOptionValue) {
						var isSelected = $this.hasClass('selected');
						$this.addClass('hidden');

						if (isSelected) {
							$('.submit-button').attr('data-active', false);
							app.product.size.selected = false;
							$sizeSelector.find('li').removeClass('selected');
						}
					} else {
						$this.removeClass('hidden');
					}
				})
			})
		} else {
			$('.js-size-selector').find('li').each(function () {
				$(this).removeClass('hidden')
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Klarna change product price dynamically
	 **/
	function klarnaChangePrice() {
		var newPrice = $('#bundlePrice').find('span:not(.money-discount)').find('.money').text().replace(/\D/g, ""),
			isKlarnaEnabled = document.getElementsByTagName("klarna-placement").length > 0;

		if (newPrice.indexOf('.') > -1) {
			newPrice.replace('.', '');
		} else {
			newPrice = newPrice + '00';
		}

		if (isKlarnaEnabled) {
			document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", newPrice);
			window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
			window.KlarnaOnsiteService.push({eventName: 'refresh-placements'});
		}
	}

	function getSizeRange() {
		var sizeRange = '35-51';
		var skuSplitted = app.product.data.sku.split('-');
		var skuToCheck = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4];
		var allRange = $.parseJSON(Theme.product.sizesRange);
		var customRange = allRange[skuToCheck];

		if (customRange) {
			sizeRange = customRange;
		}

		return sizeRange
	}

	function generateOOSMessage(sku) {
		var skuSplitted = sku.split('-'),
			newSku = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4],
			$wrapper = $('#deliveryTermsWrapper');

		if (newSku in Theme.product.outOfStockDelivery) {
			$wrapper.find('#deliveryTermsDate').text(Theme.product.outOfStockDelivery[newSku]);
			$wrapper.removeClass('hidden');
		} else {
			$wrapper.addClass('hidden');
		}
	}

	function toggleProductAccordion($el) {
		var $parent = $el.parent();
		$parent.toggleClass('is-active');
	}

	function getCustomerReviews() {
		var skuSplitted = Theme.product.firstVariantSKU.split('-'),
			skuFormatted = skuSplitted[0] + '-' + skuSplitted[1],
			reviewsRenderLimit = 30,
			reviewsUrl = 'https://cdn.mahabis.com/trustpilot/' + skuFormatted + '.json';

		console.log(reviewsUrl);

		$.ajax({
			url: reviewsUrl,
			type: 'GET',
			success: function (data) {
				$cache.reviewsCache = data;
				setCustomerReviews(data, reviewsRenderLimit);
			}
		})
	}

	function initializeReviewsCarousel() {
		$('#productReviews').owlCarousel({
			items: 3,
			loop: true,
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 3500,
			margin: 0,
			responsive: {
				0: {
					items: 2,
					center: true
				},
				600: {
					items: 3,
					center: false
				}
			},
			navText: ["<i class='chevron left'></i>", "<i class='chevron right'></i>"]
		});
	}

	function setCustomerReviews(data, reviewsRenderLimit) {
		var $reviewsWrapper = $('#productReviews'),
			starsImageUrl = $reviewsWrapper.data('star-icon'),
			starsImageUrlRed = $reviewsWrapper.data('star-icon-red'),
			productTitle = $('#productSubtitle').text() + ' reviews',
			productHandle = $reviewsWrapper.data('handle'),
			starsEmptyImageUrl = $reviewsWrapper.data('star-icon-empty'),
			starsEmptyImageUrlRed = $reviewsWrapper.data('star-icon-empty-red'),
			starsHalfImageUrl = $reviewsWrapper.data('star-icon-half'),
			starsHalfImageUrlRed = $reviewsWrapper.data('star-icon-half'),
			globalReviewsRatingTotal = 0,
			globalReviewsRatingAmount = 0,
			attributedReviewsAmount = 0,
			totalReviewsRating = 0,
			globalAttributeComfort = 0,
			globalAttributeTrueToFit = 0,
			globalAttributeStyle = 0,
			globalAttributeQuality = 0,
			globalAttributeValue = 0,
			reviewsIteratedAmount = 0,
			reviewsLoadLimit = reviewsRenderLimit || $('#productReviewsMore').data('reviews-limit'),
			initialReviewsCount = data.length,
			importedReviewsCount = data.length + 26474,
			reviewsCount = data.length,
			node1stars = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li></ul>",
			node2stars = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li></ul>",
			node3stars = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li></ul>",
			node35stars = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsHalfImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li></ul>",
			node4stars = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrl + "/>'</li></ul>",
			node45stars = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsHalfImageUrl + "/>'</li></ul>",
			node5stars = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li><li class='review-star'><img src='" + starsImageUrl + "/>'</li></ul>",
			node1starsRed = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li></ul>",
			node2starsRed = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li></ul>",
			node3starsRed = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li></ul>",
			node35starsRed = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsHalfImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li></ul>",
			node4starsRed = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsEmptyImageUrlRed + "/>'</li></ul>",
			node45starsRed = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsHalfImageUrlRed + "/>'</li></ul>",
			node5starsRed = "<ul class='review-star-wrapper'><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li><li class='review-star'><img src='" + starsImageUrlRed + "/>'</li></ul>";



		// Adding Yotpo exported reviews
		if (productHandle == "classic-slippers") {
			var	reviewsCountNode = "<div class='reviewsCount'><span>" + importedReviewsCount + " Reviews </span></div>";
		} else {
			var	reviewsCountNode = "<div class='reviewsCount'><span>" + reviewsCount + " Reviews </span></div>";
		}

		var reviewsNode = "";

		$('#productReviewsTitle').html(productTitle);
		$(reviewsCountNode).insertAfter('#productReviews');

		$.each(data, function (key, review) {
			var content = review.content,
				author = review.consumer.displayName,
				createdAt = review.createdAt.split('T')[0],
				stars = review.stars,
				reviewsRenderStop = false,
				starsNode = null,
				attributes = review.attributeRatings,
				attributeComfort = null,
				attributeTrueToFit = null,
				attributeQuality = null,
				attributeStyle = null,
				attributesNode = "<div></div>",
				showReviewOnsite = true,
				attributeValueForMoney = null;

			if (content.indexOf('disappointed') > -1 ||
				content.indexOf('too expensive') > -1 ||
				content.indexOf('too expensive') > -1 ||
				content.indexOf('weeks') > -1  ||
				content.indexOf('wears down') > -1 ||
				content.indexOf('bit sweaty') > -1 ||
				content.indexOf('Not very safe') > -1 ||
 				content.length > 260 ||
				content.indexOf('digital platform') > -1)
			{
				showReviewOnsite = false
			}



			reviewsIteratedAmount++;

			if (reviewsIteratedAmount > reviewsLoadLimit) {
				reviewsRenderStop = true;
			}

			// Count global stars rating
			globalReviewsRatingAmount++;
			globalReviewsRatingTotal = globalReviewsRatingTotal + stars;

			// Review stars
			if (stars === 3) {
				starsNode = node3stars;
			} else if (stars === 4) {
				starsNode = node4stars;
			} else if (stars === 5) {
				starsNode = node5stars;
			}

			// Custom attributes
			if (attributes.length > 0) {
				attributedReviewsAmount++;

				$.each(attributes, function(atrributeKey, attributeValue) {

					var attributeId = attributeValue.attributeId,
						attributeRatingInitial = attributeValue.rating,
						attributeRating = attributeValue.rating;

					if (attributeRating === 1) {
						attributeRating = node1stars;
					} else if (attributeRating === 2) {
						attributeRating = node2stars;
					} else if (attributeRating === 3) {
						attributeRating = node3stars;
					} else if (attributeRating === 4) {
						attributeRating = node4stars;
					} else if (attributeRating === 5) {
						attributeRating = node5stars;
					}

					if (attributeId === "attributes.default.style" || attributeId === "attributes.default.design") {
						globalAttributeStyle = globalAttributeStyle + attributeRatingInitial;
						attributeStyle = attributeRating
					} else if (attributeId === "attributes.default.comfort") {
						globalAttributeComfort = globalAttributeComfort + attributeRatingInitial;
						attributeComfort = attributeRating
					} else if (attributeId === "attributes.default.true-to-fit") {
						globalAttributeTrueToFit = globalAttributeTrueToFit + attributeRatingInitial;
						attributeTrueToFit = attributeRating
					} else if (attributeId === "attributes.default.quality") {
						globalAttributeQuality = globalAttributeQuality + attributeRatingInitial;
						attributeQuality = attributeRating
					} else if (attributeId === "attributes.default.value-for-money") {
						globalAttributeValue = globalAttributeValue + attributeRatingInitial;
						attributeValueForMoney = attributeRating
					}
				})
			}

			if (attributeComfort) {
				attributesNode =
					"<div class='reviewRight  reviewContainer'>" +
					"<ul class='reviewAttributes'>" +
					"<li><b>Comfort: </b> " + attributeComfort + "</li>" +
					"<li><b>True to size: </b> " + attributeTrueToFit + "</li>" +
					"<li><b>Quality: </b> " + attributeQuality + "</li>" +
					"<li><b>Style: </b> " + attributeStyle + "</li>" +
					"<li><b>Value for money: </b> " + attributeValueForMoney + "</li>" +
					"</ul>" +
					"</div>";
			}

			if (!reviewsRenderStop && showReviewOnsite) {
				reviewsNode +=
					"<div class='reviewSection'>" +
					"<div class='reviewLeft reviewContainer'> " +
					"<div class='reviewStars'>" + starsNode + " </div>" +
					"<div class='reviewContent'>" + content + "</div>" +
					"<div class='reviewAuthor'>" + author + "</div>" +
					"<div class='reviewDate'>" + createdAt + "</div>" +
					"</div>" +
					// attributesNode +
					"</div>";
			}
		});

		$reviewsWrapper.html(reviewsNode);

		initializeReviewsCarousel()

		// Count average rating amount
		totalReviewsRating = parseFloat(globalReviewsRatingTotal / globalReviewsRatingAmount).toFixed(1);

		var totalReviewsRatingNode = "<span>" +  totalReviewsRating + '</span>';

		if (totalReviewsRating == 5) {
			totalReviewsRatingNode = totalReviewsRatingNode + node5stars
		} else if (totalReviewsRating < 5 && totalReviewsRating >= 4.5) {
			totalReviewsRatingNode = totalReviewsRatingNode + node45stars
		} else if  (totalReviewsRating > 4 && totalReviewsRating <= 4.5) {
			totalReviewsRatingNode = totalReviewsRatingNode + node4stars
		} else if (totalReviewsRating > 3.5 && totalReviewsRating < 4) {
			totalReviewsRatingNode = totalReviewsRatingNode + node35stars
		} else if (totalReviewsRating < 3.5) {
			totalReviewsRatingNode = totalReviewsRatingNode + node3stars
		}

		$('#productReviewsRating').html(totalReviewsRatingNode);

		// Adding Yotpo exported reviews
		if (productHandle == "classic-slippers") {
			$('.js-reviews-toptotal, #mobileReviews, #desktopReviews').html(totalReviewsRatingNode + '<div>(' + importedReviewsCount + ')</div>');
		} else {
			$('.js-reviews-toptotal, #mobileReviews, #desktopReviews').html(totalReviewsRatingNode + '<div>(' + globalReviewsRatingAmount + ')</div>');
		}

		var averageValue = parseFloat(globalAttributeValue / attributedReviewsAmount).toFixed(1),
			averageTrueToFit = parseFloat(globalAttributeTrueToFit / attributedReviewsAmount).toFixed(1),
			averageStyle = parseFloat(globalAttributeStyle / attributedReviewsAmount).toFixed(1),
			averageQuality = parseFloat(globalAttributeQuality / attributedReviewsAmount).toFixed(1),
			averageComfort = parseFloat(globalAttributeComfort / attributedReviewsAmount).toFixed(1);

		if (averageValue >= 5) {
			averageValue = averageValue + node5stars
		} else if (averageValue < 5 && averageValue >= 4.5) {
			averageValue = averageValue + node45stars
		} else if  (averageValue >= 4 && averageValue <= 4.5) {
			averageValue = averageValue + node4stars
		} else if (averageValue >= 3.5 && averageValue < 4) {
			averageValue = averageValue + node35stars
		} else if (averageValue < 3.5) {
			averageValue = averageValue + node3stars
		}

		if (averageTrueToFit >= 5) {
			averageTrueToFit = averageTrueToFit + node5stars
		} else if (averageTrueToFit < 5 && averageTrueToFit >= 4.5) {
			averageTrueToFit = averageTrueToFit + node45stars
		} else if  (averageTrueToFit >= 4 && averageTrueToFit <= 4.5) {
			averageTrueToFit = averageTrueToFit + node4stars
		} else if (averageTrueToFit >= 3.5 && averageTrueToFit < 4) {
			averageTrueToFit = averageTrueToFit + node35stars
		} else if (averageTrueToFit < 3.5) {
			averageTrueToFit = averageTrueToFit + node3stars
		}

		if (averageStyle >= 5) {
			averageStyle = averageStyle + node5stars
		} else if (averageStyle < 5 && averageStyle >= 4.5) {
			averageStyle = averageStyle + node45stars
		} else if  (averageStyle >= 4 && averageStyle <= 4.5) {
			averageStyle = averageStyle + node4stars
		} else if (averageStyle >= 3.5 && averageStyle < 4) {
			averageStyle = averageStyle + node35stars
		} else if (averageStyle < 3.5) {
			averageStyle = averageStyle + node3stars
		}

		if (averageQuality >= 5) {
			averageQuality = averageQuality + node5stars
		} else if (averageQuality < 5 && averageQuality >= 4.5) {
			averageQuality = averageQuality + node45stars
		} else if  (averageQuality >= 4 && averageQuality <= 4.5) {
			averageQuality = averageQuality + node4stars
		} else if (averageQuality >= 3.5 && averageQuality < 4) {
			averageQuality = averageQuality + node35stars
		} else if (averageQuality < 3.5) {
			averageQuality = averageQuality + node3stars
		}

		if (averageComfort >= 5) {
			averageComfort = averageComfort + node5stars
		} else if (averageComfort < 5 && averageComfort >= 4.5) {
			averageComfort = averageComfort + node45stars
		} else if  (averageComfort >= 4 && averageComfort <= 4.5) {
			averageComfort = averageComfort + node4stars
		} else if (averageComfort >= 3.5 && averageComfort < 4) {
			averageComfort = averageComfort + node35stars
		} else if (averageComfort < 3.5) {
			averageComfort = averageComfort + node3stars
		}

		var averageNode =
			"<ul>" +
			"<li><div class='consolidatedTitle'>True To Fit</div><div class='consolidatedReviews'>" + averageTrueToFit + "</div></li>" +
			"<li><div class='consolidatedTitle'>Style</div><div class='consolidatedReviews'>" + averageStyle + "</div></li>" +
			"<li><div class='consolidatedTitle'>Comfort</div><div class='consolidatedReviews'>" + averageComfort + "</div></li>" +
			"<li><div class='consolidatedTitle'>Quality</div><div class='consolidatedReviews'>" + averageQuality + "</div></li>" +
			// "<li><div class='consolidatedTitle'>Value for money</div><div class='consolidatedReviews'>" + averageValue + "</div></li>" +
			"</ul>";

		$('#productReviewsRatingAverage').html(averageNode);
	}

	function showDropHintPopup() {
		var productImage = $('.product-gallery-thumbs').find('.product-thumb.first img').attr('src').replace('small', '1024x'),
			collectionName = $('#productSubtitle').text(),
			selectedSize = $('.js-size-selector').find('.selected').text(),
			upperName = $('#legend-upper').text(),
			productName = collectionName + '<br/>' + upperName + '<br/>' + selectedSize;

		if (app.ui.isMobile()) {
			productImage = $('.product-gallery-thumbs').find('.product-thumb.first img').attr('data-src').replace('small', '1024x');
		}

		$('#dropHintImage').attr('src', productImage);
		$('#dropHintProduct').html(productName);

		app.popup.open('modalDropHint');
	}

	function getDropHintUrl() {
		var urlOrigin = window.location.origin,
			urlPath = window.location.pathname,
			skuSplitted = app.product.data.sku.split("-"),
			selectedCollection = skuSplitted[0] + '-' + skuSplitted[1],
			selectedGenderLabel = $('.sizelegend').attr('style'),
			selectedGenderValue = null,
			sizeUrlParams = null,
			selectedSize = parseInt(skuSplitted[2]),
			selectedUpper = skuSplitted[3].toLowerCase(),
			selectedColour = skuSplitted[4].toLowerCase();

		var productLink = urlOrigin + urlPath;

		if (selectedGenderLabel == "display: inline-block;") {
			selectedGenderValue = $('.sizelegendGenderValue').text();
			selectedGenderValue = selectedGenderValue.substring(0, selectedGenderValue.length - 1);
		}

		sizeUrlParams = "&size=" + selectedSize;

		if (selectedGenderValue) {
			sizeUrlParams = sizeUrlParams + "&gender=" + selectedGenderValue;
		}

		if (selectedCollection === "MC-F") {
			productLink = productLink + '?upper=' + selectedUpper + '&colour=' + selectedColour + sizeUrlParams
		} else if (selectedCollection == "MO-F") {
			productLink = productLink + '?upper=' + selectedUpper + sizeUrlParams;
		} else {
			productLink = productLink + '?upper=' + selectedUpper + selectedColour + sizeUrlParams
		}

		return productLink
	}

	function triggerDropHintEmail() {
		$('#dropHintForm').on('submit', function(e){
			e.preventDefault();

			var $form = $(this),
				url = getDropHintUrl(),
				isValidForm = true,
				recepientEmail = $form.find("input[name='recepient_email']").val(),
				recepientName = $form.find("input[name='recepient_name']").val(),
				senderName = $form.find("input[name='sender_name']").val();


			$('.js-hint-error').addClass('hidden');

			// validation
			if (recepientEmail === "" || recepientEmail === " " || recepientEmail.indexOf('@') < 0 || recepientEmail.indexOf('..') > -1) {
				isValidForm = false;
				$('.js-hint-error-email').removeClass('hidden');
			} else if (recepientName === "" || recepientName === " ") {
				isValidForm = false;
				$('.js-hint-error-name').removeClass('hidden');
			} else if (senderName === "" || senderName === " ") {
				isValidForm = false;
				$('.js-hint-error-sender').removeClass('hidden');
			}

			if (isValidForm) {
				var data = {
					"recipient_email": recepientEmail,
					"recipient_name": recepientName,
					"sender_name": senderName,
					"product_url": url,
					"product_title": $('#productSubtitle').text(),
					"sku": app.product.data.sku
				};

				$.ajax({
					type: "POST",
					url: "https://store-live-api.mahabis.io/v1/slipper-hints",
					data: JSON.stringify(data),
					beforeSend: function() {
						$('#modalDropHint').addClass('is-loading');
					},
					cache: false,
					dataType: 'json',
					success: function (data) {
						$('#modalDropHint').removeClass('is-loading');
						$('#modalDropHint').addClass('is-success');
					},
					error: function (xhr, textStatus, errorThrown) {
						$('#modalDropHint').removeClass('is-loading');
						$('#modalDropHint').addClass('is-success');
					}
				});
			}
		})
	}

	function generateGiftImage(src) {
		$('#modalMyGiftImage, #modalMyGiftImageSuccess').attr('src', src);
	}

	function generateDynamicCollectionLink(size) {
		var $link = $('#dynamicSizesCollection'),
			sizeCountry = $('.sizelegendCountryValue').html(),
			sizeGender = $('.sizelegendGenderValue').html().slice(0, -1),
			sizeLabel = $('.js-size-selector').find('.selected').html().split('&nbsp;')[0],
			href = $link.data('initial-href'),
			newHref = href + '?size=' + size + '&sizeGender=' + sizeGender + '&sizeCountry=' + sizeCountry + '&sizelabel=' + sizeLabel + '&isLabeledUrl=true';

		if (sizeCountry == 'EU') {
			newHref = href + '?size=' + size + '&sizeCountry=' + sizeCountry + '&sizelabel=' + size + '&isLabeledUrl=true';
		}

		$link.attr('href', newHref);
	}

	function generateGiftLink(variantId) {
		var redirectLink = "https://mahabis.com/cart/" + variantId + ":1?isMyGift=true";
		$('#productGiftingLink').attr('data-href', redirectLink);
		generateGiftImage();
	}

	function startGiftingCheckout($el) {
		var redirectUrl = $el.attr('data-href'),
			isActive = $el.attr('data-active'),
			$form = $('#sendGiftForm'),
			recepientName = $form.find('.js-gift-recepient-name').val(),
			recepientEmail = $form.find('.js-gift-recepient-email').val(),
			greetingsText = $form.find('.js-gift-greetings').val();

		$('.js-hint-error-email').addClass('hidden');
		$('.js-hint-error-name').addClass('hidden');
		$('.js-hint-error-message').addClass('hidden');

		if (recepientName === '') {
			$('.js-hint-error-name').removeClass('hidden');
		} else if (recepientEmail === '' || recepientEmail.indexOf('@') === -1) {
			$('.js-hint-error-email').removeClass('hidden');
		} else if (greetingsText === '') {
			$('.js-hint-error-message').removeClass('hidden');
		} else {
			$el.addClass('is-loading');
			$.cookie('perfectGiftName', recepientName, {expires: 1,path: '/',	domain: window.location.hostname});
			$.cookie('perfectGiftEmail', recepientEmail, {expires: 1,path: '/',	domain: window.location.hostname});
			$.cookie('perfectGiftGreetings', greetingsText, {expires: 1,path: '/',	domain: window.location.hostname});

			window.location.href = redirectUrl;
		}

	}

	function showGiftingPopup($el) {
		var isActive = $el.attr('data-active');

		if (isActive === "true") {
			app.popup.open('modalMyGift');
		} else {
			var $sizeOption = $('.size-options'),
				$title = $sizeOption.find('.option-legend'),
				animateTitle = function () {
					$sizeOption.addClass('options-group-error');
					$('#selectSizeValidation').removeClass('hidden');
					$title.addClass('animated shake');
					$title.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
						$title.removeClass('animated shake');
					});
				};

			if ($('.size-options').length) {
				if (!app.utils.isInViewport($sizeOption)) {
					var scrollCorrection = 0; // due to fixed header we need to correct scroll

					if (!app.utils.isMobile()) {
						scrollCorrection = 65;
					}

					app.utils.scrollTo($sizeOption, 800, scrollCorrection, function () {
						animateTitle();
					})
				} else {
					animateTitle();
				}
			}
		}
	}

	function switchTitleNote($el) {
		var productNote = $el.attr('data-product-note'),
			productDescription = $el.attr('data-product-description'),
			$productNote = $('#productNote'),
			$productDescription = $('.js-product-description-content'),
			$productNoteMobile = $('#productNoteMobile'),
			nonDiscountedItems = parseInt($('#main-hdr').data('nondiscount-items'));

		if (productDescription) {
			$productDescription.html(productDescription)
		} else {
			var initialDescription = $productDescription.data('content');

			$productDescription.html(initialDescription);
		}

		if (productNote) {
			$('#preOrderCustomMessage').attr('data-product-note', productNote);
			$('#productNote').html(productNote);
			$('#productNoteMobile').html(productNote);
		} else {
			var msg = '';
			// if (nonDiscountedItems === 0) {
			// 	msg = '<span>Buy one pair, <b>GET 15%</b> with the code <b>BUY1</b></span>';
			// } else if (nonDiscountedItems === 1) {
			// 	msg = '<span>use <b>code BUY1 for 15% off</b>, add another pair to get 20% off</span>';
			// } else if (nonDiscountedItems === 2) {
			// 	msg = '<span>use <b>code BUY2 for 20% off</b>, add another pair to get 25% off</span>';
			// } else if (nonDiscountedItems > 2) {
			// 	msg = '<span>use <b>code BUY3 for 25% off</b></span>';
			// }

			$productNote.html(msg);
			$productNoteMobile.html(msg);
		}
	}

	function chooseVariant($el) {
		var variantId = $el.data('variant-id'),
			$submit = $('.submit-button'),
			isOutStock = $el.hasClass('is-out-stock');

		$('.js-variant-selector').removeClass('selected');
		$el.addClass('selected');

		if (isOutStock) {
			$submit.attr('disabled', true);
			$submit.addClass('disabled');
			$submit.val('SOLD OUT');
		} else {
			$submit.attr('disabled', false);
			$submit.removeClass('disabled');
			$submit.val('ADD TO CART')
		}

		app.product.data.quantity = 1;
	}

	function selectSizeGender($el) {
		var gender = $el.data('gendertype');

		$('<span class="sizelegend" style="display:inline">' + gender + '</span>').insertAfter('.option-legend');
		$('.js-sizes-row').addClass('hidden');
		$('#genderSelection3P').addClass('hidden');
		$('.js-sizes-row[data-gender="' + gender + '"]').removeClass('hidden');


		console.log(gender);
	}

	function checkGiftAvailable(sku) {
		var skuSplitted = sku.split('-'),
			skuCombined = skuSplitted[0] + '-' + skuSplitted[1] + '-' +  skuSplitted[3] + '-' +  skuSplitted[4],
			country = Shopify.country,
			isUkStore = false,
			isPreorderProduct = $('#addToCartWrapper .submit-button').val() == 'pre order',
			isProductOutStock = $('#addToCartWrapper .submit-button').attr('disabled') == 'disabled',
			isGiftAvailable = $('#productCustomVariants').find('.js-customvariants-price[data-sku="' + skuCombined + '"]').attr('data-gift-available');

		if (country == 'GB') {
			isUkStore = true
		}

		if (isGiftAvailable == 'true' && !isProductOutStock && isUkStore && !isPreorderProduct) {
			$('#productGifting').removeClass('hidden');
		} else {
			$('#productGifting').addClass('hidden');
		}
	}

	function setGiftSwitch() {
		var newSKU = app.product.data.sku,
			oldSKU = app.utils.getUrlParam('sku'),
			isDisabled = 	$('#switchGiftProduct').attr('data-disabled'),
			acode = app.utils.getUrlParam('acode'),
			orderID = app.utils.getUrlParam('order_id'),
			upperSelected = $('#legend-upper').text(),
			requestUrl = "https://store-live-api.mahabis.io/v1/gift-update";
		requestBody = {
			"order_id": orderID,
			"acode": acode,
			"old_sku": oldSKU,
			"new_sku": newSKU
		};

		$('#giftColourSelected').html(upperSelected);

		if (isDisabled == 'false') {
			$.ajax({
				url: requestUrl,
				type: 'POST',
				data: JSON.stringify(requestBody),
				dataType: 'json',
				contentType: "application/json",
				beforeSend: function (xhr) {
					$('#switchGiftProduct').addClass('is-loading').attr('data-disabled', 'true');
				},
				success: function (data) {
					if (data.status === 'success'){
						app.popup.open('modalMyGiftSuccess');
						$('#switchGiftProduct').addClass('hidden');
					}
				},
				error: function (data) {
					var $popup = $('#modalMyGiftSuccess');
					$popup.find('.js-gift-success, #giftColourSelected, #modalMyGiftImage').addClass('hidden');
					$popup.find('.js-gift-error-container').removeClass('hidden');

					if (data.responseJSON) {
						$popup.find('.js-gift-error').html("(" + data.responseJSON.error + ")");
					}

					app.popup.open('modalMyGiftSuccess');
					$('#switchGiftProduct').removeClass('is-loading');

				}
			})
		}
	}

	function showDeliveryMessage() {
		if (Shopify.country == "GB") {
			$('#deliveryMessageDynamic').removeClass('hidden');
		}
	}

	function hideDeliveryMessage() {
		$('#deliveryMessageDynamic').addClass('hidden');
	}

	function toggleSaleLabels(colours) {
		var $parent = $('#soleColorBadges');

		$parent.find('.js-variant-inline').removeClass('is-labeled is-discounted')
		if (colours) {
			var coloursArray = colours.split(',');
			$.each(coloursArray, function(key, colour){
				$parent.find(".js-variant-inline[data-colour='" + colour + "']").addClass('is-labeled is-discounted');
			})
		}
	}

	function getNewCustomColourParams(colour) {
		if (colour === "ho") {
			return "hekla_orange"
		} else if (colour === "sy") {
			return "skane_yellow"
		} else if (colour === "sb") {
			return "skien_black"
		} else if (colour === "sp") {
			return "sakura_pink"
		}
	}

	function getNewCustomUpperParams(colour) {
		if (colour === "dg") {
			return "dark_grey"
		} else if (colour === "lg") {
			return "light_grey"
		}
	}

	function checkCustomProductAvailability(sku) {
		var $message = $('.js-customizing-nosize-message'),
			$sizeMessage = $('.js-sizing-message'),
			$link = $('#customizingNosizeLink'),
			link = $link.data('href'),
			skuSplitted = sku.split('-'),
			skuNew = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4],
			linkColour = getNewCustomColourParams(skuSplitted[4].toLowerCase()),
			linkUpper = getNewCustomUpperParams(skuSplitted[3].toLowerCase()),
			linkNew = link + '?cu=' + linkUpper + '&cc=' + linkColour,
			isCustomizerNoStockProduct = (Theme.product.customizerNoStockProductsList.indexOf(skuNew) > -1),
			isCustomizerProduct = (Theme.product.customizerProductsList.indexOf(skuNew) > -1);

		if ($message) {
			if (isCustomizerNoStockProduct) {
				$message.removeClass('hidden');
				$sizeMessage.addClass('hidden');
				$link.attr('href', linkNew);
			} else {
				$message.addClass('hidden');
				$sizeMessage.removeClass('hidden');
			}
		}
	}

	function checkDynamicDiscount() {
		var discountedPrice = $('#bundlePrice').find('.money-discount').find('.money').html(),
			price = $('#bundlePrice').children(":first").find('.money').html();

		if (discountedPrice) {
			var priceDiscounted = parseInt(discountedPrice.replace(/[^0-9.]/g, '')),
				priceOrigin = parseInt(price.replace(/[^0-9.]/g, '')),
				discountPercentage = parseInt(100 - parseFloat(priceOrigin / priceDiscounted * 100).toFixed(2)),
				discountValue = discountPercentage + "% OFF";

			$('#productImagesWrapper, #productpage-carousel').attr('data-discount', discountValue)
		} else {
			$('#productImagesWrapper, #productpage-carousel').removeAttr('data-discount')
		}
	}

	function triggerPdpBanner(el) {
		var $modal = $('#modalPDPbanner'),
			title = el.attr('data-popup-title'),
			content = el.attr('data-popup-content'),
			isPopupEnabled = el.attr('data-popup-enabled');

		if (isPopupEnabled === "true") {
			$modal.find('.js-modal-title').html(title);
			$modal.find('.js-modal-content').html(content);
			app.popup.open('modalPDPbanner');
		}
	}

	function showProductFeturesPopup(el) {
		var feature = el.attr('data-feature'),
			featureContent = ProductFeatures[feature],
			productTitle = $('#productSubtitle').text();

		// set up popup content
		$('#modalFeaturesProductTitle').html(productTitle);
		$('#modalFeaturesDescription').html(featureContent);
		$('#modalFeaturesPill').html(feature);
		$('#modalFeaturesPillsList').find('li[data-feature="' + feature + '"]').addClass('is-active');

		app.popup.open('modalFeaturesList');
	}

	function updateProductFeturesPopup(el) {
		var feature = el.attr('data-feature'),
			featureContent = ProductFeatures[feature];

		el.siblings().removeClass('is-active');
		el.addClass('is-active');
		$('#modalFeaturesPill').html(feature);
		$('#modalFeaturesDescription').html(featureContent);
	}

	function showProductVideo() {
		var productHandle = $('#video-popup').data('handle'),
			showProductVideo = true,
			productVideosClosedList = sessionStorage.getItem("closedProductVideos");

		if (productVideosClosedList) {
			if (productVideosClosedList.indexOf(productHandle) > -1) {
				showProductVideo = false
			}
		}

		if (showProductVideo) {
			setTimeout(function () {
				var $video = $('#video-src'),
					videoSource = $video.attr('data-src')
				$('#video-popup').fadeIn();
				$('#video-src').attr('src', videoSource);
				$('#video-src').load();
			}, 3000);
		}

	}

	function closeProductVideo() {
		var currentVideoHandle = $('#video-popup').data('handle'),
			closedVideosList = sessionStorage.getItem("closedProductVideos");

		if (!closedVideosList) {
			var newVideosList = currentVideoHandle;
			sessionStorage.setItem("closedProductVideos", newVideosList);
		} else {
			if (closedVideosList.indexOf(currentVideoHandle) < 0) {
				var newVideosList = closedVideosList + ';' + currentVideoHandle;
				sessionStorage.setItem("closedProductVideos", newVideosList);
			}
		}

		$('#video-popup').addClass('hidden');
		$('#video-popup').remove();
	}

	function initProductVideoEvents() {
		$('#video-play').on('click', function(){
			$(this).addClass('hidden');
			$('#video-src').prop('muted', false);
			$('#video-src').prop("controls",true);
		})

		$('#video-close').on('click', function(){
			closeProductVideo();
		})
	}

	function showArchiveProducts() {
		var isArchive = app.utils.getUrlParam('arcv'),
			isArchiveProductsOnPage = $('.js-archive-product').length > 0;

		if (isArchive && isArchiveProductsOnPage) {
			$('.js-variant-inline').addClass('is-hidden').removeClass('is-visible');
			$('.js-archive-product').removeClass('is-hidden').addClass('is-visible');
		}
	}

	function sendKlaviyoProductView(el) {
		var globalId = el.data('global-id');

		if (globalId && klaviyo) {
			var item = {
				ProductID: globalId
			};

			klaviyo.track("Viewed Product", item);
		}
	}

	function initFreeGiftCarousel() {
		var $carousel = $('.js-pdp-free-gift-carousel');

		if (!$carousel.length) return;

		if (typeof $carousel.owlCarousel !== 'function') {
			// Owl not ready yet – try again shortly
			setTimeout(initFreeGiftCarousel, 200);
			return;
		}

		$carousel.owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: false,
			margin: 0
		});

		var $prev = $('.pdp-extra-accordion__nav-btn--prev');
		var $next = $('.pdp-extra-accordion__nav-btn--next');

		$prev.on('click', function() {
			$carousel.trigger('prev.owl.carousel');
		});

		$next.on('click', function() {
			$carousel.trigger('next.owl.carousel');
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initializes product cache
	 **/
	function initializeCache() {
		$cache = {
			productType: $('#productType'),
			productSKU: $('#productSKU'),
			productTitle: $('#productSubtitle'),
			productTitleMobile: $('#subtitleMobile'),
			imageWrapper: $('.js-product-mainimage'),
			videoWrapper: $('.js-product-mainvideo'),
			optionSelector: $('#sizeSelect').find('option:selected'),
			swatchSelector: $('.sole-options'),
			giftBoxID: $('.js-gift-extra-id'),
			productCarousel: $('#productpage-carousel'),
			sizeSelector: $('#sizeSelection'),
			sizeGenderSelector: $('#genderSelection'),
			sizeLegend: $('.sizelegend, .sizeChange'),
			sizeGenderValue: $('.sizelegendGenderValue'),
			sizeCountryValue: $('.sizelegendCountryValue'),
			upperSelector: $('#upperSelector'),
			colourSelector: $('#colourSelector'),
			oosUpsell: $('#stockErrorUpsell'),
			stockAvailableMsg: $('#deliveryInStock'),
			genderPopup: $('#modalGenderSelect'),
			backInStockPopup: $('#modalBackInStock'),
			deliveryDate: $('#deliveryDateEstimated'),
			collectionType: $('#productCollectionType').text(),
			reviewsCache: null,
			importedReviewsLoaded: false
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes product settings
	 **/
	function initializeSettings() {
		settings = {
			productType: $cache.productType.text(),
			productSKU: $cache.productSKU.text(),
			productOption: $cache.optionSelector.val(),
			variantFirstSKU: Theme.product.firstVariantSKU,
			itemStockToOOS: Theme.stock.outOfStockLimit,
			sizes: {
				bundle: {
					small: [35, 36, 37, 38, 39, 40],
					large: [41, 42, 43, 44, 45, 46, 47]
				},
				slippers: {
					small: [35, 36, 37, 38, 39],
					medium: [40, 41, 42, 43],
					large: [44, 45, 46, 47]
				}
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes product DOM
	 **/
	function initializeDOM() {
		showArchiveProducts();
		setProductTypeSKU();
		hideProductImage();
		detectTitleLabel();
		resetSizeSelector();
		detectSizeSelector();
		generateSizeSelector();
		initProductCarousel();
		switchProductStyling('initial');
		initializeAllSizesStock();
		showProductVideo();
		initProductVideoEvents();
		initFreeGiftCarousel();

		if (app.page.template == 'pdp') {
			getCustomerReviews();
			triggerDropHintEmail();
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes product events
	 **/
	function initializeEvents() {
		$('.js-quantitySelector').find('.js-qtyChange').on('click', function () {
			changeQuantity($(this));
		});

		$('.js-giftcard-select').on('change', function () {
			changeGiftCardType($(this));
		});

		$('#multiSizeSelector').on('click', 'li', function () {
			changeSizeCountry($(this));
		});

		$('.sizeChange').on('click', function () {
			clearGender($(this));
		});

		$cache.sizeGenderSelector.on('click', 'li', function () {
			selectGender($(this));
			generateSizeSelector(true);
		});

		$('.js-pdp-banner').on('click', function(){
			triggerPdpBanner($(this));
		})

		$('#dropHintTrigger').on('click', function() {
			showDropHintPopup();
		});

		$('.js-variant-selector').on('click', function(){
			chooseVariant($(this));
		});

		// toggle pinch zoom
		$('#sizeSelect').on('change', function () {
			if (($(window).width()) < 769) {
				app.ui.togglePinchZoom(true);
			}
		}).on('click', function () {
			if (($(window).width()) < 769) {
				app.ui.togglePinchZoom(false);
			}
		});

		// upper tabs selector
		$('.js-upper-tabs-selector').on('click', function () {
			changeUpperCollection($(this), true);
		});

		// gender popup dynamic links
		$('.js-genderpopup-dynamic').on('click', function () {
			var $this = $(this),
				linkWomen = $this.data('link-women'),
				linkMen = $this.data('link-men');
			changeGenderLinks(linkWomen, linkMen);
		});

		// back in stock popup
		$('#backInStockForm').on('submit', function (e) {
			e.preventDefault();
			postBackInStockEmail($(this));
		});

		// flow interest popup
		$('#slipperInterestForm').on('submit', function (e) {
			e.preventDefault();
			postSlipperInterestEmail($(this));
		});

		// play product video
		$('.js-thumbnail-video').on('click', function () {
			playProductVideo($(this));
		});

		// play product video
		$('.js-thumbnail-video-unboxing').on('click', function () {
			playUnboxingVideo($(this));
		});

		// play spinner video
		$('.js-thumbnail-video-spinner').on('click', function () {
			playSpinnerVideo($(this));
		});

		// play spinner video
		$('.js-thumbnail-video-onfoot').on('click', function () {
			playOnFootVideo($(this));
		});

		// product accordion
		$('.js-product-accordion-toggle').on('click', function(){
			toggleProductAccordion($(this))
		});

		// product fatures pills
		$('.js-productfeature-popup').on('click', function(){
			showProductFeturesPopup($(this));
		})

		$('#modalFeaturesList').on('click', '.js-modalfeatures-popup-pill', function(){
			updateProductFeturesPopup($(this));
		})

		// perfect gift
		$('#productGifting').on('click', function(){
			showGiftingPopup($(this));
		});

		$('#productGiftingLink').on('click', function() {
			startGiftingCheckout($(this));
		});

		$('#switchGiftProduct').on('click', function() {
			setGiftSwitch();
		});

		$('.js-gender-selection').on('click', function(){
			selectSizeGender($(this));
		});

		$('.js-additional-product-item').on('click', function(){
			$(this).toggleClass('is-active');
		})
	}

	app.product = {
		init: function () {
			initializeCache();
			initializeSettings();
			initializeDOM();
			initializeEvents();
		},
		sendKlaviyoProductView: function(el) {
			sendKlaviyoProductView(el)
		},
		checkGiftAvailable: function (sku) {
			checkGiftAvailable(sku);
		},
		switchProductSizes: function () {
			switchProductSizes();
		},
		setUrlUpper: function (upper) {
			setUrlUpper(upper);
		},
		setUrlColour: function (colour) {
			setUrlColour(colour);
		},
		setUrlGender: function (gender) {
			setUrlGender(gender);
		},
		getSizeRange: function() {
			return getSizeRange()
		},
		getID: function (sku, store) {
			return getProductID(sku, store);
		},
		checkCustomProductAvailability: function(sku) {
			checkCustomProductAvailability(sku)
		},
		checkUpperStock: function (size) {
			checkUpperStock(size);
		},
		checkCollectionStock: function () {
			checkCollectionStock();
		},
		checkComboStock: function (size) {
			checkComboStock(size);
		},
		checkAllSizesStock: function ($upper) {
			checkAllSizesStock($upper)
		},
		resetComboStock: function () {
			resetComboStock();
		},
		switchToAvailableVariant: function () {
			switchToAvailableVariant();
		},
		switchSolesRange: function (soles) {
			switchSolesRange(soles)
		},
		switchUpperTab: function (el) {
			switchUpperTab(el);
		},
		switchProductSlider: function (slide) {
			switchProductSlider(slide);
		},
		switchTitleLabel: function (label, style) {
			switchTitleLabel(label, style)
		},
		switchTitleNote: function (sku) {
			switchTitleNote(sku)
		},
		generateSizeSelector: function (triggerSelect) {
			generateSizeSelector(triggerSelect)
		},
		switchProductStyling: function (style) {
			switchProductStyling(style)
		},
		setSizeRange: function (sizeRange) {
			setSizeRange(sizeRange);
		},
		klarnaChangePrice: function (newPrice) {
			klarnaChangePrice(newPrice)
		},
		generateOOSMessage: function (sku) {
			generateOOSMessage(sku)
		},
		generateGiftLink: function(sku) {
			generateGiftLink(sku)
		},
		generateDynamicCollectionLink: function(size) {
			generateDynamicCollectionLink(size)
		},
		generateGiftImage: function(url) {
			generateGiftImage(url)
		},
		showDeliveryMsg: function() {
			showDeliveryMessage()
		},
		hideDeliveryMsg: function() {
			hideDeliveryMessage()
		},
		toggleSaleLabels: function(colours) {
			toggleSaleLabels(colours)
		},
		checkDynamicDiscount: function() {
			checkDynamicDiscount()
		},
		sizeStockRetryAmount: 0,
		data: {
			quantity: 1,
			collection: '',
			type: '',
			sku: '',
			id: '',
			saleType: '',
			preorder: true
		},
		isNegotiation: false,
		size: {
			selected: false,
			gender: false,
			country: false
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.multistore
 */
(function (app, $) {
	var $cache,
		settings;

	/**
	 * @private
	 * @function
	 * @description Switch checkout buttons to correct currency
	 **/
	function switchCheckout(checkoutCurrency) {
		var isCheckoutFound = false,
			checkoutCur = checkoutCurrency;

		if (checkoutCur != 'EUR' && checkoutCur != 'USD' && checkoutCur != 'AUD') {
			checkoutCur = $cache.$currency.find('.selected').data('checkout');
		}

		$('.js-checkout-btn').each(function () {
			var $this = $(this),
				buttonCurrency = $this.data('checkout').toUpperCase();

			if (buttonCurrency == 'EU') {
				buttonCurrency = 'EUR';
			}

			if (checkoutCur == 'EU') {
				checkoutCur = 'EUR';
			}

			var checkoutEURenabled = (checkoutCur == 'EUR' && Theme.multistore.checkoutEU),
				checkoutUSDenabled = (checkoutCur == 'USD' && Theme.multistore.checkoutUS),
				checkoutAUDenabled = (checkoutCur == 'AUD' && Theme.multistore.checkoutAU);

			if (checkoutCur == buttonCurrency) {
				if (checkoutEURenabled || checkoutUSDenabled || checkoutAUDenabled) {
					$this.removeClass('hidden').siblings().addClass('hidden');
					isCheckoutFound = true;
				}
			}
		});

		// Setting default GBP checkout
		if (!isCheckoutFound) {
			$('.js-checkout-btn-default').removeClass('hidden').siblings().addClass('hidden');
		}
	}

	/**
	 * @private
	 * @function
	 * @description Detect currency and set specific checkout links
	 **/
	function setInitialCheckout() {
		switchCheckout(app.currency.get());
	}

	/**
	 * @private
	 * @function
	 * @description Format multistore data into working object
	 **/
	function getSkuList() {
		$cache.$document.find('span.money').each(function () {
			var productSku = $(this).data('sku');
			if (productSku && ($.inArray(productSku, $cache.skuList) == -1)) {
				$cache.skuList.push(productSku);
			}
		})
	}

	/**
	 * @private
	 * @function
	 * @description Filter multistore array to work with smaller amount of values
	 *              Look for dataArray in sourceArray
	 **/
	function filterMultistoreArray(sourceArray, dataArray) {
		var filteredObj = {};
		$.each(dataArray, function (key, value) {
			if (sourceArray[value] != undefined) {
				filteredObj[value] = sourceArray[value];
			}
		});
		return filteredObj;
	}

	/**
	 * @private
	 * @function
	 * @description Set price for multistore
	 **/
	function setMultistorePrice(el, data, qty, discount) {
		var currency = el.attr('data-currency'),
			isDiscountPrice = el.hasClass('js-money-discount'),
			originPriceUSD = el.attr('data-currency-usd'),
			originPriceEUR = el.attr('data-currency-eur'),
			originPriceAUD = el.attr('data-currency-aud'),
			staticPriceUSD = parseFloat(data.prices.usd * parseInt(qty) * parseFloat(discount)).toFixed(2),
			staticPriceAUD = parseFloat(data.prices.aud * parseInt(qty) * parseFloat(discount)).toFixed(2),
			staticPriceEUR = parseFloat(data.prices.eur * parseInt(qty) * parseFloat(discount)).toFixed(2);

		// Origin prices if discount enabled
		if (isDiscountPrice) {
			var staticOriginPriceUSD = data.pricesorigin.usd * qty * discount,
				staticOriginPriceAUD = data.pricesorigin.aud * qty * discount,
				staticOriginPriceEUR = parseFloat(data.pricesorigin.eur * parseInt(qty) * parseFloat(discount));
		}

		// Set converting data attributes
		if (Theme.multistore.checkoutUS) {
			var replacePriceUSD = staticPriceUSD,
				comparePriceUSD = data.prices.usd;

			if (isDiscountPrice) {
				replacePriceUSD = staticOriginPriceUSD;
				comparePriceUSD = data.pricesorigin.usd;
			}

			el.attr('data-currency-usd', '$' + replacePriceUSD);
			if (currency == 'USD' && (originPriceUSD !== comparePriceUSD)) {
				el.html('$' + replacePriceUSD);
			}
		}

		if (Theme.multistore.checkoutEU) {
			var replacePriceEUR = staticPriceEUR,
				comparePriceEUR = data.prices.eur;

			if (isDiscountPrice) {
				replacePriceEUR = staticOriginPriceEUR;
				comparePriceEUR = data.pricesorigin.eur;
			}

			el.attr('data-currency-eur', '&euro;' + replacePriceEUR);
			if (currency == 'EUR' && (originPriceEUR !== comparePriceEUR)) {
				el.html('&euro;' + replacePriceEUR);
			}
		}

		if (Theme.multistore.checkoutAU) {
			var replacePriceAUD = staticPriceAUD,
				comparePriceAUD = data.prices.aud;

			if (isDiscountPrice) {
				replacePriceAUD = staticOriginPriceAUD;
				comparePriceAUD = data.pricesorigin.aud;
			}

			el.attr('data-currency-aud', 'AUD$' + replacePriceAUD);
			if (currency == 'AUD' && (originPriceAUD !== comparePriceAUD)) {
				el.html('AUD$' + replacePriceAUD);
			}
		}
	}

	function detectDiscountedCurrency($el, data) {
		$el.attr('data-discounted-eur', 'false');
		$el.attr('data-discounted-gbp', 'false');
		$el.attr('data-discounted-aud', 'false');
		$el.attr('data-discounted-usd', 'false');

		app.product.discounted = {
			gbp: false,
			usd: false,
			eur: false,
			aud: false,
		};

		// compare gbp prices
		if (data.pricesorigin.gbp && (data.pricesorigin.gbp !== data.prices.gbp)) {
			$el.attr('data-discounted-gbp', true);
			app.product.discounted.gbp = true;
		}

		// compare usd prices
		if (data.pricesorigin.usd && (data.pricesorigin.usd !== data.prices.usd)) {
			$el.attr('data-discounted-usd', true);
			app.product.discounted.usd = true;
		}

		// compare eur prices
		if (data.pricesorigin.eur && (data.pricesorigin.eur !== data.prices.eur)) {
			$el.attr('data-discounted-eur', true);
			app.product.discounted.eur = true;
		}

		// compare aud prices
		if (data.pricesorigin.aud && (data.pricesorigin.aud !== data.prices.aud)) {
			$el.attr('data-discounted-aud', true);
			app.product.discounted.aud = true;
		}
	}

	/**
	 * @private
	 * @function
	 * @description Get multistore prices sku
	 **/
	function getMultistorePrice(data) {
		$cache.$document.find('span.money').each(function () {
			var $this = $(this),
				sku = $this.attr('data-sku'),
				discount = $this.attr('data-discount') || 1,
				qty = $this.attr('data-qty') || 1,
				isDiscountPrice = $this.hasClass('js-money-discount'),
				isTotalPrice = $this.hasClass('js-money-total');
			if (data[sku] && !isTotalPrice) {
				// setMultistorePrice($this, data[sku], qty, discount, isDiscountPrice);

				if (isDiscountPrice) {
					detectDiscountedCurrency($this, data[sku]);
				}
			}
		});

		// detect currency discounts
		app.currency.getDiscount();
	}

	/**
	 * @private
	 * @function
	 * @description Get static price from sku
	 **/
	function getStaticPrice(sku) {
		return app.multistore.data.prices[sku];
	}

	/**
	 * @private
	 * @function
	 * @description Generate multistore objects with smaller amount of data
	 **/
	function setMultistoreObjects(data) {
		// subsets data
		// TODO. Performance update
		$.each(data, function (key, item) {
			var itemDiscounted = item["prices-compare"];
			if (itemDiscounted) {
				app.multistore.data.prices[key] = {
					"prices": {
						"gbp": item.prices.gbp,
						"eur": item.prices.eur,
						"usd": item.prices.usd,
						"aud": item.prices.aud
					},
					"pricesorigin": {
						"gbp": item["prices-compare"].gbp,
						"eur": item["prices-compare"].eur,
						"usd": item["prices-compare"].usd,
						"aud": item["prices-compare"].aud
					}
				};
			} else {
				app.multistore.data.prices[key] = {
					"prices": {
						"gbp": item.prices.gbp,
						"eur": item.prices.eur,
						"usd": item.prices.usd,
						"aud": item.prices.aud
					}
				};
			}
			app.multistore.data.variants[key] = {
				"variant-eu": item["variant-eu"],
				"variant-usd": item["variant-usd"],
				"variant-aud": item["variant-aud"],
				"variant-gbp": item["variant-gbp"]
			};
		});
	}

	/**
	 * @private
	 * @function
	 * @description Calculate static total prices from SKU array format: [SKU,QTY]
	 **/
	function calcStaticTotals(items) {
		var skus = [],
			prices = {},
			qty = {},
			discounts = {},
			totalEur = 0,
			totalUsd = 0,
			totalGbp = 0,
			totalAud = 0,
			itemData;

		$.each(items, function (key, item) {
			var sku = item.split(',')[0],
				quantity = item.split(',')[1],
				discount = item.split(',')[2] || 1;

			skus.push(sku);

			if (qty[sku]) {
				qty[sku] = parseInt(qty[sku]) + parseInt(quantity);
			} else {
				qty[sku] = quantity;
			}

			discounts[sku] = discount;
		});

		itemData = filterMultistoreArray(app.multistore.data.prices, skus);

		$.each(itemData, function (idx, obj) {
			totalEur += (parseFloat(obj.prices.eur) * parseInt(qty[idx]) * parseFloat(discounts[idx]));
			totalUsd += (parseFloat(obj.prices.usd) * parseInt(qty[idx]) * parseFloat(discounts[idx]));
			totalGbp += (parseFloat(obj.prices.gbp) * parseInt(qty[idx]) * parseFloat(discounts[idx]));
			totalAud += (parseFloat(obj.prices.aud) * parseInt(qty[idx]) * parseFloat(discounts[idx]));
		});

		prices['eur'] = totalEur.toFixed(2);
		prices['usd'] = totalUsd.toFixed(2);
		prices['gbp'] = totalGbp.toFixed(2);
		prices['aud'] = totalAud.toFixed(2);

		return prices;
	}

	/**
	 * @private
	 * @function
	 * @description Set multistore total prices
	 **/
	function setMultistoreTotals(el, data) {
		var currency = "GBP",
			prices = calcStaticTotals(data);

		if (Theme.multistore.checkoutUS) {
			el.attr('data-currency-usd', '$' + prices.usd);
			// Replace converted price based on static values
			if (currency == 'USD') {
				el.html('$' + prices.usd);
			}
		}

		if (Theme.multistore.checkoutEU) {
			el.attr('data-currency-eur', '&euro;' + prices.eur);
			if (currency == 'EUR') {
				el.html('&euro;' + prices.eur);
			}
		}

		if (Theme.multistore.checkoutAU) {
			el.attr('data-currency-aud', 'AUD$' + prices.aud);
			if (currency == 'AUD') {
				el.html('AUD$' + prices.aud);
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Get multistore total prices
	 **/
	function getTotals() {
		$cache.$document.find('.js-money-total').each(function () {
			var $this = $(this),
				totalSkus = $this.attr('data-sku-list').split(';');
			setMultistoreTotals($this, totalSkus);
		});
	}

	/**
	 * @private
	 * @function
	 * @description Collect line items sku/qty/sizetype to configure checkout buttons
	 **/
	function getLineItemsData() {
		var list = $('#multistoreCheckoutList').text().split(';');
		if (list != '') {
			$.each(list, function (key, value) {
				var arr = value.split(','),
					sku = arr[0],
					obj = {},
					quantity = arr[1];

				if ($cache.checkoutList[sku]) {
					quantity = parseInt($cache.checkoutList[sku].qty) + parseInt(arr[1]);
				}

				obj[sku] = {
					qty: quantity,
					sizetype: arr[3],
					sizevalue: arr[4]
				};

				$cache.checkoutList[sku] = obj[sku];
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Generate multistore checkout links
	 * @param country string EU/USD
	 **/
	function genCheckoutLinks(currency) {
		var str = '',
			domain = '',
			country = currency.toLowerCase();

		if (country === "eur") {
			country = "eu";
		}

		// generate subdomain for permalinks
		if (country === "usd") {
			domain = "us."
		} else if (country === "eu") {
			domain = "eu."
		} else if (country === "aud") {
			domain = "au."
		}
		str = "//" + domain + "mahabis.com/cart/";

		$.each($cache.checkoutList, function (sku, value) {
			var qty = value["qty"],
				countryType = "variant-" + country,
				type = "eu",
				variant = app.multistore.data.variants[sku][countryType],
				isMultiSku = $.type(variant) === "object";

			if (isMultiSku) {
				str += variant[type] + ":" + qty + ',';
			} else {
				str += variant + ":" + qty + ',';
			}
		});

		return str.slice(0, -1);
	}

	/**
	 * @private
	 * @function
	 * @description Get expansion store name depends on currency selected
	 **/
	function getExpansionStore(currency) {
		var storeName = 'mahabis';

		if (currency === "EUR") {
			storeName = "mahabis-eu";
		} else if (currency === "USD") {
			storeName = "mahabis-usd";
		} else if (currency === "AUD") {
			storeName = "mahabis-aud"
		}

		return storeName;
	}

	/**
	 * @private
	 * @function
	 * @description Get variant name depends on currency
	 **/
	function getCheckoutCountryVariant(currency) {
		var variantName = 'variant-gbp';

		if (currency === "EUR") {
			variantName = 'variant-eu'
		} else if (currency === "USD") {
			variantName = 'variant-usd'
		} else if (currency === "AUD") {
			variantName = 'variant-aud'
		}

		return variantName;
	}

	/**
	 * @private
	 * @function
	 * @description Generate checkout line items data to get link
	 * 							from Storefront API
	 **/
	function getCheckoutLineItemsData(currency) {
		var itemsArray = [],
			variantType = getCheckoutCountryVariant(currency);

		$.each($cache.checkoutList, function(sku, value){
			var itemObj = {},
				amount = parseInt(value["qty"]),
				sizeValue = value["sizevalue"],
				variantId = app.multistore.data.variants[sku][variantType];

			if (currency !== "GBP" && app.multistore.data.variants[sku][variantType]["eu"]) {
				variantId = app.multistore.data.variants[sku][variantType]["eu"];
			}

			itemObj = {
				"variant_id": variantId,
				"quantity": amount,
				"attributes": [
					{
						"key":  "size",
						"value": sizeValue
					}
				]
			};

			itemsArray.push(itemObj);
		});

		return itemsArray;
	}

	function setCheckoutPermalinks(currency, discountCode, forceRedirect) {
		var fallbackPermalink = genCheckoutLinks(currency);

		$('.js-checkout-btn').removeClass('is-loading');
		$('.js-checkout-custom').removeClass('is-loading');
		$('.js-checkout-generated').attr('data-checkouttype', 'permalink');
		// append discount param at the end

		if (discountCode && discountCode !== '') {
			fallbackPermalink += '?discount=' + discountCode
		}

		if (forceRedirect) {
			window.location = fallbackPermalink;
		} else {
			$('.js-checkout-generated').attr('href', fallbackPermalink);
			$('.js-checkout-generated').attr('data-initial-href', fallbackPermalink);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Set multistore checkout links
	 **/
	function setCheckoutStorefrontApiLinks(currency, discountCode, expansionStore, lineItemsObj, forceRedirect) {
		$.ajax({
			type: "POST",
			url: "https://store-live-api.mahabis.io/v1/checkouts",
			data: JSON.stringify({
				"store": expansionStore,
				"items": lineItemsObj
			}),
			cache: false,
			dataType: 'json',
			contentType: "application/json",
			timeout: 5000,
			beforeSend: function() {
				$('.js-checkout-custom').attr('href','#').addClass('is-loading');
				$('.js-checkout-custom').attr('data-initial-href','#').addClass('is-loading');
			},
			success: function (data) {
				var newCheckoutLink = data.data.url;

				// append discount param at the end
				if (discountCode && discountCode !== '') {
					newCheckoutLink += '&discount=' + discountCode
				}

				// Replace to customer friendly link
				newCheckoutLink = newCheckoutLink.replace('mahabis-aud.myshopify.com', 'au.mahabis.com');
				if (forceRedirect) {
					window.location = newCheckoutLink;
				} else {
					$('.js-checkout-generated').attr('href', newCheckoutLink);
					$('.js-checkout-generated').attr('data-initial-href', newCheckoutLink);
				}

				// Custom discounts added
				// setCustomDiscount();

				$('.js-checkout-btn').removeClass('is-loading');
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.error('MAHABIS API ERROR:' + 'currency:' + app.currency.get() + '; items:' + JSON.stringify($cache.checkoutList));
				setCheckoutPermalinks(currency, discountCode);

				// Custom discounts added
				// setCustomDiscount();
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Set multistore checkout links
	 **/
	function setCheckoutLinks(forceRedirect) {
		var currency = app.currency.get(),
			expansionStore = getExpansionStore(currency),
			discountCode = $('#discountCodeInput').val(),
			lineItemsObj = getCheckoutLineItemsData(currency);

		if (currency === "GBP" || currency === "EUR" || currency === "USD") {
			// use permalinks approach for UK/US/EU stores
			// setCheckoutPermalinks(currency, discountCode, forceRedirect);
		} else {
			// use Storefront API with mahabis backend for AU/CAD etc.
			// setCheckoutStorefrontApiLinks(currency, discountCode, expansionStore, lineItemsObj, forceRedirect)
		}
	}

	/**
	 * @private
	 * @function
	 * @description Append discount value into checkout url
	 **/
	function updateCheckoutLinks() {
		var $checkoutButton = $('.js-checkout-generated'),
			isPermalinksCheckout = $checkoutButton.attr('data-checkouttype') == "permalink",
			checkoutUrl = $checkoutButton.attr('data-initial-href'),
			checkoutUrlParam = '&discount=',
			discountCode = $('#discountCodeInput').val();

		if (isPermalinksCheckout) {
			checkoutUrlParam = '?discount='
		}

		if (checkoutUrl !== '#') {
			checkoutUrl += checkoutUrlParam + discountCode;
		}

		$checkoutButton.attr('href', checkoutUrl);
	}

	function setCustomDiscount() {
		var isFullPricedCart = true,
			$total = $('.js-money-total'),
			totalEur = parseInt($total.attr('data-currency-eur').split('.')[0].replace('&euro;','')),
			totalGbp = parseInt($total.attr('data-currency-gbp').split('.')[0].replace('£','')),
			totalUsd = parseInt($total.attr('data-currency-usd').split('.')[0].replace('$','')),
			totalAud = parseInt($total.attr('data-currency-aud').split('.')[0].replace('AUD$','')),
			fullPricedItemsAmount = 0;

		$('.js-cart-item-row').each(function(){
			var $this = $(this),
				isFullPricedItem = $this.data('item-fullprice'),
				itemType = $this.data('item-type'),
				itemAmount = parseInt($this.data('item-amount'));

			if (itemType !== "socks" && itemType !== "insole") {
				if (!isFullPricedItem) {
					isFullPricedCart = false
				} else {
					fullPricedItemsAmount = fullPricedItemsAmount + itemAmount
				}

			}

			if (isFullPricedCart && fullPricedItemsAmount > 1) {
				// small bundle discount
				$('#discountCodeInput').val('MAHABISBUNDLE');
				$.cookie('discount_code', 'MAHABISBUNDLE', {
					expires: 7,
					path: '/',
					domain: window.location.hostname
				});
				updateCheckoutLinks();
			} else {
				$.cookie('discount_code', null, {
					expires: 7,
					path: '/',
					domain: window.location.hostname
				});
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize multistore after success data response
	 **/
	function initializeMultiStore(data) {
		setMultistoreObjects(data);
		getMultistorePrice(filterMultistoreArray(app.multistore.data.prices, $cache.skuList));
		getTotals();
		getLineItemsData();
		if (!$.isEmptyObject($cache.checkoutList) && app.page.template === "cart") {
			// setCheckoutLinks();
			// setCustomDiscount()
		}
	}

	/**
	 * @private
	 * @function
	 * @description Get multistore prices/ids
	 **/
	function getMultistoreData() {
		app.multistore.variantDataDeffer = $.ajax({
			url: settings.fetchUrl,
			dataType: "json",
			method: 'GET',
			async: true,
			success: function (data) {
				initializeMultiStore(data);
				if (app.page.template == 'pdp') {
					app.microdata.init();
				}
				app.multistore.initialized = true;
			},
			error: function (xhr, textStatus, errorThrown) {
				console.warn('Error while loading multistore data. ' + xhr + ' ' + textStatus + ' ' + errorThrown);
			},
			complete: function (xhr, textStatus, errorThrown) {
				setVisiblePrices();
			}
		})
	}

	/**
	 * @private
	 * @function
	 * @description Get cart items and return list of [SKU,QTY,Discount]
	 **/
	function getMultistoreCartItems(items) {
		var cartPrices = [];

		$.each(items, function (key, item) {
			var discountPart = 1,
				customSize = item.properties.Size,
				sizeCountry = '',
				sizeType = '';

			if (item.discounted_price) {
				discountPart = parseFloat(item.discounted_price) / parseFloat(item.price);
			}

			// detect type
			if (customSize.indexOf('women') > -1) {
				sizeType = 'w'
			} else if (customSize.indexOf('men') > -1) {
				sizeType = 'm'
			}

			// detect country
			if (customSize.indexOf('us ') > -1) {
				sizeCountry = 'us'
			} else if (customSize.indexOf('uk ') > -1) {
				sizeCountry = 'uk'
			} else if (customSize.indexOf('eu ') > -1) {
				sizeCountry = 'eu'
			}


			cartPrices.push(item.sku + ',' + item.quantity + ',' + discountPart + ',' + sizeCountry + sizeType);
		});

		return cartPrices;
	}

	/**
	 * @private
	 * @function
	 * @description Show hidden prices
	 **/
	function setVisiblePrices() {
		$('span.money').each(function () {
			$(this).removeClass('invisible');
		});
	}

	/**
	 * @private
	 * @function
	 * @description Get preorder item attribute data from tags
	 **/
	function getPreorderData() {
		app.product.data.preorder = ($('#preOrderAvailable').text() == "true");
	}

	/**
	 * @private
	 * @function
	 * @description Initializes multistore cache
	 **/
	function initializeCache() {
		$cache = {
			$document: $(document),
			$currency: $('#currencies'),
			multistoreData: {},
			multistorePrices: {},
			multistoreVariants: {},
			checkoutList: {},
			skuList: []
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes multistore settings
	 **/
	function initializeSettings() {
		settings = {
			fetchUrl: Theme.multistore.variantDataUrl
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes multistore DOM
	 **/
	function initializeDOM() {
		if ((app.page.template == 'pdp' ||
			app.page.template == 'cart' ||
			app.page.template == 'plp') || Theme.cart.itemsCount > 0) {
			getSkuList();
			getMultistoreData();
			getPreorderData();
			// setInitialCheckout();
		}
	}

	app.multistore = {
		init: function () {
			initializeCache();
			initializeSettings();
			initializeDOM();
		},
		switchCheckout: function (checkout) {
			switchCheckout(checkout)
		},
		getPrice: function (sku) {
			return getStaticPrice(sku);
		},
		getCartItems: function (items) {
			return getMultistoreCartItems(items);
		},
		getLineItemsData: function () {
			getLineItemsData();
		},
		setCheckoutLinks: function (forceRedirect) {
			setCheckoutLinks(forceRedirect);
		},
		updateCheckoutLinks: function() {
			updateCheckoutLinks()
		},
		initialized: false,
		data: {
			prices: {},
			variants: {}
		},
		variantDataDeffer: false
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.microdata
 */
(function (app, $) {

	function setMicrodataValues(product,variant) {
		var productAvailability = "http://schema.org/InStock",
			productReviewsValue = parseFloat($('#productReviewsRating span').text()),
			productReviewsCount = parseInt($('.reviewsCount span').text().replace(/[^0-9]/gi, '')),
			productDescription = $('.js-product-description-content').text().replace(/\s\s+/g, ' ');

		if (product.available === false) {
			productAvailability = "http://schema.org/OutOfStock";
		}

		var el = document.createElement('script');

		el.type = 'application/ld+json';
		el.text = JSON.stringify({
			"@context": "http://schema.org",
			"@type": "Product",
			"name": product.title,
			"description": productDescription,
			"image": product.images[0].src,
			"url": "https://mahabis.com/products/" + product.handle,
			"gtin": variant.id,
			"sku": app.product.data.sku,
			"offers": [
				{
					"@type": "Offer",
					"url": "https://mahabis.com/products/" + product.handle,
					"priceCurrency": "GBP",
					"price": variant.price,
					"availability": productAvailability,
					"itemCondition": "http://schema.org/NewCondition"
				}
			],
			"aggregateRating": {
				"@type": "AggregateRating",
				"ratingValue": productReviewsValue,
				"reviewCount": productReviewsCount,
				"bestRating":5,
				"worstRating":0
			},
		});

		document.querySelector('body').appendChild(el);
	}

	function variantIdLookup(data) {
		$.each(data.products, function(key, product) {
			$.each(product.variants, function(key2, variant){
				if (variant.sku === app.product.data.sku) {
					console.log(product);
					setMicrodataValues(product,variant);
				}
			})
		});
	}

	function getMicrodata() {
		var productsFetchUrl = "https://mahabis.com/products.json?limit=250&page=1"

		$.ajax({
			url: productsFetchUrl,
			dataType: 'json',
			type: 'GET',
			success: function (productsData) {
				variantIdLookup(productsData)
			}
		});
	}

	function setMicrodata() {
		getMicrodata();
	}

	app.microdata = {
		init: function () {
			setMicrodata();
		}
	}

}(window.app = window.app || {}, jQuery));

/**
 * @class app.zoom
 */
(function (app, $) {
	var $cache;

	/**
	 * @private
	 * @function
	 * @description Initialize desktop product zoom
	 **/
	function initDesktopZoom() {
		$cache.zoomDesktop.trigger('zoom.destroy');
		$cache.zoomDesktop.zoom({
			on: 'click',
			touch: true,
			onZoomIn: function () {
				$(this).addClass('zoomed');
				$(this).parent().addClass('expanded');
			},
			onZoomOut: function () {
				$(this).removeClass('zoomed');
				$(this).parent().removeClass('expanded');
			},
			callback: function () {
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize zoom cache
	 **/
	function initializeCache() {
		$cache = {
			zoomDesktop: $('#imgZoomed')
		}
	}

	app.zoom = {
		init: function () {
			initializeCache();
		},
		initDesktop: function () {
			initDesktopZoom();
		}
	}

}(window.app = window.app || {}, jQuery));


/**
 * @class app.subscribe
 */
(function (app, $) {
	var $cache,
		settings,
		properties;

	/**
	 * @private
	 * @function
	 * @description Subscribe success
	 **/
	function subscribeSuccess() {
		var modalSignup = $('#modal-signup'),
			modalButton = modalSignup.find('button'),
			modalClass = $('.modal-subscribe'),
			modalText = modalClass.find('.modal-text'),
			thankyouTitle = $('#subscribeThanksTitle').text(),
			thankyouContent = $('#subscribeThanksContent').html();

		dataLayer.push({'event': 'discount_button_submit'});
		modalButton.addClass('transitioning');
		app.utils.setCookie('subscribeEmail', settings.subscribeData.email);

		setTimeout(function () {
			modalText.addClass('fading');
			setTimeout(function () {
				modalSignup.addClass('success-state');
				modalText.find('h3').html(thankyouTitle);
				modalText.find('p').html(thankyouTitle);
				modalClass.find('.no-thanks').html(properties.successclose);
				modalSignup.find('input').addClass('hidden');
				$('#modalSubscribe').addClass('is-success');
				$('#subscribeStatusContainer').html(thankyouContent);
				$('#subscribeForm').addClass('hidden');
				modalText.removeClass('fading');
			}, 1000);
		}, 200);
	}

	/**
	 * @private
	 * @function
	 * @description Subscribe submit functionality
	 **/
	function subscribePopupSubmit(timeInitialized) {
		var geoCountry = $.cookie('deliveryC'),
			timeSubmitted = new Date(),
			timeDiff = (timeSubmitted - timeInitialized) / 1000, // convert to seconds
			source = $('#subscribeForm').find("input[name='properties.signup_source']").val();

		if (timeDiff > 2 && source === 'pop up') {
			$('#subscribeForm').find('.js-ometria-geoip-country').val(geoCountry);

			correctCaptchaSubscribePopup();
		}
	}

	function initWelcomeSubscribe() {
		var timeInitialized = new Date();
		// Add loading state
		$('#subscribeForm').on('submit', function (e) {
			e.preventDefault();
			subscribePopupSubmit(timeInitialized);
		});
	}

	function showSubscribePopup() {
		// Subscribe popup fire
		if ($.cookie('popupSubscribe') == null) {
			var pageURL = window.location.href,
				siteFirstVisit = $.cookie('siteFirstVisit'),
				timeOut = app.subscribe.timeOut,
				timeToOpen = timeOut,
				timeNow = new Date();

			if (siteFirstVisit) {
				var timeDelta = timeNow - new Date($.cookie('siteFirstVisit'));
				timeToOpen = timeOut - timeDelta;

				if (timeToOpen < 3000) {
					timeToOpen = 3000;
				}
			} else {
				$.cookie('siteFirstVisit', timeNow, {
					expires: 7,
					path: '/',
					domain: window.location.hostname
				});
			}

			if (pageURL.indexOf("a=0") > -1 || pageURL.indexOf("ll_ref_id=") > -1) {
				$.cookie('popupSubscribe', 1, {
					expires: 7,
					path: '/',
					domain: window.location.hostname
				});
			} else {
				if (!(pageURL.indexOf("ll_ref_id=") > -1) &&
					!(pageURL.indexOf("a=0") > -1) &&
					!(pageURL.indexOf("ig=true") > -1) &&
					!(pageURL.indexOf("email_response=") > -1)) {
					setTimeout(function () {
						app.popup.open('modalSubscribe');
						$.cookie('popupSubscribe', 1, {
							expires: 7,
							path: '/',
							domain: window.location.hostname
						});
					}, timeToOpen);
				}
			}
		}
	}

	function correctCaptchaSubscribePopup(response) {
		$.ajax({
			type: "POST",
			url: "https://api.ometria.com/forms/signup/ajax",
			data: $('#subscribeForm').serialize(),
			cache: false,
			timeout: 5000,
			contentType: "application/x-www-form-urlencoded",
			beforeSend: function () {
				var $form = $('#subscribeForm'),
					customerEmail = $form.find('.js-customer-email').val();

				$form.find('.button').addClass('isLoadingBtn');
				app.analytics.event('Subscribe Popup', 'Email Sent');
				app.tracking.email.fb();
				app.subscribe.emailSent = true;
				app.utils.setCookie('cEmail', customerEmail);
			},
			success: function (data) {
				if (data.ok) {
					$('#subscribeForm').find('.button').removeClass('isLoadingBtn');
					$('#subscribeErrorContainer').addClass('hidden');
					app.subscribe.onSuccess(data);
				} else if (data.errors) {
					$('#subscribeErrorContainer').html(response.errors[0][1]);
					app.analytics.event('Subscribe Popup', 'Email Error');
				}
				$('#subscribePopupRecaptcha').addClass('hidden');
			},
			error: function () {
				$('#subscribeErrorContainer').html("Something is wrong, please try again later");
				app.analytics.event('Subscribe Popup', 'Email Error');
			}
		});
	}

	function getSubscibePopupTiming() {
		function implementExperimentTiming(value) {
			if (value ==  '0') {

			} else if (value == '1') {
				app.subscribe.timeOut = 5000;
			} else if (value == '2') {
				app.subscribe.timeOut = 15000;
			} else if (value == '3') {
				app.subscribe.timeOut = 30000;
			} else {
				app.subscribe.timeOut = 10000;
			}
		}

		if (window.gtag) {
			gtag('event', 'optimize.callback', {
				name: 'JP9BSYzXT66jPay1RPwKtQ',
				callback: implementExperimentTiming
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes subscribe cache
	 **/
	function initializeCache() {
		$cache = {
			subscribeModal: $('#modalSubscribe'),
			subscribeForm: $('#subscribeForm'),
			subscribeError: $('#subscribeErrorContainer'),
			subscribeStatus: $('#modalSubscribe').find('#subscribeStatusContainer')
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes subscribe properties
	 **/
	function initializeProperties() {
		properties = {
			tryagain: "oops, try again",
			alreadyregistered: "you're already registered",
			emailerror: "Please enter a valid email address.",
			successclose: "continue shopping"
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes subscribe settings
	 **/
	function initializeSettings() {
		settings = {
			promocode: "MS74JDO39",
			subscribeUrl: "https://a11.mahbais.com/api/subscribe",
			subscribeData: {},
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initializes subscribe popup
	 **/
	function initializeDOM() {
		getSubscibePopupTiming();
		//showSubscribePopup();
		if ($cache.subscribeForm.length) {
			initWelcomeSubscribe();
		}
	}

	function initializeEvents() {
		$('#subscribeEmailError').on('click', function () {
			var val = $(this).text();
			$('#exit_email3').val(val);
			$('#subscribeEmailErrorWrapper').addClass('hidden');
		});

		$('.js-subscribe-close').on('click touchend', function (e) {
			$('body').removeClass('isFixed');
			if (!app.subscribe.emailSent) {
				if (window.ga) {
					app.analytics.event('Subscribe Popup', 'Email Not Sent');
				}
			}
		});
	}

	app.subscribe = {
		init: function () {
			initializeCache();
			initializeSettings();
			initializeProperties();
			initializeEvents();
			initializeDOM();
		},
		timeOut: 10000,
		emailSent: false,
		onSuccess: function(data) {
			subscribeSuccess(data)
		}
	}

}(window.app = window.app || {}, jQuery));


/**
 * @class app.currency
 */
(function (app, $) {
	var $cache,
		settings;

	/**
	 * @private
	 * @function
	 * @description Currency select trigger
	 **/
	function selectCurrency(el) {
		var newCurrency = el.attr('data-currency');
		app.currency.sign = el.attr('data-currency-sign');
		$cache.currencyButton.removeClass('selected');
		el.addClass('selected');
		// Currency.convertAll('GBP', newCurrency);
	}

	/**
	 * @private
	 * @function
	 * @description Get currency from cookies
	 **/
	function getCookieCurrency() {
		return "GBP";
		// return app.utils.getCookie('sitecurrency') || app.utils.getUrlParam('sitecurrency') || 'GBP';
	}

	/**
	 * @private
	 * @function
	 * @description Set country-specific class
	 **/
	function setCurrencyClass() {
		var currency = app.currency.get(),
			countryClass = 'currency-' + currency.toLowerCase();

		$('body').alterClass('currency-*').addClass(countryClass);
	}

	/**
	 * @private
	 * @function
	 * @description Show wrapper for multilang
	 **/
	function showMultilangWrapper() {
		$('.js-multilang-wrapper').removeClass('hidden');
	}

	/**
	 * @private
	 * @function
	 * @description Detect currency sign
	 **/
	function getCurrencySign() {
		// var urlCurrency = app.utils.getUrlParam('sitecurrency');
		// if (urlCurrency) {
		// 	app.currency.sign = $('#currencies').find('span[data-currency="' + urlCurrency.toUpperCase() + '"]').data('currency-sign');
		// 	Currency.cookie.write(urlCurrency.toUpperCase());
		// } else {
		// 	app.currency.sign = $('#currencies').find('.selected').data('currency-sign');
		// }

		app.currency.value = app.currency.get();
		app.currency.sign = "£";
	}

	/**
	 * @private
	 * @function
	 * @description Detect if selected currency have discounts
	 **/
	function getCurrencyDiscount() {
		var currency = app.currency.get().toLowerCase();

		$('.js-money-discount').each(function () {
			var $this = $(this),
				discountedAttr = 'data-discounted-' + currency,
				attrAvailable = $this.attr(discountedAttr);

			if (attrAvailable && attrAvailable !== 'false') {
				$this.removeClass('is-hidden');
			} else {
				$this.addClass('is-hidden');
			}
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize currency cache
	 **/
	function initializeCache() {
		$cache = {
			currencyButton: $('#currencies span')
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize currency settings
	 **/
	function initializeSettings() {
		settings = {
			changeAmount: 0
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize currency DOM
	 **/
	function initializeDOM() {
		setCurrencyClass();
		showMultilangWrapper();
		getCurrencySign();
	}

	/**
	 * @private
	 * @function
	 * @description Initialize currency events
	 **/
	function initializeEvents() {
		// Change select event
		$cache.currencyButton.on('click', function () {
			var $this = $(this),
				currencyCheckout = $this.data('checkout') || 'GBP';

			settings.changeAmount++;
			selectCurrency($this);
			if (app.page.template === "cart") {
				app.multistore.setCheckoutLinks();
			}
			setCurrencyClass();
		});
	}

	app.currency = {
		init: function () {
			initializeCache();
			initializeSettings();
			initializeDOM();
			initializeEvents();
		},
		get: function () {
			return getCookieCurrency();
		},
		getDiscount: function () {
			getCurrencyDiscount();
		},
		value: '',
		detected: false,
		sign: ''
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.myaccount
 */
(function (app, $) {
	var settings;

	/**
	 * @private
	 * @function
	 * @description Toggle Restore Password
	 **/
	function toggleRestorePassword() {
		$('#RecoverPasswordForm').toggleClass('hidden');
		$('#AccountLoginForm').toggleClass('hidden');
	}

	/**
	 * @private
	 * @function
	 * @description Initialize myaccount DOM
	 **/
	function initializeEvents() {
		$('#RecoverPassword, #HideRecoverPasswordLink').on('click', function() {
			toggleRestorePassword();
		});

	}

	app.myaccount = {
		init: function () {
			initializeEvents();
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.analytics
 */
(function (app, $) {

	/**
	 * @private
	 * @function
	 * @description Send GA events from element
	 **/
	function sendTrackEvent(el) {
		var category = el.attr('data-event-category'),
			action = el.attr('data-event-action'),
			label = el.attr('data-event-label') || '';

		if (app.currency.detected && ga) {
			ga('send', 'event', category, action, label);

			if (window.gtag) {
				gtag('event', action, {
					'event_category': category,
					'event_label': label
				});
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Send GA events from request
	 **/
	function sendAnalyticsEvent(category, action, label) {
		ga('send', 'event', category, action, label || '', {
			nonInteraction: true
		});

		if (window.gtag) {
			gtag('event', action, {
				'event_category': category,
				'event_label': label
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize analytics events
	 **/
	function initializeEvents() {
		$(document).on('click touchend', '.js-track-events', function () {
			sendTrackEvent($(this));
		});
	}

	app.analytics = {
		init: function () {
			initializeEvents();
		},
		event: function (category, event, label) {
			sendAnalyticsEvent(category, event, label);
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.delivery
 */
(function (app, $) {
	var $cache,
		settings;

	/**
	 * @private
	 * @function
	 * @description Change delivery country on hash change
	 **/
	function changeCountryByHash() {
		var hash = window.location.hash.split('#')[1];
		$('#countrySelect').find('option').each(function () {
			var $this = $(this),
				country = $this.val().toLowerCase().replace(/ /g, '');

			if (hash == country) {
				$this.attr('selected', 'selected').trigger('change');
				return false;
			}
		});
	}

	function initializeHashChange() {
		$(window).on('hashchange', function () {
			changeCountryByHash();
		});
	}

	function setCountryData(countries) {
		app.delivery.countryData = countries[app.geoip.countryFullName];
	}

	function getCountriesList() {
		if (app.geoip.countryFullName && !app.delivery.countryData) {
			$.ajax({
				url: Theme.shop.countriesUrl,
				success: function (data) {
					setCountryData(data.countries);

					if (app.page.template === 'cart' && app.delivery.countryData) {
						app.cart.showCarriersList(app.delivery.countryData.carriers);
					}
				},
				error: function (error) {
					console.warn("Countries data can't be loaded: " + error);
				}
			});
		}
	}


	app.delivery = {
		initHashChange: function () {
			initializeHashChange();
		},
		getCountriesList: function () {
			getCountriesList();
		},
		countryData: null
	}
}(window.app = window.app || {}, jQuery));


/**
 * @class app.geoip
 */
(function (app, $) {
	var settings;

	function changeGeoipCountry() {
		var locationChanged = $.cookie('cLocationChanged'),
			currencyParam = app.utils.getUrlParam('sitecurrency') || '',
			currencyToChange = app.geoip.location;

		if (app.geoip.location && locationChanged == undefined && !currencyParam) {
			$('.currencySwitcher').find('[data-country=' + currencyToChange + ']').trigger('click');
			$('#currencies').removeClass('open');
			$.cookie('cLocationChanged', true);

			if (app.page.template == 'pdp') {
				app.product.switchProductSizes();
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Get geoip stored cookies
	 **/
	function getGeoipCookies() {
		var location = $.cookie('cLocation'),
			country = $.cookie('deliveryCountryISO'),
			countryFullName = $.cookie('deliveryC');

		if (location) {
			app.geoip.location = location;
			app.geoip.country = country;
			app.geoip.countryFullName = countryFullName;

			changeGeoipCountry();
			app.currency.detected = true;
		} else if (location == undefined && app.geoip.attempt < settings.tryAtemptsLimit) {
			app.geoip.attempt++;
			setTimeout(getGeoipCookies, settings.waitingDelay);
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize geoip settings
	 **/
	function initializeSettings() {
		settings = {
			tryAtemptsLimit: 10,
			waitingDelay: 200
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize geoip DOM
	 **/
	function initializeDOM() {
		getGeoipCookies();
	}

	app.geoip = {
		init: function () {
			initializeSettings();
			initializeDOM();
		},
		location: false,
		attempt: 0
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.customizer
 */
(function (app, $) {
	var settings;

	function initCustomization() {
		app.customizer.ripe = new Ripe({
			url: "https://app.platforme.com/api/",
			brand: settings.initialBrand,
			model: settings.initialModel,
			options: {
				format: 'webp',
				errorPopup: false,
				remoteCalls: false,
				useMasks: false,
				usePrice: false,
				useSync: false,
			}
		});

		app.customizer.ripe.bind("ready", function() {
			$('#customizerWrapper').removeClass('is-loading');
			console.log('loaded');
			var paramsAdded = app.utils.getUrlParam('cu') || app.utils.getUrlParam('cc') || app.utils.getUrlParam('tle') || app.utils.getUrlParam('tre') || app.utils.getUrlParam('lse') || app.utils.getUrlParam('rse');

			if (paramsAdded) {
				setParamsCustomizer();
			} else {
				setDefaultCustomizer();
			}
		});

		app.customizer.ripe.bind("update", function(data) {
			console.log(data);
			getProductDKU(data.state)
			setPersonalizationView();
			app.customizer.parts = data.state.parts;
		});
	}

	function setDefaultCustomizer() {
		$('.js-customizer-color[data-value="light_grey"]').trigger('click');
		$('.js-customizer-color[data-value="skien_black"]').trigger('click');
	}

	function setParamsCustomizer() {
		var upperParam = app.utils.getUrlParam('cu'),
			colourParam = app.utils.getUrlParam('cc'),
			topLeftColourParam = app.utils.getUrlParam('tlc'),
			topRightColourParam = app.utils.getUrlParam('trc'),
			sideLeftColourParam = app.utils.getUrlParam('slc'),
			sideRightColourParam = app.utils.getUrlParam('src'),
			topLeftEmbroideryParam = app.utils.getUrlParam('tle'),
			topRightEmbroideryParam = app.utils.getUrlParam('tre'),
			sideLeftEmbroideryParam = app.utils.getUrlParam('sle'),
			sideRightEmbroideryParam = app.utils.getUrlParam('sre');

		setTimeout(function () {
			// customisation
			$('.js-customizer-color[data-value="' + colourParam + '"]').trigger('click');
			$('.js-customizer-color[data-value="' + upperParam + '"]').trigger('click');

			// embroidery
			$('.js-customization-text[data-position="topleft"]').val(topLeftEmbroideryParam.substring(0,3)).trigger('keyup');
			$('.js-customization-text[data-position="topright"]').val(topRightEmbroideryParam.substring(0,3)).trigger('keyup');
			$('.js-customization-text[data-position="leftside"]').val(sideLeftEmbroideryParam.substring(0,12)).trigger('keyup');
			$('.js-customization-text[data-position="rightside"]').val(sideRightEmbroideryParam.substring(0,12)).trigger('keyup');


		}, 500);

		setTimeout(function() {
			// embroidery colour
			$('.js-customization-text-wrapper[data-position="topleft"]').find('.js-customization-text-colour[data-colour="' + topLeftColourParam + '"]').trigger('click');
			$('.js-customization-text-wrapper[data-position="topright"]').find('.js-customization-text-colour[data-colour="' + topRightColourParam + '"]').trigger('click');
			$('.js-customization-text-wrapper[data-position="leftside"]').find('.js-customization-text-colour[data-colour="' + sideLeftColourParam + '"]').trigger('click');
			$('.js-customization-text-wrapper[data-position="rightside"]').find('.js-customization-text-colour[data-colour="' + sideRightColourParam + '"]').trigger('click');
		}, 700);
	}

	function getProductDKU(data) {
		var url = "https://app.platforme.com/api/config/info?",
			params = "brand=" + data.brand + "&model=" + data.model,
			parts = data.parts;

		$.each(parts, function(part, index){
			var partObj = parts[part];
			var partParam = "&p=" + part + ":" + partObj.material + ":" + partObj.color;
			params = params + partParam;
		})

		url = url + params;

		// set for custom image
		app.customizer.productParams = params;

		$.ajax({
			url: url,
			type: 'GET',
			beforeSend: function (xhr) {
				console.log('get');
			},
			success: function (data) {
				app.customizer.productDKU = data.dku;
			}
		})
	}

	function getCustomizationProperties() {
	}

	function getCustomizationConfigs() {
		// get configuration
		app.customizer.ripe.bind("config", function(config) {
			var parts = config.parts;

			//set max frames
			settings.framesMax = config.frames;

			// console.log(config)

			// console.log('config loaded');
			// console.log(parts);

			setConfigurationOptions(parts);
		});
	}

	function setCustomizerPreviewImages(topViewSrc) {
		var sideViewSrc = "" || topViewSrc,
			embroideryTopLeft = $('#topleft').attr('src'),
			embroideryTopRight = $('#topright').attr('src'),
			embroiderySideLeft = $('#leftside').attr('src'),
			embroiderySideRight = $('#rightside').attr('src'),
			$wrapperMobile = $('#productpage-carousel'),
			$wrapper = $('#productImagesWrapper');

		if (topViewSrc) {
			sideViewSrc = topViewSrc.replace('frame=top', 'frame=side')
		}

		// top side view
		$wrapper.find('.product-thumb.first img').attr('src', sideViewSrc);
		$wrapper.find('.product-thumb-2 img').attr('src', topViewSrc);

		// mobile carousel view update
		$wrapperMobile.find('.js-slider-item-1 img').attr('src', sideViewSrc);
		$wrapperMobile.find('.js-slider-item-2 img').attr('src', topViewSrc);

		// embroidery views
		if (embroideryTopLeft) {
			$('.js-slider-item-3 img').attr('src', embroideryTopLeft);
			$('.js-slider-item-4 img').attr('src', embroideryTopRight);
			$('.js-slider-item-5 img').attr('src', embroiderySideLeft);
			$('.js-slider-item-6 img').attr('src', embroiderySideRight);
			$wrapper.find('.product-thumb-4 img').attr('src', embroideryTopLeft);
			$wrapper.find('.product-thumb-3 img').attr('src', embroideryTopRight);
			$wrapper.find('.product-thumb-6 img').attr('src', embroiderySideLeft);
			$wrapper.find('.product-thumb-5 img').attr('src', embroiderySideRight);
		}
	}

	function renderCustomizationImage() {
		// render image
		var element = document.getElementById("frame-0"),
			initialFrame = settings.currentView + "-" + "0";

		app.customizer.$image = app.customizer.ripe.bindImage(element, {
			frame: initialFrame
		});

		app.customizer.$image.bind("loaded", function(frame) {
			console.log("frame " + frame + " loaded");
			var newImage = $('#frame-0').attr('src');
			$('#customizerImages').removeClass('is-loading');
			setTimeout(function () {
				setCustomizerPreviewImages(newImage);
			}, 1000);
		});

		app.customizer.ripe.load();
	}

	function getCustomizerAddTocartNode() {
		var node = $('#customizationActions').html(),
			returnNode = "<div class='js-customizer-part customizer-part' data-value='addtocart'>" + node + "</div>";

		return returnNode;
	}

	function setConfigurationOptions(parts) {
		var $options = $('#customizationOptions'),
			partIndex = 0,
			partNavigationLimit = 3,
			partsNavigationNode = '',
			addToCartNode = getCustomizerAddTocartNode();

		// iterate parts
		$.each(parts, function(key, part){
			var partName = part.name,
				partMaterials = part.materials,
				materialIndex = 0,
				materialsListNode = "",
				partClass = partIndex === 0 ? 'js-customizer-part customizer-part is-active' : 'js-customizer-part customizer-part',
				partNode = "<div class='" + partClass + "' data-value='" + partName + "'><p>" + partName +"</p>";

			// generate tabs
			if (key < partNavigationLimit) {
				var partActiveClass = '';

				if (key == 0) {
					partActiveClass = 'is-active'
				}

				partsNavigationNode = partsNavigationNode + '<li data-tab="' + partName + '" class="js-customizer-nav-tab ' + partActiveClass + '">' + partName + '</li>';
			}

			// iterate materials
			$.each(partMaterials, function(key2, material){
				var materialName = material.name,
					materialColours = material.colors,
					materialClass = "js-customizer-material customizer-material",
					colourIndex = 0;

				materialsListNode = materialsListNode + "<div>" + material.name +"</div>"

				if (materialIndex === 0) {
					materialClass = materialClass + ' is-active';
				}

				var materialNode = "<div class='" + materialClass + "' data-value='" + materialName + "'><p>" + materialName + "</p>";

				// iterate colours
				$.each(materialColours, function(key3, colour){
					var colourImgSrc = settings.swatchesUrl + settings.initialBrand + "/" + materialName + "/" + colour + ".png",
						colourClass = "js-customizer-color customizer-color";

					if (colourIndex === 0) {
						colourClass = colourClass + ' is-active';

					}

					// settings default colour name
					if (colourIndex === 0 && materialIndex === 0 && partIndex === 0) {
						var colourNew = colour.replace('_', ' ');
						$('#customizerActiveColour').html(colourNew);
					}

					if (colourIndex > 4) {
						colourClass = colourClass + ' is-temporary-hidden'
					}

					var colourNode =
						"<div class='" + colourClass + "' data-value='" + colour + "'>" +
						"<img src='" + colourImgSrc + "'/>" +
						"<div class='customizer-label'>" + colour + "</div>" +
						"</div>";

					materialNode = materialNode + colourNode;
					colourIndex++
				})

				materialNode = materialNode + "</div>";

				partNode = partNode + materialNode;

				materialIndex++;
			})

			partNode = partNode + "</div>";
			partIndex++;

			$options.append(partNode);
		})

		$options.append(addToCartNode);
		$('#customizerParts').append(partsNavigationNode);

		initCustomizerEvents();
	}

	function changePersonalizationImage(id) {
		$('#customizerImages img').removeClass('is-active');
		$('#' + id).addClass('is-active');
	}

	function initCustomizerEvents() {
		// personalizetion
		$('.js-customization-text').on('keyup change', function(){
			var $this = $(this),
				isActivated = $this.hasClass('is-activated'),
				text = $this.val().toUpperCase(),
				position = $this.data('position');

			// hiding initial images
			$('.js-product-thumb-1, .js-product-thumb-2, .js-slider-item-1, .js-slider-item-2').addClass('hidden');
			$('#productpage-carousel').trigger('to.owl.carousel', [2, 1, true]);


			// set default colour
			// if (!isActivated) {
			$this.parents('.js-customization-text-wrapper').find('.js-customization-text-colour-wrapper').addClass('is-visible');
			$this.parents('.js-customization-text-wrapper').find('.js-customization-text-colour.is-active').trigger('click');
			$this.addClass('is-activated');
			// }

			// validate using only letters and numbers
			text = text.replace(/[^a-zA-Z0-9 ☆★♡♥︎⚡︎]/g,'');
			$this.val(text);

			// replacing icons
			if (text.indexOf('☆') > -1) {
				text = text.replaceAll('☆', '');
			}

			if (text.indexOf('★') > -1) {
				text = text.replaceAll('★', '');
			}

			if (text.indexOf('♡') > -1) {
				text = text.replaceAll('♡', '');
			}

			if (text.indexOf('♥︎') > -1) {
				text = text.replaceAll('♥︎', '');
			}

			if (text.indexOf('⚡︎') > -1) {
				text = text.replaceAll('⚡︎', '');
			}

			// new
			app.customizer.initialsExtra[position].initials = text;
			// console.log(app.customizer.initialsExtra[position].initials);

			// for empty text reset embroidery colour
			if (text === '') {
				app.customizer.initialsExtra[position].engraving = null;
				$this.siblings('.js-customization-text-colour-wrapper').find('.js-customization-text-colour').removeClass('is-active');
				$this.siblings('.js-customization-text-colour-wrapper').find('.js-customization-text-colour[data-colour="blackside"]').addClass('is-active');
				$this.siblings('.js-customization-text-colour-wrapper').find('.js-customization-text-colour[data-colour="blackside"]').addClass('is-active');
			}
			app.customizer.ripe.setInitialsExtra(app.customizer.initialsExtra);


			if ($('#frame-0').hasClass('is-active')) {
				changePersonalizationImage(position);
			}

			$('#customizerImages').addClass('is-loading');

			setCustomizerPreviewImages();
		})

		// personalization views (new)
		$('.js-customization-position').on('click', function(){
			var $this = $(this),
				currentPosition = $this.data('position'),
				shoePosition = $('.js-customization-shoe.is-active').data('position'),
				newPosition = 'leftside';

			if (currentPosition === "side") {
				newPosition = shoePosition + currentPosition
			} else {
				newPosition = currentPosition + shoePosition
			}

			$this.siblings().removeClass('is-active');
			$this.addClass('is-active');

			$('.js-customization-text-wrapper').removeClass('is-active');
			$('.js-customization-text').removeClass('is-active');
			$('.js-customization-text-wrapper[data-position="' + newPosition + '"]').addClass('is-active');
			$('.js-customization-text[data-position="' + newPosition + '"]').addClass('is-active');
			$('#customizerAddSymbols').addClass('is-active');
			$('#customizerSymbolsList').removeClass('is-active');

			app.customizer.ripe.setInitialsExtra(app.customizer.initialsExtra);
			changePersonalizationImage(newPosition);
		});

		// personalization add icon (new)
		$('.js-customizer-symbol-item').on('click', function(){
			var $wrapper = $('.js-customization-text-wrapper.is-active'),
				$el = $wrapper.find('input'),
				symbol = $(this).data('icon'),
				limit = parseInt($wrapper.data('charlimit')),
				currentChars = $el.val().length,
				symbolStr = "",
				currentText = $el.val();

			// hiding initial images
			$('.js-product-thumb-1, .js-product-thumb-2, .js-slider-item-1, .js-slider-item-2').addClass('hidden');
			$('#productpage-carousel').trigger('to.owl.carousel', [2, 1, true]);

			if (symbol === "starfull") {
				symbolStr = "★"
			} else if (symbol === "star") {
				symbolStr = "☆"
			} else if (symbol === "flash") {
				symbolStr = "⚡︎"
			} else if (symbol === "heart") {
				symbolStr = "♡"
			}  else if (symbol === "heartfull") {
				symbolStr = "♥︎"
			}

			var newText = currentText + symbolStr;

			if (currentChars < limit) {
				$el.val(newText).trigger('change');
			}

			$('#customizerImages').addClass('is-loading');

		})

		$('#customizerAddSymbols').on('click', function(){
			$(this).removeClass('is-active');
			$('#customizerSymbolsList').addClass('is-active');
		})

		// personalization shoes (new)
		$('.js-customization-shoe').on('click', function(){
			var $this = $(this),
				currentPosition = $this.data('position'),
				viewPosition = $('.js-customization-position.is-active').data('position'),
				newPosition = 'topleft';

			if (viewPosition === "side") {
				newPosition = currentPosition + viewPosition
			} else {
				newPosition = viewPosition + currentPosition
			}

			$this.siblings().removeClass('is-active');
			$this.addClass('is-active');

			$('.js-customization-text-wrapper').removeClass('is-active');
			$('.js-customization-text').removeClass('is-active');
			$('.js-customization-text-wrapper[data-position="' + newPosition + '"]').addClass('is-active');
			$('.js-customization-text[data-position="' + newPosition + '"]').addClass('is-active');
			$('#customizerAddSymbols').addClass('is-active');
			$('#customizerSymbolsList').removeClass('is-active');

			app.customizer.ripe.setInitialsExtra(app.customizer.initialsExtra);
			changePersonalizationImage(newPosition);
		});

		// personalization colour (new)
		$('.js-customization-text-colour').on('click', function(){
			var $this = $(this),
				colour = $this.data('colour'),
				position = $this.parents('.js-customization-text-wrapper').data('position'),
				newColourString = colour + ':style:font.' + position + ':position';

			$this.siblings().removeClass('is-active');
			$this.addClass('is-active');

			app.customizer.initialsExtra[position].engraving = newColourString;
			app.customizer.ripe.setInitialsExtra(app.customizer.initialsExtra);

			$('#customizerImages').addClass('is-loading');

			setCustomizerPreviewImages();
		})


		// navigation (new)
		$('.js-customizer-nav-tab').on('click', function(){
			var $this = $(this),
				tab = $this.attr('data-tab');

			$this.siblings().removeClass('is-active');
			$this.addClass('is-active');

			$('.js-customizer-part').removeClass('is-active');
			$('.js-customizer-part[data-value="' + tab + '"]').addClass('is-active')
		})

		// personalization start (new)
		$('#customizerAddEmbroideryBtn').on('click', function(){
			$('#customizationInProgress').addClass('is-embroidery');
			$('#customizationRotate').addClass('hidden');
			$('#customizerAddSymbols').addClass('is-active');
			$('#customizerSymbolsList').removeClass('is-active');
			setPersonalizationView();
		});

		// personalization initial start (new)
		$('#embroiderStart').on('click', function(){
			if (!app.product.size.selected) {
				$('.js-size-selector-custom').detach().appendTo('#customizationSizeSelector');
				$('.js-size-selector-custom').removeClass('hidden')
			}
			$('#customizationInProgress').addClass('is-active is-embroidery');
			$('#customizationRotate').addClass('hidden');
			$('#customizerAddSymbols').addClass('is-active');
			$('#customizerSymbolsList').removeClass('is-active');
			setPersonalizationView();
		})

		// add to cart
		$('.js-customizer-addtocart').on('click', function(){
			var productSize = 'EU ' + app.customizer.productSizeSelected,
				sizeGender = $('#sizeSelection'),
				productModel = $('#customizerModelName').data('model'),
				productId = $('#customizerVariants').find('li[data-size="' + productSize + '"]').data('id');

			console.log(productSize);
			// window.ripeSdk.localeToNativeP("it", 46, "male")

			if (app.product.size.selected) {
				$('#selectSizeValidation').addClass('hidden');
				customizerAddToCart(productId, productSize, productModel);
			} else {
				$('#selectSizeValidation').removeClass('hidden');
			}

		})
	}

	function customizerAddToCart(id,size,model) {
		// console.log(app.customizer.productParams)
		// console.log(app.customizer.initialsExtra)
		var submitData = {
			quantity: 1,
			id: id,
			properties: {
				'CUSTOMIZER_MODEL': model,
				'CUSTOMIZER_SIZE': app.customizer.productSizeConverted,
				'PARTS_SOLE_COLOR': app.customizer.parts.sole.color,
				'PARTS_UPPER_COLOR': app.customizer.parts.upper.color,
				'PARTS_BINDING_COLOR': app.customizer.parts.binding.color,
				'PARTS_SOLE_MATERIAL': app.customizer.parts.sole.material,
				'PARTS_UPPER_MATERIAL': app.customizer.parts.upper.material,
				'PARTS_BINDING_MATERIAL': app.customizer.parts.binding.material,
				'ENGRAVING_TOPLEFT_INITIALS': app.customizer.initialsExtra.topleft.initials,
				'ENGRAVING_TOPRIGHT_INITIALS': app.customizer.initialsExtra.topright.initials,
				'ENGRAVING_LEFTSIDE_INITIALS': app.customizer.initialsExtra.leftside.initials,
				'ENGRAVING_RIGHTSIDE_INITIALS': app.customizer.initialsExtra.rightside.initials,
				'ENGRAVING_TOPRIGHT_COLOUR': app.customizer.initialsExtra.topright.engraving,
				'ENGRAVING_LEFTSIDE_COLOUR': app.customizer.initialsExtra.leftside.engraving,
				'ENGRAVING_TOPLEFT_COLOUR': app.customizer.initialsExtra.topleft.engraving,
				'ENGRAVING_RIGHTSIDE_COLOUR': app.customizer.initialsExtra.rightside.engraving
				// 'DKU': app.customizer.productDKU,
				// 'Initials': app.customizer.initialsExtra,
				// 'Params': app.customizer.productParams,
			}
		};

		// Clear cart
		$.ajax({
			type: "POST",
			dataType: 'json',
			url: '/cart/clear.js',
			success: function(){

				// Add to cart
				$.ajax({
					url: '/cart/add.js',
					dataType: 'json',
					type: 'post',
					data: submitData,
					beforeSend: function () {
						app.header.addToCartToggle(null, true);
					},
					success: function (itemData) {
						// app.tracking.addToCart.ttq(id, 1);
						app.header.updateMinicartAmount();
						app.header.getCartData(true);
					}
				});
			},
		});
	}

	function setPersonalizationView() {
		// default view
		var $image = app.customizer.ripe.bindImage(document.getElementById("frame-0"), {
			frame: "top-0"
		});

		$image.setFrame("top-0");

		// additional zoom view
		var initialsGroups = ['topleft', 'topright', 'leftside', 'rightside'];

		$.each(initialsGroups, function(index, item) {
			var groupImg = item,
				initialsProfiles = 'position::' + item;

			app.customizer.ripe.bindImage(document.getElementById(item), {
				showInitials: true,
				initials: app.customizer.initialsExtra[item].initials,
				initialsGroup: item,
				initialsProfiles: [initialsProfiles]
			});
		});
	}

	function setDefaultView() {
		var $image = app.customizer.ripe.bindImage(document.getElementById("frame-0"), {
			frame: "top-0"
		});

		$image.setFrame("top-0");
	}

	function setSizeToNative() {
		var genderSelected = "male";

		if (app.product.size.gender === "women") {
			genderSelected = "female"
		}

		if (!app.customizer.productSizeConverted) {
			console.log('Converting sizes to native');

			console.log('Selected size - ' , app.customizer.productSizeSelected)
			app.customizer.ripe.localeToNativeP("it", app.customizer.productSizeSelected, "male").then(function(response){
				app.customizer.productSizeConverted = response.native;

				console.log('Native size - ' , response.native)
			})
		}

	}

	function initCustomizationEvents() {
		app.customizer.ripe.bind("selected_part", function(part) {
			console.log("Part selected: ", part);
		});

		// customizer open
		$('#customizerStartButton').on('click', function(){
			if (!app.product.size.selected) {
				$('.js-size-selector-custom').detach().appendTo('#customizationSizeSelector');
				$('.js-size-selector-custom').removeClass('hidden')
			}
			$('#customizerSymbolsList').removeClass('is-active');
			$('#customizationInProgress').removeClass('is-embroidery');
			$('#customizationInProgress').addClass('is-active');
			$('#customizerImages img').removeClass('is-active');
			$("#frame-0").addClass('is-active');
			$('#customizationRotate').removeClass('hidden');
			$('#customizerAddSymbols').removeClass('is-active');
		})

		// finish customizer
		$('#customizerDoneBtn').on('click', function(){
			$('#customizationInProgress').removeClass('is-active');
			$(window).scrollTop(0)
			setCustomizerPreviewImages();
			setPersonalizationView();
			setSizeToNative();
		})

		// back event
		$('#customizerBackBtn').on('click', function(){
			app.customizer.ripe.undo();
		})

		$('#customizerRestart').on('click touchend', function(){
			$('#customizationInProgress').removeClass('is-active');
			$(window).scrollTop(0)
			setCustomizerPreviewImages();
			setPersonalizationView();
			setSizeToNative();
		})

		// customizer start
		$('.js-customizer-model-select').on('click', function(){
			$('#customizerStart').fadeOut('slow', function(){
				$('#customizerStart').addClass("hidden");
				$('#customizationInProgress').addClass("is-active");
			})
		})

		// customizer image rotate
		$('.js-customization-next').on('click', function(){
			if (settings.currentFrame < settings.framesMax) {
				settings.currentFrame = settings.currentFrame + 1;
			} else if (settings.currentFrame === settings.framesMax) {
				settings.currentFrame = 0;
			}
			var newFrame = settings.initialView + "-" + settings.currentFrame;

			app.customizer.$image.setFrame(newFrame);
		});

		$('.js-customization-prev').on('click', function(){
			if (settings.currentFrame === 0) {
				settings.currentFrame = settings.framesMax - 1;
			} else if (settings.currentFrame < settings.framesMax) {
				settings.currentFrame = settings.currentFrame - 1;
			}
			var newFrame = settings.initialView + "-" + settings.currentFrame;
			app.customizer.$image.setFrame(newFrame);
		});

		// customization events
		$('#customizationOptions').on('click', '.js-customizer-color', function(){
			var $this = $(this),
				$colour = $('#customizerActiveColour'),
				colour = $this.data('value'),
				newColour = colour.replace("_", " "),
				material = $this.parent().data('value'),
				part = $this.parent().parent().data('value');

			$this.parents('.js-customizer-part').find('.js-customizer-color').removeClass('is-active');
			$this.addClass('is-active');
			$colour.html(newColour);

			$('#customizerImages').addClass('is-loading');

			app.customizer.ripe.setPart(part, material, colour);
		})
	}

	/**
	 * @private
	 * @function
	 * @description Initialize geoip settings
	 **/
	function initializeSettings() {
		settings = {
			initialBrand: "mahabis",
			initialModel: $('#customizerType').data('type'),
			swatchesUrl: "https://app.platforme.com/api/swatch/",
			initialView: "top",
			currentFrame: 0,
			currentView: "top",
			framesMax: 0
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize geoip DOM
	 **/
	function initializeDOM() {
		initCustomization();
		getCustomizationConfigs();
		getCustomizationProperties();
		renderCustomizationImage();
		initCustomizationEvents();
		// setPersonalizationView();
	}

	app.customizer = {
		init: function () {
			initializeSettings();
			initializeDOM();
		},
		initialsExtra: {
			topleft: {
				initials: '',
				engraving: null,
			},
			topright: {
				initials: '',
				engraving: null,
			},
			leftside: {
				initials: '',
				engraving: null,
			},
			rightside: {
				initials: '',
				engraving: null,
			}
		},
		parts: null,
		ripe: {},
		$image: null,
		imagesCartUrl: "https://app.platforme.com/api/compose",
		productDKU: null,
		productParams: null,
		properties: null,
		initials: null,
		productSizeSelected: null,
		productSizeConverted: null
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.returns
 */
(function (app, $) {
	var $cache;

	function initReturnsForm() {
		var orderNumParam = app.utils.getUrlParam('order_id'),
			zipParam = app.utils.getUrlParam('postcode');

		if (orderNumParam && zipParam) {
			zipParam = zipParam.replace('%20', '').replace(' ', '')
			$('.js-order-number').val(orderNumParam);
			$('.js-order-zip').val(zipParam);

			sendReturnsRequest(orderNumParam, zipParam)
		}


		$('#returnsForm').on('submit', function(e){
			e.preventDefault();

			var $this = $(this),
				orderNumber = $this.find('.js-order-number').val(),
				orderZip = $this.find('.js-order-zip').val();

			// validation
			$('.js-returns-error').addClass('hidden');

			if (orderNumber === '') {
				$('.js-error-ordernumber').removeClass('hidden')
			}

			if (orderZip === '') {
				$('.js-error-zipcode').removeClass('hidden')
			}

			if (orderNumber !== '' && orderZip !== '') {
				sendReturnsRequest(orderNumber, orderZip)
			}
		})
	}

	function startReturnsOld() {
		$('.js-returns-step-0-0').fadeOut(function(){
			$('.js-returns-step-1').fadeIn();
			$(window).scrollTop(0);
		});
	}

	function sendReturnsRequest(order, zip) {
		var requestUrl = "https://store-live-api.mahabis.io/v1/return-requests",
			$errorContainer = $('.js-error-container'),
			ceAgent = app.utils.getUrlParam('ce_agent'),
			$submitButton = $('.js-returns-submit'),
			requestData = {
				"order_id": order,
				"postcode": zip
			};

		if (ceAgent) {
			requestData["override_token"] = ceAgent;
		}

		$.ajax({
			type: "POST",
			url: requestUrl,
			data: JSON.stringify(requestData),
			cache: false,
			dataType: 'json',
			contentType: "application/json",
			beforeSend: function () {
				$errorContainer.addClass('hidden');
				$submitButton.addClass('is-loading');
			},
			error: function (err, message) {
				$errorContainer.removeClass('hidden');
				$submitButton.removeClass('is-loading');

				if (err.responseJSON) {
					$errorContainer.html(err.responseJSON.status + ': ' + err.responseJSON.error);
				} else {
					$errorContainer.html("Something went wrong. Please try again later or contact support");
				}

				ga('send', 'event', "Returns Portal", "Return Start Error", err.responseJSON.error);

				if (window.gtag) {
					gtag('event', "Return Start Error", {
						'event_category': "Returns Portal",
						'event_label': err.responseJSON.error
					});
				}
			},
			success: function (data) {

				ga('send', 'event', 'Returns Portal', 'Return_Started', '');

				if (window.gtag) {
					gtag('event', 'Return_Started', {
						'event_category': 'Returns Portal'
					});
				}

				$submitButton.removeClass('is-loading');

				$cache.returnStep1.fadeOut(function(){
					$('.js-returns-step-1-1').fadeIn();
					$(window).scrollTop(0);
					$('.return-restart').removeClass('hidden');

					$('#returnEmailNew').html(data.data.email);
					$('#returnIdNew').html(data.data.order_name);
				});

				// if (data.status === "success") {
				// 	returnCustomerEmail = data.data.email;
				//
				// 	setDefaultReturnAddress(data.data.shipping_address);
				//
				// 	$('.js-order-number-found').html(order);
				// 	orderData = data.data;
				// 	setAvailableRoutes(data.data.available_routes);
				// 	generateItemsList(data.data.eligible_line_items);
				//
				// 	$('.js-return-email').html(returnCustomerEmail);
				//
				// 	filterNonReturnableItems(data.data);
				//
				// 	if (!itemListEventsInited) {
				// 		initItemsListEvents();
				// 	}
				// }
			}
		});
	}

	function filterNonReturnableItems(order) {
		var orderDate = new Date(order.created_at),
			nowDate = new Date(Date.now()),
			nonReturnableDaysLimit = 15,
			diffTime = Math.abs(nowDate - orderDate),
			diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

		if (diffDays > nonReturnableDaysLimit) {
			setNonReturnableItems();
		}
	}

	function setNonReturnableItems() {
		$('.js-return-item').each(function(){
			var $this = $(this),
				sku = $this.attr('data-item-sku'),
				isNonReturnableItem = $.inArray(sku, Theme.stock.returnsLimitedSKU) > -1;

			if (isNonReturnableItem) {
				$this.removeClass('js-return-item');
				$this.addClass('is-disabled');
				$this.find('.return-item-properties').html(Theme.stock.nonReturningMessage);
			}
		})
	}

	function setDefaultReturnAddress(address) {
		console.log(address);
		if (address) {
			var address2 = "";

			if (address.address2) {
				address2 = address.address2;
			}
			var returnAddressDefault = address.address1 + " " + address2 + ", " + address.zip + " " + address.city + ", " + address.country_code

			$('.js-return-address-default').html(returnAddressDefault);
		} else {
			$('.js-address-confirm').addClass('hidden');
			$('.js-return-address-confirmation ').addClass('is-noaddress');
			$('.js-address-change-label').html('please enter you address');
			$('.js-return-address-other-wrapper').removeClass('hidden');
		}
	}

	function setAvailableRoutes(routes) {
		routes.forEach(function (route) {
			if (route === "exchange") {
				$cache.returnTypeExchange.removeClass('hidden');
			} else if (route === "refund") {
				$cache.returnTypeRefund.removeClass('hidden');
			}
		});
	}

	function generateItemsList(items) {
		var itemsNode = "";
		$cache.itemsAmount = items.length;
		items.forEach(function(item) {
			var itemTitle = item.title,
				itemSKUDraft = item.sku,
				itemSKU = item.sku.split('-'),
				itemId = item.id,
				itemNonReturningMsg = Theme.stock.nonReturningMessage,
				itemNonReturning = $.inArray(item.sku, Theme.stock.returnsDisabledSKU) > -1,
				itemSKUFormatted = itemSKU[0] + '-' + itemSKU[1] + '-' + itemSKU[3] + '-' + itemSKU[4],
				itemProperties = item.variant_title;

			if (item.properties.length) {
				itemProperties = item.properties[0].value;
			}

			if (itemTitle == 'mahabis watch') {
				var itemPrice = parseInt(item.price) - parseInt(item.total_discount);

				if (itemPrice === 0) {
					itemNonReturning = true;
					itemNonReturningMsg = 'we do not accept returns of watches, as this was a free gift. if you purchased a watch instead, please contact our support team';
				} else if (itemPrice > 0) {
					itemNonReturning = false;
				}
			}

			if (itemNonReturning) {
				var itemNode = "<div class='return-item is-disabled' data-item-id='" + itemId + "'>" +
					"<div class='return-image-wrapper'>" +
					"<img class='return-item-image' src='//cdn.mahabis.com/website/plp/images/" + itemSKUFormatted + "-2.jpg?39'/>" +
					"</div>" +
					"<div class='return-item-content'>" +
					"<span class='return-item-title'>" + itemTitle + "</span>" +
					"<span class='return-item-properties'>" + itemNonReturningMsg + "</span>" +
					"</div>" +
					"</div>";
			} else {
				var itemNode = "<div class='js-return-item return-item' data-item-sku='" + itemSKUDraft + "' data-item-id='" + itemId + "'>" +
					"<div class='return-image-wrapper'>" +
					"<img class='return-item-image' src='//cdn.mahabis.com/website/plp/images/" + itemSKUFormatted + "-2.jpg?39'/>" +
					"</div>" +
					"<div class='return-item-content'>" +
					"<span class='return-item-title'>" + itemTitle + "</span>" +
					"<span class='return-item-properties'>" + itemProperties + "</span>" +
					"</div>" +
					"</div>";
			}



			itemsNode = itemsNode + itemNode;
		});

		$cache.returnItemsList.html(itemsNode);
	}

	function onReturnTypeSelected(type) {
		var $returnExchangeButton = $('.js-return-type-exchange'),
			isButtonExpanded = $returnExchangeButton.hasClass('is-expanded');
		$cache.returnTypeSelected.html(type);

		if (isButtonExpanded) {
			// no actions
		} else if (type === "exchange") {
			$returnExchangeButton.addClass('is-expanded');
			$('.js-exchange-input-wrapper').removeClass('hidden');
			$('.js-return-type-exchange-label').html('what would you like in <b>exchange</b>?');
		} else {
			$cache.returnStep3.fadeOut(function(){
				$cache.returnStep4.fadeIn();
				$('.js-return-type-exchange').removeClass('is-expanded');

			});
		}
	}

	function submitExchangeInput() {
		var inputValue = $('.js-exchange-input').val();

		if (inputValue !== "") {
			returnItemData["item_note"] = inputValue;

			$('.js-exchange-input').val('');
			$('.js-exchange-input-wrapper').addClass('hidden');
			$('.js-exchange-input-error').addClass('hidden');
			$('.js-return-type-exchange-label').html('i want to make an <b>exchange</b>');

			$cache.returnStep3.fadeOut(function(){
				$cache.returnStep4.fadeIn();
			});
		} else {
			$('.js-exchange-input-error').removeClass('hidden');
		}

	}

	function generateReturnReasons() {
		var returnReasonsNode = '';

		orderData.reasons.forEach(function(reason) {
			var reasonLabel = reason.label,
				reasonType = reason.type,
				reasonNode = '';

			if (reasonType === 'other') {
				reasonNode = "<li class='js-return-reason' data-reason='" + reasonType +"'>" +
					"<span>" + reasonLabel + "</span>" +
					"<div class='js-return-reason-other-wrapper return-reason-other-wrapper hidden'>" +
					"<input class='js-return-reason-other' type='text' placeholder='please enter the other reason'/>" +
					"<span class='js-return-reason-other-error error hidden'>this field is required</span>" +
					"<span class='js-return-reason-submit button'>submit</span>" +
					"</div>" +
					"</li>";
			} else {
				reasonNode = "<li class='js-return-reason' data-reason='" + reasonType +"'>" + reasonLabel + "</li>";
			}

			returnReasonsNode = returnReasonsNode + reasonNode;
		});

		$cache.returnReasonsList.html(returnReasonsNode);
	}

	function initItemsListEvents() {
		$('.js-return-item').on('click', function(){
			var $this = $(this),
				$thisInner = $this.html(),
				itemId = $this.attr('data-item-id');

			$('.js-return-type-exchange').removeClass('is-expanded');

			if (!$this.hasClass('is-selected')) {

				// multiple products flow
				returnItemData = {
					"id": parseInt(itemId),
					"quantity": 1,
					"return_type": null,
					"reason_type": null,
					"reason_comment": null,
					"item_note": null
				};

				$this.addClass('is-selected');

				$('.js-return-item-selected').html($thisInner);
				$('.js-return-items-summary, .js-return-final-items-summary').append($thisInner);

				generateReturnReasons();
				initReasonsListEvents();

				$(window).scrollTop(0);

				$cache.returnStep2.fadeOut(function(){
					$cache.returnStep3.fadeIn();
				});

				ga('send', 'event', "Returns Portal", "Step 1. Return Item Selected", "");

				if (window.gtag) {
					gtag('event', "Step 1. Return Item Selected", {
						'event_category': "Returns Portal"
					});
				}
			}
		});

		// Email confirmation
		$('.js-email-confirm').on('click', function(){
			$cache.returnStep42.fadeOut(function(){
				$cache.returnStep43.fadeIn();
			});
		});

		$('.js-address-confirm').on('click', function() {
			submitReturnRequest();
		});

		$('.js-return-address-change-submit').on('click', function() {
			submitAddressChange();
		});

		$('.js-email-change').on('click', function(){
			showEmailChange();
		});

		$('.js-address-change').on('click', function() {
			showAddressChange();
		});

		$('.js-return-email-change-submit').on('click', function(){
			submitEmailChange();
		})

		// Single item flow
		$('.js-return-item-single').on('click', function() {
			addReturnItemsToArray();

			$cache.returnStep41.fadeOut(function(){
				$cache.returnStep42.fadeIn();
			});

			ga('send', 'event', "Returns Portal", "Step 4. Single item return", "");

			if (window.gtag) {
				gtag('event', "Step 4. Single item return", {
					'event_category': "Returns Portal"
				});
			}
		});

		// Multiple items flow
		$('.js-return-item-multiple').on('click', function(){
			addReturnItemsToArray();

			$cache.returnStep41.fadeOut(function(){
				$cache.returnStep2.fadeIn();
			});

			ga('send', 'event', "Returns Portal", "Step 4. Multiple items return", "");

			if (window.gtag) {
				gtag('event', "Step 4. Multiple items return", {
					'event_category': "Returns Portal"
				});
			}
		});

		itemListEventsInited = true;
	}

	function showEmailChange() {
		$('.js-return-email-other-wrapper').removeClass('hidden');
	}

	function showAddressChange() {
		$('.js-return-address-other-wrapper').removeClass('hidden');
	}

	function submitAddressChange() {
		var country = $('.js-return-address-country').val(),
			city = $('.js-return-address-city').val(),
			zip = $('.js-return-address-zip').val(),
			address1 = $('.js-return-address-address1').val(),
			address2 = $('.js-return-address-address2').val();

		if (address1 !== '') {
			returnCustomerAddress["address1"] = address1;
		} else {
			$('.js-return-address-address1-error').removeClass('hidden');
		}

		if (address2 !== '') {
			returnCustomerAddress["address2"] = address2;
		}

		if (city !== '') {
			returnCustomerAddress["city"] = city;
		} else {
			$('.js-return-address-city-error').removeClass('hidden');
		}

		if (zip !== '') {
			returnCustomerAddress["zip"] = zip;
		} else {
			$('.js-return-address-zip-error').removeClass('hidden');
		}

		if (country !== '') {
			returnCustomerAddress["country_code"] = country;
		} else {
			$('.js-return-address-country-error').removeClass('hidden');
		}

		if (address1 !== '' && city !== '' && zip !== '' && country !== '') {
			$('.js-return-address-error').addClass('hidden');
			$('.js-return-address-city').val('');
			$('.js-return-address-zip').val('');
			$('.js-return-address-address1').val('');
			$('.js-return-address-address2').val('');
			$('.js-return-address-other-wrapper').addClass('hidden');
			$(window).scrollTop(0);
			submitReturnRequest();
		}
	}

	function submitEmailChange() {
		var newEmail = $('.js-return-email-other').val(),
			$error = $('.js-return-email-error'),
			isWrongEmail = newEmail.indexOf('..') > -1;
		isValidEmail = newEmail.indexOf('@') > -1;


		if (isWrongEmail) {
			$error.removeClass('hidden');
		} else if (newEmail !== '' && isValidEmail ) {
			returnCustomerEmail = newEmail;
			$error.addClass('hidden');

			$cache.returnStep42.fadeOut(function () {
				$cache.returnStep43.fadeIn();
			});

			$('.js-return-email').html(newEmail);
			$('.js-return-email-other-wrapper').addClass('hidden');
			$('.js-return-email-other').val('');
		} else {
			$error.removeClass('hidden');
		}

		ga('send', 'event', "Returns Portal", "Step 5. Customer email changed", "");

		if (window.gtag) {
			gtag('event', "Step 5. Customer email changed", {
				'event_category': "Returns Portal"
			});
		}

	}

	function initReasonsListEvents() {
		$('.js-return-reason').on('click', function(){
			var $this = $(this),
				returnReason = $this.attr('data-reason');
			returnItemsSubmitted = returnSubmitItems.length + 1;

			$cache.returnReasonsError.addClass('hidden');

			returnItemData["reason_type"] = returnReason;

			ga('send', 'event', "Returns Portal", "Step 3. Return Reason Selected", returnReason);

			if (window.gtag) {
				gtag('event', "Step 3. Return Reason Selected", {
					'event_category': "Returns Portal",
					'event_label': returnReason
				});
			}

			if (returnReason == 'other') {
				showOtherReturnField();
			} else {
				if ($cache.itemsAmount > 1 && (returnItemsSubmitted !== $cache.itemsAmount)) {
					$cache.returnStep4.fadeOut(function(){
						$cache.returnStep41.fadeIn();
						$(window).scrollTop(0);
					});
				} else {
					$cache.returnStep4.fadeOut(function(){
						$cache.returnStep42.fadeIn();
						$(window).scrollTop(0);
					});
					addReturnItemsToArray();

					ga('send', 'event', "Returns Portal", "Step 4. Single item return", "");

					if (window.gtag) {
						gtag('event', "Step 4. Single item return", {
							'event_category': "Returns Portal"
						});
					}
				}
			}
		});

		$('.js-return-reason-submit').on('click', function() {
			var $this = $(this),
				returnItemsSubmitted = returnSubmitItems.length + 1,
				reasonComment = $('.js-return-reason-other').val();

			if (reasonComment !== "") {
				returnItemData["reason_comment"] = reasonComment;
				$('.js-return-reason-other-error').addClass('hidden');

				if ($cache.itemsAmount > 1 && (returnItemsSubmitted !== $cache.itemsAmount)) {
					$cache.returnStep4.fadeOut(function(){
						$cache.returnStep41.fadeIn();
						$(window).scrollTop(0);
					});
				} else {
					$cache.returnStep4.fadeOut(function(){
						$cache.returnStep42.fadeIn();
						$(window).scrollTop(0);
					});
					addReturnItemsToArray();
				}
			} else {
				$('.js-return-reason-other-error').removeClass('hidden');
			}


		})
	}

	function addReturnItemsToArray() {
		if (returnItemData !== null) {
			returnSubmitItems.push(returnItemData);
		}

		returnItemData = null;
	}

	function showOtherReturnField() {
		$('.js-return-reason-other-wrapper').removeClass('hidden');
	}

	function submitReturnRequest() {
		var requestUrl = "https://store-live-api.mahabis.io/v1/return-requests/" + orderData.token + "/submit";

		var requestData = {
			"line_items": returnSubmitItems
		};

		// with address override
		if (returnCustomerAddress["address1"]) {
			var requestData = {
				"line_items": returnSubmitItems,
				"address": returnCustomerAddress
			};
		}

		$.ajax({
			type: "POST",
			url: requestUrl,
			data: JSON.stringify(requestData),
			cache: false,
			dataType: 'json',
			contentType: "application/json",
			beforeSend: function () {
				$cache.returnStep43.fadeOut(function(){
					$cache.returnStep42.fadeOut();
					$cache.returnStep41.fadeOut();
					$cache.returnStep5.fadeIn();
				})
			},
			error: function (err, message) {
				showReturnError(err.responseJSON.error);
			},
			complete: function(data) {

			},
			success: function (data) {
				$cache.returnStep5.find('.js-return-locations-load').fadeOut(function(){
					renderPlacesData(data.data);
					initPlacesEvents(orderData.token);
					clearCustomAddressData();
					$cache.returnStep5.find('.js-return-places').fadeIn();
					$cache.returnStep5.find('.js-return-places-mobile').fadeIn();
				});
			}
		});
	}

	function showReturnError(content) {
		$('.js-return-locations-load').addClass('hidden');
		$('.js-return-locations-error p').html(content);
		$('.js-return-locations-error').removeClass('hidden');
	}

	function clearCustomAddressData() {
		returnCustomerAddress = {
			"address1": null,
			"address2": null,
			"city": null,
			"zip": null,
			"country_code": null
		};
	}

	function initPlacesEvents(token) {
		$('.js-return-place').on('click', function(){
			var $this = $(this),
				placeID = $this.attr('data-place-id'),
				dropOffID = $this.attr('data-dropoff-id'),
				serviceName = $this.attr('data-service-name'),
				carrierName = $this.attr('data-carrier-name'),
				serviceAddress = $this.attr('data-service-address'),
				serviceIndex = $this.attr('data-service-index'),
				isServiceQr = $this.attr('data-service-qr');

			$this.addClass('is-loading');
			onPlaceSelected(placeID, token, dropOffID, isServiceQr, serviceIndex, serviceName, carrierName, serviceAddress);

			ga('send', 'event', "Returns Portal", "Step 5. Return Location Selected", isServiceQr ? "QR" : "Print");

			if (window.gtag) {
				gtag('event', "Step 5. Return Location Selected", {
					'event_category': "Returns Portal"
				});
			}

		});
	}

	function renderPlacesData(placesList) {
		$cache.returnStep4.attr('style','display:none');
		$cache.returnStep41.attr('style','display:none');
		$cache.returnStep5.removeClass('hidden');

		var placesNode = '',
			placesQrNode = '',
			placesPrinterNode = '',
			isQrFilterAvailable = false,
			placesFilterNode = '';

		$cache.returnPlacesList = placesList;

		// check if qr places available
		$.each(placesList, function(index, place) {
			if (place.service_name.indexOf("No Printer Required") > -1) {
				isQrFilterAvailable = true;
				return false;
			}
		});

		placesList.forEach(function(place, index) {
			var placeTitle = place.title,
				placeServiceId = place.service_id,
				placeDropoffId = place.id,
				placeCarrierName = place.carrier_name,
				placeCarrierId = place.carrier_id,
				placeServiceName = place.service_name,
				placeServiceType = "",
				isServiceQr = false,
				placeDistanceFormatted = "",
				placeDistanceLabel = "",
				placeCarrierImage = "",
				isAddressPoint = true,
				placeAddressNode = "",
				placeAddress = "";


			if (placeDropoffId.charAt(0) === "-")	 {
				isAddressPoint = false;
			}	else {
				placeAddress = place.address_detail.addr1 + ', ' + place.address_detail.addr2 + ' ' + place.address_detail.city + ', ' + place.address_detail.zip;
			}

			if (placeTitle == null) {
				placeTitle = "";
			}

			if (placeCarrierId == 4 || placeCarrierId == 10 || placeCarrierId == 11 || placeCarrierId == 19 || placeCarrierId == 24 || placeCarrierId == 33 || placeCarrierId == 38 || placeCarrierId == 39 ||  placeCarrierId == 55 || placeCarrierId == 62 || placeCarrierId == 65 || placeCarrierId == 81 || placeCarrierId == 92 || placeCarrierId == 97) {
				placeCarrierImage = "<img class='return-place-carrier-logo' src='//cdn.mahabis.com/website/returnportal/logos/" + placeCarrierId +  ".png'/>"
			}

			if (isAddressPoint) {
				if (place.address_detail.state !== "") {
					placeAddress = placeAddress + ", " + place.address_detail.state;
				}
			}

			if (placeServiceName.indexOf("No Printer Required") > -1) {
				placeServiceType = "<div class='return-place-qr-available'></div>";
				isServiceQr = true;
			} else {
				placeServiceType = "<div class='return-place-printer-available'></div>";
			}

			if (place.distance !== 0) {
				placeDistanceFormatted = Math.floor(place.distance * 100) / 100;
				placeDistanceLabel = placeDistanceFormatted + ' <br/> ' + place.distance_unit;
			}

			if (isAddressPoint) {
				placeAddressNode = "<div class='return-place-address'>Address: " + placeAddress + "</div>"
			} else {
				placeAddressNode = "<div class='return-place-address'>" + placeAddress + "</div>"
			}

			var	placeNode = "<div data-place-carrier-id='" + placeCarrierId + "' data-service-address='" + placeAddress + "' data-carrier-name='" + placeCarrierName + "' data-service-name='" + placeServiceName + "' data-service-qr='" + isServiceQr + "' data-dropoff-id='" + placeDropoffId + "' data-service-index='" + index + "' data-place-id='" + placeServiceId +"' class='js-return-place return-place'>" +
				"<div class='return-place-left'>" +
				"<div class='return-place-pin'></div>" +
				"<span class='return-place-distance'>" + placeDistanceLabel + "</span>" +
				"</div>" +
				"<div class='return-place-right'>" +
				"<div class='return-place-title'>" + placeTitle + "</div>" +
				"<div class='return-place-servicename'>" + placeServiceName + "</div>" +
				placeAddressNode +
				placeServiceType +
				placeCarrierImage +
				"</div>" +
				"</div>";
			// console.log(placeDistance);
			// console.log(placeServiceName);

			// global list (sort by distance)
			placesNode = placesNode + placeNode;

			// split into separate arrays
			// if (isQrFilterAvailable) {
			// 	if (isServiceQr) {
			// 		placesQrNode = placesQrNode + placeNode;
			// 	} else {
			// 		placesPrinterNode = placesPrinterNode + placeNode;
			// 	}
			// }
		});

		// if (isQrFilterAvailable) {
		// $('.js-return-places-filter').removeClass('hidden');
		// }

		$('.js-return-places').html(placesNode);
		// $('.js-return-places-mobile').html(placesQrNode + placesPrinterNode)
	}

	function onPlaceSelected(placeId, token, dropoOffId, isServiceQr, serviceIndex, serviceName, carrierName, dropoffAddress) {
		var errorMsg = 'please contact our ce team at info@mahabis.com';

		var requestUrl = "https://store-live-api.mahabis.io/v1/return-requests/" + token + "/confirm";
		var requestData = {
			"service_id": placeId,
			"dropoff_point_id": dropoOffId,
			"dropoff_address": dropoffAddress,
			"service_name": serviceName,
			"carrier_name": carrierName,
			"email": returnCustomerEmail,
			"customer_name": orderData.shipping_address.first_name + " " + orderData.shipping_address.last_name
		};

		$.ajax({
			type: "POST",
			url: requestUrl,
			data: JSON.stringify(requestData),
			cache: false,
			dataType: 'json',
			contentType: "application/json",
			beforeSend: function () {
			},
			error: function (err, message) {
				console.log(err);
				$('.js-return-places').addClass('hidden');
				$('.js-return-places-error').removeClass('hidden');

				if (err.responseJSON) {
					$('.js-return-places-error p').html(err.responseJSON.error.provider_error.message[0] + '<br/>please contact our ce team at info@mahabis.com')
				} else {
					$('.js-return-places-error p').html('processing error, ' + errorMsg)
				}
			},
			complete: function(data) {

			},
			success: function (data) {
				if (data.status === "success") {

					$cache.returnStep5.fadeOut(function(){
						$cache.returnStep6.fadeIn();
					});

					generateReturnLabel(data.data, isServiceQr, serviceIndex);
				}
			}
		});
	}

	function generateReturnLabel(response, isServiceQr, serviceIndex) {
		var returnPlaceData = $cache.returnPlacesList[serviceIndex],
			returnPlaceMapLink = "https://www.google.com/maps/search/?api=1&query=" + returnPlaceData.lat + "," + returnPlaceData.lng,
			returnPlaceAddress = "",
			returnPlaceHours = "",
			returnPlaceMap = "";

		if (returnPlaceData.address_detail) {
			returnPlaceAddress = returnPlaceData.address_detail.addr1 + ' ' + returnPlaceData.address_detail.addr2 + ' ' + returnPlaceData.address_detail.city + ' ' + returnPlaceData.address_detail.country + ' ' + returnPlaceData.address_detail.state + ' ' + returnPlaceData.address_detail.suburb + ' '  + returnPlaceData.address_detail.zip;
			returnPlaceHours = returnPlaceData.hours;
			returnPlaceMap = 	"<a target='_blank' class='button' href='" + returnPlaceMapLink + "'>View map</a>";
		}

		$cache.returnStep5.fadeOut(function(){
			$cache.returnStep6.fadeIn();
		});

		// console.log(response);
		// console.log(isServiceQr);

		if (isServiceQr === "true") {
			var returnLabelNode =
				"<div class='return-label-generated'>" +
				"<img src='" + response.label_url + "' class='return-label-qr-image'/>" +
				"<div class='return-label-trackingnum'>Tracking number: " + response.tracking_number + "</div>" +
				"<a target='_blank' download='qr.png' href='" + response.label_url + "' class='button'>Download Label</a>"
			"</div>";
		} else {
			var returnLabelNode =
				"<div class='return-label-generated'>" +
				"<div class='return-label-printer-wrapper'>" +
				"<div class='icon icon-returns'></div>" +
				"<a target='_blank' class='button hide-desktop' href='" + response.label_url + "'>View label</a>" +
				"<a class='button hide-mobile hide-tablet' target='_blank' download href='" + response.label_url +"'>Download label</a>" +
				"</div>" +
				"<div class='return-label-trackingnum'>Tracking number: " + response.tracking_number + "</div>"
			"</div>";
		}

		$('.js-label-generated').html(returnLabelNode);

		var returnPlaceNode =
			"<div class='return-label-place'>" +
			"<div class=\"icon icon-shipping\"></div>" +
			"<span>Your return drop-off point</span>" +
			"<div>" + returnPlaceData.title + "</div>" +
			"<div>" + returnPlaceData.carrier_name + "</div>" +
			"<div>" + returnPlaceAddress + "</div>" +
			"<div>" + returnPlaceHours + "</div>" +
			returnPlaceMap +
			"</div>";

		$('.js-label-generated').append(returnPlaceNode);
	}

	function returnRestart() {
		$cache.returnStep3.hide();
		$cache.returnStep4.hide();
		$cache.returnStep41.hide();
		$cache.returnStep5.hide();

		// reset values
		$('.js-return-item').removeClass('is-selected');
		returnItemData = null;
		returnSubmitItems = [];
		$('.js-return-items-summary, .js-return-final-items-summary').html("");

		$cache.returnStep2.fadeIn(function(){
			$(window).scrollTop(0);
		});
	}

	function startRecyclingRequest() {
		var country = $('.js-recycling-country').val(),
			city = $('.js-recycling-city').val(),
			zip = $('.js-recycling-zip').val(),
			address1 = $('.js-recycling-address1').val(),
			address2 = $('.js-recycling-address2').val();

		if (address1 !== '') {
			returnCustomerAddress["address1"] = address1;
		} else {
			$('.js-recycling-address1-error').removeClass('hidden');
		}

		if (address2 !== '') {
			returnCustomerAddress["address2"] = address2;
		}

		if (city !== '') {
			returnCustomerAddress["city"] = city;
		} else {
			$('.js-recycling-city-error').removeClass('hidden');
		}

		if (zip !== '') {
			returnCustomerAddress["zip"] = zip;
		} else {
			$('.js-recycling-zip-error').removeClass('hidden');
		}

		if (country !== '') {
			returnCustomerAddress["country_code"] = country;
		} else {
			$('.js-recycling-country-error').removeClass('hidden');
		}

		if (address1 !== '' && city !== '' && zip !== '' && country !== '') {
			submitRecyclingRequest(country, city, address1, zip);
		}
	}

	function submitRecyclingRequest(country, city, address1, zip) {
		var requestUrl = "https://store-live-api.mahabis.io/v1/return-requests/get_services_only/submit",
			$submitButton = $('.js-recycling-submit');

		var requestData = {
			"address": {
				"address1": address1,
				"city": city,
				"zip": zip,
				"country_code": country
			}
		};

		$.ajax({
			type: "POST",
			url: requestUrl,
			data: JSON.stringify(requestData),
			cache: false,
			dataType: 'json',
			contentType: "application/json",
			beforeSend: function () {
				$submitButton.addClass('is-loading');
				// $cache.returnStep43.fadeOut(function(){
				// 	$cache.returnStep42.fadeOut();
				// 	$cache.returnStep41.fadeOut();
				// 	$cache.returnStep5.fadeIn();
				// })
			},
			error: function (err, message) {
				$submitButton.removeClass('is-loading');

				// if (err.status === 404) {
				// 	showReturnError(err.responseJSON.error);
				// }
			},
			complete: function(data) {

			},
			success: function (data) {
				console.log(data);
				$('.js-recycling-step-1').fadeOut(function(){
					$('.js-recycling-step-2').fadeIn();
					$(window).scrollTop(0);
					setRecyclingAddress(country, city, address1, zip);
					generateRecyclingPlaces(data.data);
					initRecyclingEvents();
				});

				// $cache.returnStep5.find('.js-return-locations-load').fadeOut(function(){
				// 	renderPlacesData(data.data);
				// 	initPlacesEvents(orderData.token);
				// 	clearCustomAddressData();
				// 	$cache.returnStep5.find('.js-return-places').fadeIn();
				// 	$cache.returnStep5.find('.js-return-places-mobile').fadeIn();
				// });
			}
		});

		console.log(country, city, address1, zip);
	}

	function setRecyclingAddress(country, city, address1, zip) {
		recyclingCustomerAddress = {
			"address1": address1,
			"city": city,
			"zip": zip,
			"country_code": country
		}
	}

	function generateRecyclingPlaces(placesList) {
		var placesNode = '';

		placesList.forEach(function(place, index) {
			var placeTitle = place.title,
				placeServiceId = place.service_id,
				placeDropoffId = place.id,
				placeCarrierName = place.carrier_name,
				placeCarrierId = place.carrier_id,
				placeServiceName = place.service_name,
				placeServiceType = "",
				placeDistanceFormatted = "",
				placeDistanceLabel = "",
				isServiceQr = false,
				placeCarrierImage = "",
				isAddressPoint = true,
				placeAddressNode = "",
				placeAddress = "";

			if (placeDropoffId.charAt(0) === "-")	 {
				isAddressPoint = false;
			}	else {
				placeAddress = place.address_detail.addr1 + ', ' + place.address_detail.addr2 + ' ' + place.address_detail.city + ', ' + place.address_detail.zip;
			}

			if (placeTitle == null) {
				placeTitle = "";
			}

			if (placeCarrierId == 4 || placeCarrierId == 10 || placeCarrierId == 19 || placeCarrierId == 24 || placeCarrierId == 33 || placeCarrierId == 38 ||  placeCarrierId == 55 || placeCarrierId == 62 || placeCarrierId == 65 || placeCarrierId == 81 || placeCarrierId == 92 || placeCarrierId == 97) {
				placeCarrierImage = "<img class='return-place-carrier-logo' src='//cdn.mahabis.com/website/returnportal/logos/" + placeCarrierId +  ".png'/>"
			}

			if (isAddressPoint) {
				if (place.address_detail.state !== "") {
					placeAddress = placeAddress + ", " + place.address_detail.state;
				}
			}

			if (placeServiceName.indexOf("No Printer Required") > -1) {
				placeServiceType = "<div class='return-place-qr-available'></div>";
				isServiceQr = true;
			} else {
				placeServiceType = "<div class='return-place-printer-available'></div>";
			}

			if (isAddressPoint) {
				placeAddressNode = "<div class='return-place-address'>Address: " + placeAddress + "</div>"
			} else {
				placeAddressNode = "<div class='return-place-address'>" + placeAddress + "</div>"
			}

			var	placeNode = "<div data-service-fulladdress='" + placeTitle + ", " + placeAddress + "' data-service-address='" + placeAddress + "' data-carrier-name='" + placeCarrierName + "' data-service-name='" + placeServiceName + "' data-service-qr='" + isServiceQr + "' data-dropoff-id='" + placeDropoffId + "' data-service-index='" + index + "' data-place-id='" + placeServiceId +"' class='js-recycle-place return-place'>" +
				"<div class='return-place-left'>" +
				"<div class='return-place-pin'></div>" +
				"<span class='return-place-distance'>" + placeDistanceLabel + "</span>" +
				"</div>" +
				"<div class='return-place-right'>" +
				"<div class='return-place-title'>" + placeTitle + "</div>" +
				"<div class='return-place-servicename'>" + placeServiceName + "</div>" +
				placeAddressNode +
				placeServiceType +
				placeCarrierImage +
				"</div>" +
				"</div>";

			placesNode = placesNode + placeNode;

			$('.js-recycling-places').html(placesNode);
		});
	}

	function initRecyclingEvents() {
		$('.js-recycle-place').on('click', function() {
			var $this = $(this),
				placeID = $this.attr('data-place-id'),
				serviceName = $this.attr('data-carrier-name') + ' ' + $this.attr('data-service-name'),
				fullAddress = $this.attr('data-service-fulladdress'),
				dropOffID = $this.attr('data-dropoff-id');

			$('.js-recycling-dropoff-address').html(fullAddress);

			onRecyclingPlaceSelected(placeID, dropOffID, serviceName);
			// console.log($this);
		})
	}

	function onRecyclingPlaceSelected(placeID, dropOffID, serviceName) {
		recyclingCustomerPoint = {
			"placeId": placeID,
			"serviceName": serviceName,
			"dropOffID": dropOffID
		};

		$(window).scrollTop(20);

		$('.js-recycling-step-2').fadeOut(function(){
			$('.js-recycling-step-3').fadeIn();

		})
	}

	function submitRecyclingEmail() {
		var email = $('.js-recycling-email').val(),
			$error = $('.js-recycling-email-error'),
			$submit  = $('.js-recycling-email-submit'),
			$wrapper = $('.js-recycling-email-wrapper'),
			requestUrl = "https://store-live-api.mahabis.io/v1/return-requests/recycle/confirm";
		requestData = {
			"service_id": recyclingCustomerPoint["placeId"],
			"service_name": recyclingCustomerPoint["serviceName"],
			"dropoff_point_id": recyclingCustomerPoint["dropOffID"],
			"email": email,
			"address": {
				"address1": recyclingCustomerAddress["address1"],
				"city": recyclingCustomerAddress["city"],
				"zip": recyclingCustomerAddress["zip"],
				"country_code": recyclingCustomerAddress["country_code"]
			}
		};

		if (email === '') {
			$error.removeClass('hidden');
		}	else {
			$.ajax({
				type: "POST",
				url: requestUrl,
				data: JSON.stringify(requestData),
				cache: false,
				dataType: 'json',
				contentType: "application/json",
				beforeSend: function () {
					$wrapper.addClass('is-loading');
					$error.addClass('hidden');
				},
				error: function (err, message) {
					$wrapper.removeClass('is-loading');
				},
				success: function (data) {
					$wrapper.removeClass('is-loading');

					if (data.status === "success") {
						setRecyclingData(data.data);
					}
				}
			})
		}
	}

	function setRecyclingData(data) {
		$('.js-recycling-trackingnum').html(data.tracking_number);
		$('.js-recycling-link').attr('href', data.label_url);

		$('.js-recycling-step-3').fadeOut(function(){
			$('.js-recycling-step-4').fadeIn();
		})
	}

	function changeCustomerCountry(e) {
		e.preventDefault();
		var selectedCountry = $('.js-customer-country').val();

		if (
			selectedCountry === "GB" ||
			selectedCountry === "US" ||
			selectedCountry === "AU" ||
			selectedCountry === "NZ" ||
			selectedCountry === "AT" ||
			selectedCountry === "BE" ||
			selectedCountry === "BE" ||
			selectedCountry === "CZ" ||
			selectedCountry === "DK" ||
			selectedCountry === "EE" ||
			selectedCountry === "FI" ||
			selectedCountry === "FR" ||
			selectedCountry === "DE" ||
			selectedCountry === "GG" ||
			selectedCountry === "JE" ||
			selectedCountry === "HU" ||
			selectedCountry === "IE" ||
			selectedCountry === "IT" ||
			selectedCountry === "LV" ||
			selectedCountry === "LT" ||
			selectedCountry === "LU" ||
			selectedCountry === "NL" ||
			selectedCountry === "PL" ||
			selectedCountry === "PT" ||
			selectedCountry === "RO" ||
			selectedCountry === "SK" ||
			selectedCountry === "SI" ||
			selectedCountry === "ES" ||
			selectedCountry === "SE" ||
			selectedCountry === "BU" ||
			selectedCountry === "CA" ||
			selectedCountry === "CR" ||
			selectedCountry === "CY"
		) {
			$('.js-returns-step-0').addClass('hidden');
			$('.js-returns-step-1').show();
		} else {
			window.location.href = "https://web.global-e.com/Returns/Portal/mZYf";
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize returns cache
	 **/
	function initializeCache() {
		orderData = {};
		itemsAmount = 0;
		itemListEventsInited = false;
		returnItemData = null;
		returnSubmitItems = [];
		returnCustomerEmail = "";
		recyclingCustomerPoint = {
			"placeId": null,
			"serviceName": null,
			"dropOffID": null
		};
		recyclingCustomerAddress = {
			"address1": null,
			"city": null,
			"zip": null,
			"country_code": null
		};
		returnCustomerAddress = {
			"address1": null,
			"address2": null,
			"city": null,
			"zip": null,
			"country_code": null
		};
		returnPlacesList = null;
		$cache = {
			wrapper: $('#returnsWrapper'),
			returnStep1: $('.js-returns-step-1'),
			returnStep2: $('.js-returns-step-2'),
			returnStep3: $('.js-returns-step-3'),
			returnStep4: $('.js-returns-step-4'),
			returnStep41: $('.js-returns-step-4-1'),
			returnStep42: $('.js-returns-step-4-2'),
			returnStep43: $('.js-returns-step-4-3'),
			returnStep5: $('.js-returns-step-5'),
			returnStep51: $('.js-returns-step-5-1'),
			returnStep6: $('.js-returns-step-6'),
			returnTypeExchange: $('.js-return-type-exchange'),
			returnTypeRefund: $('.js-return-type-refund'),
			returnTypeSelected: $('.js-return-type-selected'),
			returnReasonsList: $('.js-return-reasons-list'),
			returnReasonsError: $('.js-return-reasons-error'),
			returnItemsList: $('.js-return-items-list'),
		}
	}

	function initializeDOM() {
		initReturnsForm();
	}

	function initializeEvents() {
		$('.js-return-type').on('click', function(){
			var selectedType = $(this).data('type');

			returnItemData["return_type"] = selectedType;

			onReturnTypeSelected(selectedType);

			ga('send', 'event', "Returns Portal", "Step 2. Return Type Selected", selectedType);

			if (window.gtag) {
				gtag('event', 'Step 2. Return Type Selected', {
					'event_category': 'Returns Portal'
				});
			}
		});

		$('.js-return-restart').on('click', function(){
			returnRestart();
		});

		$('.js-exchange-input-submit').on('click', function(){
			submitExchangeInput();
		});

		$('.js-recycling-submit').on('click', function(){
			startRecyclingRequest();
		});

		$('.js-recycling-email-submit').on('click', function(){
			submitRecyclingEmail();
		})

		$('.js-customer-country-submit').on('click', function(e) {
			changeCustomerCountry(e);
		})

		$('#returnsBeforeJune').on('click', function(){
			startReturnsOld();
		})
	}

	app.returns = {
		init: function () {
			initializeCache();
			initializeDOM();
			initializeEvents();
		},
		submit: function() {
			submitRecyclingEmail()
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.tracking
 */
(function (app, $) {
	var $cache;

	/**
	 * @private
	 * @function
	 * @description GTM send item data after switch variant
	 **/
	function gtmProductView(upper, sole) {
		var bundlePrefix = upper.split('-')[2] + '-' + sole.split('-')[2];
		if (dataLayer) {
			dataLayer.push({
				'itemShortSku': bundlePrefix,
				'event': 'variantChange'
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description FB send item data after switch variant
	 **/
	function fbProductView(sku) {
		var skuSplitted = sku.split('-'),
			skuFormatted = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4],
			productID = $('#productCustomVariants').find('.js-customvariants-price[data-sku="' + skuFormatted + '"]').data('product-id'),
			variantID = app.multistore.data.variants[sku]["variant-gbp"],
			facebookContentID = "shopify_GB_" + productID + "_" + variantID;

		if (typeof fbq === "function" && productID && variantID) {
			console.log("tracking event");

			fbq('track', 'ViewContent', {
				content_name: $cache.productTitle.text(),
				content_category: $cache.productType.text(),
				content_ids: facebookContentID,
				content_type: 'product',
				value: $cache.productPrice.text().replace(/\,/g, '.').replace(/h/g, '.'),
				currency: 'GBP'
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Google remarketing send item data after switch variant
	 **/
	function googleProductView(price, sku) {
		var googleFnLoad = $.isFunction(window.google_trackConversion);

		// Update last n visited array
		if (sku !== app.tracking.data.lastVisitedProd[app.tracking.data.lastVisitedProd.length - 1]) {
			if (app.tracking.data.lastVisitedProd.length > (app.tracking.data.lastVisitedAmount - 1)) {
				app.tracking.data.lastVisitedProd[app.tracking.data.lastVisitedAmount - 2] = app.tracking.data.lastVisitedProd[app.tracking.data.lastVisitedAmount - 1];
				app.tracking.data.lastVisitedProd.pop();
				app.tracking.data.lastVisitedProd[app.tracking.data.lastVisitedProd.length] = sku;
			} else {
				app.tracking.data.lastVisitedProd[app.tracking.data.lastVisitedProd.length] = sku;
			}
		}

		if (googleFnLoad) {
			window.google_trackConversion({
				google_conversion_id: 959346701,
				google_custom_params: {
					ecomm_prodid: app.tracking.data.lastVisitedProd,
					ecomm_pagetype: Theme.page.template,
					ecomm_totalvalue: price
				},
				google_remarketing_only: true
			});
		}
	}

	function gtagProductView(sku) {
		var skuSplitted = sku.split('-'),
			skuFormatted = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4],
			productID = $('#productCustomVariants').find('.js-customvariants-price[data-sku="' + skuFormatted + '"]').data('product-id'),
			variantID = app.multistore.data.variants[sku]["variant-gbp"],
			currency = app.currency.get(),
			productPrice = $cache.productPrice.text().replace(/\,/g, '.').replace(/h/g, '.'),
			googleContentID = "shopify_GB_" + productID + "_" + variantID;

			gtag('event', 'view_item', {
				currency: 'GBP',
				value: productPrice,
				items: [{
					item_id: googleContentID,
					quantity: 1
				}]
			});
	}

	/**
	 * @private
	 * @function
	 * @description Facebook dynamic content tracking
	 **/
	function initDynamicTracking() {
		if (app.page.template == 'pdp') {
			setTimeout(function() {
				fbProductView(app.product.data.sku);
			}, 3000)

			if (app.ui.isDesktop()) {
				$('.product-options').on('mouseleave', function () {
					if (app.product.data.sku && !app.tracking.productView.fbIsSent) {
						// send data when no selecting
						fbProductView(app.product.data.sku);
						app.tracking.productView.fbIsSent = true;

						if (window.gtag) {
							gtagProductView(app.product.data.sku)
						}
					}
				})
			} else {
				$(window).on('touchend', function (event) {
					var $el = $(event.target),
						isOutside = $el.parents('.js-product-options').length == 0;

					if (isOutside && app.product.data.sku && !app.tracking.productView.fbIsSent) {
						// send data when no selecting
						fbProductView(app.product.data.sku);
						app.tracking.productView.fbIsSent = true;

						if (window.gtag) {
							gtagProductView(app.product.data.sku)
						}
					}
				});
			}
		}
	}

	/**
	 * @private
	 * @function
	 * @description Facebook email submitted event on subscribe popup
	 **/
	function fbEmailSent() {
		if (typeof fbq === "function") {
			fbq('track', 'CompleteRegistration');
		}
	}

	/**
	 * @private
	 * @function
	 * @description TikTok Add to cart Event
	 **/
	function ttqAddToCart(id, quantity) {
		var productSKU = app.product.data.sku,
			productPrices = app.multistore.getPrice(productSKU),
			currency = app.currency.get();

		if (currency === "GBP") {
			if (window.ttq) {
				ttq.track('AddToCart', {
					content_id: app.product.data.sku,
					quantity: quantity,
					price: productPrices.prices.gbp,
					currency: 'GBP'
				});
			}

		} else if (currency === "USD") {
			if (window.ttq) {
				ttq.track('AddToCart', {
					content_id: app.product.data.sku,
					quantity: quantity,
					price: productPrices.prices.usd,
					currency: 'USD'
				});
			}
		}
	}

	function fbAddToCart(sku, price) {
		var itemSKU = [],
			productSKU = sku || app.product.data.sku,
			productPrice = app.multistore.getPrice(productSKU),
			productPriceFormatted = parseFloat(productPrice.prices.gbp),
			skuSplitted = productSKU.split('-'),
			skuFormatted = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4],
			productID = $('#productCustomVariants').find('.js-customvariants-price[data-sku="' + skuFormatted + '"]').data('product-id'),
			variantID = app.multistore.data.variants[sku]["variant-gbp"],
			facebookContentID = "shopify_GB_" + productID + "_" + variantID;

		itemSKU.push(productSKU);

		if (price) {
			productPriceFormatted = parseFloat(price);
		}

		if (typeof fbq === "function" && productID) {
			fbq('track', 'AddToCart', {
				content_ids: facebookContentID,
				content_type: 'product',
				value: productPriceFormatted,
				currency: 'GBP'
			});
		}
	}

	function gtagAddToCart(sku, price) {
		var productPrice = app.multistore.getPrice(sku),
			productPriceFormatted = parseFloat(productPrice.prices.gbp),
			productName = $('#productSubtitle').text() + ' ' + $('#legend-upper').text();

		if (window.gtag) {
			gtag('event', 'add_to_cart', {
				'currency': "GBP",
				'value': productPriceFormatted,
				'items': [
					{
						item_id: sku,
						item_name: productName,
						price: productPriceFormatted,
						quantity: 1
					}
				]
			});
		}
	}

	/**
	 * @private
	 * @function
	 * @description Initialize tracking cache
	 **/
	function initializeCache() {
		$cache = {
			productTitle: $('#productTitle'),
			productType: $('#productType'),
			productPrice: $('#moneyWithoutCurrency')
		}
	}

	function initializeDOM() {
		initDynamicTracking();
	}

	app.tracking = {
		productView: {
			fb: function (sku) {
				fbProductView(sku);
			},
			gtm: function (upper, sole) {
				gtmProductView(upper, sole);
			},
			google: function (price, sku) {
				googleProductView(price, sku);
			},
			fbIsSent: false
		},
		addToCart: {
			ttq: function(id, quantity) {
				ttqAddToCart(id, quantity)
			},
			fb: function(id, price) {
				fbAddToCart(id, price);
			},
			gtag: function(id, price) {
				gtagAddToCart(id, price)
			}
		},
		email: {
			fb: function () {
				fbEmailSent();
			}
		},
		data: {
			lastVisitedProd: [],
			lastVisitedAmount: 2
		},
		init: function () {
			initializeCache();
			initializeDOM();
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.blog
 */
(function (app, $) {

	function resizeBlogImages() {
		$('.articleExcerptImage').each(function () {
			var $this = $(this),
				img = $this.find('img'),
				imgSrc = img.attr('src');

			if (imgSrc.indexOf('1024x1024.jpg') > -1) {
				imgSrc = imgSrc.replace('1024x1024.jpg', 'grande.jpg');
				img.attr('src', imgSrc);
			}

			$this.removeClass('hidden');
		});
	}

	/**
	 * @private
	 * @function
	 * @description Set articles list images link
	 **/
	function initializeImagesLink() {
		$('.blogJumbo').each(function () {
			var $this = $(this),
				$parent = $this.parent(),
				$firstImg = $this.find('img:first'),
				linkToArticle = $parent.find('.title > a').attr('href'),
				linkToArticle2 = $parent.parent().find('a.title').attr('href');

			$firstImg.prependTo(this);
			$firstImg.on('click', function () {
				if (linkToArticle != undefined) {
					window.location.href = linkToArticle;
				} else {
					window.location.href = linkToArticle2;
				}
			});
		});
	}

	/**
	 * @private
	 * @function
	 * @description Remove first duplicated article in articles list
	 **/
	function removeDuplicatedArticle() {
		var blogPageNum = +$('#currentPageNum').text();

		if (blogPageNum !== 1) {
			$('.blogManualList').hide();
		}
	}

	/**
	 * @private
	 * @function
	 * @description Hide share widget once it reached bottom page
	 **/
	function shareWidgetFixScrolling() {
		var $window = $(window);

		$window.on('load', function () {
			var $content = $('.articleContentText'),
				$shareWidget = $('#at4-share'),
				articleHeight = $content.height();
			articleOffset = $content.offset().top;
			totalScrolling = articleHeight + articleOffset;
			totalScrollingleft = $('.articles').offset().left;

			$window.scroll(function () {
				if ($window.scrollTop() > articleHeight + 80) {
					$shareWidget.addClass('sticky').css('top', articleHeight + 280);
				} else if ($(window).scrollTop() < articleHeight + 80) {
					$shareWidget.removeClass('sticky').css('top', 200);
				}
			});
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize blog articles DOM
	 **/
	function initializeArticlesDOM() {
		shareWidgetFixScrolling();
	}

	/**
	 * @private
	 * @function
	 * @description Initialize blog carousel
	 **/
	function initializeBlogsCarousel() {
		$('#blogsCarousel').owlCarousel({
			items:3,
			margin: 30,
			loop:true,
			nav: true,
			dots: true,
			navText : ["<i class='chevron left'></i>","<i class='chevron right'></i>"]
		});
	}

	/**
	 * @private
	 * @function
	 * @description Initialize blog DOM
	 **/
	function initializeDOM() {
		if (app.page.template === 'blog') {
			initializeImagesLink();
			resizeBlogImages();
			removeDuplicatedArticle();
		} else if (app.page.template === 'article') {
			initializeArticlesDOM();
		} else if (app.page.template == 'blogs') {
			initializeBlogsCarousel();
		}
	}

	app.blog = {
		init: function () {
			initializeDOM();
		}
	}

}(window.app = window.app || {}, jQuery));

/**
 * @class app.faq
 */
(function (app, $) {
	var $cache;

	function changeFaqByHash() {
		var urlHash = $.trim(window.location.hash);
		if (urlHash) {
			$('.tabs nav a[href="' + urlHash + '"]').trigger('click');
		}
	}

	function changeTabHeader(el) {
		if (!el.hasClass('tab-current')) {
			var selectedTab = el.data('content'),
				selectedContent = $cache.tabContentWrapper.find('div[data-content="' + selectedTab + '"]');

			$cache.tabParents.removeClass('tab-current');
			el.parent().addClass('tab-current');
			selectedContent.addClass('selected').siblings('div').removeClass('selected');
		}
	}

	function changeTabContent(el) {
		var isActive = el.hasClass('active');

		if (!isActive) {
			el.addClass('active').siblings().removeClass('active');
		}
	}

	function initializeDOM() {
		changeFaqByHash()
	}

	function initializeEvents() {
		$(".faq").on('click', function () {
			changeTabContent($(this));
		});

		$('.js-tabs-header').on('click', function () {
			changeTabHeader($(this));
		});
	}

	function initializeCache() {
		$cache = {
			tabParents: $('.tabs nav li'),
			tabContentWrapper: $('.tab-content')
		}
	}


	app.faq = {
		init: function () {
			initializeCache();
			initializeEvents();
			initializeDOM();
		}
	}


}(window.app = window.app || {}, jQuery));

/**
 * @class app.collection
 */
(function (app, $) {
	var $cache;

	function initCollectionPrices(value) {
		var variantSku = value + Theme.product.suffix;

		if (value.indexOf('FC-L') > -1) {
			variantSku = value;
		}

		return app.multistore.getPrice(variantSku);
	}

	function initProductImages(value) {
		var imageUrl = '//cdn.mahabis.com/website/plp/images/',
			imageUrlPdp = "//cdn.mahabis.com/201806/products/",
			imageHoveredUrl = '//cdn.mahabis.com/website/plp/imagesHovered/',
			skuEnd = ""
			skuSplitted = value.split('-');

		if (skuSplitted[1] === "F" && skuSplitted[0] == "MC") {
			imageUrl = imageUrlPdp;
			imageUrlPdp = "https://cdn.shopify.com/s/files/1/0238/5795/files/";
			skuEnd = '-A2';
		}

		var	skuImage = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4] + skuEnd + '-2.jpg' + Theme.images.cacheBooster,
			skuImage2 = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4] + skuEnd + '-1.jpg' + Theme.images.cacheBooster,
			skuImage3 = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4] + skuEnd + '-3.jpg' + Theme.images.cacheBooster,
			skuImage4 = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4] + skuEnd + '-4.jpg' + Theme.images.cacheBooster,
			skuImage5 = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4] + skuEnd + '-5.jpg' + Theme.images.cacheBooster,
			skuImageHovered = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4] + '.jpg';



		return {
			initial: imageUrl + skuImage,
			image2: imageUrlPdp + skuImage2,
			image3: imageUrlPdp + skuImage3,
			image4: imageUrlPdp + skuImage4,
			image5: imageUrlPdp + skuImage5,
			hovered: imageHoveredUrl + skuImageHovered
		}
	}

	function initCollectionRange(sku) {
		var itemRangeShort = sku.split('-')[0] + '-' + sku.split('-')[1];
		// console.log(itemRangeShort);
		return {
			short: itemRangeShort,
			long: CollectionRange[itemRangeShort]
		}
	}

	function initCollectionUpper(sku) {
		var itemUpperShort = sku.split('-')[3],
			upperLong =  CollectionUpper[itemUpperShort],
			upperShort = itemUpperShort.toLowerCase();

		if (sku.indexOf('DS-L') > -1 || sku.indexOf('DL-P') > -1) {
			upperLong = CollectionUpper2[itemUpperShort]
		} else if (sku.indexOf("SS-F") > -1) {
			upperLong = CollectionUpper3[itemUpperShort];
		} else if (sku.indexOf("QW-C") > -1 || sku.indexOf("QM-C") > -1) {
			upperLong = CollectionUpper4[itemUpperShort];
		} else if (sku.indexOf("SH-F") > -1) {
			upperLong = CollectionUpper5[itemUpperShort];
		} else if (sku.indexOf("VI-F") > -1) {
			upperLong = CollectionUpperVista[itemUpperShort];
		} else if (sku.indexOf("PL-F") > -1) {
			upperLong = CollectionUpperSierra[itemUpperShort];
		} else if (sku.indexOf("SL-F") > -1) {
			upperLong = CollectionUpperSolar[itemUpperShort];
		} else if (sku.indexOf("BT-L") > -1) {
			upperLong = CollectionUpperNova[itemUpperShort];
		} else if (sku.indexOf("LI-T") > -1) {
			upperLong = CollectionUpperLite[itemUpperShort];
		} else if (sku.indexOf("TS-T") > -1) {
			upperLong = CollectionUpperTova[itemUpperShort];
		} else if (sku.indexOf("VO-S") > -1) {
			upperLong = CollectionUpperVolare[itemUpperShort];
		} else if (sku.indexOf("FC-L") > -1) {
			upperLong = CollectionUpperNeo[itemUpperShort];
		} else if (sku.indexOf("LM-F") > -1) {
			upperLong = CollectionUpperMetallic[itemUpperShort];
		} else if (sku.indexOf("CL-L") > -1) {
			upperLong = CollectionUpperSereno[itemUpperShort];
		}

		return {
			short: upperShort,
			long: upperLong
		}

	}

	function initCollectionColour(sku) {
		var itemColourShort = sku.split('-')[4];
		colourShort = itemColourShort.toLowerCase(),
		colourLong = CollectionColour[itemColourShort];

		if (sku.indexOf('DS-L') > -1 || sku.indexOf('DL-P') > -1) {
			colourLong = CollectionColour2[itemColourShort]
		} else if (sku.indexOf("LI-T") > -1) {
			colourLong = CollectionColourLite[itemColourShort];
		} else if (sku.indexOf("TS-T") > -1) {
			colourLong = CollectionColourTova[itemColourShort];
		} else if (sku.indexOf("VO-S") > -1) {
			colourLong = CollectionColourVolare[itemColourShort];
		} else if (sku.indexOf("FC-L") > -1) {
			colourLong = CollectionColourNeo[itemColourShort];
		}

		return {
			short: colourShort,
			long: colourLong
		}
	}

	function initCollectionSize(sku) {
		return sku.split('-')[2];
	}

	function initCollectionLink(sku) {
		var itemCollectionShort = sku.split('-')[0] + '-' + sku.split('-')[1],
			itemSkuSuffix = sku.split('-')[3] + '-' + sku.split('-')[4];

		if (CollectionName === "outlet" && itemCollectionShort === "MS-F") {
			itemCollectionShort = "MS-F";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "MB-HV") {
			itemCollectionShort = "MC-CO";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "ST-CC") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MS-F" && itemSkuSuffix === "BK-SB") {
			itemCollectionShort = "MS-O";
		} else if (itemCollectionShort === "MS-F" && itemSkuSuffix === "GR-WH") {
			itemCollectionShort = "MS-O";
		} else if (itemCollectionShort === "MS-F" && itemSkuSuffix === "NN-SB") {
			itemCollectionShort = "MS-O";
		} else if (itemCollectionShort === "MS-F" && itemSkuSuffix === "SA-WH") {
			itemCollectionShort = "MS-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "ON-SB") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LG-VB") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "DG-SR") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "VV-PO") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "BK-SY") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "FR-FR") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LW-WH") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LW-FB") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "DG-BU") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LG-BU") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LG-HP") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "DG-HP") {
			itemCollectionShort = "MC-O";
		} else if (itemCollectionShort === "MR-C" && itemSkuSuffix === "BK-SB") {
			itemCollectionShort = "MR-C";
		} else if (itemCollectionShort === "MR-C" && itemSkuSuffix === "NT-CC") {
			itemCollectionShort = "MR-C";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "LG-HO") {
			itemCollectionShort = "MC-CO";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "LG-PB") {
			itemCollectionShort = "MC-CO";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "TL-SB") {
			itemCollectionShort = "MC-CO";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "BK-SB") {
			itemCollectionShort = "MC-CO";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "ST-CC") {
			itemCollectionShort = "MC-CO";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "DG-JG") {
			itemCollectionShort = "MC-CO";
		} else if (itemCollectionShort === "MC-C" && itemSkuSuffix === "ST-TO") {
			itemCollectionShort = "MC-CO";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MO-F") {
			itemCollectionShort = "MO-F";
		} else if (CollectionName === "outlet" && itemSkuSuffix === "GI-SB") {
			itemCollectionShort = "MD-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MN-C") {
			itemCollectionShort = "MN-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MD-C") {
			itemCollectionShort = "MD-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MH-C") {
			itemCollectionShort = "MH-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MQ-C") {
			itemCollectionShort = "MQ-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MT-C") {
			itemCollectionShort = "MT-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MU-C") {
			itemCollectionShort = "MU-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MV-C") {
			itemCollectionShort = "MV-C";
		} else if (CollectionName === "outlet" && itemCollectionShort === "ML-F") {
			itemCollectionShort = "ML-F";
		} else if (CollectionName === "outlet" && itemCollectionShort === "MO-C") {
			itemCollectionShort = "MO-C"
		} else if (CollectionName === "outlet" && itemCollectionShort === "MC-C") {
			itemCollectionShort = "MC-C"
		} else if (CollectionName === "outlet" && itemCollectionShort === "MB-F") {
			itemCollectionShort = "MB-F"
		} else if (CollectionName === "outlet" && itemCollectionShort === "MN-C") {
			itemCollectionShort = "MN-C"
		} else if (CollectionName === "outlet" && itemCollectionShort === "MC-F" && itemSkuSuffix === "ST-MP") {
			itemCollectionShort = "MC-F"
		} else if (itemCollectionShort !== 'MC-K' && itemCollectionShort !== 'MS-K') {
			if (CollectionName === "outlet" || itemSkuSuffix === "AW-WH" || itemSkuSuffix === "LG-GG" || itemSkuSuffix === "DG-GG" || itemSkuSuffix === "LG-II" || itemSkuSuffix === "DG-II"  || itemSkuSuffix === "DG-BB" || itemSkuSuffix === "LG-BB" || itemSkuSuffix === "LG-PR" || itemSkuSuffix === "DG-PR") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LW-LW") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "ON-LY") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LW-ON") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "ON-LW") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "BK-WH") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "GO-TG") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "DG-TO") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LG-SD") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "VG-SY") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "VO-BA") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "BK-SB") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MC-F" && itemSkuSuffix === "LG-LG") {
				itemCollectionShort = "MC-O";
			} else if (itemCollectionShort === "MN-C" && itemSkuSuffix === "GI-SB") {
				itemCollectionShort = "MD-C";
			} else if (itemCollectionShort === "MU-C" && itemSkuSuffix === "TA-SB") {
				itemCollectionShort = "MU-C-TA-SB";
			} else if (itemCollectionShort === "MS-F" && itemSkuSuffix === "NO-II") {
				itemCollectionShort = "MS-F-O";
			}
		}

		return CollectionLinks[itemCollectionShort]
	}

	function initCollectionStock(sku, range) {
		var skuFormatted = sku;

		if (range.indexOf('kids') < 0 && range.indexOf('neo') < 0) {
			skuFormatted = skuFormatted + Theme.product.suffix;
		}

		return app.stock.get(skuFormatted);
	}

	function initCollectionMaterial(sku) {
		var materialPrefix = sku.split('-')[0] + '-' + sku.split('-')[1];

		return CollectionMaterials[materialPrefix];
	}

	function initCollectionNote(sku) {
		var skuSplitted = sku.split('-'),
			skuFormatted = skuSplitted[0] + '-' + skuSplitted[1] + '-' + skuSplitted[3] + '-' + skuSplitted[4],
			note = null;

		if (CollectionNote[skuFormatted]) {
			note = CollectionNote[skuFormatted]
		}

		return note;
	}

	function initCollectionObject() {
		var collectionItems = $('#CollectionItems').html().trim().split(';');
		console.log(collectionItems);
		$.each(collectionItems, function (index, item) {
			var itemDataSplitted = item.split('#'),
				itemData = itemDataSplitted[0],
				itemSplitted = itemData.split(':'),
				sku = itemSplitted[0],
				attributes = itemDataSplitted[1] || "",
				secondLabel = itemDataSplitted[6] || "",
				image = initProductImages(sku),
				prices = initCollectionPrices(sku),
				priceNew = itemDataSplitted[4],
				priceNewCompare = itemDataSplitted[5],
				fixedPrices = itemDataSplitted[2],
				fixedPricesCompare = itemDataSplitted[3],
				fixedPriceMiddle = itemDataSplitted[8],
				isArchiveProduct = itemDataSplitted[7],
				range = initCollectionRange(sku),
				upper = initCollectionUpper(sku, range),
				colour = initCollectionColour(sku),
				link = initCollectionLink(sku),
				size = initCollectionSize(sku),
				note = initCollectionNote(sku),
				material = initCollectionMaterial(sku),
				isTrending = attributes.indexOf('TR') > -1,
				isBestSeller = attributes.indexOf('BS') > -1,
				isNew = attributes.indexOf('NC') > -1,
				isBackInStock = attributes.indexOf('ST') > -1,
				isLastChance = attributes.indexOf('LC') > -1,
				isPreorder = attributes.indexOf('PRE') > -1,
				isFreeSocks = attributes.indexOf('FS') > -1,
				isWaterProof = attributes.indexOf('WP') > -1,
				isBlackFriday = attributes.indexOf('BF') > -1,
				isJustAdded = attributes.indexOf('JA') > -1,
				isSale = attributes.indexOf('SL') > -1,
				isSpecial = attributes.indexOf('LE') > -1,
				is70off = attributes.indexOf('70OFF') > -1,
				is60off = attributes.indexOf('60OFF') > -1,
				is50off = attributes.indexOf('50OFF') > -1,
				is25off = attributes.indexOf('25OFF') > -1,
				is30off = attributes.indexOf('30OFF') > -1,
				is35off = attributes.indexOf('35OFF') > -1,
				is15off = attributes.indexOf('15OFF') > -1,
				is20off = attributes.indexOf('20OFF') > -1,
				is10off = attributes.indexOf('10OFF') > -1,
				is51off = attributes.indexOf('51OFF') > -1,
				isNewColour = attributes.indexOf('NC') > -1,
				stock = initCollectionStock(sku, range.long);

			addCollectionFilters(sku);

			app.collection.products[sku] = {
				image: image,
				prices: prices,
				priceNew: priceNew,
				priceNewCompare: priceNewCompare,
				fixedPrices: fixedPrices,
				fixedPricesCompare: fixedPricesCompare,
				range: range,
				upper: upper,
				colour: colour,
				material: material,
				stock: stock,
				link: link,
				sku: sku,
				size: size,
				note: note,
				secondLabel: secondLabel,
				is70off: is70off,
				is60off: is60off,
				is50off: is50off,
				is51off: is51off,
				is15off: is15off,
				is10off: is10off,
				is20off: is20off,
				is25off: is25off,
				is30off: is30off,
				is35off: is35off,
				isTrending: isTrending,
				isBestSeller: isBestSeller,
				isNew: isNew,
				isLastChance: isLastChance,
				isPreorder: isPreorder,
				isFreeSocks: isFreeSocks,
				isWaterProof: isWaterProof,
				isBlackFriday: isBlackFriday,
				isJustAdded: isJustAdded,
				isSale: isSale,
				isSpecial: isSpecial,
				isBackInStock: isBackInStock,
				isNewColour: isNewColour,
				isArchive: isArchiveProduct,
				middlePrice: fixedPriceMiddle
			}
		});
	}

	function pushCollectionFilter(attribute, filtersArray) {
		if ($.inArray(attribute, filtersArray) < 0) {
			filtersArray.push(attribute);
		}
	}

	function addCollectionFilters(sku) {
		var skuSplitted = sku.split('-'),
			upper = skuSplitted[3],
			range = skuSplitted[0] + '-' + skuSplitted[1],
			colour = skuSplitted[4],
			material = skuSplitted[0] + '-' + skuSplitted[1],
			skuNoSize = range + '-' + upper + '-' + colour,
			size = skuSplitted[2];

		// ugly fix for summer
		if (skuNoSize === 'MS-F-AA-II' || skuNoSize === 'MS-F-SS-II' || skuNoSize === 'MS-F-GG-II' || skuNoSize === 'MS-F-GY-LG' || skuNoSize === 'MS-F-GG-SB' || skuNoSize === 'MS-F-BS-SB' || skuNoSize === 'MS-F-NO-II' || skuNoSize === 'MS-F-NO-SB') {
			range = "summer";
		}

		pushCollectionFilter(size, app.collection.filters.size);
		pushCollectionFilter(upper, app.collection.filters.upper);
		pushCollectionFilter(colour, app.collection.filters.colour);
		pushCollectionFilter(range, app.collection.filters.range);
		pushCollectionFilter(material, app.collection.filters.material);
	}

	function addFilterValues(filterArray, $el, attribute) {
		var nodeArray = $("<div></div>");
		var filtersAdded = [];

		filterArray.sort();
		$el.html('');

		$.each(filterArray, function (index, value) {
			var filterContent = value,
				filterImage = null,
				filterValue = null;

			if (attribute === 'range') {
				if (filterContent === 'summer') {
					filterValue = 'summer';
					value = 'ms-f';
				} else {
					filterValue = CollectionRange[value];
				}
				filterImage = CollectionFilterImages[value];
			} else if (attribute === 'material') {
				filterValue = CollectionMaterials[value];
			} else if (attribute === 'upper') {
				$.each(CollectionUpperCombined, function (key) {
					if (key.indexOf(value) > -1) {
						filterValue = key.toLowerCase();
						filterContent = CollectionUpperCombined[key].title
					}
				});
			} else if (attribute === 'colour') {
				$.each(CollectionColourCombined, function (key) {
					if (key.indexOf(value) > -1) {
						filterValue = key.toLowerCase();
						filterContent = CollectionColourCombined[key].title
					}
				});
			} else {
				filterValue = filterContent;
			}

			if (attribute === 'upper' ||
				attribute === 'colour'
			) {
				// refactor later
				var node = "<li data-unavailable='false' data-value-combined='" + filterValue + "' data-value='" + filterContent + "' data-type='" + attribute + "' class='js-filter-item js-track-events filter-item filter-item-" + attribute + "' data-event-action='Collection Page' data-event-category='Filter " + attribute + " selected' data-event-label='" + value + "' >" + filterContent + "<span class='js-filter-counter clp-filter-counter'></span></li>";
			} else {
				if (filterImage) {
					var node = "<li data-unavailable='false' data-value-combined='" + filterValue + "' data-value='" + value.toLowerCase() + "' data-type='" + attribute + "' data-image='" + filterImage + "' class='js-filter-item js-track-events filter-item filter-item-" + attribute + "' data-event-action='Collection Page' data-event-category='Filter " + attribute + " selected' data-event-label='" + value + "' >" + filterValue + "<span class='js-filter-counter clp-filter-counter'></span></li>";
				} else {
					var node = "<li data-unavailable='false' data-value-combined='" + filterValue + "' data-value='" + value.toLowerCase() + "' data-type='" + attribute + "' class='js-filter-item js-track-events filter-item filter-item-" + attribute + "' data-event-action='Collection Page' data-event-category='Filter " + attribute + " selected' data-event-label='" + value + "' >" + filterValue + "<span class='js-filter-counter clp-filter-counter'></span></li>";
				}
			}

			if (filtersAdded.indexOf(filterValue) < 0) {
				filtersAdded.push(filterValue);
				nodeArray.append(node);
			}
		});

		$el.append(nodeArray).addClass('is-loaded')
	}

	function initFilters() {
		addFilterValues(app.collection.filters.upper, $cache.filterUpper, "upper");
		addFilterValues(app.collection.filters.colour, $cache.filterColour, "colour");
		addFilterValues(app.collection.filters.range, $cache.filterRange, "range");
		addFilterValues(app.collection.filters.material, $cache.filterMaterial, "material");
	}

	function initUrlFilters() {
		var upperUrlFilter = app.utils.getUrlParam("upper"),
			colourUrlFilter = app.utils.getUrlParam("colour"),
			sizeUrlFilter = app.utils.getUrlParam("size"),
			genderUrlFilter = app.utils.getUrlParam("gender"),
			materialUrlFilter = app.utils.getUrlParam("material"),
			labeledUrlFilter = app.utils.getUrlParam("isLabeledUrl"),
			rangeUrlFilter = app.utils.getUrlParam("range");

		if (upperUrlFilter) {
			var $upperFilter = $cache.filterUpper.find('.js-filter-item[data-value="' + upperUrlFilter.toLowerCase() + '"]');
			onFilterClicked($upperFilter);
		}

		if (colourUrlFilter) {
			var $colourFilter = $cache.filterColour.find('.js-filter-item[data-value="' + colourUrlFilter.toLowerCase() + '"]');
			onFilterClicked($colourFilter);
		}

		if (rangeUrlFilter) {
			var $rangeFilter = $cache.filterRange.find('.js-filter-item[data-value="' + rangeUrlFilter.toLowerCase() + '"]');
			onFilterClicked($rangeFilter);
		}

		if (genderUrlFilter) {
			var $genderFilter = $cache.filterGender.find('.js-filter-item[data-value="' + genderUrlFilter.toLowerCase() + '"]');
			onFilterClicked($genderFilter);
		}

		if (sizeUrlFilter) {
			var $sizeFilter = $cache.filterSizeSelector.find('.js-filter-item[data-value="' + sizeUrlFilter.toLowerCase() + '"]');
			onFilterClicked($sizeFilter, true);
		}

		if (materialUrlFilter) {
			var $materialFilter = $cache.filterSizeSelector.find('.js-filter-item.is-visible[data-value="' + materialUrlFilter.toLowerCase() + '"]');
			onFilterClicked($materialFilter);
		}

		if (labeledUrlFilter) {
			setLabeledCollection();
		}
	}

	function setLabeledCollection() {
		var sizelabel = app.utils.getUrlParam("sizelabel"),
			sizeCountry = app.utils.getUrlParam("sizeCountry"),
			sizeGender = app.utils.getUrlParam("sizeGender") || '',
			currentTitle = $('#collectionTitle').html(),
			newTitle = currentTitle + ' / ' + sizeGender + ' ' + sizeCountry + ' ' + sizelabel

		$('#collectionTitle').html(newTitle);
	}

	function getSizesRange(sku) {
		var skuArray = sku.split('-'),
			skuFormatted = skuArray[0] + '-' + skuArray[1] + '-' + skuArray[3] + '-' + skuArray[4],
			sizesRange = [],
			sizesRangeAll = $.parseJSON(Theme.product.sizesRange);

		console.log(sizesRangeAll[skuFormatted]);
		if (sizesRangeAll[skuFormatted]) {
			var sizesRangeSplitted = sizesRangeAll[skuFormatted].split('-'),
				sizesStart = sizesRangeSplitted[0],
				sizesFinish = sizesRangeSplitted[1];

			for(var size = sizesStart; size <= sizesFinish; size++) {
				var newSKU = skuArray[0] + '-' + skuArray[1] + '-' + size + '-' + skuArray[3] + '-' + skuArray[4] + Theme.product.suffix;
					// console.log(newSKU);
					// console.log(app.multistore.data.prices[newSKU]);

					if (skuFormatted.indexOf('FC-L') > -1) {
						newSKU = skuArray[0] + '-' + skuArray[1] + '-' + size + '-' + skuArray[3] + '-' + skuArray[4] + '-PE';
					}

					var skuStock = app.stock.get(newSKU),
					isPreorder = app.stock.checkPreorderForced(newSKU),
					preorderDates = app.stock.getPreorderDates(sku),
					newVariantPrice = app.multistore.data.prices[newSKU].prices["gbp"],
					newVariantId = app.multistore.data.variants[newSKU]["variant-gbp"];


				sizesRange.push({
					"size": parseInt(size),
					"sku": newSKU,
					"variant": newVariantId,
					"inventory": skuStock,
					"price": newVariantPrice,
					"preorder": isPreorder,
					"preorderDates": preorderDates,
				})
			}
		}

		return sizesRange;
	}

	function generateQuickAddNode(data) {
		var quickLabelText = "quick add:",
			isOutlet = $('body').hasClass('collection-warehouse-clearance');

		if (isOutlet) {
			quickLabelText = "available sizes:"
		}

		var node = '<div class="clp-collection-quickadd"><div class="clp-quickadd-label">' + quickLabelText + '</div>',
			preorderData = null;

		$.each(data, function(index, item) {
			var currentSize = item.size,
				sizeChart = Theme.product.sizesChartSlippers[currentSize];

			if (index === 0 && item.preorderDates) {
				preorderData = item.preorderDates
			}

			if (item.inventory > 0) {
				node = node + '<div data-price-origin="' + item.price + '" data-size-aum="' + sizeChart.aum + '" data-size-usm="' + sizeChart.usm + '" data-size-ukm="' + sizeChart.ukm + '" data-size-auw="' + sizeChart.auw + '" data-size-usw="' + sizeChart.usw + '" data-size-ukw="' + sizeChart.ukw + '"  data-size-eu="' + sizeChart.eu + '" class="clp-quickadd-item js-clp-quickadd-item js-clp-quickadd" data-id="' + item.variant + '" data-sku="' + item.sku + '">EU ' + item.size + '</div>'
			} else {
				var replacementSkuList = $.parseJSON(Theme.product.replacementSKU),
					replacementSku = replacementSkuList[item.sku],
					replacementIDSet = app.multistore.data.variants[replacementSku],
					replacementID = null,
					replacementSkuStock = app.stock.get(replacementSku);

				if (replacementIDSet) {
					replacementID = replacementIDSet["variant-gbp"];
				}

				if (replacementSku && replacementSkuStock > 0 && replacementID) {
					node = node + '<div data-size-aum="' + sizeChart.aum + '" data-size-usm="' + sizeChart.usm + '" data-size-ukm="' + sizeChart.ukm + '" data-size-auw="' + sizeChart.auw + '" data-size-usw="' + sizeChart.usw + '" data-size-ukw="' + sizeChart.ukw + '"  data-size-eu="' + sizeChart.eu + '" class="clp-quickadd-item js-clp-quickadd-item js-clp-quickadd" data-id="' + replacementID + '" data-sku="' + item.sku + '">EU ' + item.size + '</div>'
				} else {
					node = node + '<div data-size-aum="' + sizeChart.aum + '" data-size-usm="' + sizeChart.usm + '" data-size-ukm="' + sizeChart.ukm + '" data-size-auw="' + sizeChart.auw + '" data-size-usw="' + sizeChart.usw + '" data-size-ukw="' + sizeChart.ukw + '"  data-size-eu="' + sizeChart.eu + '" class="clp-quickadd-item js-clp-quickadd-item clp-quickadd-unavailable">EU ' + item.size + '</div>'
				}

			}
		});

		node = node + '</div>';

		if (preorderData) {
			node = node + '<div class="productNote">' + preorderData + '</div>';
		}

		node = '<div class="clp-collection-quickadd-mobile js-quickadd-mobile">' + quickLabelText + ' </div><div class="clp-collection-quickadd-wrapper">' + node + '</div>';

		return node;
	}

	function quickAddToCart(id, size, $parent) {
		// var submitData = {
		// 	quantity: 1,
		// 	id: id,
		// 	properties: {
		// 		'Size': size
		// 	}
		// };

		var submitData = {
			'items': [{
				'id': id,
				'quantity': 1,
				'properties': {
					'Size': size
				}
			}]
		};

		$.ajax({
			url: '/cart/add.js',
			dataType: 'json',
			type: 'post',
			data: submitData,
			beforeSend: function () {
				app.header.addToCartToggle($parent, true);
			},
			success: function (itemData) {
				// app.tracking.addToCart.ttq(id, 1);
				app.header.updateMinicartAmount();
				app.header.getCartData(true);
			}
		});
	}

	function initMarketingSpotEvents() {
		$('#collectionProductsList').on('click', '.js-clp-marketingspot', function(e){
			e.preventDefault();

			var $this = $(this),
				$modal = $('#modalMarketingSpot'),
				$modalTitle = $modal.find('.js-modal-title'),
				$modalContent = $modal.find('.js-modal-content'),
				content = $this.attr('data-popup-content'),
				title = $this.attr('data-popup-title'),
				isEnabledPopup = $this.attr('data-popup-enabled');

			if (isEnabledPopup === "true") {
				$modalTitle.html(title);
				$modalContent.html(content);
				app.popup.open('modalMarketingSpot');
			}
		})
	}

	function initQuickAddEvents() {
		$('#collectionProductsList').on('click', '.js-clp-quickadd', function(){
			var $this = $(this),
				$parent = $this.parents('.js-collection-item'),
				price = $this.attr('data-price-origin'),
				sku = $this.attr('data-sku'),
				size = $this.html(),
				id = $this.attr('data-id');

			quickAddToCart(id, size, $parent)

			// Carousel scroll event
			if (ga) {
				ga('send', 'event', 'Collection Quick Add', 'Product Added to Cart');
			}

			// FB Add to cart event
			app.tracking.addToCart.fb(sku, price);
			//app.tracking.addToCart.gtag(sku, price);
		}).on('click', '.js-quickadd-mobile', function(){
			var $this = $(this);
			$this.parents('.js-collection-item').siblings().find('.is-quickadd-opened').removeClass('is-quickadd-opened');
			$this.toggleClass('is-quickadd-opened');

			if (ga) {
				ga('send', 'event', 'Collection Quick Add', 'Mobile. Quick add opened');
			}
		});
	}

	function initCollectionCarousels() {
		$('.js-collection-item-link').on('click', function(e){
			var $this = $(this),
				isNavigation = $(e.target).hasClass('chevron') || $(e.target).hasClass('owl-prev') || $(e.target).hasClass('owl-next');

			if (isNavigation) {
				e.preventDefault();
				e.stopPropagation();
			}
		});

		$('#collectionProductsList').find('.js-clp-collection-imagescarousel').each(function(){
			var $this = $(this),
				$prev = $this.find('.owl-prev'),
				$next = $this.find('.owl-next');

			setTimeout(function() {
				$this.owlCarousel({
					items: 1,
					loop: true,
					lazyLoad: true,
					nav: true,
					dots: true,
					touchDrag: true,
					mouseDrag: false,
					margin: 0,
					responsive: {
						768: {
							items: 1,
							dots: false,
							center: false
						}
					},
					navText : ["<i class='chevron left'></i>","<i class='chevron right'></i>"]
				}).on('changed.owl.carousel', function (event) {

				});
			}, 10);

		})
	}

	function initCustomMarketingSpot() {
		$('.clp-collection-imagewrapper').each(function(){
			var $parent = $(this).parent(),
				parentUrl = $parent.attr('src');

			if (parentUrl === "#") {
				$parent.on('click', function(e){
					e.preventDefault();
				})
			}

			if (app.ui.isMobile()) {
				var $img = $(this).find('img'),
					src = $img.attr('src'),
					newSrc = src.replace('coming-soon', 'coming-soon-mobile');
				if (src.indexOf('coming-soon') > -1) {
					$img.attr('src', newSrc);
					$img.attr('data-original', newSrc);
				}
			}
		})
	}

	function renderProducts(productsList, initialLoad) {
		var productsAddedToList = [],
			productsInStock = [],
			productsNode = [],
			marketingSlotAdded = [],
			outOfStockNode = [],
			marketingSlotsApplied = 0,
			isEmptyList = false,
			outOfStockLimit = Theme.stock.outOfStockLimit,
			isGenderFilterSelected = (app.collection.selectedFilters.gender !== ''),
			isSizeFilterSelected = (app.collection.selectedFilters.size !== ''),
			sizeGenderParams = '',
			itemsAmount = 0,
			itemIndex = 1,
			isFirstPageLoad = $(window).scrollTop() < 20;

		if (initialLoad) {
			$cache.productsList.addClass('is-loading');
		}

		if (CollectionName === "outlet") {
			outOfStockLimit = Theme.stock.zeroOutOfStockLimit;
		}

		if (isSizeFilterSelected) {
			sizeGenderParams = '&gender=' + app.collection.selectedFilters.gender + '&size=' + app.collection.selectedFilters.size
		} else if (isGenderFilterSelected) {
			sizeGenderParams = '&gender=' + app.collection.selectedFilters.gender;
		}

		clearFiltersCounter();

		$.each(productsList, function(index, item){
			var itemArr = index.split('-'),
				itemSize = parseInt(itemArr[2]),
				itemCombinedSKU = itemArr[0] + '-' + itemArr[1] + '-' + itemArr[3] + '-' + itemArr[4],
				sizeInArray = $.inArray(itemSize, app.collection.sizesInStock) > -1,
				itemCombinedInStock = $.inArray(itemCombinedSKU, productsInStock) > -1;

			// Check if it's not total out of stock
			if (item.stock > 0 && !itemCombinedInStock) {
				productsInStock.push(itemCombinedSKU);
			}

			// Check if size is already added
			if (item.stock > 0 && !sizeInArray) {
				app.collection.sizesInStock.push(itemSize);
			}
		});

		$.each(productsList, function (index, item) {
			var discountPriceStatus = "hidden",
				itemStockClass = "",
				itemAttributesNode = "",
				itemNotesNode = "",
				isOutStockProduct = false,
				itemArr = index.split('-'),
				secondLabel = item.secondLabel,
				isTrending = item.isTrending,
				isBestSeller = item.isBestSeller,
				isNew = item.isNew,
				isBackInStock = item.isBackInStock,
				isNewColour = item.isNewColour,
				isLastChange = item.isLastChance,
				isPreorder = item.isPreorder,
				is70off = item.is70off,
				is60off = item.is60off,
				is50off = item.is50off,
				is51off = item.is51off,
				is30off = item.is30off,
				is25off = item.is25off,
				is20off = item.is20off,
				is15off = item.is15off,
				is10off = item.is10off,
				is35off = item.is35off,
				isFreeSocks = item.isFreeSocks,
				isWaterProof = item.isWaterProof,
				isBlackFriday = item.isBlackFriday,
				isJustAdded = item.isJustAdded,
				isSale = item.isSale,
				middlePrice = item.middlePrice,
				itemPriceOrigin = 0,
				itemPrice = 0,
				discountAmount = 0,
				isSpecial = item.isSpecial,
				isArchive = item.isArchive,
				initialImagesShow = 4,
				itemCombinedSKU = itemArr[0] + '-' + itemArr[1] + '-' + itemArr[3] + '-' + itemArr[4],
				itemCombinedInStock = $.inArray(itemCombinedSKU, productsInStock) > -1,
				itemCombineChar = " & ",
				itemVariantParams = "?upper=" + item.upper.short + "&colour=" + item.colour.short,
				itemNoSizeSku = item.range.short + '-' + item.upper.short.toUpperCase() + '-' + item.colour.short.toUpperCase(),
				itemAlreadyAdded = $.inArray(itemNoSizeSku, productsAddedToList) > -1;

			if (item.priceNew) {
				itemPriceOrigin = parseInt(item.priceNewCompare.replace(/[^0-9.]/g, ''));
				itemPrice = parseInt(item.priceNew.replace(/[^0-9.]/g, ''));
			} else if (item.prices) {
				itemPriceOrigin = parseFloat(item.prices.pricesorigin.gbp);
				itemPrice = parseFloat(item.prices.prices.gbp);
			}

			// Do not show full out of stock items
			if (!itemCombinedInStock) {
				itemStockClass = "hidden";
				isOutStockProduct = true;
			}

			// Do not check stock until size is not selected
			if (
				isSizeFilterSelected &&
				item.stock < outOfStockLimit
			) {
				itemStockClass = "is-out-stock";
				isOutStockProduct = true;
			}

			// Ugly Fix
			// if (isSizeFilterSelected ) {
				if (item.sku.indexOf('MC-F') > -1 && item.sku.indexOf('LG-SY') > -1) {
					itemStockClass = "";
					isOutStockProduct = false;
				} else if (item.sku.indexOf('MC-F') > -1 && item.sku.indexOf('DG-SB') > -1) {
					itemStockClass = "";
					isOutStockProduct = false;
				}
			// }

			// Combine url params for specific range
			if (item.range.short === 'TS-T' || item.range.short === 'QM-C' || item.range.short === 'QW-C' || item.range.short === 'SH-F' || item.range.short === 'LR-F' || item.range.short === 'SS-F' || item.range.short === 'DL-P' || item.range.short === 'DS-L' || item.range.short === 'BC-C' || item.range.short === 'MT-C' || item.range.short === 'MC-C' || item.range.short === 'MR-C' || item.range.short === 'MN-C' || item.range.short === 'MO-C' || item.range.short === 'MH-C' || item.range.short === 'MD-C' || item.range.short === 'MQ-C'  || item.range.short === 'MV-C' || item.range.short === 'MB-F' || item.range.short === "MU-C" || item.range.short === 'MM-C' || item.range.short === 'AE-C' || item.range.short === 'VI-F' || item.range.short === 'SL-F'  || item.range.short === 'PL-F' || item.range.short === 'CL-L'  || item.range.short === 'VO-S') {
				itemVariantParams = "?upper=" + item.upper.short + item.colour.short;
			} else if (item.range.short === 'MO-F') {
				itemVariantParams = "?upper=" + item.upper.short;
			} else if (item.range.short === 'MS-F') {
				if(item.sku.indexOf('SS-II') > -1 || item.sku.indexOf('NO-SB') > -1 || item.sku.indexOf('NN-LG') > -1 || item.sku.indexOf('GG-SB') > -1 || item.sku.indexOf('GY-LG') > -1 || item.sku.indexOf('GG-II') > -1) {
					itemVariantParams = "?upper=" + item.upper.short + "&colour=" + item.colour.short;
				} else {
					itemVariantParams = "?upper=" + item.upper.short + item.colour.short;
				}
			} else if (item.range.short === 'BT-L') {
				itemVariantParams = "?upper=" + item.upper.short + item.colour.short;
			} else if (item.range.short === "LI-T") {
				itemVariantParams = "?upper=" + item.upper.short + item.colour.short;
			} else if (item.range.short === "LM-F") {
				itemVariantParams = "?upper=" + item.upper.short + item.colour.short;
			}

			if (isArchive == "true") {
				itemVariantParams = itemVariantParams + "&arcv=true";
			}

			// Replace url for specific pages
			if (item.range.short == "MO-C" && item.sku.indexOf('IS-WH') > -1) {
				item.link = 'curve-canvas-shibori'
			}

			// Automatic discount roundels
			if (itemPriceOrigin !== itemPrice) {
				discountAmount = parseInt(100 - parseFloat(itemPrice / itemPriceOrigin * 100).toFixed(2));
			}

			// Custom attributes (labels)
			if (isBestSeller) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs clp-collection-label-bs-2'><span>bestseller</span></div>"
			} else if (isPreorder) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-pre'>pre order</div>"
			} else if (isNew) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs clp-collection-label-pre'><span>new</span></div>"
			} else if (isJustAdded) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs clp-collection-label-pre'><span>just added</span></div>"
			} else if (isTrending) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs clp-collection-label-bs-2'><img src='https://cdn.shopify.com/s/files/1/0238/5795/files/icon-trending.png?v=1708088426'/><span>trending</span></div>"
			} else if (isBackInStock) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-st'>back in stock</div>"
			} else if (isNewColour) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-nc'>new colour</div>"
			} else if (isLastChange) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-lc'>last chance</div>"
			} else if (is50off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>20% off</div>"
			} else if (is15off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>15% off</div>"
			} else if (is10off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>10% off</div>"
			} else if (is60off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>60% off</div>"
			} else if (is70off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>70% off</div>"
			} else if (is30off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>30% off</div>"
			} else if (is25off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>25% off</div>"
			} else if (is20off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>20% off</div>"
			} else if (is35off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>35% off</div>"
			} else if (is51off) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>50% off</div>"
			} else if (isFreeSocks) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>free socks</div>"
			} else if (isSpecial) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bs'>special edition</div>"
			} else if (isWaterProof) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-wp icon-WaterDrop'></div>"
			} else if (isBlackFriday) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bf'>25% OFF | black friday</div>"
			} else if (isSale) {
				itemAttributesNode = "<div class='clp-collection-label clp-collection-label-bf'>40% OFF | black friday </div>"
			}


			if (discountAmount && discountAmount !== 0) {
				itemAttributesNode = "<div data-discount='" + discountAmount + "' class='clp-collection-label clp-collection-label-bs'>" + discountAmount + "% off</div>"
			}

			// second label
			if (secondLabel !== "") {
				var secondLabelValue = secondLabel.replaceAll('_', ' ');
				itemAttributesNode = itemAttributesNode + "<div class='clp-collection-label-2'>" + secondLabelValue + "</div>"
			}

			// Custom note
			if (item.note) {
				itemNotesNode = "<div class='clp-collection-note'>" + item.note + "</div>"
			}

			if (!itemAlreadyAdded && item.prices) {
				itemsAmount++;

				if (parseInt(item.priceNew.replace(/[^0-9.]/g, '')) < parseInt(item.priceNewCompare.replace(/[^0-9.]/g, ''))) {
						discountPriceStatus = null;
				}

				var slotPosition = productsNode.length + 1,
					marketingSlot = app.collection.marketingSpots[slotPosition],
					hoverImageNode = "<div></div>",
					productImageNode = "<div></div>";

				if (app.ui.isDesktop()) {
					initialImagesShow = 12;
				}

				if (app.ui.isDesktop()) {
					if (isFirstPageLoad && itemsAmount > initialImagesShow) {
						hoverImageNode = "";
						// hoverImageNode = "<img class='js-lazyload-clp clp-collection-image2' src='//cdn.shopify.com/s/files/1/0238/5795/t/101/assets/no-bg.png' data-original='" + item.image.hovered + "'/>";
					} else {
						hoverImageNode = "";
						// hoverImageNode = "<img class='clp-collection-image2' src='" + item.image.hovered + "'/>";
					}
				}

				// if (isFirstPageLoad && itemsAmount > initialImagesShow) {
				// 	productImageNode = "<div class='slider-item'><img class='js-lazyload-clp clp-collection-image' src='//cdn.shopify.com/s/files/1/0238/5795/t/101/assets/no-bg.png' data-original='" + item.image.initial + "' /></div>" +
				// 		"<div class='slider-item'><img class='js-lazyload-clp clp-collection-image' src='//cdn.shopify.com/s/files/1/0238/5795/t/101/assets/no-bg.png' data-original='" + item.image.image2 + "' /></div>" +
				// 		"<div class='slider-item'><img class='js-lazyload-clp clp-collection-image' src='//cdn.shopify.com/s/files/1/0238/5795/t/101/assets/no-bg.png' data-original='" + item.image.image3 + "' /></div>" +
				// 		"<div class='slider-item'><img class='js-lazyload-clp clp-collection-image' src='//cdn.shopify.com/s/files/1/0238/5795/t/101/assets/no-bg.png' data-original='" + item.image.image5 + "' /></div>";
				// } else {
				// 	productImageNode =
				// 		"<div class='slider-item'><img class='clp-collection-image' src='" + item.image.initial + "' /></div>" +
				// 		"<div class='slider-item'><img class='clp-collection-image' src='" + item.image.image2 + "' /></div>" +
				// 		"<div class='slider-item'><img class='clp-collection-image' src='" + item.image.image3 + "' /></div>" +
				// 		"<div class='slider-item'><img class='clp-collection-image' src='" + item.image.image5 + "' /></div>";
				// }

				if (isFirstPageLoad && itemsAmount > initialImagesShow) {
					productImageNode = "<img class='js-lazyload-clp clp-collection-image' src='//cdn.shopify.com/s/files/1/0238/5795/t/101/assets/no-bg.png' data-original='" + item.image.initial + "' />";
				} else {
					productImageNode = "<img class='clp-collection-image' src='" + item.image.initial + "' />";
				}

				if (item.sku.indexOf('IS-WH') > -1) {
					item.range.long = 'shibori'
				} else if (item.sku.indexOf('MU-C') > -1 && item.sku.indexOf('TA-SB') > -1) {
					item.upper.long.long = 'leopard'
				} else if (item.sku.indexOf('MF-I') > -1 && item.sku.indexOf('BK-WH') > -1) {
					item.upper.long.long = 'curve & classic';
					item.colour.long.long = '';
					itemVariantParams = '';
					itemCombineChar = '';
				} else if (item.sku.indexOf('MC-I') > -1 && item.sku.indexOf('BK-WH') > -1) {
					item.upper.long.long = 'curve & classic';
					item.colour.long.long = '';
					itemVariantParams = '';
					itemCombineChar = '';
				} else if (item.sku.indexOf('MB-I') > -1) {
					item.upper.long.long = 'breathe';
					item.colour.long.long = '';
					itemVariantParams = '';
					itemCombineChar = '';
				} else if (item.sku.indexOf('MR-I') > -1 && item.sku.indexOf('CC-SB') > -1) {
					item.upper.long.long = 'alto shearling';
					item.colour.long.long = '';
					itemVariantParams = '';
					itemCombineChar = '';
				} else if (item.sku.indexOf('MB-SY') > -1 && item.sku.indexOf('MC-P') > -1) {
					item.upper.long.long = 'caspian blue';
					itemVariantParams = "?upper=mb2&colour=sy"
				} else if (item.sku.indexOf('MB-BL') > -1 && item.sku.indexOf('MC-P') > -1) {
					item.upper.long.long = 'malmo blue';
				}

				if (itemVariantParams.length < 1) {
					sizeGenderParams = sizeGenderParams.replace(sizeGenderParams.charAt(0), "?");
				}

				if (item.sku.indexOf('MB-I') > -1) {
					sizeGenderParams = ""
				}

				var compareFixedPriceNode = "data-fp=''";
				var fixedPriceNode = "data-fp=''";
				var itemSizesRange = getSizesRange(item.sku);
				var quickAddNode = generateQuickAddNode(itemSizesRange);

				if (item.fixedPricesCompare) {
					compareFixedPriceNode =  "data-fp=" + item.fixedPricesCompare;
				}

				if (item.fixedPrices) {
					fixedPriceNode = "data-fp=" + item.fixedPrices;
				}

				var itemSubtitle = item.upper.long.long + itemCombineChar + item.colour.long.long;

				if (item.sku.indexOf('DS-L') > -1 || item.sku.indexOf('DL-P') > -1  ) {
					itemSubtitle = item.upper.long.long;
				}

				var collectionItemLink = Theme.shop.baseUrl + "/products/" + item.link + itemVariantParams + sizeGenderParams;

				var itemSubtitle = item.upper.long.long + itemCombineChar + item.colour.long.long;

				if (item.sku.indexOf('VO-S') > -1 || item.sku.indexOf('TS-T') > -1 || item.sku.indexOf('QM-C') > -1 || item.sku.indexOf('QW-C') > -1 || item.sku.indexOf('SH-F') > -1 || item.sku.indexOf('LR-F') > -1 || item.sku.indexOf('SS-F') > -1 || item.sku.indexOf('DS-L') > -1 || item.sku.indexOf('DL-P') > -1 || item.sku.indexOf('AE-C') > -1 || item.sku.indexOf('VI-F') > -1 || item.sku.indexOf('SL-F') > -1 || item.sku.indexOf('CL-L') > -1 || item.sku.indexOf('PL-F') > -1  ) {
					itemSubtitle = item.upper.long.long;
				}

				var collectionUrlDiscount = app.utils.getUrlParam('discount') || app.utils.getUrlParam('DISCOUNT');

				if (collectionUrlDiscount) {
					collectionItemLink = collectionItemLink + '&discount=' + collectionUrlDiscount;
				}

				var itemTitle = "mahabis " + item.range.long;

				if (item.sku.indexOf('LI-T') > -1) {
					itemTitle = "l i t e™ by mahabis";
				}

				// TEMPORARY
				// var showLinks = app.utils.getUrlParam('sl');
				// if (!showLinks) {
				// 	if (item.sku.indexOf('MC-F') > -1 || item.sku.indexOf('MC-P') > -1) {
				// 		collectionItemLink = '/collections/classic-slippers'
				// 	} else if (item.sku.indexOf('MC-C') > -1) {
				// 		collectionItemLink = '/collections/curve-slippers'
				// 	} else if (item.sku.indexOf('LI-T') > -1) {
				// 		collectionItemLink = '/collections/lite-slippers'
				// 	}
				// }

				// Middle price node
				itemMiddlePriceNode = "";
				if (item.middlePrice) {
					itemMiddlePriceNode = "<span class='money money-discount clp-collection-item-pricediscounted clp-collection-item-middleprice'>" + item.middlePrice + "</span>";
				}

				var node =
					"<div class='clp-collection-item js-collection-item " + itemStockClass + "' data-index='" + itemIndex + "' data-price='" + item.prices.prices.gbp.replace(".", "") + "'>" +
					"<a class='js-track-events js-collection-item-link' href='" + collectionItemLink + "' data-event-category='Collection Page' data-event-action='Product clicked' data-event-label='" + item.link + itemVariantParams + "' >" +
					"<div class='js-clp-collection-imagescarousel owl-carousel clp-collection-imagewrapper'>" +
					productImageNode +
					// hoverImageNode +
					"</div>" +
					itemAttributesNode +
					itemNotesNode +
					"<div class='clp-collection-item-title'>" + itemTitle + "</div>" +
					"<div class='clp-collection-item-subtitle'>" + itemSubtitle + "</div>" +
					"<span " + compareFixedPriceNode + " class='money " + discountPriceStatus + " money-discount clp-collection-item-pricediscounted' data-currency='GBP' data-currency-eur='\u20ac" + item.prices.pricesorigin.eur + "' data-currency-usd='$" + item.prices.pricesorigin.usd + "' data-currency-gbp='&pound;" + item.prices.pricesorigin.gbp + "' data-currency-aud='AUD$" + item.prices.pricesorigin.aud + "' data-sku='" + item.sku + "'>" + item.priceNewCompare + "</span>" +
					itemMiddlePriceNode +
					"<span " + fixedPriceNode + " class='money clp-collection-item-price' data-currency='GBP' data-currency-eur='\u20ac" + item.prices.prices.eur + "' data-currency-usd='$" + item.prices.prices.usd + "' data-currency-gbp='&pound;" + item.prices.prices.gbp + "' data-currency-aud='AUD$" + item.prices.prices.aud + "' data-sku='" + item.sku + "' >" + item.priceNew + "</span>" +
					"</a>" +
					quickAddNode +
					"</div>";

				// Attach marketing spots
				if (marketingSlot && marketingSlotAdded.indexOf(slotPosition) < 0) {
					var marketingLink = '#/',
						marketingImageNode = "<img class='js-lazyload-clp' src='" + marketingSlot.image + "' data-original='" + marketingSlot.image + "' />"

					if (app.ui.isDesktop()) {
						marketingImageNode = "" +
							"<img class='currency-gbp-content content-inlineblock' src='" + marketingSlot.image + "' />" +
							"<img class='currency-usd-content content-inlineblock' src='" + marketingSlot.imageUSD + "' />" +
							"<img class='currency-aud-content content-inlineblock' src='" + marketingSlot.imageAUD + "' />" +
							"<img class='currency-eur-content content-inlineblock' src='" + marketingSlot.imageEUR + "' />"
					}

					if (marketingSlot.link != '') {
						marketingLink = Theme.shop.baseUrl + marketingSlot.link
					}

					if (!isFirstPageLoad) {
						marketingImageNode = "" +
							"<img class='currency-gbp-content content-inlineblock' src='" + marketingSlot.image + "' />" +
							"<img class='currency-usd-content content-inlineblock' src='" + marketingSlot.imageUSD + "' />" +
							"<img class='currency-aud-content content-inlineblock' src='" + marketingSlot.imageAUD + "' />" +
							"<img class='currency-eur-content content-inlineblock' src='" + marketingSlot.imageEUR + "' />"
					}

					var marketingNode =
						"<a href='" + marketingLink + "' class='clp-collection-item clp-collection-marketing' data-popup-title='" + marketingSlot.popupTitle + "' data-popup-content='" + marketingSlot.popupContent + "' data-popup-enabled='" + marketingSlot.isPopupEnabled +"'><div class='clp-collection-imagewrapper'>" +
						marketingImageNode +
						"</div>" +
						"<div class='clp-collection-item-title'>" + marketingSlot.label + "</div>" +
						"</a>";

					if (marketingSlot.appear === "before") {
						node = marketingNode + node;
					} else if (marketingSlot.appear === "after") {
						node = node + marketingNode;
					}

					marketingSlotsApplied++;
					marketingSlotAdded.push(slotPosition);
				}

				if (isOutStockProduct) {
					outOfStockNode.push(node)
				} else {
					productsNode.push(node);
				}

				productsAddedToList.push(itemNoSizeSku);
				countFiltersAmount(item);
				itemIndex++
			}
		});

		if (productsNode.length === 0) {
			isEmptyList = true
		}

		productsNode.push.apply(productsNode, outOfStockNode);

		setFiltersCounter();

		$cache.productsList.fadeOut(500, function () {
			$cache.productsList.html('').append(productsNode).removeClass('is-loading');
			// Currency.convertAll("GBP", app.currency.get());
			$cache.productsList.fadeIn(500);

			$('.js-lazyload-clp').lazyload({
				threshold: 100
			});

			// Init outlet collection selector
			initCollectionSizeSelector();
			initCustomMarketingSpot();
			// initCollectionCarousels();
		});

		initQuickAddEvents();
		initMarketingSpotEvents();

		if (isEmptyList) {
			$cache.noItemsMessage.fadeIn(500);
		} else {
			$cache.noItemsMessage.fadeOut(500);
		}
	}



	function countFiltersAmount(item) {
		// Counting upper
		if (app.collection.filtersCount.upper[item.upper.short]) {
			app.collection.filtersCount.upper[item.upper.short]++;
		} else {
			app.collection.filtersCount.upper[item.upper.short] = 1;
		}

		// Counting colour
		if (app.collection.filtersCount.colour[item.colour.short]) {
			app.collection.filtersCount.colour[item.colour.short]++;
		} else {
			app.collection.filtersCount.colour[item.colour.short] = 1;
		}

		// Counting collection
		if (app.collection.filtersCount.range[item.range.short.toLowerCase()]) {
			app.collection.filtersCount.range[item.range.short.toLowerCase()]++;
		} else {
			app.collection.filtersCount.range[item.range.short.toLowerCase()] = 1;
		}

		// Counting materials
		if (app.collection.filtersCount.material[item.material.toLowerCase()]) {
			app.collection.filtersCount.material[item.material.toLowerCase()]++;
		} else {
			app.collection.filtersCount.material[item.material.toLowerCase()] = 1;
		}
	}

	function clearFiltersCounter() {
		app.collection.filtersCount = {
			size: {},
			upper: {},
			colour: {},
			range: {},
			gender: {},
			material: {}
		}
	}

	function setFiltersCounter() {
		$('.js-collection-filterlist').each(function () {
			var $this = $(this),
				collectionType = $this.attr('data-filtertype');

			if (collectionType === 'range') {
				$this.find('.js-filter-item').each(function () {
					var $item = $(this),
						filterValue = $item.attr('data-value'),
						filterCount = app.collection.filtersCount[collectionType][filterValue];
					$item.find('.js-filter-counter').html(filterCount);
				})
			} else if (collectionType === 'upper' || collectionType === 'colour') {
				$this.find('.js-filter-item').each(function () {
					var $item = $(this),
						filterValue = $item.attr('data-value-combined').split(','),
						totalCount = 0;

					$.each(filterValue, function (key, value) {
						var filterCount = app.collection.filtersCount[collectionType][value];
						if (filterCount) {
							totalCount += filterCount;
						}
					});

					if (totalCount !== 0) {
						$item.find('.js-filter-counter').html(totalCount);
					}
				})
			}
		})
	}

	function getCountrySizes() {
		var country = Shopify.country,
			gender = app.collection.selectedFilters.gender,
			genderShort = null,
			sizeDataAttribute = null,
			url = window.location.href,
			selectedSizeType = 'eu';

		// Settings gender size
		if (gender !== '') {
			if (gender === 'women') {
				genderShort = 'w'
			} else if (gender === 'men') {
				genderShort = 'm'
			}
		} else {
			if (url.indexOf('womens') > 0) {
				genderShort = "w"
			} else if (url.indexOf('mens') > 0) {
				genderShort = "m"
			}
		}

		// Settings country size
		if (country === 'GB') {
			selectedSizeType = 'uk';
		} else if (country === 'US') {
			selectedSizeType = 'us';
		} else if (country === 'AU') {
			selectedSizeType = 'au';
		}

		if (selectedSizeType !== 'eu') {
			if (genderShort !== null) {
				sizeDataAttribute = selectedSizeType + genderShort
			} else {
				sizeDataAttribute = 'eu'
			}
		} else {
			sizeDataAttribute = 'eu'
		}

		setCountrySizes(sizeDataAttribute);
	}

	function setCountrySizes(attr) {
		$('.js-clp-quickadd-item').each(function(){
			var $this = $(this),
				euSize = $this.attr('data-size-eu'),
				newSize = $this.attr('data-size-' + attr);

			if (newSize === "null") {
				$this.addClass('hidden');
			} else {
				var node = newSize + '<div>EU ' + euSize + '</div>';
				$this.html(node);
			}
		})
	}

	function initCountrySizes() {
		getCountrySizes();
	}

	function initProductsRendering() {
		if (
			app.utils.getUrlParam("upper") ||
			app.utils.getUrlParam("colour") ||
			app.utils.getUrlParam("range") ||
			app.utils.getUrlParam("gender") ||
			app.utils.getUrlParam("material") ||
			app.utils.getUrlParam("size")
		) {
			initUrlFilters();
		} else {
			renderProducts(app.collection.products, true);
		}
	}

	function initCollectionProducts() {
		if (
			app.multistore.initialized &&
			app.stock.initialized
		) {
			initCollectionObject();
			initFilters();
			initCollectionBanner();
			initProductsRendering();
			initCountrySizes();
		} else {
			setTimeout(function () {
				initCollectionProducts();
			}, 500);
		}
	}

	function initCollectionBanner() {
		if (!app.utils.getUrlParam("range")) {
			$cache.collectionImage.addClass('is-visible');
		}
	}

	function onSortClicked($el) {
		var type = $el.data('sort'),
			$wrapper = $('#collectionProductsList'),
			products = $('.js-collection-item').not('.is-out-stock');

		$el.siblings().removeClass('is-active').attr('data-selected', false);
		$el.addClass('is-active').attr('data-selected', true);

		if (type === "priceup") {
			products.sort(function(a, b){
				return $(a).data("price")-$(b).data("price")
			});
		} else if (type === "pricedown") {
			products.sort(function(a, b){
				return $(b).data("price") - $(a).data("price")
			});
		} else if (type === "default") {
			products.sort(function(a, b){
				return $(a).data("index")-$(b).data("index")
			});
		}

		$wrapper.fadeOut('slow', function(){
			$wrapper.html(products).fadeIn();
		})

		// Remove lazy loaded images
		$('.js-lazyload-clp').each(function(){
			var $this = $(this),
				imgSrc = $this.attr('data-original');

			$this.attr('src', imgSrc);
		})
	}

	function onFilterClicked($el, preventUrlReset) {
		var type = $el.attr('data-type'),
			value = $el.attr('data-value'),
			category = $el.attr('data-event-category'),
			isGender = (type === 'gender'),
			isRange = (type === 'range'),
			isAvailable = ($el.attr('data-unavailable') == "false"),
			isSelected = $el.attr('data-selected') || false;

		if (isGender) {
			app.collection.selectedFilters.size = '';
		}

		if (type === 'upper' || type === 'colour') {
			value = $el.attr('data-value-combined')
		}

		if (isAvailable) {
			if (isSelected === "true" || isSelected) {
				var newCategory = category.replace('selected', 'removed');
				$el.removeClass('is-active');
				$el.attr('data-event-category', newCategory);
			} else {
				$el.siblings().removeClass('is-active');
				$el.addClass('is-active');
			}

			triggerFilterItem(type, value, isSelected, $el);
			filterSelectedProducts();
			setFiltersCount();
			setAvailableFilters(type);
			setAppliedFilters();
		}

		if (isGender) {
			triggerFilterSizes()
		} else if (isRange) {
			changeCollectionImage($el);
		}

		scrollToProducts();
		if (!preventUrlReset) {
			updateFiltersUrlParam();
		}

		$('#collectionDiscountRoundels li').removeClass('is-active');
	}

	function updateFiltersUrlParam() {
		var filterUrlParams = '';

		$.each(app.collection.selectedFilters, function (key) {
			var filterType = app.collection.selectedFilters[key],
				filterPrefix = '?';

			if (filterUrlParams.length > 0) {
				filterPrefix = '&';
			}

			if (filterType !== "") {
				if (key === 'upper') {
					filterUrlParams += filterPrefix + key + '=' + CollectionUpperCombined[filterType.toUpperCase()].title;
				} else if (key === 'colour') {
					filterUrlParams += filterPrefix + key + '=' + CollectionColourCombined[filterType.toUpperCase()].title;
				} else {
					filterUrlParams += filterPrefix + key + '=' + filterType
				}
			}
		});

		if (history.pushState) {
			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + filterUrlParams;
			window.history.pushState({path: newurl}, '', newurl);
		}
	}

	function scrollToProducts() {
		var wrapperPosition = parseInt($cache.productsWrapper.offset().top),
			$headerHeight = $('#main-hdr').outerHeight(),
			$deliveryHeight = $('.delivery-hdr').outerHeight(),
			windowPosition = $(window).scrollTop(),
			screenPosition = windowPosition + $headerHeight + $deliveryHeight,
			diffToScroll = 100;


		if ((wrapperPosition + diffToScroll) < screenPosition) {
			$('html, body').animate({scrollTop: wrapperPosition - diffToScroll}, 900);
		}
	}

	function changeCollectionImage($el) {
		var collectionImage = $el.attr('data-image'),
			$img = $cache.collectionImage.find('img');
		if (collectionImage) {
			$img.fadeOut('fast', function() {
				$img.attr('src', collectionImage);

				$img.one('load', function(){
					$cache.collectionImage.addClass('is-visible');
					$img.fadeIn('fast');
				})
			});
		}
	}

	function onSelectedFilterClicked(type) {
		if (type == 'all') {
			app.collection.selectedFilters.upper = '';
			app.collection.selectedFilters.colour = '';
			app.collection.selectedFilters.range = '';
			app.collection.selectedFilters.gender = '';
			app.collection.selectedFilters.material = '';
			app.collection.selectedFilters.size = '';

			var category = $el.attr('data-event-category').replace('removed', 'selected');

			$('.js-filter-item').attr('data-selected', false);
			$el.attr('data-event-category', category);
		} else {
			app.collection.selectedFilters[type] = '';
			$('.js-filter-item[data-type="' + type + '"]').attr('data-selected', false)
		}

		filterSelectedProducts();
		setAvailableFilters(type);
		setFiltersCount();
		setAppliedFilters();
		triggerFilterSizes();
	}

	function setFiltersCount() {
		var selectedFiltersCount = 0;

		if (app.collection.selectedFilters.upper != '') {
			selectedFiltersCount++
		}

		if (app.collection.selectedFilters.colour != '') {
			selectedFiltersCount++
		}

		if (app.collection.selectedFilters.range != '') {
			selectedFiltersCount++
		}

		if (app.collection.selectedFilters.gender != '') {
			selectedFiltersCount++
		}

		if (app.collection.selectedFilters.size != '') {
			selectedFiltersCount++
		}

		if (app.collection.selectedFilters.material != '') {
			selectedFiltersCount++
		}

		if (selectedFiltersCount === 0) {
			$cache.filtersCounter.addClass('hidden')
		} else {
			$cache.filtersCounter.html(selectedFiltersCount).removeClass('hidden');
		}
	}

	function triggerFilterItem(type, value, isSelected, $el) {
		if (!isSelected || isSelected == 'false') {
			app.collection.selectedFilters[type] = value;
			$el.siblings().attr('data-selected', false);
			$el.attr('data-selected', true);
		} else {
			app.collection.selectedFilters[type] = '';
			$el.attr('data-selected', false)
		}
	}

	function getSizeFromCurrency() {
		var currency = app.currency.get(),
			sizeType = null;

		if (currency === 'EUR') {
			sizeType = 'eu'
		} else if (currency === 'GBP') {
			sizeType = 'uk'
		} else if (currency === 'USD') {
			sizeType = 'us'
		} else if (currency === 'AUD') {
			sizeType = 'eu'
		}

		return sizeType;
	}

	function triggerFilterSizes(country) {
		var selectedCurrency = Shopify.currency.active,
			selectedCountry = Shopify.country,
			selectedSizeType = "uk";

		if (selectedCurrency === 'USD' || selectedCountry === "US") {
			selectedSizeType = "us";
		} else if (selectedCurrency === 'AUD' || selectedCountry === "AU") {
			selectedSizeType = "au";
		} else if (selectedCurrency === 'GBP' || selectedCountry === "GB") {
			selectedSizeType = "uk";
		} else {
			selectedSizeType = "eu";
		}

		var genderSelected = app.collection.selectedFilters.gender,
			sizeCountry = selectedSizeType;

		$cache.filterSizeSelector.find('.js-filter-item').removeClass('is-visible');

		if (genderSelected !== '') {
			$cache.filterSizeSelector.addClass('is-visible is-loaded');
			$cache.filterSizeSelector.find('.js-filter-item[data-gender="' + genderSelected + '"]').each(function () {
				var $this = $(this),
					sizeAttr = 'data-size-' + sizeCountry,
					sizeEu = $this.attr('data-size-eu'),
					sizeToShow = $this.attr(sizeAttr),
					sizeEuToShow = '<span>(EU ' + sizeEu + ')</span>';

				if (sizeCountry === 'eu') {
					sizeEuToShow = '';
				}

				$this.html(sizeToShow + sizeEuToShow);
				$this.addClass('is-visible')
			});
		} else {
			$cache.filterSizeSelector.removeClass('is-visible is-loaded');
		}
	}

	function setAvailableFilters(type) {
		var selectedProductVariants = {
			size: [],
			range: [],
			colour: [],
			upper: [],
			material: []
		};

		$.each(app.collection.selectedProducts, function (index, item) {
			var skuSplit = item.sku.split('-'),
				itemRange = skuSplit[0] + '-' + skuSplit[1],
				itemSize = skuSplit[2],
				itemUpper = skuSplit[3],
				itemMaterial = skuSplit[0] + '-' + skuSplit[1],
				itemColour = skuSplit[4];

			if ($.inArray(itemSize, selectedProductVariants.size) == -1) {
				selectedProductVariants.size.push(itemSize);
			}

			if ($.inArray(itemRange, selectedProductVariants.range) == -1) {
				selectedProductVariants.range.push(itemRange);
			}

			if ($.inArray(itemColour, selectedProductVariants.colour) == -1) {
				selectedProductVariants.colour.push(itemColour);
			}

			if ($.inArray(itemUpper, selectedProductVariants.upper) == -1) {
				selectedProductVariants.upper.push(itemUpper);
			}

			if ($.inArray(itemMaterial, selectedProductVariants.material) == -1) {
				selectedProductVariants.upper.push(itemMaterial);
			}
		});

		triggerAvailableFilters(selectedProductVariants, type);
	}

	function triggerAvailableFilters(selectedProducts, type) {
		// reset available filters
		$('.js-filter-item[data-type!="' + type + '"]').attr('data-unavailable', false);

		// $.each(app.collection.selectedFilters, function(key, filterType) {
		// 	if (filterType == '' && key != type) {
		// 		console.log('filtered by -' + key);
		// 		$('.js-filter-item[data-type!="' + filterType +'"]').attr('data-unavailable', false);
		// 	}
		// });

		$('.js-collection-filterlist').each(function () {
			var $this = $(this),
				selectedFilters = app.collection.selectedFilters,
				type = $this.attr('data-filtertype');

			if (selectedFilters[type] === "") {
				$this.find('.js-filter-item').each(function () {
					var $filter = $(this),
						filterItemValue = $filter.attr('data-value').toUpperCase(),
						filterValueAvailableToChoose = ($.inArray(filterItemValue, selectedProducts[type]) > -1);

					if (type === "upper" || type === "colour") {
						filterItemValue = $filter.attr('data-value-combined').split(',');
						$.each(filterItemValue, function (index, value) {
							if ($.inArray(value.toUpperCase(), selectedProducts[type]) > -1) {
								filterValueAvailableToChoose = true;
							}
						});
					}

					if (!filterValueAvailableToChoose) {
						$filter.attr('data-unavailable', true);
					}
				});
			}
		});
	}

	function setAppliedFilters() {
		var filterSelected = false;
		$cache.filtersApplied.html('');
		$.each(app.collection.selectedFilters, function (key, filter) {
			var filterKey = "Collection" + key.charAt(0).toUpperCase() + key.slice(1),
				filterValue = filter.toUpperCase();

			// getting long version
			if (window[filterKey]) {
				if (filterKey === 'CollectionUpper' && window["CollectionUpperCombined"][filterValue]) {
					filterValue = window["CollectionUpperCombined"][filterValue].title;
				} else if (filterKey === 'CollectionColour' && window["CollectionColourCombined"][filterValue]) {
					filterValue = window["CollectionColourCombined"][filterValue].title;
				} else {
					filterValue = window[filterKey][filterValue];
				}
			}

			if (
				filterValue &&
				filterValue.short
			) {
				filterValue = filterValue.short
			}

			if (filter !== '') {
				filterSelected = true;
				var node = "<li data-type='" + key + "' class='js-filter-selected'>" + key + ": " + filterValue.toLowerCase() + "</li>";

				$cache.filtersApplied.append(node);
			}
		});

		if (filterSelected) {
			var node = "<li data-type='all' class='js-filter-selected js-filter-clearall'>clear all</li>";
			$cache.filtersApplied.append(node);
		}
	}

	function filterSaleProducts($el) {
		var filterAmounts = $el.data('amounts').split(','),
			isActiveFilter = $el.hasClass('is-active');

		if (isActiveFilter) {
			$el.removeClass('is-active')
		} else {
			$el.addClass('is-active');
			$el.siblings().removeClass('is-active');
		}

		// clear selected range
		app.collection.selectedProducts = {};

		$.each(app.collection.products, function (index, item) {
			var itemPriceOrigin = 0,
				itemPrice = 0;

			if (item.priceNew) {
				itemPriceOrigin = parseInt(item.priceNewCompare.replace(/[^0-9.]/g, ''));
				itemPrice = parseInt(item.priceNew.replace(/[^0-9.]/g, ''));
			} else if (item.prices) {
				itemPriceOrigin = parseFloat(item.prices.pricesorigin.gbp);
				itemPrice = parseFloat(item.prices.prices.gbp);
			}

			var discountAmount = parseInt(100 - parseFloat(itemPrice / itemPriceOrigin * 100).toFixed(2));
			var discountAmountStr = discountAmount.toString()
			var isDiscountInRange = (filterAmounts.indexOf(discountAmountStr) > -1);

			if (isActiveFilter) {
				app.collection.selectedProducts[item.sku] = item;
			} else {
				if (isDiscountInRange) {
					app.collection.selectedProducts[item.sku] = item;
				}
			}

		})

		renderProducts(app.collection.selectedProducts, false);
	}

	function filterSelectedProducts() {
		var selectedFilters = app.collection.selectedFilters;
		app.collection.selectedProducts = {};

		$.each(app.collection.products, function (index, item) {
			var upperSelectedFilter = app.collection.selectedFilters.upper,
				colourSelectedFilter = app.collection.selectedFilters.colour,
				sizeSelectedFilter = app.collection.selectedFilters.size,
				rangeSelectedFilter = app.collection.selectedFilters.range,
				materialSelectedFilter = app.collection.selectedFilters.material,
				upperMatchFilter = true,
				colourMatchFilter = true,
				rangeMatchFilter = true,
				sizeMatchFilter = true,
				materialMatchFilter = true;

			if (upperSelectedFilter != '') {
				upperMatchFilter = false;
				if (upperSelectedFilter.indexOf(item.upper.short) > -1) {
					upperMatchFilter = true;
				}
			}

			if (colourSelectedFilter != '') {
				colourMatchFilter = false;
				if (colourSelectedFilter.indexOf(item.colour.short) > -1) {
					colourMatchFilter = true;
				}
			}

			if (sizeSelectedFilter !== '') {
				sizeMatchFilter = false;
				if (item.size === sizeSelectedFilter) {
					sizeMatchFilter = true;
				}
			}

			if (rangeSelectedFilter !== '') {
				rangeMatchFilter = false;
				if (item.range.short === rangeSelectedFilter.toUpperCase()) {
					rangeMatchFilter = true;
				}
			}

			if (materialSelectedFilter !== '') {
				materialMatchFilter = false;
				if (item.material.short === materialSelectedFilter.toUpperCase()) {
					materialMatchFilter = true;
				}
			}

			if (
				upperMatchFilter &&
				colourMatchFilter &&
				sizeMatchFilter &&
				materialMatchFilter &&
				rangeMatchFilter
			) {
				app.collection.selectedProducts[item.sku] = item;
			}
		});

		if (
			selectedFilters.size === '' &&
			selectedFilters.upper === '' &&
			selectedFilters.range === '' &&
			selectedFilters.material === '' &&
			selectedFilters.colour === ''
		) {
			renderProducts(app.collection.products, false);
		} else {
			renderProducts(app.collection.selectedProducts, false);
		}
	}

	function triggerFilterSelector() {
		$('#collectionPageNew').toggleClass('is-filter-active');
		$('html').toggleClass('noscroll');
	}

	function initCollectionMarketing() {
		$('#CollectionMarketingSpots').find('.js-marketing-spot').each(function () {
			var $this = $(this),
				imageSrc = $this.attr('src'),
				imageSrcUsd = $this.attr('data-image-usd'),
				imageSrcEur = $this.attr('data-image-eur'),
				imageSrcAud = $this.attr('data-image-aud'),
				label = $this.attr('data-label'),
				popupTitle = $this.attr('data-popup-title'),
				popupContent = $this.attr('data-popup-content'),
				popupEnabled = $this.attr('data-popup-enabled'),
				position = $this.attr('data-position');

			app.collection.marketingSpots[position] = {
				image: imageSrc,
				imageUSD: imageSrcUsd,
				imageEUR: imageSrcEur,
				imageAUD: imageSrcAud,
				label: label,
				isPopupEnabled: popupEnabled,
				popupTitle: popupTitle,
				popupContent: popupContent,
				link: $this.attr('data-href'),
				appear: $this.attr('data-appear')
			};
		});
	}

	function initiCollectionSizeFilters() {
		var selectedCurrency = Shopify.currency.active,
			selectedCountry = Shopify.country,
			selectedSizeType = "uk";

		if (selectedCurrency === 'GBP' || selectedCountry === "GB") {
			selectedSizeType = "uk";
		} else if (selectedCurrency === 'USD' || selectedCountry === "US") {
			selectedSizeType = "us";
		} else if (selectedCurrency === 'AUD' || selectedCountry === "AU") {
			selectedSizeType = "au";
		} else {
			selectedSizeType = "eu";
		}
		// $('#multiSizeSelector').find("li[data-size-country='" + selectedSizeType + "']").trigger('click');
	}

	function toggleFilterDropdown($el) {
		var $parent = $el.parent();

		$parent.siblings().removeClass('active');
		$parent.toggleClass('active');
	}

	function setCollectionSizeSelectors(country) {
		var countryFormatted = country.toLowerCase();

		$('.js-collection-sizeselect').each(function(){
			var $this = $(this),
				initialSize = $this.data('value'),
				newSize = $this.data('size-' + countryFormatted);

			$this.html(newSize);

			if ($.inArray(initialSize, app.collection.sizesInStock) < 0) {
				$this.addClass('is-outofstock')
			}
		})
	}

	function initCollectionSizeSelector() {
		var country = Shopify.country,
			countryISO = "EU",
			$country = $('.js-collection-sizeselect-country');

		if (country === "US") {
			countryISO = "US";
		} else if (country === "GB") {
			countryISO = "UK";
		}

		$country.html(countryISO)

		setCollectionSizeSelectors(countryISO);

		$('.js-collection-sizeselect').on('click', function(){
			var $this = $(this),
				value = $this.data('value'),
				gender = $this.data('gender');

			$('#collectionFilterGender').find('.js-filter-item[data-value="' + gender + '"]').trigger('click');
			$('#collectionFilterSizeSelector').find(".js-filter-item[data-gender='" + gender + "'][data-value='" + value +"']").trigger('click');
			$('.js-sizeselect-close').trigger('click');
		})
	}

	function initializeCache() {
		$cache = {
			productsWrapper: $('#collectionProductsWrapper'),
			productsList: $('#collectionProductsList'),
			collectionImage: $('#collectionImage'),
			productsLoadingList: $('#collectionLoadingList'),
			filtersList: $('#collectionFilters'),
			filterSizeSelector: $('#collectionFilterSizeSelector'),
			filterRange: $('#collectionFilterRange'),
			filterGender: $('#collectionFilterGender'),
			filterUpper: $('#collectionFilterUpper'),
			filterColour: $('#collectionFilterColour'),
			filterMaterial: $('#collectionFilterMaterial'),
			filtersApplied: $('#collectionFiltersSelected'),
			filtersCounter: $('#collectionFiltersCount'),
			marketingSpotsList: $('#CollectionMarketingSpots'),
			noItemsMessage: $('#collectionNoItems')
		}
	}

	function initializeDOM() {
		initCollectionMarketing();
		initCollectionProducts();
		initiCollectionSizeFilters();
		//initCollectionSizeSelector();
	}

	function initializeEvents() {
		$cache.filtersList.on('click', '.js-filter-item', function () {
			onFilterClicked($(this));
		});

		$cache.filtersList.on('click', '.js-collection-sort', function() {
			onSortClicked($(this));
		});

		$('.js-sale-roundel').on('click', function(){
			filterSaleProducts($(this));
		})

		$cache.filtersApplied.on('click', '.js-filter-selected', function () {
			onSelectedFilterClicked($(this).attr('data-type'));
		});

		$('.js-filters-trigger').on('click', function () {
			triggerFilterSelector();
		});

		$('.js-collection-filtertitle').on('click', function() {
			toggleFilterDropdown($(this));
		});

		$('.js-filters-clear').on('click', function () {
			onSelectedFilterClicked('all');
		});

		$('.js-sizeselect-close ').on('click touchend', function() {
			$('#collectionOutletSizes').addClass('hidden');
		})
	}

	app.collection = {
		products: {},
		marketingSpots: {},
		selectedProducts: {},
		sizesInStock: [],
		filters: {
			size: [],
			upper: [],
			colour: [],
			range: [],
			material: []
		},
		selectedFilters: {
			size: "",
			upper: "",
			colour: "",
			range: "",
			gender: "",
			material: ""
		},
		filtersCount: {
			size: {},
			upper: {},
			colour: {},
			range: {},
			gender: {},
			material: {}
		},
		changeFilterSizes: function (country) {
			triggerFilterSizes(country)
		},
		init: function () {
			initializeCache();
			initializeDOM();
			initializeEvents();
		}
	}
}(window.app = window.app || {}, jQuery));

/**
 * @class app.paralax
 */
(function (app, $) {

	function initializeParalax() {
		var hasWebAnimations = (typeof HTMLElement.prototype.animate === 'function');
		var hasIntersectionObserver = (typeof window.IntersectionObserver === 'function');
		var hasTransforms = (typeof document.body.style['transform'] === 'string');
		var oldBrowser = (!hasIntersectionObserver || !hasTransforms);
		var intersectionTrigger = document.getElementById('IntersectionTrigger');
		var steps = 20000;

		// No support found
		if (!intersectionTrigger || oldBrowser) return;

		initObserver();
		IntersectionObserver.prototype.USE_MUTATION_OBSERVER = false;

		var soleBottomPositionMobile = -99.1;
		var soleBottomPositionDesktop =  -157;
		var basePositionMobile = -67;

		if (app.page.template == 'pdp' && app.product.data.type == 'verbier') {
			soleBottomPositionDesktop = -139;
			soleBottomPositionMobile = -92.5;
		} else if (app.page.template == 'pdp' && app.product.data.type == 'quilted-womens') {
			soleBottomPositionDesktop = -138;
			soleBottomPositionMobile = -91.5;
			basePositionMobile = -50;
		} else if (app.page.template == 'pdp' && app.product.data.type == 'leather') {
			soleBottomPositionDesktop = -140;
			soleBottomPositionMobile = -92.5;
		} else if (app.page.template == 'pdp' && app.product.data.type == 'meribel') {
			soleBottomPositionDesktop = -140;
			soleBottomPositionMobile = -92.5;
		} else if (app.page.template == 'pdp' && app.product.data.type == 'quilted-mens') {
			soleBottomPositionDesktop = -143.5;
			soleBottomPositionMobile = -88.5;
			basePositionMobile = -50;
		} else if (app.page.template === 'pdp' && app.product.data.type !== 'slippers-curve') {
			soleBottomPositionDesktop =  -150.5;
			soleBottomPositionMobile = -96.5;
		}

		var animationData = [
			{
				element: document.getElementById('layer-bottom'),
				y: soleBottomPositionMobile,
				yd: soleBottomPositionDesktop,
				opacity: false
			},
			{
				element: document.getElementById('layer-inside'),
				y: -37,
				yd: -60,
				opacity: false
			},
			{
				element: document.getElementById('layer-base'),
				y: basePositionMobile,
				yd: -101,
				opacity: false
			},
			{
				element: document.getElementById('layer-bottom-content'),
				y: -90,
				yd: -90,
				opacity: true
			},
			{
				element: document.getElementById('layer-base-content'),
				y: -90,
				yd: -90,
				opacity: true
			},
			{
				element: document.getElementById('layer-inside-content'),
				y: -90,
				yd: -90,
				opacity: true
			},
			{
				element: document.getElementById('layer-top-content'),
				y: -90,
				yd: -90,
				opacity: true
			},
			{
				element: document.getElementById('layer-cradle-content'),
				y: -90,
				yd: -90,
				opacity: true
			}
		];

		function initObserver() {
			var observer = new IntersectionObserver(
				handleIntersect,
				{
					root: null,
					rootMargin: '0px',
					threshold: buildThresholdList()
				}
			);

			observer.observe(intersectionTrigger);
		}

		// Creates an Array of steps for IntersectionObserver
		function buildThresholdList() {
			var thresholds = [];

			for (var i = 0.0; i <= steps; i++) {
				thresholds.push(i / steps);
			}

			thresholds.push(0);
			return thresholds;
		}

		function handleIntersect(IntersectionObserverEntry) {
			var intersection = IntersectionObserverEntry[0];

			if (intersection.boundingClientRect.top > intersection.rootBounds.top) {
				animate(intersection.intersectionRatio * steps);
			}
		}

		// Used for solveBezier(), taken from Webkit source
		function solveBezierForT(ax, ay, bx, by, cx, cy, x, duration) {
			var epsilon = 1.0 / (200.0 * duration);

			var t0, t1, t2, x2, d2, i;
			for (t2 = x, i = 0; i < 8; i++) {
				x2 = ((ax * t2 + bx) * t2 + cx) * t2 - x; // sample curve x for t2, - x
				if (Math.abs(x2) < epsilon) // obviously, this is determining the accuracy
					return t2;
				d2 = (3.0 * ax * t2 + 2.0 * bx) * t2 + cx;
				if (Math.abs(d2) < Math.pow(10, -6)) break;
				t2 = t2 - x2 / d2;
			}

			// fall back to bisection
			t0 = 0.0;
			t1 = 1.0;
			t2 = x;
			if (t2 < t0) return t0;
			if (t2 > t1) return t1;
			while (t0 < t1) {
				x2 = ((ax * t2 + bx) * t2 + cx) * t2;
				if (Math.abs(x2 - x) < epsilon) return t2;

				if (x > x2) t0 = t2;
				else t1 = t2;

				t2 = (t1 - t0) * .5 + t0;
			}

			return t2; // on failure
		}

		// Used for value interpolation, taken from Webkit source
		function solveBezier(p1x, p1y, p2x, p2y, x, duration) {
			// calculate coefficients
			var cx = 3.0 * p1x;
			var bx = 3.0 * (p2x - p1x) - cx;
			var ax = 1.0 - cx - bx;

			var cy = 3.0 * p1y;
			var by = 3.0 * (p2y - p1y) - cy;
			var ay = 1.0 - cy - by;

			var t = solveBezierForT(ax, ay, bx, by, cx, cy, x, duration);

			// now calculate Y
			return ((ay * t + by) * t + cy) * t;
		}

		function animate(t) {
			if (t < steps) {
				// Interpolate values
				var tMin = 0;
				var valMin = 0;
				var duration = steps;
				var isChromeDesktop = false;
				var ua = navigator.userAgent;

				if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {

				} else if (/Chrome/i.test(ua)) {
					isChromeDesktop = true;
				}

				animationData.forEach(function (anim) {
					// Time progress
					var time = (t - tMin) / duration;
					// Ease interpolation - 0.25, 0.1, 0.25, 1.0
					var time2 = solveBezier(0.25, 0.1, 0.25, 1.0, time, duration);
					var time3 = solveBezier(0.25, 0.1, 0.25, 1.0, time, duration * 2);
					var valMax = anim.y;

					if (isChromeDesktop) {
						valMax = anim.yd;
					}

					var val2Max = 1;
					var value = (valMax + (valMin - valMax) * time2).toFixed(3);
					var value2 = (valMin + (val2Max * time3)).toFixed(3);

					anim.element.style.transform = 'translate(0,' + value + '%)';

					if (value2 < .8) {
						value2 = 0
					}

					if (anim.opacity) {
						anim.element.style.opacity = value2;
					}
				});
			}
		}
	}

	function initParalaxImages() {
		$('.js-parallax-image').each(function(){
			var $this = $(this),
				$source = $this.find('source'),
				$img = $this.find('img'),
				lazyImg = $img.data('src');

			$img.attr('src', lazyImg);
			$source.attr('srcset', lazyImg);
		})

		app.paralax.inited = true;
	}

	function initializeDOM() {
		initializeParalax();
	}

	app.paralax = {
		init: function () {
			initializeDOM();
		},
		initImages: function() {
			initParalaxImages()
		},
		inited: false

	}
}(window.app = window.app || {}, jQuery));

// Mahabis-4-1-0
// =============

$(document).ready(function () {
	(function (App, $) {
		// initialize v2 first
		App.init();

		var $cache,
			$stock;

		function initCache() {
			$cache = {
				isBundle: false,
				isGiftCard: false,
				isSingleProduct: false,
				isBag: false,
				isRetina: window.devicePixelRatio > 1,
				isWideScreen: $(window).width() > 1280,
				locationHash: window.location.hash.split('#')[1],
				body: $('body'),
				meta: $('meta[name=viewport]'),
				productType: $('#productType').text(),
				productTags: $('#productTags'),
				breadcrumbsTitle: $('#breadcrumbsTitle'),
				slipperBaseColor: $('.product-style-title'),
				slipperSubtitle: $('.product-style-subtitle'),
				slipperSubtitleMobile: $('#subtitleMobile'),
				slipperUpperSelect: $('#upperSelector'),
				slipperUpperDetect: $('.item-upper-select'),
				slipperThumbImage: $('.product-thumb'),
				slipperMainImage: $('.product-gallery-feature').find('img'),
				soleColorLegend: $('#legend-sole'),
				soleColorSelector: $('#soleColorBadges'),
				slipperColorOption: $('#soleColorBadges').find('.label-max'),
				slipperColorItem: $('#soleColorBadges').children(),
				slipperSizeSelector: $('#sizeSelect'),
				slipperSizeSelected: $('#sizeSelect option:selected').val(), // *detecting which size is selected by default
				slipperNoSoleSelected: false,
				submitActive: $('#addToCartWrapper').find('.submit-button').attr('data-active'),
				stockCheckContainer: $("#stockCheck"),
				deliveryTerms: $('#deliveryTerms'),
				checkStockFn: '',
				productIsOutOfStock: $('#upperSelector').find('.item-upper-select.selected').data('is-out-stock') || false,
				soleIsOutOfStock: false,
				addToCartButton: $('.submit-button'),
				addToCartOutOfStock: 'out of stock',
				addToCartStockReturn: $('#stockReturn').text(),
				stockError: $('.stock-error'),
				upperOptionsContainer: $('#upperSelector .product-options-form'),
				upperSizeLegend: $('#legend-size'),
				stockErrorSole: $('#soleOutOfStock'),
				stockErrorMsg: $('#stockErrorMsg'),
				stockReturnedDelivery: $('#deliveryInStock'),
				stockErrorDelivery: $('#deliveryOutOfStock'),
				stockScarcity: $('#scarcityMessage'),
				cartLink: $('#cartLink').attr('href'),
				descriptionTabs: $('#tabs'),
				currencyDropdown: $('#currencies'),
				currencySwitcher: $('.currencySwitcher'),
				productDetails: $('.product-details'),
				headerDropdownLink: $("#main-hdr").find('li.dropdown > a'),
				navigation: $('#hdr-nav'),
				navigationList: $('#hdr-nav li.dropdown ul'),
				navigationHoveredList: '',
				miniCart: $('.mini-cart-container'),
				bundleUpperSKU: '',
				bundleSoleSKU: '',
				productProperty: '',
				productSKU: '',
				productID: '',
				productSKUList: [],
				productThumbs: $('.product-gallery-thumbs'),
				currentPrice: $('#bundlePrice').text(),
				productImagesSrc: Theme.product.imageUrl,
				apparelImagesSrc: Theme.product.imageApparelUrl,
				cdnImagesSrc: Theme.product.imageCdnUrl,
				pageTemplate: Theme.page.template,
				lastVisitedProd: [],
				lastVisitedAmount: 2,
				changeGiftCurrency: '',
				giftCurrencyPriceList: $('#giftCurrencyPrice'),
				giftCurrencyPriceValue: $('#giftLocalPrice'),
				giftCurrencyContainer: $('#giftCurrencyContainer'),
				slipperURLDetectedCurrency: '',
				cartDeliveryPrice: $('#delivery-price'),
				cartDeliveryMsg: $('.delivery-msg'),
				stockRetryAmount: 0,
				productCollectionType: $('#productCollectionType').text()
			}
		}

		function initEvents() {

			/* ON LOAD FUNCTIONS BEGIN */
			// Detecting product type on load
			if ($cache.productType == 'upper') {
				$cache.productSKU = $('#productSKU').text();
			} else if ($cache.productType.indexOf('bag') > -1) {
				$cache.isBag = true;
				$cache.productSKU = $("#productSKU").text(); // ?
			} else if ($cache.productType.indexOf('bundle') > -1) {
				$cache.isBundle = true;
			} else if ($cache.productType.indexOf('Gift Card') > -1) { // on live : gift-cards
				$cache.isGiftCard = true;
				$cache.productSKU = $cache.slipperSizeSelected;
			} else if ($cache.productType.indexOf('apparel')) {
				$cache.productSKU = $('#productSKU').text();
			} else {
				$cache.isSingleProduct = true; // ??
				$cache.productSKU = $('#productSKU').text();
			}

			// Detecting upper color on page load
			var detectUpper = (function () {
				$cache.slipperUpperDetect.each(function () {
					var $this = $(this),
						dataUpper = $this.data('upper').toLowerCase(),
						dataTitle = $this.data('title'),
						dataSKU = $this.data('sku'),
						dataSubtitle = $this.data('subtitle'),
						upperTitle = $('#productTitle').text().toLowerCase();
					if (upperTitle.indexOf(dataUpper) > -1) {
						$(this).addClass('selected');
						$cache.slipperBaseColor.text(dataTitle);
						$cache.slipperSubtitle.text(dataSubtitle);
						$cache.slipperSubtitleMobile.text(dataSubtitle);
						$cache.bundleUpperSKU = dataSKU + '-' + $cache.slipperSizeSelected;
					} else if ($this.hasClass('selected')) {
						$cache.slipperBaseColor.text(dataTitle);
						$cache.slipperSubtitle.text(dataSubtitle);
						$cache.slipperSubtitleMobile.text(dataSubtitle);
						$cache.bundleUpperSKU = dataSKU + '-' + $cache.slipperSizeSelected;
					}
				});
			})();

			// Detect sole color on page load
			var detectSole = (function () {
				var $this = $cache.soleColorSelector.find('.selected'),
					dataSKU = $this.data('sku'),
					colour = $this.find('input').val();

				$cache.bundleSoleSKU = dataSKU + '-' + $cache.slipperSizeSelected;

				//console.log($cache.bundleSoleSKU);

			})();

			// Detect selected size
			var detectSizeSelected = function () {
				$cache.slipperSizeSelected = $('#sizeSelect').find('option:selected').val();
			};

			// Detect product ID depending on SKU
			var detectBundleID = (function (newSku) {
				var productSKU = $cache.productSKU;

				if (newSku) {
					productSKU = newSku;
				}

				App.multistore.variantDataDeffer.done(function () {
					if (App.multistore.data.variants[productSKU]) {
						$cache.productID = App.multistore.data.variants[productSKU]["variant-gbp"];
					}
				});
			});

			detectBundleID();
			/* ON LOAD FUNCTIONS END */

			/* ON EVENT FUNCTIONS BEGIN */

			// Change sole on click function
			var switchSole = (function () {
				var $this = $cache.soleColorSelector.find('.selected'),
					dataSKU = $this.data('sku'),
					soleSubtitle = $this.find('label').data('sole-name'),
					soleSubtitleSize = $this.find('label').data('sole-sizeselected');


				detectSizeSelected();
				if (App.product.size.selected && soleSubtitleSize) {
					soleSubtitle = $this.find('label').data('sole-sizeselected');
				}

				$cache.soleColorLegend.text(soleSubtitle);

				$cache.bundleSoleSKU = dataSKU + '-' + $cache.slipperSizeSelected;
			});

			// Change upper on click function
			var switchUpper = (function (upper) {
				var $this = $cache.upperOptionsContainer.find("[data-upper='" + upper + "']"),
					dataTitle = $this.data('title'),
					dataSKU = $this.data('sku'),
					dataFixedPrice = $this.find('.js-multicurrency-data').html(),
					dataSubtitle = $this.data('subtitle');

				// history.pushState('data to be passed', 'Title of the page', '/products/test');

				// set fixed prices
				$('#bundlePrice, #bundlePriceMobile').html(dataFixedPrice);

				detectSizeSelected();
				$cache.slipperUpperSelect.find('.item').removeClass('selected');
				$this.addClass('selected');
				$cache.slipperBaseColor.text(dataTitle);
				$cache.slipperSubtitle.text(dataSubtitle);
				$cache.slipperSubtitleMobile.text(dataSubtitle);
				$cache.bundleUpperSKU = dataSKU + '-' + $cache.slipperSizeSelected;
				if (App.product.size.selected && App.product.data.type == 'slippers-fs') {
					App.product.checkComboStock($cache.slipperSizeSelected);
				}
			});

			// Change size on click function
			var switchSize = (function () {
				var thisSole = $cache.soleColorSelector.find('.selected'),
					thisUpper = $cache.upperOptionsContainer.find('.selected'),
					soleSKU = thisSole.data('sku'),
					upperSKU = thisUpper.data('sku');
				$cache.bundleUpperSKU = upperSKU + '-' + $cache.slipperSizeSelected;
				$cache.bundleSoleSKU = soleSKU + '-' + $cache.slipperSizeSelected;
				if ($cache.isGiftCard) {
					$cache.productSKU = $cache.slipperSizeSelected;

					if (typeof $cache.changeGiftCurrency === "function") {
						$cache.changeGiftCurrency();
					}
				}

				// console.log($cache.productSKU);
			});

			// Change product alternative description
			var switchDescAlt = (function (el) {
				var description = el.parent().data('descalt');
				if (description) {
					$('#altDescField').removeClass("hidden").html(description);
				} else {
					$('#altDescField').addClass("hidden");
				}
			});

			// Change product gallery thumbs on click
			$('.product-thumb, .product-thumb-new').on('click', function () {
				var $this = $(this),
					$imgWrapper = $('.js-product-mainimage');

				if (App.ui.isMobile()) {
					// var thumbIndex = $(this).index();
					//
					// $('#productpage-carousel').trigger('to.owl.carousel', [thumbIndex, 1, true]);
				} else {
					if (!$this.hasClass('active')) {
						if ($imgWrapper.hasClass('hidden')) {
							$('.js-product-mainvideo, .js-product-unboxingvideo, .js-product-spinvideo, .js-product-onfootvideo').addClass('hidden');
							$imgWrapper.removeClass('hidden');
							$('.js-thumbnail-video').removeClass('active');
						}

						var slipperImageSrc = $this.find('img').attr('src').replace('small', '1024x1024');

						if (App.ui.isMobile()) {
							slipperImageSrc = $this.find('img').attr('data-src').replace('small', '1024x1024');
						}

						$cache.slipperMainImage.stop().fadeTo('fast', 0, function () {
							$cache.slipperMainImage.attr('src', slipperImageSrc).on('load', function () {
								$cache.slipperMainImage.stop().fadeTo('fast', 100);

								var zoomedImgDesktop = $('#mobileZoomedImgDesktop'),
									img = $('.product-gallery-feature').find('img'),
									imgSrc = img.first().attr('src');

								zoomedImgDesktop.stop().fadeTo('fast', 0, function () {
									zoomedImgDesktop.attr('src', imgSrc).on('load', function () {
										App.zoom.initDesktop();
										zoomedImgDesktop.stop().fadeTo('fast', 100);
									});
								});
							});
						});

						$cache.slipperThumbImage.removeClass('active');
						$('.product-thumb-new').removeClass('active');
						$this.addClass('active');
					}
				}

			});

			// Generate product SKU
			var generateBundleSKU = (function () {
				var soleSKU = $cache.bundleSoleSKU.split('-'),
					upperSKU = $cache.bundleUpperSKU.split('-'),
					upperSuffix = $cache.slipperUpperSelect.find('.item-upper-select.selected').data('sku-suffix'),
					bundleSKUPreffix = upperSKU[0],
					bundleSKUUpper = upperSKU[2],
					bundleSKUType = upperSKU[1],
					outdoorSkuSole = upperSKU[3],
					bundleSKUSole = soleSKU[2],
					bundleSKUSize = $cache.slipperSizeSelected,
					bundleOutdoor = ($cache.bundleUpperSKU.indexOf('MO-F') > -1),
					bundleNoSole = ($cache.bundleSoleSKU.indexOf('NOSOLE') > -1);

				// ugly fix, but we need to do it fast
				if (bundleSKUUpper === "FR" && bundleSKUSole === "FR" && bundleSKUSize === "35") {
					bundleSKUSize = "36"
				}
				if ($cache.isBundle) {
					if (!bundleNoSole) {
						$cache.productSKU = bundleSKUPreffix + '-B-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole;
					} else {
						$cache.productSKU = $cache.bundleUpperSKU;
					}
				} else if (App.product.data.type == 'slippers-curve' || App.product.data.type == 'slippers-curve') {
					$cache.productSKU = bundleSKUPreffix + '-C-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'mule' || App.product.data.type == 'alto') {
					$cache.productSKU = bundleSKUPreffix + '-C-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'sandals') {
					$cache.productSKU = bundleSKUPreffix + '-L-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'verbier') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'leather') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'meribel') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'aero') {
					$cache.productSKU = bundleSKUPreffix + '-C-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'vista') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'solar') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'boot') {
					$cache.productSKU = bundleSKUPreffix + '-L-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'lite') {
					$cache.productSKU = bundleSKUPreffix + '-T-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'tova') {
					$cache.productSKU = bundleSKUPreffix + '-T-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'volare') {
					$cache.productSKU = bundleSKUPreffix + '-S-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'neo') {
					$cache.productSKU = bundleSKUPreffix + '-L-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-PE';
				} else if (App.product.data.type == 'detachable') {
					$cache.productSKU = bundleSKUPreffix + '-S-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole + '-PE';
				} else if (App.product.data.type == 'metallic') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'sereno') {
					$cache.productSKU = bundleSKUPreffix + '-L-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'sierra') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'quilted-womens' || App.product.data.type == 'quilted-mens') {
					$cache.productSKU = bundleSKUPreffix + '-C-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'slides') {
					$cache.productSKU = bundleSKUPreffix + '-P-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (App.product.data.type == 'slippers-flow' || App.product.data.type == 'slippers-breathe') {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if (bundleOutdoor) {
					$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + outdoorSkuSole + '-' + upperSuffix;
				} else if (App.product.data.type == 'slippers-fs') {
					if (bundleSKUUpper == 'ON' && bundleSKUSole == 'WH') {
						bundleSKUUpper = 'AW'
					}

					if (bundleSKUType == 'BN') {
						$cache.productSKU = bundleSKUPreffix + '-BN-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole;
					} else if (bundleSKUPreffix == "MC" && bundleSKUType == "P") {
						$cache.productSKU = bundleSKUPreffix + '-P-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole;
					} else if (bundleSKUPreffix == "MC" && bundleSKUUpper == "LG" && bundleSKUSole == "NY") {
						$cache.productSKU = bundleSKUPreffix + '-P-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole;
					} else if (bundleSKUPreffix == "MC" && bundleSKUUpper == "LG" && bundleSKUSole == "CR") {
						$cache.productSKU = bundleSKUPreffix + '-P-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole;
					} else if (bundleSKUPreffix == "MC" && bundleSKUUpper == "LG" && bundleSKUSole == "GM") {
						$cache.productSKU = bundleSKUPreffix + '-P-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole;
					} else {
						$cache.productSKU = bundleSKUPreffix + '-F-' + bundleSKUSize + '-' + bundleSKUUpper + '-' + bundleSKUSole;
					}

					if (upperSuffix) {
						$cache.productSKU += '-' + upperSuffix;
					}
				}	else if (App.product.data.type == 'insole') {
					var skuSplitted = $cache.productSKU.split('-');
					$cache.productSKU = skuSplitted[0] + '-' + skuSplitted[1] + '-' + bundleSKUSize + '-' + skuSplitted[3] + '-' + skuSplitted[4] + '-' + skuSplitted[5];
				} else if (App.product.data.type == 'socks') {
					$cache.productSKU = upperSKU[0] + '-' + upperSKU[1] + '-' + bundleSKUSize + '-' + upperSKU[2] + '-' + upperSKU[3] + '-' + upperSuffix;
				} else if ($cache.isBag) {
					$cache.productSKU = $("#productSKU").text();
				} else if (App.product.data.type == 'apparel') {
					$cache.productSKU = $cache.bundleUpperSKU.replace('-undefined', '');
				} else if (App.product.data.type == 'watch') {
					$cache.productSKU = soleSKU[0] + '-' + soleSKU[1] + '-' + upperSKU[0] + '-' + soleSKU[2] + '-' + soleSKU[3] + '-' + soleSKU[4];
				} else if ($cache.productType.indexOf('upper') > -1) { // shame
					var tempSKU = $cache.productSKU.split('-');
					tempSKU[3] = $cache.slipperSizeSelected;
					$cache.productSKU = tempSKU[0] + '-' + tempSKU[1] + '-' + tempSKU[2] + '-' + tempSKU[3];
				}
				console.log('test1');
				console.log($cache.productSKU);

				App.product.data.sku = $cache.productSKU;
			});
			generateBundleSKU();

			var changeAnimationImage = function(productSKU) {
				var $image = $('.js-modelshot-image-1'),
					$imageMobile = $('.js-modelshot-image-1-mobile'),
					imageSrc = $image.attr('src'),
					productSkuSplitted = productSKU.split('-'),
					newProductImage = productSkuSplitted[0] + '-' + productSkuSplitted[1] + '-' + productSkuSplitted[3] + '-' + productSkuSplitted[4] +  '-7.gif',
					newProductImageSrc = 'https://cdn.shopify.com/s/files/1/0238/5795/files/' + newProductImage;

				$image.attr('src', newProductImageSrc);
				$imageMobile.attr('src', newProductImageSrc);
			}

			// Change image function
			var changeThumbnail = function (upperChangeDisabled) {
				var imageNumber = 0, mImageNumber = 0, imageArray = [2, 1, 3, 4, 5, 2],
					productArr = $cache.productSKU.replace('-A5', '').replace('-A0', '').replace(/[0-9]/g, '').replace('--', '-'),
					isOutdoor = $cache.productSKU.indexOf('MO-F') > -1;

				if (isOutdoor) {
					productArr = productArr.replace('--', '-');
				} else if (App.product.data.type == 'socks') {
					var skuParts = $cache.productSKU.replace('--', '-').split('-');
					productArr = skuParts[0] + '-' + skuParts[1] + '-' + skuParts[3] + '-' + skuParts[4];
					imageArray = [1, 2, 3, 4, 5];
				} else if (App.product.data.type == 'watch') {
					productArr = $cache.productSKU;
					imageArray = [1,2,3,4,5,6];
				} else if (App.product.data.type == 'slippers-fs') {
					var skuParts = $cache.productSKU.replace('A5', 'A2').replace('A4', 'A2').replace('A0', 'A2').split('-'); // using A4 for CN sku
					productArr = skuParts[0] + '-' + skuParts[1] + '-' + skuParts[3] + '-' + skuParts[4] + '-' + skuParts[5];
					imageArray = [1, 2, 5, 4, 6, 3];
					if (skuParts[0] == 'ML') {
						imageArray = [1, 2, 5, 4, 6, 3];
					}
				} else if (App.product.data.type == 'neo' || App.product.data.type == 'volare' || App.product.data.type == 'detachable') {
					imageArray = [1, 2, 5, 4, 6, 3, 7];
					changeAnimationImage($cache.productSKU);
				} else if (App.product.data.type == 'metallic' || App.product.data.type == 'boot' || App.product.data.type == 'tova' || App.product.data.type == 'lite' || App.product.data.type == 'solar' || App.product.data.type == 'sereno' || App.product.data.type == 'sierra' || App.product.data.type == 'vista' || App.product.data.type == 'aero' || App.product.data.type == 'quilted-mens' || App.product.data.type == 'quilted-womens' || App.product.data.type == 'leather' || App.product.data.type == 'tova' || App.product.data.type == 'meribel' || App.product.data.type == 'verbier' || App.product.data.type == 'slides' || App.product.data.type == 'sandals' || App.product.data.type == 'mule' || App.product.data.type == 'slippers-flow'  || App.product.data.type == 'slippers-curve' || App.product.data.type == 'slippers-breathe' || App.product.data.type == 'alto') {
					if (App.product.data.sku.indexOf('MR-C') > -1 || App.product.data.sku.indexOf('MN-C') > -1) {
						imageArray = [1, 2, 3, 4, 5]
					} else if (App.product.data.sku.indexOf('BC-C') > -1 ) {
						imageArray = [2, 1, 4, 5, 6]
					} else if (App.product.data.sku.indexOf('SH-F') > -1) {
						imageArray = [3, 2, 1, 4, 5, 6]
					} else if (App.product.data.sku.indexOf('QM-C') > -1 || App.product.data.sku.indexOf('QW-C') > -1 || App.product.data.sku.indexOf('MU-C') > -1 || App.product.data.sku.indexOf('MO-C') > -1 || App.product.data.sku.indexOf('MD-C') > -1 || App.product.data.sku.indexOf('MH-C') > -1 || App.product.data.sku.indexOf('MQ-C') > -1 || App.product.data.sku.indexOf('MV-C') > -1  || App.product.data.sku.indexOf('AE-C') > -1 || App.product.data.sku.indexOf('VI-F') > -1 || App.product.data.sku.indexOf('SL-F') > -1 || App.product.data.sku.indexOf('PL-F') > -1) {
						imageArray = [1, 2, 3, 4, 5, 6]
					} else if (App.product.data.sku.indexOf('BT-L') > -1) {
						imageArray = [3, 2, 5, 4, 6, 1]
					} else if (App.product.data.sku.indexOf('LI-T') > -1) {
						imageArray = [3, 2, 5, 4, 6, 1]
					} else if (App.product.data.sku.indexOf('LM-F') > -1) {
						imageArray = [3, 2, 5, 4, 6, 1]
					} else if (App.product.data.sku.indexOf('MT-C') > -1) {
						imageArray = [2, 1, 4, 3, 6]
					} else if (App.product.data.sku.indexOf('DS-L') > -1 || App.product.data.sku.indexOf('DL-P') > -1) {
						imageArray = [1, 2, 4, 5, 6, 3]
					} else if (App.product.data.sku.indexOf('SS-F') > -1) {
						imageArray = [1, 2, 4, 5, 6, 3]
					} else if (App.product.data.sku.indexOf('LR-F') > -1) {
						imageArray = [1, 2, 4, 5, 6, 3]
					} else if (App.product.data.sku.indexOf('CL-L') > -1) {
						imageArray = [1, 2, 3, 4, 5, 6, 7]
					} else {
						imageArray = [1, 2, 5, 4, 6, 3]
					}
				}

				var soleSelected = $('#soleColorBadges').find('.item.selected').data('colour');

				$cache.productThumbs.find('.product-thumb').each(function () { // Desktop
					var divider = '-';

					var imageSrcFull = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg',
						imageSrcLarge = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '_large' + '.jpg',
						imageSrcHighRes = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';

					if (App.product.data.type == 'slippers-fs')
					{
						imageSrcFull = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (App.product.data.type == 'tova')
					{
						imageSrcFull = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (App.product.data.type == 'volare')
					{
						imageSrcFull = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.productImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (App.product.data.type == 'neo')
					{
						imageSrcFull = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (App.product.data.type == 'detachable')
					{
						imageSrcFull = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (App.product.data.type == 'slippers-flow' || isOutdoor || App.product.data.type === 'slippers-curve' || App.product.data.type == 'slippers-breathe'  || App.product.data.type == 'alto' || App.product.data.type == 'sandals' ||  App.product.data.type == 'slides' || App.product.data.type == 'leather' || App.product.data.type == 'meribel'  || App.product.data.type == 'verbier'  || App.product.data.type == 'quilted-womens' || App.product.data.type == 'quilted-mens' || App.product.data.type == 'aero' || App.product.data.type == 'vista' || App.product.data.type == 'solar' || App.product.data.type == 'boot' || App.product.data.type == 'lite' || App.product.data.type == 'metallic' || App.product.data.type == 'sereno' || App.product.data.type == 'sierra') {
						imageSrcFull = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (App.product.data.type == 'apparel') {
						imageSrcFull = $cache.apparelImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.apparelImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.apparelImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (App.product.data.type == 'watch') {
						imageSrcFull = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcLarge = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
						imageSrcHighRes = $cache.cdnImagesSrc + productArr + divider + imageArray[imageNumber] + '.jpg';
					}

					if (imageNumber == 5 && App.product.data.type != "quilted-mens" && App.product.data.type != "quilted-womens" && App.product.data.type != "leather"  && App.product.data.type != "meribel" && App.product.data.type != "verbier"  && App.product.data.type != "sandals" && App.product.data.type != "slides" && App.product.data.type != 'slippers-fs' && App.product.data.type != 'slippers-flow' && App.product.data.type != 'slippers-curve' &&  App.product.data.type != 'slippers-breathe' &&  App.product.data.type != 'aero' &&  App.product.data.type != 'vista' &&  App.product.data.type != 'sierra' &&  App.product.data.type != 'boot' &&  App.product.data.type != 'volare' &&  App.product.data.type != 'detachable' &&  App.product.data.type != 'neo' &&  App.product.data.type != 'tova' &&  App.product.data.type != 'lite' &&  App.product.data.type != 'metallic' &&  App.product.data.type != 'tova' &&  App.product.data.type != 'solar' &&  App.product.data.type != 'sereno') {
						var sku = $cache.soleColorSelector.find('.selected').data('sku');
						if (sku == 'NOSOLE') {
							$('.thumb-sole').hide();
						} else {
							if (productArr == 'ML-B-BE-BE') {
								var imageNum = '3';
							} else {
								var imageNum = imageArray[imageNumber];
							}

							if (App.product.data.type == 'outdoor') {
								sku = $cache.slipperUpperSelect.find('.item-upper-select.selected').data('sku');
							}

							if (App.product.data.type == 'outdoor') {
								imageSrcFull = $cache.productImagesSrc + sku + '-' + '6_small.jpg';
								imageSrcLarge = $cache.productImagesSrc + sku + '-' + '6_large.jpg';
								imageSrcHighRes = $cache.productImagesSrc + sku + '-' + '6.jpg';
							} else {
								imageSrcFull = $cache.productImagesSrc + sku + '-' + imageNum + '_small.jpg';
								imageSrcLarge = $cache.productImagesSrc + sku + '-' + imageNum + '_large.jpg';
								imageSrcHighRes = $cache.productImagesSrc + sku + '-' + imageNum + '.jpg';
							}

							$('.thumb-sole').show();
						}
					}

					// change thumbnail src for desktop/mobile
					var $img = $(this).find('img');
					
					if (!App.ui.isMobile()) {
						$img.attr('src', imageSrcFull + Theme.images.cacheBooster);
						$img.attr('data-high-res-url', imageSrcHighRes + Theme.images.cacheBooster);
					} else {
						$img.attr('src', imageSrcFull + Theme.images.cacheBooster);
					}

					$img.parent().removeClass('hidden');

					// hide if image not exist
					$img.error(function () {
						$img.parent().addClass('hidden');
					});

					if ($(this).hasClass('active')) {
						var imgSrc = $(this).find('img').attr('data-high-res-url');

						if (App.ui.isMobile()) {
							imgSrc = $(this).find('img').attr('src');
						}

						$cache.slipperMainImage.stop().fadeTo('fast', 0, function () {  // Main image animation load
							$cache.slipperMainImage.attr('src', imgSrc).on('load', function () {
								$cache.slipperMainImage.stop().fadeTo('fast', 100);
							});
						});


						App.product.generateGiftImage(imgSrc);
					}

					if (App.product.data.type == "solar") {
						var classImageNumber = mImageNumber + 1;
						// console.log(App.product.data.type);
						// console.log(mImageNumber);
						var sliderClass = '.js-slider-item-' + classImageNumber;

						// console.log(sliderClass);
						// console.log(imageSrcLarge);
						// var $mobileImg = $('.owl-stage').find('.owl-item:not(.cloned)').eq(mImageNumber).find('img');
						var $mobileImg = $('.owl-stage').find('.owl-item').find(sliderClass).find('img');
					} else {
						var $mobileImg = $('.owl-stage').find('.owl-item').eq(mImageNumber).find('img').not('.js-pdp-free-gift-image');
					}


					$mobileImg.attr('src', imageSrcLarge + Theme.images.cacheBooster);
					$mobileImg.attr('data-high-res-url', imageSrcHighRes + Theme.images.cacheBooster);
					
					$mobileImg.removeClass('hidden');

					// hide error images
					$mobileImg.error(function () {
						$mobileImg.addClass('hidden');
					});

					if (imageNumber == 2 && !upperChangeDisabled) {
						$cache.upperOptionsContainer.find('.item').each(function () {
							var thisSKU = $(this).data('sku').toString(),
								thisSoleColourRange = $(this).data('colour-range') || false,
								thisSKUNotSplitted = $(this).data('sku'),
								productSplit = productArr.split('-');

							if (thisSKU.indexOf('-') > -1) {
								thisSKU = thisSKU.split('-');
							}

							if (thisSoleColourRange) {
								thisSoleColourRange = thisSoleColourRange.split(',')
							}

							if (productSplit[2] == 'AW' && productSplit[3] == 'WH' && thisSKU[2] == 'ON') {
								thisSKU[2] = 'AW';
							}

							productSplit[2] = thisSKU[2]; // change this to chenge upper image 1-2
							productSplit[0] = thisSKU[0];

							var productUpperSrc = productSplit.join('-'),
								imgUpperSrc = $cache.productImagesSrc + productUpperSrc + '-' + imageNumber + '.jpg' + Theme.images.cacheBooster;

							if (App.product.data.type == "detachable") {
								productUpperSrc = productSplit.join('-');
								imgUpperSrc = $cache.cdnImagesSrc + productUpperSrc + '-' + imageNumber + '.jpg' + Theme.images.cacheBooster;

							}

							if (App.product.data.type == 'apparel') {
								productUpperSrc = thisSKU.join('-');
								imgUpperSrc = $cache.apparelImagesSrc + productUpperSrc + '-' + '1' + '.jpg';
							}

							if (App.product.data.type == 'watch') {
								var skuSplitted = $cache.productSKU.split('-'),
									imageUrl = skuSplitted[0] + '-' + skuSplitted[1] + '-' + thisSKU + '-' + skuSplitted[3] + '-' + skuSplitted[4] + '-' + skuSplitted[5];
								imgUpperSrc = $cache.cdnImagesSrc + imageUrl + '-' + '1' + '.jpg';
							}

							if (thisSoleColourRange) {
								var changeUpperPreview = false,
									showUpper = $(this).data('show-upper') || false;

								$.each(thisSoleColourRange, function (index, value) {
									if (soleSelected == value) {
										changeUpperPreview = true;
									}
								});

								if (changeUpperPreview) {
									$(this).removeClass('hidden');
									$(this).find('img').attr('src', imgUpperSrc);
								} else if (showUpper) {
									$(this).removeClass('hidden');
								} else {
									$(this).addClass('hidden');
								}
							} else {
								$(this).find('img').attr('src', imgUpperSrc);
							}
						});
					}

					imageNumber++;
					mImageNumber++;
				});

				$('.product-gallery-feature').find('img').on('load', function () {
					$('#productImagesWrapper').removeClass('invisible');
				});
			};

			var detectPrice = (function (oldSku) {
				var skuSplitted = $cache.productSKU.split('-'),
					skuCombined = skuSplitted[0] + '-' + skuSplitted[1] + '-' +  skuSplitted[3] + '-' +  skuSplitted[4],
					fixedPrice = $('#productCustomVariants').find('.js-customvariants-price[data-sku="' + skuCombined + '"]').html();

				if (fixedPrice) {
					var fixedPriceAvailable = fixedPrice.toString().trim();
					if (fixedPriceAvailable) {
						$('#bundlePrice, #bundlePriceMobile').html(fixedPrice);
					} else {
						setTimeout(function () {
							detectPrice();
						}, 500);
					}
				}
			});

			// Show out of stock message
			var checkStockFn = function () {
				var outOfStockLimit = Theme.stock.outOfStockLimit,
					stockLevel = App.stock.get($cache.productSKU),
					replacementSkuList = $.parseJSON(Theme.product.replacementSKU),
					replacementSku = replacementSkuList[$cache.productSKU],
					isPreorderProduct =  $('#upperSelector').find('.selected').data('is-preorder') || false;

				if (stockLevel < outOfStockLimit && replacementSku) {
					stockLevel = app.stock.get(replacementSku);
				}

				if ($cache.productCollectionType === 'slippers-fs-summer') {
					outOfStockLimit = Theme.stock.zeroOutOfStockLimit;
				}
				if (($cache.isBag ||
					App.product.data.type === 'watch' ||
					App.product.data.type === 'outdoor' ||
					App.product.data.type === 'socks' ||
					App.product.data.type === 'insole' ||
					App.product.data.type === 'mule' ||
					App.product.data.type === 'sandals' ||
					App.product.data.type === 'verbier' ||
					App.product.data.type === 'leather' ||
					App.product.data.type === 'meribel' ||
					App.product.data.type === 'aero' ||
					App.product.data.type === 'vista' ||
					App.product.data.type === 'solar' ||
					App.product.data.type === 'boot' ||
					App.product.data.type === 'lite' ||
					App.product.data.type === 'tova' ||
					App.product.data.type === 'volare' ||
					App.product.data.type === 'neo' ||
					App.product.data.type === 'detachable' ||
					App.product.data.type === 'metallic' ||
					App.product.data.type === 'sereno' ||
					App.product.data.type === 'sierra' ||
					App.product.data.type === 'quilted-womens' ||
					App.product.data.type === 'quilted-mens' ||
					App.product.data.type === 'slides' ||
					App.product.data.type === 'alto' ||
					App.product.data.type === 'slippers-flow' ||
					App.product.data.type === 'slippers-breathe' ||
					App.product.data.type === 'slippers-curve' ||
					App.product.data.type === 'slippers-fs') && $cache.submitActive) {

					var isPreorderForced = App.stock.checkPreorderForced($cache.productSKU);

					// console.log(isPreorderForced);
					if (isPreorderForced) {
						singleItemInPreorder();
					} else if (stockLevel < outOfStockLimit) {
						$cache.deliveryTerms.text(App.stock.terms[$cache.productSKU]);
						$cache.productInPreOrder = true;
						var isSoldOutProduct = App.stock.checkSoldOut($cache.productSKU);

						// console.log($cache.productSKU);
						// console.log(isSoldOutProduct);
						if ((App.product.data.type == 'quilted-mens' || App.product.data.type == 'quilted-womens' || App.product.data.type == 'leather'  || App.product.data.type == 'meribel' || App.product.data.type == 'verbier' || App.product.data.type == 'slides' || App.product.data.type == 'sandals' || App.product.data.type == 'outdoor' || App.product.data.type == 'mule' || App.product.data.type == 'alto' || App.product.data.type == 'slippers-fs' || App.product.data.type == 'slippers-flow' || App.product.data.type == 'slippers-curve' || App.product.data.type == 'socks' || App.product.data.type == 'insole' || App.product.data.type == 'watch' || App.product.data.type == 'slippers-breathe' || App.product.data.type == 'aero' || App.product.data.type == 'vista' || App.product.data.type == 'detachable'  || App.product.data.type == 'volare' || App.product.data.type == 'neo' || App.product.data.type == 'tova' || App.product.data.type == 'solar' || App.product.data.type == 'boot' || App.product.data.type == 'tova' || App.product.data.type == 'lite' || App.product.data.type == 'metallic' || App.product.data.type == 'sereno' || App.product.data.type == 'sierra') && $cache.productIsOutOfStock) {
							if (isPreorderProduct) {
								singleItemOutOfStock(isSoldOutProduct);
							}	 else {
								singleItemOutOfStock(isSoldOutProduct);
							}
						} else {
							if (App.product.data.type == 'apparel') {
								if (App.stock.get($cache.productSKU) < Theme.stock.apparelOutOfStockLimig) {
									if ($cache.productIsOutOfStock) {
										singleItemOutOfStock(isSoldOutProduct);
									} else {
										singleItemInPreorder();
									}
								}
							} else {
								singleItemInPreorder();
							}
						}
					} else if (stockLevel < 10) {
						singleItemAlmostEnd();
					} else {
						if (isPreorderProduct) {
							singleItemPreorderAvailable()
						} else {
							singleItemInStock();
						}
					}
				}
				$cache.stockCheckContainer.remove();
			};


			function waitForProductStock(forceStockCheck) {
				if (App.stock.initialized) {
					if (App.product.size.selected || forceStockCheck) {
						checkStockFn();
					}
				} else if ($cache.stockRetryAmount < 20) {
					$cache.stockRetryAmount++;
					setTimeout(waitForProductStock, 1000);
				}
			}

			if (App.page.template == 'pdp') {
				// do not check stock on initial page load
				waitForProductStock();
			} else if (App.page.template == 'cart') {
				waitForProductStock(true);
			}

			// Mobile panzoom
			(function () {
				var zoomedImg = $('#mobileZoomedImg'),
					zoomedImgDesktop = $('#mobileZoomedImgDesktop'),
					mobileCarousel = $('#productpage-carousel'),
					thumbs = $('.product-gallery-thumbs'),
					thumbsAmount = thumbs.children('.product-thumb').length,
					paginationDOM = $('#carouselPagination'),
					pagination = [];

				for (var i = 0; i < thumbsAmount; i++) {
					pagination.push('<li></li>');
				}

				paginationDOM.append(pagination.join('\n'));

				$('#enlargeImgMobile').on('click', function () {
					var imgSrc = mobileCarousel.find('.center').find('img').attr('data-high-res-url');
					zoomedImg.attr('src', imgSrc);
				});

				$('.js-zoomCarouselRight').on('click', function () {
					var activeSlide = thumbs.find('.product-thumb.active'),
						isLast = false,
						nextIsDisabled = activeSlide.next().hasClass('hidden'),
						activeImg = $('.product-gallery-feature').children(),
						activeImgSrc = activeImg.attr('src'),
						windowsize = $(window).width();

					// Infinity loop
					(!activeSlide.next().length || activeSlide.next().hasClass('js-thumbnail-video')) ? isLast = true : isLast = false;

					if (isLast || nextIsDisabled) {
						// thumbs.find('.product-thumb').first().trigger('click');
						// paginationDOM.find('.active').removeClass('active');
						// paginationDOM.children().first().addClass('active');
					} else {
						var nextSlideSrc = activeSlide.next().find('img').attr('src');
						activeSlide.removeClass('active');
						activeSlide.next().trigger('click').addClass('active');
						paginationDOM.find('.active').removeClass('active').next().addClass('active');
						if (App.ui.isMobile()) {
							$('#mobileZoomedImg').attr('src', nextSlideSrc)
						}
					}

					if (windowsize < 1025) {
						activeImg.on('load', function () {
							activeImgSrc = activeImg.attr('src');
							zoomedImg.attr('src', activeImgSrc);
							zoomedImg.panzoom("reset");
						});
					}
				});

				$('.js-zoomCarouselLeft').on('click', function () {
					var activeSlide = thumbs.find('.product-thumb.active'),
						isFirst = false,
						activeImg = $('.product-gallery-feature').children(),
						activeImgSrc = activeImg.attr('src'),
						windowsize = $(window).width();

					// Infinity loop
					(activeSlide.hasClass('first')) ? isFirst = true : isFirst = false;

					if (isFirst) {
						// console.log(thumbs.find('.product-thumb:not(.hidden)').last())
						// thumbs.find('.product-thumb:not(.hidden)').last().trigger('click');
						// paginationDOM.find('.active').removeClass('active');
						// paginationDOM.children().last().addClass('active');
					} else {
						activeSlide.removeClass('active');
						activeSlide.prev().trigger('click').addClass('active');
						thumbs.find('.product-thumb.active').parent().prev().find('.product-thumb').trigger('click');
						paginationDOM.find('.active').removeClass('active').prev().addClass('active');
						if (App.ui.isMobile()){
							var prevSlideSrc = activeSlide.prev().find('img').attr('src');
							$('#mobileZoomedImg').attr('src', prevSlideSrc)
						}
					}

					if (windowsize < 1025) {
						activeImg.on('load', function () {
							activeImgSrc = activeImg.attr('src');
							zoomedImg.attr('src', activeImgSrc);
							zoomedImg.panzoom("reset");
						});
					}
				});

				paginationDOM.find('li').on('click', function () {
					var orderNumber = $(this).index();

					paginationDOM.find('li').each(function () {
						$(this).removeClass('active');
					});
					$(this).addClass('active');
					thumbs.children().eq(orderNumber).trigger('click');
				});

				$('.product-thumb').on('click', function () {

					if (App.ui.isMobile()) {
						var thumbIndex = $(this).index();

						$('#productpage-carousel').trigger('to.owl.carousel', [thumbIndex, 1, true]);
					} else {
						var img = $(this).find('img'),
							imgSrc = img.first().attr('src'),
							activeThumb = thumbs.find('.active').index(),
							width = $(window).width();

						paginationDOM.find('.active').removeClass('active');
						paginationDOM.children().eq(activeThumb).addClass('active');

						if (imgSrc.indexOf('grande') > -1) {
							imgSrc = imgSrc.replace('grande', '1024x1024');
						}

						zoomedImgDesktop.attr('src', imgSrc);
						App.popup.open('modalZoomImageDesktop', false);
					}

				});

				zoomedImg.panzoom({
					increment: 0.85,
					minScale: 1,
					disablePan: true,
					$reset: $(".modal-close")
				});

				zoomedImg.on('panzoomzoom', function (e, panzoom, matrix, changed) {
					if (changed) {
						zoomedImg.panzoom("option", "disablePan", false);
					}
				});

				zoomedImg.on('panzoomreset', function (e, panzoom, matrix, changed) {
					zoomedImg.panzoom("option", "disablePan", true);
				});

				mobileCarousel.on('click', '.center', function () {
					var imgSrc = $(this).find('img').attr('data-high-res-url');
					if (imgSrc) {
						zoomedImg.attr('src', imgSrc);
						App.popup.open('modalZoomImage', false);
						$(window).scrollTop(50);
					}
				});
			})();

			$('#modalZoomImage').on('doubletap', function (event) {
				$('#mobileZoomedImg').panzoom("reset");
			});

			var checkReplacementSKU = function (sku) {
				var replacementSkuList = $.parseJSON(Theme.product.replacementSKU),
					replacementSku = replacementSkuList[sku];

				if (replacementSku) {
					if (app.stock.initialized) {
						var stock = app.stock.get(replacementSku);

						if (stock > 0) {
							App.product.data.sku = replacementSku;
						}
					}
				}

			}

			var addUpsellItems = function() {
				var $carousel = $('.js-pdp-free-gift-carousel');
				var $upsellGift = $('.js-upsell-gift');

				if ($carousel.length) {
					// Owl duplicates slides for looping; take the first "active" slide with a valid selection.
					var $activeSlide = $carousel.find('.owl-item.active').first();
					if (!$activeSlide.length) {
						$activeSlide = $carousel.find('.active').first();
					}

					var $select = $activeSlide.find('select[name="id"]').first();
					if (!$select.length) return;

					var selectedVariantId = ($select.val() || '').toString().trim();
					var selectedVariantNote = ($select.find('option:selected').data('note') || '').toString().trim();
					if (!selectedVariantId) return;

					// Ensure numeric-ish variant id (Shopify variant IDs are digits)
					selectedVariantId = selectedVariantId.replace(/[^\d]/g, '');
					if (!selectedVariantId) return;
				} else if ($upsellGift.length) {
					var $select = $upsellGift.find('select[name="id"]').first();
					var selectedVariantId = ($select.val() || '').toString().trim();
					var selectedVariantNote = ($select.find('option:selected').data('note') || '').toString().trim();
				}

				var upsellSubmitData = {
					id: selectedVariantId,
					quantity: 1,
					properties: {
						'Note': selectedVariantNote
					}
				};

				$.ajax({
					url: '/cart/add.js',
					dataType: 'json',
					type: 'post',
					data: upsellSubmitData,
					success: function () {
						App.header.updateMinicartAmount();
						App.header.getCartData(true);
					}
				});
			}

			// Multi-country size selector
			var switchProductSize = function (size) {
				$cache.productIsOutOfStock = $('#upperSelector').find('.selected').data('is-out-stock') || false;
				$cache.soleIsOutOfStock = $('#soleColorBadges').find('.selected').data('is-out-stock') || false;

				$cache.slipperSizeSelected = size;
				$cache.slipperSizeSelector.val(size);
				switchSize();
				generateBundleSKU();
				checkReplacementSKU(App.product.data.sku);

				detectBundleID(App.product.data.sku);

				App.product.generateGiftLink($cache.productID);
				App.product.generateDynamicCollectionLink(size)

				waitForProductStock();

				if (App.product.data.type == 'slippers-fs') {
					App.product.checkComboStock(size);
				} else if (App.product.data.type == 'outdoor' || App.product.data.type == 'slippers-flow') {
					App.product.checkUpperStock(size);
				}

				if ($cache.productCollectionType == 'bundle classic' || $cache.productCollectionType == 'bundle summer' || $cache.productCollectionType == 'bundle detachable') {
					//App.product.checkUpperStock(size);
					//App.product.checkCollectionStock();
					//App.product.switchToAvailableVariant();
				}

				App.tracking.productView.fbIsSent = false;
				App.product.data.sku = $cache.productSKU;
			};


			$('#sizeSelection').on('click', 'li', function () {
				var $this = $(this),
					size = $this.data('size-eu'),
					$parent = $this.parent(),
					selectorType = $parent.attr('data-sizing'),
					isOutOfStock = $this.hasClass('is-out-stock'),
					gender = $this.parent().data('size-gender') || '',
					sizeCurrent = $this.attr('data-value'),
					colourRange = $this.data('colour-range'),
					countrySize = $('.currencySwitcher').find('.selected').data('sizetype'),
					$sizeOptions = $('.size-options');

				if (selectorType === "custom") {
					App.customizer.productSizeSelected = size;
				}

				var selectedCurrency = Shopify.currency.active,
					selectedCountry = Shopify.country,
					countrySize = "uk";

				if (selectedCurrency === 'USD' || selectedCountry === "US") {
					countrySize = "us";
				} else if (selectedCurrency === 'AUD' || selectedCountry === "AU") {
					countrySize = "au";
				} else if (selectedCurrency === 'GBP' || selectedCountry === "GB") {
					countrySize = "uk";
				} else {
					countrySize = "eu";
				}

				if (countrySize === 'us') {
					var sizeAttribute = 'size-' + countrySize + '-' + gender;
					sizeCurrent = $this.data(sizeAttribute);
				} else if (countrySize === 'uk') {
					sizeCurrent = $this.data('size-uk');
				} else if (countrySize === 'eu' || countrySize === 'au') {
					sizeCurrent = $this.data('size-eu');
				}

				if (App.product.data.type === "socks") {
					size = $this.data("value");
				}

				// get correct property size
				if (gender) {
					if (countrySize == 'au') {
						$cache.productProperty = 'eu ' + sizeCurrent;
					} else if (countrySize == 'uk') {
						$cache.productProperty = countrySize + ' ' + sizeCurrent + ' (EU ' + size + ')';
					} else {
						$cache.productProperty = countrySize + ' ' + gender + ' ' + sizeCurrent + ' (EU ' + size + ')';
					}
				} else {
					if (countrySize == 'eu' || countrySize == 'au') {
						$cache.productProperty = 'eu ' + sizeCurrent;
					} else {
						$cache.productProperty = countrySize + ' ' + sizeCurrent;
					}
				}

				$cache.submitActive = true;
				App.product.size.selected = true;
				$('#selectSizeValidation').addClass('hidden');
				$('.submit-button, #productGifting').attr('data-active', 'true');

				if ($sizeOptions.hasClass('options-group-error')) {
					$('.size-options').removeClass('options-group-error');
					$('#selectSizeValidation').addClass('hidden');
				}

				if (isOutOfStock) {
					$('#dropHintTrigger').addClass('hidden');
				} else {
					$('#dropHintTrigger').removeClass('hidden');
				}

				// customizer limit sizing
				if (App.product.data.sku.indexOf('CF-C') > -1 || App.product.data.sku.indexOf('CC-C') > -1) {
					$('#customizationSizeSelector').addClass('hidden');
					if (size > 42) {
						$('.js-customizer-color[data-value="havana_pink"]').addClass('hidden');
						$('.js-customizer-color[data-value="sakura_pink"]').addClass('hidden');
					}
				}

				$this.parent().parent().parent().find('li').removeClass('selected');
				$this.addClass('selected');
				switchProductSize(size);
				switchProductPrice(App.product.data.sku);
				App.product.switchSolesRange(colourRange);

				// trigger pre-order sizes (PURPLEDOT)
				if ($this.hasClass('js-is-preorder-size')){
					$('#pd-waitlist-info').removeClass('is-hidden')
					$('#addToCartSubmitBtn').removeClass('disabled').prop("disabled", false).val('PRE-ORDER');
					if (App.currency.get() == 'GBP' ) {
						$('#addToCartSubmitBtn').removeClass('hidden');
					}
				} else {
					$('#pd-waitlist-info').addClass('is-hidden')
				}
			});

			// check this
			App.product.switchProductSizes();
			/* ON EVENT FUNCTIONS END */

			// Out of stock functions
			var singleItemInStock = function () {
				$cache.stockReturnedDelivery.removeClass('hidden is-initial');
				$cache.stockErrorDelivery.addClass('hidden');
				$cache.stockScarcity.addClass('hidden');
				app.product.showDeliveryMsg();
				$cache.addToCartButton.val('add to cart').attr('disabled', false).removeClass('hidden disabled');
				$('#switchGiftProduct').attr('data-disabled', false);
				App.product.switchTitleNote($('#preOrderCustomMessageEmpty'));
			};

			var singleItemPreorderAvailable = function () {
				$cache.stockReturnedDelivery.removeClass('hidden is-initial');
				$cache.stockErrorDelivery.addClass('hidden');
				$cache.stockScarcity.addClass('hidden');
				app.product.hideDeliveryMsg();
				$cache.addToCartButton.val('pre order').attr('disabled', false).removeClass('hidden disabled');
			};

			var singleItemInPreorder = function () {
				var itemStock = app.stock.data[$cache.productSKU];
				$cache.stockReturnedDelivery.addClass('hidden is-initial');
				$cache.stockErrorDelivery.removeClass('hidden');
				if (itemStock > 0) {
					$cache.addToCartButton.val('pre order').attr('disabled', false).removeClass('hidden disabled').addClass('pre-order');
					App.product.switchTitleNote($('#preOrderCustomMessage'));
					if ($cache.productSKU.indexOf('SH-F') > -1 && $cache.productSKU.indexOf('BE-BE') > -1) {
						App.product.switchTitleNote($('#preOrderCustomMessage2'));
					} else if ($cache.productSKU.indexOf('LR-F') > -1 && $cache.productSKU.indexOf('BE-BE') > -1) {
						App.product.switchTitleNote($('#preOrderCustomMessage2'));
					} else {
						App.product.switchTitleNote($('#preOrderCustomMessage'));
					}
				} else {
					$cache.addToCartButton.val('out of stock').attr('disabled', true).removeClass('hidden disabled').addClass('pre-order');
					App.product.switchTitleNote($('#preOrderCustomMessageEmpty'));
				}
				$('#productGifting').addClass('hidden');
				$('.dropHintWrapper').addClass('hidden');
				$('#deliveryOutOfStock').addClass('hidden');
				app.product.hideDeliveryMsg();
			};

			var singleItemOutOfStock = function (isSoldOut) {
				$cache.stockReturnedDelivery.addClass('hidden').removeClass('is-initial');
				$cache.stockErrorDelivery.removeClass('hidden');
				App.product.generateOOSMessage(App.product.data.sku);
				$cache.stockScarcity.addClass('hidden');
				App.product.switchTitleNote($('#preOrderCustomMessageEmpty'));
				app.product.hideDeliveryMsg();

				if (isSoldOut) {
					$cache.addToCartButton.val('sold out').attr('disabled', 'disabled').addClass('disabled');
					$('#stockErrorMsg').addClass('hidden');
					$('#switchGiftProduct').attr('data-disabled', true);
					$('#stockSoldOutMsg').removeClass('hidden');
				} else {
					$cache.addToCartButton.val('out of stock').attr('disabled', 'disabled').addClass('disabled hidden');
					$('#stockErrorMsg').removeClass('hidden');
					$('#switchGiftProduct').attr('data-disabled', true);
					$('#stockSoldOutMsg').addClass('hidden');
				}
			};

			var singleItemAlmostEnd = function() {
				$cache.stockReturnedDelivery.removeClass('hidden is-initial');
				$cache.stockErrorDelivery.addClass('hidden');
				$('#switchGiftProduct').attr('data-disabled', false);
				$cache.stockScarcity.removeClass('hidden');
				$cache.addToCartButton.val('add to cart').attr('disabled', false).removeClass('hidden disabled');
				App.product.switchTitleNote($('#preOrderCustomMessageEmpty'));
				app.product.showDeliveryMsg();
			}

			// Track product change
			var trackProductChange = function () {
				if (App.multistore.data.prices[$cache.productSKU]) {
					App.tracking.productView.google(App.multistore.data.prices[$cache.productSKU].prices["gbp"], $cache.productSKU);
					App.tracking.productView.gtm($cache.bundleUpperSKU, $cache.bundleSoleSKU);
				}
			};

			var sendVariantChangeEvent = function(productSKU) {
				var variantID = App.multistore.data.variants[productSKU]["variant-gbp"];
				const event = new CustomEvent("onVariantChanged", {
					bubbles: true,
					detail: {
						variant: variantID
					}
				});
				document.dispatchEvent(event);
			}

			var switchProductPrice = function (oldSku) {
				if (App.multistore.initialized) {
					detectPrice(oldSku);
					trackProductChange();
					sendVariantChangeEvent(oldSku);
					App.currency.getDiscount();
					App.product.checkDynamicDiscount();
					//App.product.checkGiftAvailable($cache.productSKU);
				} else {
					setTimeout(function () {
						switchProductPrice(oldSku);
					}, 500);
				}
			};

			// Choose sole colour
			$cache.slipperColorOption.on('click', function () {
				var $this = $(this),
					imageChangeDisabled = $this.parents('.js-variant-inline').data('disable-imagechange') || false,
					isAvailable = !$this.parents('.js-variant-inline').hasClass('is-outofstock');

				if (isAvailable) {
					$cache.slipperColorItem.removeClass('selected');
					$this.parent().addClass('selected');
					switchSole();
					generateBundleSKU();
					detectBundleID();

					App.product.generateGiftLink($cache.productID);

					var sizeRange = App.product.getSizeRange();
					changeThumbnail(imageChangeDisabled);
					waitForProductStock();
					if (App.product.data.type == 'slippers-fs') {
						switchDescAlt($this);
					}
					switchProductPrice(App.product.data.sku || $cache.productSKU);
					App.product.setSizeRange(sizeRange);
					App.product.checkAllSizesStock($this);
					App.product.switchTitleNote($this);

					App.tracking.productView.fbIsSent = false;
					App.product.data.sku = $cache.productSKU;

					App.product.checkCustomProductAvailability($cache.productSKU);
					App.product.klarnaChangePrice();
				}
			});

			// Select product size
			$cache.slipperSizeSelector.on('change', function () {
				detectSizeSelected();
				switchSize();
				generateBundleSKU();
				detectBundleID();
				waitForProductStock();
				App.tracking.productView.fbIsSent = false;
				App.product.data.sku = $cache.productSKU;
			});

			// Upper change on click
			$cache.slipperUpperDetect.on('click', function () {
				var $this = $(this),
					isPreorder = $this.hasClass('is-preorder-pd'),
					isAvailable = !$this.hasClass('is-outofstock');

				if (isAvailable) {
					var upperSelected = $this.data('upper'),
						solesRange = $this.data('colour-range'),
						colourSale = $this.data('colour-sale') || null,
						sliderChange = $this.data('slider-change') || false,
						titleLabel = $this.data('title-label') || false,
						titleStyle = $this.data('label-style') || false,
						additionalLabels = $this.data('style-switch') || false,
						upperChangeDisabled = $this.data('disable-imagechange') || false,
						oldSku = $cache.productSKU;

					$cache.productIsOutOfStock = $this.data('is-out-stock') || false;
					switchUpper(upperSelected);
					App.product.switchSolesRange(solesRange);
					App.product.switchUpperTab($this);
					App.product.switchProductSlider(sliderChange);
					App.product.switchTitleLabel(titleLabel, titleStyle);
					App.product.switchTitleNote($this);
					App.product.switchProductStyling(additionalLabels);
					App.product.toggleSaleLabels(colourSale);
					generateBundleSKU();
					detectBundleID();

					App.product.generateGiftLink($cache.productID);

					var sizeRange = App.product.getSizeRange();
					changeThumbnail(upperChangeDisabled);
					waitForProductStock();
					switchProductPrice(oldSku);
					App.product.setSizeRange(sizeRange);
					App.product.checkAllSizesStock($this);
					App.product.checkCustomProductAvailability($cache.productSKU);
					App.product.sendKlaviyoProductView($this);
					App.tracking.productView.fbIsSent = false;
					App.product.data.sku = $cache.productSKU;
				}

				// Purple dot preorder
				if (isPreorder) {
					$('#pd-waitlist-info').removeClass('is-hidden');
					$('#addToCartSubmitBtn').removeClass('disabled').prop("disabled", false).val('PRE-ORDER');
					if (App.currency.get() == 'GBP' ) {
						$('#addToCartSubmitBtn').removeClass('hidden');
					}
				} else {
					$('#pd-waitlist-info').addClass('is-hidden')
				}
			});

			// Add to cart with extras
			// $('#addToCartSubmitBtn').on('click', function(){
			// 	console.log('123');
			// 	var submitData = {
			// 		'id': 40554847699014,
			// 		'quantity': 1,
			// 	};
			//
			// 	$.ajax({
			// 		url: '/cart/add.js',
			// 		dataType: 'json',
			// 		type: 'post',
			// 		data: submitData,
			// 	});
			// })
			$('#addToCartSubmitBtn').on('click', function (e) {
				// e.preventDefault();
				var $submitBtn = $('form[action="/cart/add"]').find('.submit-button'),
					$sizeOption = $('.size-options'),
					activeSubmit = $submitBtn.attr('data-active'),
					upsellID = $submitBtn.attr('data-upsell-id') || 'false',
					showPDPUpsell = $submitBtn.attr('data-show-upsell'),
					popupID = $submitBtn.attr('data-popup');

				console.log('adding to cart');

				if (activeSubmit == 'true') {
					console.log('clicked');
					var $freeGiftCarousel = $('.js-pdp-free-gift-carousel');
					if ($freeGiftCarousel.length) {
						var ensureFreeGiftConfirmModal = function () {
							if ($('#modalFreeGiftConfirm').length) return;

							$('body').append(
								'<div id="modalFreeGiftConfirm" class="modal-frm modal-subscribe">' +
									'<div class="valign">' +
										'<div class="modal-popup modal-subscribe img-bottom" style="padding-bottom:60px;">' +
											'<div class="modal-title">Continue without a free gift?</div>' +
											'<div class="modal-content">' +
												'<div class="modal-text">' +
													'<p style="margin:0 0 16px;">No free gift size is selected. Do you want to continue without adding a gift?</p>' +
															'<div class="modal-form" style="display:flex; gap:10px; justify-content:center; align-items:center; flex-wrap:wrap;">' +
																'<button type="button" class="button popups-close js-free-gift-confirm-cancel" style="background:#fff; color:#000; border:1px solid #000; min-width:140px;">Go back</button>' +
																'<button type="button" class="button js-free-gift-confirm-continue" style="background:#000; color:#fff; border:1px solid #000; min-width:140px;">Continue without a gift</button>' +
													'</div>' +
												'</div>' +
											'</div>' +
											'<div class="modal-close icons icon-cross popups-close"></div>' +
										'</div>' +
									'</div>' +
									'<div class="modal-area popups-close"></div>' +
								'</div>'
							);
						};

						var $activeGiftSelect = $freeGiftCarousel.find('.owl-item.active select[name="id"]:enabled').first();
						if (!$activeGiftSelect.length) {
							$activeGiftSelect = $freeGiftCarousel.find('select[name="id"]:enabled').first();
						}

						var freeGiftVariantId = ($activeGiftSelect.val() || '').toString().trim();
						if (!freeGiftVariantId) {
							var freeGiftConfirmDismissed = false;
							try {
								freeGiftConfirmDismissed = window.sessionStorage.getItem('freeGiftConfirmDismissed') === 'true';
							} catch (err) {}

							if (!freeGiftConfirmDismissed && $submitBtn.data('skip-gift-confirm') !== true) {
								e.preventDefault();
								ensureFreeGiftConfirmModal();

								// One-shot handlers per open
								$(document).off('click.freeGiftConfirm');
								$(document).on('click.freeGiftConfirm', '.js-free-gift-confirm-continue', function () {
									$(document).off('click.freeGiftConfirm');
									$submitBtn.data('skip-gift-confirm', true);
									App.popup.close();
									$('#addToCartSubmitBtn').trigger('click');
								});
								$(document).on('click.freeGiftConfirm', '.js-free-gift-confirm-cancel', function () {
									$(document).off('click.freeGiftConfirm');
									try {
										window.sessionStorage.setItem('freeGiftConfirmDismissed', 'true');
									} catch (err) {}
									App.popup.close();
								});

								App.popup.open('modalFreeGiftConfirm', true);
								return;
							} else {
								// reset the bypass for the next add-to-cart
								$submitBtn.data('skip-gift-confirm', false);
							}
						}
					}

					var itemsToCart = new Array(),
						quantity = App.product.data.quantity,
						submitData = {},
						preorderData = $('#productNote').text(),
						isExternalProduct = $('.js-variant-selector').length > 0;

					if (isExternalProduct) {
						var variantID = $('.js-variant-selector.selected').data('variant-id');
						itemsToCart.push(variantID);
						// submitData = {
						// 	'items': [{
						// 		'id': itemsToCart,
						// 		'quantity': quantity,
						// 	}]
						// };
						submitData = {
							quantity: quantity,
							id: itemsToCart
						}
					} else {
						itemsToCart.push($cache.productID);
						// submitData = {
						// 	'items': [{
						// 		'id': itemsToCart,
						// 		'quantity': quantity,
						// 		'properties': {
						// 			'Size': $cache.productProperty
						// 		}
						// 	}]
						// };
						submitData = {
							quantity: quantity,
							id: itemsToCart,
							properties: {
								'Size': $cache.productProperty,
								'Note': preorderData
							}
						}
					}

					console.log('adding to cart');

					$.ajax({
						url: '/cart/add.js',
						dataType: 'json',
						type: 'post',
						data: submitData,
						beforeSend: function () {
							App.header.addToCartToggle();
						},
						success: function (itemData) {
							if (showPDPUpsell == "true") {
								$('.upsell-subtotal').addClass('invisible');
								App.lazyload.show('upsellProducts');
								App.popup.open(popupID);
								App.upsell.getTotals();
								App.carousel.initUpsellCarousel();
							} else {
								if (!isExternalProduct) {
									App.tracking.addToCart.ttq($cache.productID, quantity);
									App.tracking.addToCart.fb($cache.productSKU);
									//App.tracking.addToCart.gtag($cache.productSKU);
								}
								App.header.updateMinicartAmount();
								App.header.getCartData(true);
								// window.location = $cache.cartLink;
							}
							addUpsellItems()
						}
					});
				} else {
					console.log('clicked2');
					var $title = $sizeOption.find('.option-legend'),
						animateTitle = function () {
							$sizeOption.addClass('options-group-error');
							$('#selectSizeValidation').removeClass('hidden');
							$title.addClass('animated shake');
							$title.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
								$title.removeClass('animated shake');
							});
						};

					if ($('.size-options').length) {

						if (!App.utils.isInViewport($sizeOption)) {
							var scrollCorrection = 0; // due to fixed header we need to correct scroll

							if (!App.utils.isMobile()) {
								scrollCorrection = 65;
							}

							App.utils.scrollTo($sizeOption, 800, scrollCorrection, function () {
								animateTitle();
							})
						} else {
							animateTitle();
						}
					}

				}
			});

			// Tabs functionality
			$cache.descriptionTabs.find('nav').on('click', 'a', function () {
				var linkAttr = $(this).attr('data-content');

				$cache.descriptionTabs.find('nav').find('li').removeClass('selected');
				$(this).parent().addClass('selected');

				$cache.descriptionTabs.find('.tab-content').children().each(function () {
					$(this).addClass('hidden');
					if ($(this).attr('data-content') === linkAttr) {
						$(this).removeClass('hidden');
					}
				});
			});

			var changeProductSize = function (value) {
				if (App.stock.initialized) {
					var $sizeSelector = $('#sizeSelection').find('div[data-size-show]:not(.hidden)').find('.js-size-selector');
					$sizeSelector.find('li[data-value="' + value + '"]').trigger('click');
				} else {
					setTimeout(function () {
						changeProductSize(value);
					}, 1000)
				}
			}

			// Detect URL parameters to change slipper color
			var detectURLParameters = function () {
				var slipperURLProductSize = App.utils.getUrlParam('size'),
					slipperURLSoleColour = $('#redirectColour').text() || App.utils.getUrlParam('colour'),
					slipperURLUpperColour = $('#redirectUpper').text() ||  App.utils.getUrlParam('upper'),
					slipperUrlGender = App.utils.getUrlParam('gender'),
					slipperURLCollection = App.utils.getUrlParam('col') || 'classic';

				// URL - Getting select values (active sizes)
				var slipperAvailableSizes = [];
				$cache.slipperSizeSelector.find('option').each(function () {
					var sizeValue = $(this).val();
					slipperAvailableSizes.push(sizeValue);
				});

				// URL - Changing product gender
				if (slipperUrlGender) {
					App.product.setUrlGender(slipperUrlGender);
				}

				// URL - Changing product size
				var slipperURLSizeIsAvailable = $.inArray(slipperURLProductSize, slipperAvailableSizes) > -1;
				if (slipperURLSizeIsAvailable) {
					if ($cache.isGiftCard) {
						$cache.slipperSizeSelector.val(slipperURLProductSize);
						$cache.slipperSizeSelected = slipperURLProductSize;
						$cache.slipperSizeSelector.trigger('change');

						var selectedPrice = $cache.slipperSizeSelector.find('option[value="' + slipperURLProductSize + '"]').text().substring(1),
							selectedPriceWithoutDot = selectedPrice.split('.').join("");

						$cache.productSKU = $cache.slipperSizeSelected;

						// Update meta after changing price
						$('meta[itemprop="price"]').attr('content', selectedPrice);
						$('meta[name="twitter:data1"]').attr('content', selectedPriceWithoutDot);
					} else {
						changeProductSize(slipperURLProductSize);
					}
				}

				// URL - Changing upper color
				if (slipperURLUpperColour) {
					App.product.setUrlUpper(slipperURLUpperColour)
				}

				// URL - Changing sole color
				if (slipperURLSoleColour) {
					App.product.setUrlColour(slipperURLSoleColour);
				}
			};

			detectURLParameters();
		}

		function initPublic() {

			var detectURLCurrency = function () {
				function detectUrlParameter(sParam) {
					var sPageURL = window.location.search.substring(1);
					var sURLVariables = sPageURL.split('&');

					for (var i = 0; i < sURLVariables.length; i++) {
						var sParameterName = sURLVariables[i].split('=');
						if (sParameterName[0] == sParam) {
							return sParameterName[1];
						}
					}
				}

				var slipperURLCurr = detectUrlParameter('sitecurrency'),
					slipperURLCurrency;

				// URL - Change currency depending on URL
				// Checking if '&currency=' is available in URL
				if (slipperURLCurr) {
					slipperURLCurrency = slipperURLCurr.toUpperCase();
				}

				// Changing currency variable depending on URL value
				if (slipperURLCurrency === 'EUR') {
					$cache.slipperURLDetectedCurrency = 'EUR';
				} else if (slipperURLCurrency === 'USD') {
					$cache.slipperURLDetectedCurrency = 'USD';
				} else if (slipperURLCurrency === 'GBP') {
					$cache.slipperURLDetectedCurrency = 'GBP';
				} else if (slipperURLCurrency === 'AUD') {
					$cache.slipperURLDetectedCurrency = 'AUD';
				} else {
					$cache.slipperURLDetectedCurrency = 'GBP';
				}


				// Setting currency
				if (slipperURLCurr) {
					var $currencies = $("#currencies"),
						$flagSelector = $currencies.find("[data-currency='" + $cache.slipperURLDetectedCurrency + "']"),
						sizeType = $flagSelector.data('sizetype'),
						locationChanged = $.cookie('cLocationChanged');

					$currencies.find('span').removeClass('selected');
					$flagSelector.addClass('selected');

					$('#multiSizeSelector').find("li[data-size-country='" + sizeType + "']").trigger('click');

					if (!locationChanged) {
						$.cookie('cLocationChanged', true);
					}

					// Currency.convertAll(Currency.currentCurrency, $cache.slipperURLDetectedCurrency);
					Currency.cookie.write($cache.slipperURLDetectedCurrency);
				}

				// Gift card change currency
				$cache.changeGiftCurrency = (function () {
					if ($cache.isGiftCard) {
						var selectedIndex = $cache.slipperSizeSelector.find("option:selected").index(),
							selectedPrice = $cache.giftCurrencyPriceList.children().eq(selectedIndex).text();

						$cache.giftCurrencyPriceValue.text(selectedPrice);
						$cache.slipperURLDetectedCurrency = $(".currencySwitcher").find("span.selected").data('currency');

						//($cache.slipperURLDetectedCurrency !== 'GBP') ? $cache.giftCurrencyContainer.removeClass('hidden') : $cache.giftCurrencyContainer.addClass('hidden')
					}
				});

				$cache.changeGiftCurrency();
			};

			detectURLCurrency();

			// Remove dropdown click link for responsive version
			(function preventDropdownClick() {
				var windowsize = $(window).width();
				if (windowsize < 1025) {
					$cache.headerDropdownLink.on('click', function (e) {
						e.preventDefault();
					});
				}
			})($);

			// Mobile slipper subnavigation
			$('.submenu_enable > a').on('click', function (e) {
				e.preventDefault();
				$(this).parent().find('ul').slideToggle();
			});

			// Currency changer dropdown
			$cache.currencyDropdown.find('span').each(function () {
				if ($(this).hasClass('selected')) {
					$(this).parent().addClass('active');
					$(this).parent().prependTo($cache.currencySwitcher);
				}
			});

			$cache.currencyDropdown.find('span').on('click', function () {
				var $this = $(this),
					sizeType = $this.data('sizetype');
				$cache.currencyDropdown.toggleClass('open');
				$cache.currencyDropdown.find('.active').removeClass('active');
				$this.parent().addClass('active');
				$this.parent().prependTo($cache.currencySwitcher);
				$cache.slipperURLDetectedCurrency = $this.data('currency');
				$cache.changeGiftCurrency();

				if ($('.size-options').length) {
					$('.submit-button').attr('data-active', 'false');
				}

				$('#sizeSelection').find('li').each(function () {
					$(this).removeClass('selected');
				});

				$('#multiSizeSelector').find('li').each(function () {
					var $that = $(this),
						dataSize = $that.data('size-country');
					if (dataSize == sizeType) {
						$that.trigger('click');
					}
				});

				App.product.generateSizeSelector(false);
				App.currency.getDiscount();
				App.multistore.switchCheckout(App.currency.get());

				// cancel size selection
				App.product.size.selected = false;
				$cache.submitActive = false;
				App.product.resetComboStock();
				$('.submit-button').removeClass('disabled').attr('value', 'add to cart').attr('disabled', false).attr('data-active', 'false');

				// Collection change size type
				if (App.page.template == 'plp') {
					// Force EU sizing system for AU currency
					if (sizeType == 'au') {
						sizeType = 'eu'
					}
					App.collection.changeFilterSizes(sizeType);
				}
			});

			$cache.currencyDropdown.find('i').on('click', function () {
				$(this).parent().find('span').trigger('click');
			});

			$cache.currencySwitcher.on('mouseover', function () {
				if ($(window).width() > 1024) {
					$cache.currencyDropdown.addClass('open');
				}
			}).on('mouseleave', function () {
				if ($(window).width() > 1024) {
					$cache.currencyDropdown.removeClass('open');
				}
			});

			// Tablet close dropdown on blur
			$(document).on('touchend', function (event) {
				if ($(window).width() < 1025) {
					if (!$(event.target).closest($cache.currencyDropdown).length) {
						$cache.currencyDropdown.removeClass('open');
					}
				}
			});

			// Get countries list
			var getCountriesJson = (function () {

				var jsonCountriesLink = Theme.shop.countriesUrl,
					deliveryPopup = $('#modalDeliveryPopup'),
					countriesSelect = $('#countrySelect'),
					loader = countriesSelect.parent().find('.small-loader'),
					savedCountry = App.utils.getCookie('deliveryC'),
					selectedOption, selectedCountryData;

				$.ajax({
					url: jsonCountriesLink,
					tryCount: 0,
					retryLimit: 5,
					success: function (data) {
						var cList = data,
							countryList = [],
							countryFirst = [],
							countryInOrder = [];

						for (var key in cList.countries) {
							if (cList.countries.hasOwnProperty(key)) {
								if (key == "United Kingdom" || key == "United States") {
									countryFirst.push(key);
								} else {
									countryList.push(key);
								}
							}
						}

						countryList.sort();

						$.each(countryFirst, function (key, value) {
							countryInOrder.push(value);
						});

						$.each(countryList, function (key, value) {
							countryInOrder.push(value);
						});

						if (loader.length) {
							loader.hide();
							countriesSelect.find('option').html('Select your country');
						}

						$.each(countryInOrder, function (key, value) {
							countriesSelect.append('<option value="' + value + '">' + value + '</option>');
						});

						countriesSelect.on('change', function () {
							var changeAtempts = 0,
								searchContainer = $('.select-results'),
								searchLabel = $('#selectLabel'),
								GBPconvertedLabel = $('#dl-gbpconverted'),
								selectedCountryCurrency,
								selectedCountrySymbol;

							selectedOption = countriesSelect.find('option:selected').val();
							selectedCountryData = cList.countries[selectedOption] || 'United Kingdom';

							selectedCountryCurrency = selectedCountryData.currency; // converting currency
							selectedCountrySymbol = selectedCountryData.symbol;

							App.utils.setCookie('deliveryC', selectedOption);
							// Currency.convertNoCookies(Currency.currentCurrency, selectedCountryCurrency, '.deliveryFreeShip');

							if (changeAtempts == 0) {
								searchContainer.removeClass('hidden');
								searchLabel.addClass('hidden');
								changeAtempts++;
							}

							if (selectedCountryCurrency == 'GBP') {
								GBPconvertedLabel.addClass('hidden');
							} else {
								GBPconvertedLabel.removeClass('hidden');
							}

							// iterating through country data

							for (var key in selectedCountryData) {
								if (selectedCountryData.hasOwnProperty(key)) {
									for (var keyInner in selectedCountryData[key]) {

										var selectorToEdit = $('#dm-' + key + keyInner),
											valueLabel = $('#dl-' + key + keyInner),
											property = key + keyInner,
											selectorValue = selectedCountryData[key][keyInner];

										if ($(selectorToEdit).length > 0) {  // checking if container exist
											$(selectorToEdit).html(selectorValue);
										}

										if (selectorValue == null || selectorValue == false) {
											$(valueLabel).addClass('hidden');
										} else {
											$(valueLabel).removeClass('hidden');
										}

										// toggle postage express note
										if (property == 'postagechristmasexpress') {
											if (selectorValue == null) {
												$('#dl-postagechristmasexpress-note, #dl-postagechristmasexpress-code').addClass('hidden')
											} else {
												$('#dl-postagechristmasexpress-note, #dl-postagechristmasexpress-code').removeClass('hidden')
											}
										}
									}
								}
							}

							if (App.page.template == 'delivery') { // for delivery page
								$(window).on('beforeunload', function () {
									$(window).scrollTop(0);
								});
							} else if (App.page.template == 'pdp' && App.ui.isMobile()) {
								$(window).scrollTop(0);
							}
						});

						// stored country auto-select
						if (savedCountry && App.page.template == 'delivery') {
							var savedCountryExist = countriesSelect.find('option[value="' + savedCountry + '"]').length != 0;
							if (savedCountryExist) {
								countriesSelect.val(savedCountry);
								countriesSelect.trigger('change');
							}
						}

						// select country by hash
						var changeCountryByHash = function () {
							var hash = $cache.locationHash;

							countriesSelect.find('option').each(function () {
								var $this = $(this),
									country = $this.val().toLowerCase().replace(/ /g, '');

								if (hash == country) {
									$this.attr('selected', 'selected').trigger('change');
									return false;
								}
							});
						};

						if ($cache.locationHash) {
							changeCountryByHash();
							App.delivery.initHashChange();
						}
					},
					error: function (xhr, textStatus, errorThrown) {
						var throwError = (function () {
							console.log('cant load countries');
						});

						if (textStatus == 'timeout') {
							this.tryCount++;
							if (this.tryCount <= this.retryLimit) {
								//try again
								$.ajax(this);
								return;
							}
							return;
						}
						(xhr.status == 500) ? throwError() : throwError();
					}
				});
			});

			if (Theme.shop.countriesUrl &&
				(App.page.template == 'delivery' ||
					App.page.template == 'pdp' ||
					App.page.template == 'plp')) {
				getCountriesJson();
			}

		}

		// Functions load order
		initCache();

		if (App.page.template == 'pdp') {
			initEvents();
		}

		initPublic();

		if (App.page.template == 'cart') {
			App.cart.init();
		} else if (App.page.template == 'blog' || App.page.template == 'article' || App.page.template == 'blogs') {
			App.blog.init();
		} else if (App.page.template == 'faq') {
			App.faq.init();
		}


	})(window.app, jQuery);
});
